/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({"0":"data"}[chunkId]||chunkId) + "." + {"0":"3b8e35ac"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 265);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(40)
  , hide      = __webpack_require__(20)
  , redefine  = __webpack_require__(21)
  , ctx       = __webpack_require__(41)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(70);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(28);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(90)('wks')
  , uid        = __webpack_require__(52)
  , Symbol     = __webpack_require__(3).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(546)


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(5)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(2)
  , IE8_DOM_DEFINE = __webpack_require__(183)
  , toPrimitive    = __webpack_require__(34)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMProperty = __webpack_require__(72);
var ReactDOMComponentFlags = __webpack_require__(217);

var invariant = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(13)
  , createDesc = __webpack_require__(47);
module.exports = __webpack_require__(12) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , hide      = __webpack_require__(20)
  , has       = __webpack_require__(17)
  , SRC       = __webpack_require__(52)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(40).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(78)
  , defined = __webpack_require__(30);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
  , fails   = __webpack_require__(5)
  , defined = __webpack_require__(30)
  , quot    = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function(string, tag, attribute, value) {
  var S  = String(defined(string))
    , p1 = '<' + tag;
  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec){
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function(){
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(167)('wks')
  , uid        = __webpack_require__(113)
  , Symbol     = __webpack_require__(38).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(79)
  , createDesc     = __webpack_require__(47)
  , toIObject      = __webpack_require__(23)
  , toPrimitive    = __webpack_require__(34)
  , has            = __webpack_require__(17)
  , IE8_DOM_DEFINE = __webpack_require__(183)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(17)
  , toObject    = __webpack_require__(16)
  , IE_PROTO    = __webpack_require__(119)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(5);

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(51)
  , IE8_DOM_DEFINE = __webpack_require__(244)
  , toPrimitive    = __webpack_require__(164)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(39) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0)
  , core    = __webpack_require__(40)
  , fails   = __webpack_require__(5);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(41)
  , IObject  = __webpack_require__(78)
  , toObject = __webpack_require__(16)
  , toLength = __webpack_require__(15)
  , asc      = __webpack_require__(363);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(221);
var PooledClass = __webpack_require__(61);
var ReactFeatureFlags = __webpack_require__(222);
var ReactReconciler = __webpack_require__(73);
var Transaction = __webpack_require__(102);

var invariant = __webpack_require__(1);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(77)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(22);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if(__webpack_require__(12)){
  var LIBRARY             = __webpack_require__(53)
    , global              = __webpack_require__(3)
    , fails               = __webpack_require__(5)
    , $export             = __webpack_require__(0)
    , $typed              = __webpack_require__(99)
    , $buffer             = __webpack_require__(142)
    , ctx                 = __webpack_require__(41)
    , anInstance          = __webpack_require__(59)
    , propertyDesc        = __webpack_require__(47)
    , hide                = __webpack_require__(20)
    , redefineAll         = __webpack_require__(60)
    , toInteger           = __webpack_require__(49)
    , toLength            = __webpack_require__(15)
    , toIndex             = __webpack_require__(55)
    , toPrimitive         = __webpack_require__(34)
    , has                 = __webpack_require__(17)
    , same                = __webpack_require__(189)
    , classof             = __webpack_require__(80)
    , isObject            = __webpack_require__(8)
    , toObject            = __webpack_require__(16)
    , isArrayIter         = __webpack_require__(134)
    , create              = __webpack_require__(56)
    , getPrototypeOf      = __webpack_require__(27)
    , gOPN                = __webpack_require__(57).f
    , getIterFn           = __webpack_require__(136)
    , uid                 = __webpack_require__(52)
    , wks                 = __webpack_require__(9)
    , createArrayMethod   = __webpack_require__(36)
    , createArrayIncludes = __webpack_require__(91)
    , speciesConstructor  = __webpack_require__(139)
    , ArrayIterators      = __webpack_require__(138)
    , Iterators           = __webpack_require__(67)
    , $iterDetect         = __webpack_require__(95)
    , setSpecies          = __webpack_require__(58)
    , arrayFill           = __webpack_require__(137)
    , arrayCopyWithin     = __webpack_require__(198)
    , $DP                 = __webpack_require__(13)
    , $GOPD               = __webpack_require__(26)
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Map     = __webpack_require__(201)
  , $export = __webpack_require__(0)
  , shared  = __webpack_require__(90)('metadata')
  , store   = shared.store || (shared.store = new (__webpack_require__(204)));

var getOrCreateMetadataMap = function(target, targetKey, create){
  var targetMetadata = store.get(target);
  if(!targetMetadata){
    if(!create)return undefined;
    store.set(target, targetMetadata = new Map);
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if(!keyMetadata){
    if(!create)return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map);
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function(target, targetKey){
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
    , keys        = [];
  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
  return keys;
};
var toMetaKey = function(it){
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function(O){
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(61);

var emptyFunction = __webpack_require__(28);
var warning = __webpack_require__(6);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(38)
  , core      = __webpack_require__(19)
  , ctx       = __webpack_require__(76)
  , hide      = __webpack_require__(50)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(52)('meta')
  , isObject = __webpack_require__(8)
  , has      = __webpack_require__(17)
  , setDesc  = __webpack_require__(13).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(5)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(33)
  , createDesc = __webpack_require__(86);
module.exports = __webpack_require__(39) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(63);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(185)
  , enumBugKeys = __webpack_require__(120);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(2)
  , dPs         = __webpack_require__(186)
  , enumBugKeys = __webpack_require__(120)
  , IE_PROTO    = __webpack_require__(119)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(117)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(122).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(185)
  , hiddenKeys = __webpack_require__(120).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(3)
  , dP          = __webpack_require__(13)
  , DESCRIPTORS = __webpack_require__(12)
  , SPECIES     = __webpack_require__(9)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(21);
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(243)
  , defined = __webpack_require__(109);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(13).f
  , has = __webpack_require__(17)
  , TAG = __webpack_require__(9)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
  , defined = __webpack_require__(30)
  , fails   = __webpack_require__(5)
  , spaces  = __webpack_require__(124)
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(9)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(20)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(41)
  , call        = __webpack_require__(196)
  , isArrayIter = __webpack_require__(134)
  , anObject    = __webpack_require__(2)
  , toLength    = __webpack_require__(15)
  , getIterFn   = __webpack_require__(136)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactBaseClasses = __webpack_require__(211);
var ReactChildren = __webpack_require__(456);
var ReactDOMFactories = __webpack_require__(461);
var ReactElement = __webpack_require__(71);
var ReactPropTypes = __webpack_require__(462);
var ReactVersion = __webpack_require__(465);

var createReactClass = __webpack_require__(466);
var onlyChild = __webpack_require__(468);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(44);

var warning = __webpack_require__(6);
var canDefineProperty = __webpack_require__(213);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(214);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(478);
var ReactInstrumentation = __webpack_require__(32);

var warning = __webpack_require__(6);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(150);
var setInnerHTML = __webpack_require__(104);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(151);
var setTextContent = __webpack_require__(226);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(550);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(29);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(29)
  , TAG = __webpack_require__(9)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(83);
var EventPluginUtils = __webpack_require__(144);

var accumulateInto = __webpack_require__(218);
var forEachAccumulated = __webpack_require__(219);
var warning = __webpack_require__(6);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var EventPluginRegistry = __webpack_require__(143);
var EventPluginUtils = __webpack_require__(144);
var ReactErrorUtils = __webpack_require__(145);

var accumulateInto = __webpack_require__(218);
var forEachAccumulated = __webpack_require__(219);
var invariant = __webpack_require__(1);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

var getEventTarget = __webpack_require__(146);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(556)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(162)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(607);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(610);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(611);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(613);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(260);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(116);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(614);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 89 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(23)
  , toLength  = __webpack_require__(15)
  , toIndex   = __webpack_require__(55);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8)
  , cof      = __webpack_require__(29)
  , MATCH    = __webpack_require__(9)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(9)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(20)
  , redefine = __webpack_require__(21)
  , fails    = __webpack_require__(5)
  , defined  = __webpack_require__(30)
  , wks      = __webpack_require__(9);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(3)
  , $export           = __webpack_require__(0)
  , redefine          = __webpack_require__(21)
  , redefineAll       = __webpack_require__(60)
  , meta              = __webpack_require__(48)
  , forOf             = __webpack_require__(69)
  , anInstance        = __webpack_require__(59)
  , isObject          = __webpack_require__(8)
  , fails             = __webpack_require__(5)
  , $iterDetect       = __webpack_require__(95)
  , setToStringTag    = __webpack_require__(65)
  , inheritIfRequired = __webpack_require__(125);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , hide   = __webpack_require__(20)
  , uid    = __webpack_require__(52)
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(53)|| !__webpack_require__(5)(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete __webpack_require__(3)[K];
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(84);
var ViewportMetrics = __webpack_require__(225);

var getEventModifierState = __webpack_require__(148);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(18);
var DOMNamespaces = __webpack_require__(150);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(151);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var EventPluginRegistry = __webpack_require__(143);
var ReactEventEmitterMixin = __webpack_require__(499);
var ViewportMetrics = __webpack_require__(225);

var getVendorPrefixedEventName = __webpack_require__(500);
var isEventSupported = __webpack_require__(147);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(548);
var global        = __webpack_require__(38)
  , hide          = __webpack_require__(50)
  , Iterators     = __webpack_require__(75)
  , TO_STRING_TAG = __webpack_require__(25)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(51)
  , dPs         = __webpack_require__(552)
  , enumBugKeys = __webpack_require__(168)
  , IE_PROTO    = __webpack_require__(166)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(245)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(555).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(247)
  , enumBugKeys = __webpack_require__(168);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(165)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f
  , has = __webpack_require__(64)
  , TAG = __webpack_require__(25)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(109);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(3)
  , core           = __webpack_require__(40)
  , LIBRARY        = __webpack_require__(53)
  , wksExt         = __webpack_require__(184)
  , defineProperty = __webpack_require__(13).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(90)('keys')
  , uid    = __webpack_require__(52);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(29);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3).document && document.documentElement;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8)
  , anObject = __webpack_require__(2);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(41)(Function.call, __webpack_require__(26).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isObject       = __webpack_require__(8)
  , setPrototypeOf = __webpack_require__(123).set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(49)
  , defined   = __webpack_require__(30);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49)
  , defined   = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(53)
  , $export        = __webpack_require__(0)
  , redefine       = __webpack_require__(21)
  , hide           = __webpack_require__(20)
  , has            = __webpack_require__(17)
  , Iterators      = __webpack_require__(67)
  , $iterCreate    = __webpack_require__(131)
  , setToStringTag = __webpack_require__(65)
  , getPrototypeOf = __webpack_require__(27)
  , ITERATOR       = __webpack_require__(9)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(56)
  , descriptor     = __webpack_require__(47)
  , setToStringTag = __webpack_require__(65)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(20)(IteratorPrototype, __webpack_require__(9)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(94)
  , defined  = __webpack_require__(30);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(9)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(67)
  , ITERATOR   = __webpack_require__(9)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(13)
  , createDesc      = __webpack_require__(47);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(80)
  , ITERATOR  = __webpack_require__(9)('iterator')
  , Iterators = __webpack_require__(67);
module.exports = __webpack_require__(40).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(16)
  , toIndex  = __webpack_require__(55)
  , toLength = __webpack_require__(15);
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(68)
  , step             = __webpack_require__(199)
  , Iterators        = __webpack_require__(67)
  , toIObject        = __webpack_require__(23);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(130)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(2)
  , aFunction = __webpack_require__(22)
  , SPECIES   = __webpack_require__(9)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(41)
  , invoke             = __webpack_require__(93)
  , html               = __webpack_require__(122)
  , cel                = __webpack_require__(117)
  , global             = __webpack_require__(3)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(29)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , macrotask = __webpack_require__(140).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(29)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(3)
  , DESCRIPTORS    = __webpack_require__(12)
  , LIBRARY        = __webpack_require__(53)
  , $typed         = __webpack_require__(99)
  , hide           = __webpack_require__(20)
  , redefineAll    = __webpack_require__(60)
  , fails          = __webpack_require__(5)
  , anInstance     = __webpack_require__(59)
  , toInteger      = __webpack_require__(49)
  , toLength       = __webpack_require__(15)
  , gOPN           = __webpack_require__(57).f
  , dP             = __webpack_require__(13).f
  , arrayFill      = __webpack_require__(137)
  , setToStringTag = __webpack_require__(65)
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactErrorUtils = __webpack_require__(145);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(18);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(74);
var Danger = __webpack_require__(484);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInstrumentation = __webpack_require__(32);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(151);
var setInnerHTML = __webpack_require__(104);
var setTextContent = __webpack_require__(226);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactPropTypesSecret = __webpack_require__(502);
var propTypesFactory = __webpack_require__(215);

var React = __webpack_require__(70);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(44);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(32);
var ReactUpdates = __webpack_require__(37);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var emptyFunction = __webpack_require__(28);
var warning = __webpack_require__(6);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(547), __esModule: true };

/***/ }),
/* 161 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(163)
  , $export        = __webpack_require__(46)
  , redefine       = __webpack_require__(246)
  , hide           = __webpack_require__(50)
  , has            = __webpack_require__(64)
  , Iterators      = __webpack_require__(75)
  , $iterCreate    = __webpack_require__(551)
  , setToStringTag = __webpack_require__(114)
  , getPrototypeOf = __webpack_require__(248)
  , ITERATOR       = __webpack_require__(25)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(63);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(167)('keys')
  , uid    = __webpack_require__(113);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(38)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(170)
  , ITERATOR  = __webpack_require__(25)('iterator')
  , Iterators = __webpack_require__(75);
module.exports = __webpack_require__(19).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(161)
  , TAG = __webpack_require__(25)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(76)
  , call        = __webpack_require__(253)
  , isArrayIter = __webpack_require__(254)
  , anObject    = __webpack_require__(51)
  , toLength    = __webpack_require__(112)
  , getIterFn   = __webpack_require__(169)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(113)('meta')
  , isObject = __webpack_require__(63)
  , has      = __webpack_require__(64)
  , setDesc  = __webpack_require__(33).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(77)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(25);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(38)
  , core           = __webpack_require__(19)
  , LIBRARY        = __webpack_require__(163)
  , wksExt         = __webpack_require__(173)
  , defineProperty = __webpack_require__(33).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(608)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(609)();
}


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(268);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(12) && !__webpack_require__(5)(function(){
  return Object.defineProperty(__webpack_require__(117)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(9);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(17)
  , toIObject    = __webpack_require__(23)
  , arrayIndexOf = __webpack_require__(91)(false)
  , IE_PROTO     = __webpack_require__(119)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(13)
  , anObject = __webpack_require__(2)
  , getKeys  = __webpack_require__(54);

module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(23)
  , gOPN      = __webpack_require__(57).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(54)
  , gOPS     = __webpack_require__(92)
  , pIE      = __webpack_require__(79)
  , toObject = __webpack_require__(16)
  , IObject  = __webpack_require__(78)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(5)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction  = __webpack_require__(22)
  , isObject   = __webpack_require__(8)
  , invoke     = __webpack_require__(93)
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt
  , $trim     = __webpack_require__(66).trim
  , ws        = __webpack_require__(124)
  , hex       = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat
  , $trim       = __webpack_require__(66).trim;

module.exports = 1 / $parseFloat(__webpack_require__(124) + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(29);
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(22)
  , toObject  = __webpack_require__(16)
  , IObject   = __webpack_require__(78)
  , toLength  = __webpack_require__(15);

module.exports = function(that, callbackfn, aLen, memo, isRight){
  aFunction(callbackfn);
  var O      = toObject(that)
    , self   = IObject(O)
    , length = toLength(O.length)
    , index  = isRight ? length - 1 : 0
    , i      = isRight ? -1 : 1;
  if(aLen < 2)for(;;){
    if(index in self){
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if(isRight ? index < 0 : length <= index){
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(16)
  , toIndex  = __webpack_require__(55)
  , toLength = __webpack_require__(15);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if(__webpack_require__(12) && /./g.flags != 'g')__webpack_require__(13).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(96)
});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(202);

// 23.1 Map Objects
module.exports = __webpack_require__(98)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(13).f
  , create      = __webpack_require__(56)
  , redefineAll = __webpack_require__(60)
  , ctx         = __webpack_require__(41)
  , anInstance  = __webpack_require__(59)
  , defined     = __webpack_require__(30)
  , forOf       = __webpack_require__(69)
  , $iterDefine = __webpack_require__(130)
  , step        = __webpack_require__(199)
  , setSpecies  = __webpack_require__(58)
  , DESCRIPTORS = __webpack_require__(12)
  , fastKey     = __webpack_require__(48).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(202);

// 23.2 Set Objects
module.exports = __webpack_require__(98)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each         = __webpack_require__(36)(0)
  , redefine     = __webpack_require__(21)
  , meta         = __webpack_require__(48)
  , assign       = __webpack_require__(188)
  , weak         = __webpack_require__(205)
  , isObject     = __webpack_require__(8)
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(98)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll       = __webpack_require__(60)
  , getWeak           = __webpack_require__(48).getWeak
  , anObject          = __webpack_require__(2)
  , isObject          = __webpack_require__(8)
  , anInstance        = __webpack_require__(59)
  , forOf             = __webpack_require__(69)
  , createArrayMethod = __webpack_require__(36)
  , $has              = __webpack_require__(17)
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(57)
  , gOPS     = __webpack_require__(92)
  , anObject = __webpack_require__(2)
  , Reflect  = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(15)
  , repeat   = __webpack_require__(126)
  , defined  = __webpack_require__(30);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(54)
  , toIObject = __webpack_require__(23)
  , isEnum    = __webpack_require__(79).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(80)
  , from    = __webpack_require__(210);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(69);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(81),
    _assign = __webpack_require__(11);

var ReactNoopUpdateQueue = __webpack_require__(212);

var canDefineProperty = __webpack_require__(213);
var emptyObject = __webpack_require__(101);
var invariant = __webpack_require__(1);
var lowPriorityWarning = __webpack_require__(455);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(463);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(18);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(61);

var invariant = __webpack_require__(1);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(14);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(18);
var escapeTextContentForBrowser = __webpack_require__(105);
var setInnerHTML = __webpack_require__(104);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(72);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInstrumentation = __webpack_require__(32);

var quoteAttributeValueForBrowser = __webpack_require__(498);
var warning = __webpack_require__(6);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(152);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(37);

var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var ReactCompositeComponent = __webpack_require__(507);
var ReactEmptyComponent = __webpack_require__(233);
var ReactHostComponent = __webpack_require__(234);

var getNextDebugID = __webpack_require__(508);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var React = __webpack_require__(70);

var invariant = __webpack_require__(1);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(44);
var REACT_ELEMENT_TYPE = __webpack_require__(509);

var getIteratorFn = __webpack_require__(510);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(156);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(81);

var ReactCurrentOwner = __webpack_require__(44);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(28);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(522);

var containsNode = __webpack_require__(524);
var focusNode = __webpack_require__(227);
var getActiveElement = __webpack_require__(239);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(74);
var DOMProperty = __webpack_require__(72);
var React = __webpack_require__(70);
var ReactBrowserEventEmitter = __webpack_require__(106);
var ReactCurrentOwner = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMContainerInfo = __webpack_require__(539);
var ReactDOMFeatureFlags = __webpack_require__(540);
var ReactFeatureFlags = __webpack_require__(222);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(32);
var ReactMarkupChecksum = __webpack_require__(541);
var ReactReconciler = __webpack_require__(73);
var ReactUpdateQueue = __webpack_require__(157);
var ReactUpdates = __webpack_require__(37);

var emptyObject = __webpack_require__(101);
var instantiateReactComponent = __webpack_require__(231);
var invariant = __webpack_require__(1);
var setInnerHTML = __webpack_require__(104);
var shouldUpdateReactComponent = __webpack_require__(155);
var warning = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(232);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(161);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(39) && !__webpack_require__(77)(function(){
  return Object.defineProperty(__webpack_require__(245)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(63)
  , document = __webpack_require__(38).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(50);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(64)
  , toIObject    = __webpack_require__(62)
  , arrayIndexOf = __webpack_require__(553)(false)
  , IE_PROTO     = __webpack_require__(166)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(64)
  , toObject    = __webpack_require__(115)
  , IE_PROTO    = __webpack_require__(166)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),
/* 250 */
/***/ (function(module, exports) {



/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(50);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(51);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(75)
  , ITERATOR   = __webpack_require__(25)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(161);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(579);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(581);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 257 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(247)
  , hiddenKeys = __webpack_require__(168).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(175)
  , createDesc     = __webpack_require__(86)
  , toIObject      = __webpack_require__(62)
  , toPrimitive    = __webpack_require__(164)
  , has            = __webpack_require__(64)
  , IE8_DOM_DEFINE = __webpack_require__(244)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(39) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f451.06b2dc52.svg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f393.67fad046.svg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow.60e9c61e.svg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// @flow

/*::
declare var __webpack_require__: mixed;
*/

module.exports = typeof __webpack_require__ !== "undefined";


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(266);
module.exports = __webpack_require__(271);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(267).enable();
  window.Promise = __webpack_require__(269);
}

// fetch() polyfill for making API calls.
__webpack_require__(270);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(11);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(182);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(182);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__(272);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(4);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(469);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(10);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/components/Main.js



/* harmony default export */ var Main = (function (_ref) {
  var children = _ref.children;
  return react_default.a.createElement(
    "div",
    { className: "main", "data-jsx": 4025360497
    },
    react_default.a.createElement(
      "div",
      { className: "content", "data-jsx": 4025360497
      },
      children
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 4025360497,
      css: ".main[data-jsx=\"4025360497\"]{width:100vw;min-height:100vh;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.content[data-jsx=\"4025360497\"]{width:100%;max-width:944px;min-height:460px;margin:0;box-sizing:border-box}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL01haW4uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT2dCLEFBR3FCLEFBQ0QsWUFBeUIsQ0FERSxnQkFDd0IsRUFERixnQkFDb0IsVUFBK0IsdUJBQU8sNkJBRDFCLHVHQUE0QixpR0FBTyIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9NYWluLmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcblxuZXhwb3J0IGRlZmF1bHQgKHsgY2hpbGRyZW4gfSkgPT5cbiAgPGRpdiBjbGFzc05hbWU9XCJtYWluXCI+XG4gICAgPGRpdiBjbGFzc05hbWU9XCJjb250ZW50XCI+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9kaXY+XG4gICAgPHN0eWxlIGpzeD57YFxuICAgICAgLm1haW4ge1xuICAgICAgICB3aWR0aDogMTAwdnc7XG4gICAgICAgIG1pbi1oZWlnaHQ6IDEwMHZoO1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIH1cbiAgICAgIC5jb250ZW50IHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIG1heC13aWR0aDogOTQ0cHg7XG4gICAgICAgIG1pbi1oZWlnaHQ6IDQ2MHB4O1xuICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICB9XG4gYH08L3N0eWxlPlxuICA8L2Rpdj47XG4iXX0= */\n/*@ sourceURL=src/components/Main.js */"
    })
  );
});
// CONCATENATED MODULE: ./node_modules/d3-array/src/ascending.js
/* harmony default export */ var ascending = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/bisector.js


/* harmony default export */ var bisector = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/bisect.js



var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ var bisect = (bisectRight);

// CONCATENATED MODULE: ./node_modules/d3-array/src/pairs.js
/* harmony default export */ var pairs = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/cross.js


/* harmony default export */ var cross = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = pair;

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/descending.js
/* harmony default export */ var descending = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/number.js
/* harmony default export */ var number = (function(x) {
  return x === null ? NaN : +x;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/variance.js


/* harmony default export */ var variance = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/deviation.js


/* harmony default export */ var deviation = (function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/extent.js
/* harmony default export */ var extent = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/array.js
var array_array = Array.prototype;

var slice = array_array.slice;
var map = array_array.map;

// CONCATENATED MODULE: ./node_modules/d3-array/src/constant.js
/* harmony default export */ var constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/identity.js
/* harmony default export */ var identity = (function(x) {
  return x;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/range.js
/* harmony default export */ var src_range = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/ticks.js
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ var ticks = (function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/sturges.js
/* harmony default export */ var sturges = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/histogram.js









/* harmony default export */ var src_histogram = (function() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = src_range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisect(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/quantile.js


/* harmony default export */ var quantile = (function(values, p, valueof) {
  if (valueof == null) valueof = number;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/freedmanDiaconis.js





/* harmony default export */ var freedmanDiaconis = (function(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/threshold/scott.js


/* harmony default export */ var scott = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/max.js
/* harmony default export */ var src_max = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/mean.js


/* harmony default export */ var src_mean = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/median.js




/* harmony default export */ var median = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return quantile(numbers.sort(ascending), 0.5);
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/merge.js
/* harmony default export */ var src_merge = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/min.js
/* harmony default export */ var src_min = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/permute.js
/* harmony default export */ var permute = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/scan.js


/* harmony default export */ var scan = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = ascending;

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/shuffle.js
/* harmony default export */ var shuffle = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/sum.js
/* harmony default export */ var src_sum = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});

// CONCATENATED MODULE: ./node_modules/d3-array/src/transpose.js


/* harmony default export */ var src_transpose = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = src_min(matrix, transpose_length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function transpose_length(d) {
  return d.length;
}

// CONCATENATED MODULE: ./node_modules/d3-array/src/zip.js


/* harmony default export */ var zip = (function() {
  return src_transpose(arguments);
});

// CONCATENATED MODULE: ./node_modules/d3-array/index.js




























// CONCATENATED MODULE: ./node_modules/d3-collection/src/map.js
var map_prefix = "$";

function map_Map() {}

map_Map.prototype = map_map.prototype = {
  constructor: map_Map,
  has: function(key) {
    return (map_prefix + key) in this;
  },
  get: function(key) {
    return this[map_prefix + key];
  },
  set: function(key, value) {
    this[map_prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = map_prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === map_prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === map_prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === map_prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === map_prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === map_prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === map_prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === map_prefix) f(this[property], property.slice(1), this);
  }
};

function map_map(object, f) {
  var map = new map_Map;

  // Copy constructor.
  if (object instanceof map_Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ var src_map = (map_map);

// CONCATENATED MODULE: ./node_modules/d3-collection/src/nest.js


/* harmony default export */ var src_nest = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) return rollup != null
        ? rollup(array) : (sortValues != null
        ? array.sort(sortValues)
        : array);

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = src_map(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return src_map();
}

function setMap(map, key, value) {
  map.set(key, value);
}

// CONCATENATED MODULE: ./node_modules/d3-collection/src/set.js


function Set() {}

var proto = src_map.prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[map_prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ var src_set = (set);

// CONCATENATED MODULE: ./node_modules/d3-collection/src/keys.js
/* harmony default export */ var src_keys = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});

// CONCATENATED MODULE: ./node_modules/d3-collection/src/values.js
/* harmony default export */ var src_values = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});

// CONCATENATED MODULE: ./node_modules/d3-collection/src/entries.js
/* harmony default export */ var src_entries = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});

// CONCATENATED MODULE: ./node_modules/d3-collection/index.js







// CONCATENATED MODULE: ./node_modules/d3-scale/src/array.js
var src_array_array = Array.prototype;

var array_map = src_array_array.map;
var array_slice = src_array_array.slice;

// CONCATENATED MODULE: ./node_modules/d3-scale/src/ordinal.js



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = src_map(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : array_slice.call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = src_map();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = array_slice.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/band.js



function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = src_range(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}

// CONCATENATED MODULE: ./node_modules/d3-color/src/define.js
/* harmony default export */ var define = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

// CONCATENATED MODULE: ./node_modules/d3-color/src/color.js


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color_color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color_color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color_color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function color_rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, color_rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color_color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

// CONCATENATED MODULE: ./node_modules/d3-color/src/math.js
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

// CONCATENATED MODULE: ./node_modules/d3-color/src/lab.js




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    lab_t0 = 4 / 29,
    lab_t1 = 6 / 29,
    t2 = 3 * lab_t1 * lab_t1,
    t3 = lab_t1 * lab_t1 * lab_t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * deg2rad;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Rgb(
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + lab_t0;
}

function lab2xyz(t) {
  return t > lab_t1 ? t * t * t : t2 * (t - lab_t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));

// CONCATENATED MODULE: ./node_modules/d3-color/src/cubehelix.js




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    cubehelix_D = -0.90649,
    E = +1.97294,
    ED = E * cubehelix_D,
    EB = E * B,
    BC_DA = B * C - cubehelix_D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / cubehelix_D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix_cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix_cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + cubehelix_D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

// CONCATENATED MODULE: ./node_modules/d3-color/index.js




// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basis.js
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ var src_basis = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/basisClosed.js


/* harmony default export */ var basisClosed = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/constant.js
/* harmony default export */ var src_constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/color.js


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function color_hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : src_constant(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : src_constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : src_constant(isNaN(a) ? b : a);
}

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/rgb.js





/* harmony default export */ var src_rgb = ((function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = color_rgb(start)).r, (end = color_rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = color_rgb(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(src_basis);
var rgbBasisClosed = rgbSpline(basisClosed);

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/array.js


/* harmony default export */ var src_array = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = src_value(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/date.js
/* harmony default export */ var src_date = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/number.js
/* harmony default export */ var src_number = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/object.js


/* harmony default export */ var object = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = src_value(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/string.js


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function string_zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ var string = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: src_number(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : string_zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/value.js









/* harmony default export */ var src_value = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? src_constant(b)
      : (t === "number" ? src_number
      : t === "string" ? ((c = color_color(b)) ? (b = c, src_rgb) : string)
      : b instanceof color_color ? src_rgb
      : b instanceof Date ? src_date
      : Array.isArray(b) ? src_array
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : src_number)(a, b);
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/round.js
/* harmony default export */ var src_round = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/decompose.js
var degrees = 180 / Math.PI;

var decompose_identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ var decompose = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/parse.js


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return decompose_identity;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return decompose_identity;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return decompose_identity;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/transform/index.js



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: src_number(xa, xb)}, {i: i - 2, x: src_number(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: src_number(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: src_number(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: src_number(xa, xb)}, {i: i - 2, x: src_number(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/zoom.js
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function zoom_cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function zoom_sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ var zoom = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = zoom_cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - zoom_sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / zoom_cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hsl.js



function hsl_hsl(hue) {
  return function(start, end) {
    var h = hue((start = hsl(start)).h, (end = hsl(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ var src_hsl = (hsl_hsl(color_hue));
var hslLong = hsl_hsl(nogamma);

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/lab.js



function lab_lab(start, end) {
  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/hcl.js



function hcl_hcl(hue) {
  return function(start, end) {
    var h = hue((start = hcl(start)).h, (end = hcl(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ var src_hcl = (hcl_hcl(color_hue));
var hclLong = hcl_hcl(nogamma);

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/cubehelix.js



function src_cubehelix_cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = cubehelix_cubehelix(start)).h, (end = cubehelix_cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ var src_cubehelix = (src_cubehelix_cubehelix(color_hue));
var cubehelixLong = src_cubehelix_cubehelix(nogamma);

// CONCATENATED MODULE: ./node_modules/d3-interpolate/src/quantize.js
/* harmony default export */ var quantize = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});

// CONCATENATED MODULE: ./node_modules/d3-interpolate/index.js


















// CONCATENATED MODULE: ./node_modules/d3-scale/src/constant.js
/* harmony default export */ var d3_scale_src_constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/number.js
/* harmony default export */ var d3_scale_src_number = (function(x) {
  return +x;
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/continuous.js






var continuous_unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : d3_scale_src_constant(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = continuous_unit,
      range = continuous_unit,
      interpolate = src_value,
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = array_map.call(_, d3_scale_src_number), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = array_slice.call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = array_slice.call(_), interpolate = src_round, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatDecimal.js
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ var formatDecimal = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/exponent.js


/* harmony default export */ var src_exponent = (function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatGroup.js
/* harmony default export */ var formatGroup = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatNumerals.js
/* harmony default export */ var formatNumerals = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatDefault.js
/* harmony default export */ var formatDefault = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatPrefixAuto.js


var prefixExponent;

/* harmony default export */ var formatPrefixAuto = (function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatRounded.js


/* harmony default export */ var formatRounded = (function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatTypes.js




/* harmony default export */ var formatTypes = ({
  "": formatDefault,
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/formatSpecifier.js


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!formatTypes[type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};

// CONCATENATED MODULE: ./node_modules/d3-format/src/identity.js
/* harmony default export */ var src_identity = (function(x) {
  return x;
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/locale.js








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ var src_locale = (function(locale) {
  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : src_identity,
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? formatNumerals(locale.numerals) : src_identity,
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(src_exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/defaultLocale.js


var defaultLocale_locale;
var defaultLocale_format;
var defaultLocale_formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  defaultLocale_locale = src_locale(definition);
  defaultLocale_format = defaultLocale_locale.format;
  defaultLocale_formatPrefix = defaultLocale_locale.formatPrefix;
  return defaultLocale_locale;
}

// CONCATENATED MODULE: ./node_modules/d3-format/src/precisionFixed.js


/* harmony default export */ var precisionFixed = (function(step) {
  return Math.max(0, -src_exponent(Math.abs(step)));
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/precisionPrefix.js


/* harmony default export */ var precisionPrefix = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(src_exponent(value) / 3))) * 3 - src_exponent(Math.abs(step)));
});

// CONCATENATED MODULE: ./node_modules/d3-format/src/precisionRound.js


/* harmony default export */ var precisionRound = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, src_exponent(max) - src_exponent(step)) + 1;
});

// CONCATENATED MODULE: ./node_modules/d3-format/index.js







// CONCATENATED MODULE: ./node_modules/d3-scale/src/tickFormat.js



/* harmony default export */ var src_tickFormat = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = tickStep(start, stop, count == null ? 10 : count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return defaultLocale_formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return defaultLocale_format(specifier);
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/linear.js





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return src_tickFormat(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear_linear() {
  var scale = continuous(deinterpolateLinear, src_number);

  scale.copy = function() {
    return copy(scale, linear_linear());
  };

  return linearish(scale);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/identity.js




function identity_identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = array_map.call(_, d3_scale_src_number), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity_identity().domain(domain);
  };

  return linearish(scale);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/nice.js
/* harmony default export */ var nice = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/log.js






function log_deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : d3_scale_src_constant(b);
}

function log_reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = continuous(log_deinterpolate, log_reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = defaultLocale_format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return copy(scale, log().base(base));
  };

  return scale;
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/pow.js




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = continuous(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : d3_scale_src_constant(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return copy(scale, pow().exponent(exponent));
  };

  return linearish(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/quantile.js



function quantile_quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantile(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[bisect(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = array_slice.call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile_quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/quantize.js




function quantize_quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[bisect(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = array_slice.call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize_quantize()
        .domain([x0, x1])
        .range(range);
  };

  return linearish(scale);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/src/threshold.js



function threshold_threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[bisect(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = array_slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = array_slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold_threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}

// CONCATENATED MODULE: ./node_modules/d3-time/src/interval.js
var interval_t0 = new Date,
    interval_t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
    });
  };

  if (count) {
    interval.count = function(start, end) {
      interval_t0.setTime(+start), interval_t1.setTime(+end);
      floori(interval_t0), floori(interval_t1);
      return Math.floor(count(interval_t0, interval_t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

// CONCATENATED MODULE: ./node_modules/d3-time/src/millisecond.js


var millisecond_millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond_millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond_millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ var src_millisecond = (millisecond_millisecond);
var milliseconds = millisecond_millisecond.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/duration.js
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

// CONCATENATED MODULE: ./node_modules/d3-time/src/second.js



var second_second = newInterval(function(date) {
  date.setTime(Math.floor(date / durationSecond) * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ var src_second = (second_second);
var seconds = second_second.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/minute.js



var minute_minute = newInterval(function(date) {
  date.setTime(Math.floor(date / durationMinute) * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ var src_minute = (minute_minute);
var minutes = minute_minute.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/hour.js



var hour_hour = newInterval(function(date) {
  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
  if (offset < 0) offset += durationHour;
  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

/* harmony default export */ var src_hour = (hour_hour);
var hours = hour_hour.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/day.js



var day_day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ var src_day = (day_day);
var days = day_day.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/week.js



function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/month.js


var month_month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ var src_month = (month_month);
var months = month_month.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/year.js


var year_year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year_year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ var src_year = (year_year);
var years = year_year.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/utcMinute.js



var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ var src_utcMinute = (utcMinute);
var utcMinutes = utcMinute.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/utcHour.js



var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ var src_utcHour = (utcHour);
var utcHours = utcHour.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/utcDay.js



var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ var src_utcDay = (utcDay);
var utcDays = utcDay.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/utcWeek.js



function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/utcMonth.js


var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ var src_utcMonth = (utcMonth);
var utcMonths = utcMonth.range;

// CONCATENATED MODULE: ./node_modules/d3-time/src/utcYear.js


var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ var src_utcYear = (utcYear);
var utcYears = utcYear.range;

// CONCATENATED MODULE: ./node_modules/d3-time/index.js






























// CONCATENATED MODULE: ./node_modules/d3-time-format/src/locale.js


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": locale_formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + src_day.count(src_year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(src_year(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(src_year(d), d), p, 2);
}

function locale_formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + src_utcDay.count(src_utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(src_utcYear(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(src_utcYear(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

// CONCATENATED MODULE: ./node_modules/d3-time-format/src/defaultLocale.js


var src_defaultLocale_locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale_defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale_defaultLocale(definition) {
  src_defaultLocale_locale = formatLocale(definition);
  timeFormat = src_defaultLocale_locale.format;
  timeParse = src_defaultLocale_locale.parse;
  utcFormat = src_defaultLocale_locale.utcFormat;
  utcParse = src_defaultLocale_locale.utcParse;
  return src_defaultLocale_locale;
}

// CONCATENATED MODULE: ./node_modules/d3-time-format/src/isoFormat.js


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : utcFormat(isoSpecifier);

/* harmony default export */ var isoFormat = (formatIso);

// CONCATENATED MODULE: ./node_modules/d3-time-format/src/isoParse.js



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : utcParse(isoSpecifier);

/* harmony default export */ var isoParse = (parseIso);

// CONCATENATED MODULE: ./node_modules/d3-time-format/index.js





// CONCATENATED MODULE: ./node_modules/d3-scale/src/time.js








var time_durationSecond = 1000,
    time_durationMinute = time_durationSecond * 60,
    time_durationHour = time_durationMinute * 60,
    time_durationDay = time_durationHour * 24,
    time_durationWeek = time_durationDay * 7,
    durationMonth = time_durationDay * 30,
    durationYear = time_durationDay * 365;

function time_date(t) {
  return new Date(t);
}

function time_number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = continuous(deinterpolateLinear, src_number),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      time_durationSecond],
    [second,  5,  5 * time_durationSecond],
    [second, 15, 15 * time_durationSecond],
    [second, 30, 30 * time_durationSecond],
    [minute,  1,      time_durationMinute],
    [minute,  5,  5 * time_durationMinute],
    [minute, 15, 15 * time_durationMinute],
    [minute, 30, 30 * time_durationMinute],
    [  hour,  1,      time_durationHour  ],
    [  hour,  3,  3 * time_durationHour  ],
    [  hour,  6,  6 * time_durationHour  ],
    [  hour, 12, 12 * time_durationHour  ],
    [   day,  1,      time_durationDay   ],
    [   day,  2,  2 * time_durationDay   ],
    [  week,  1,      time_durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = tickStep(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(array_map.call(_, time_number)) : domain().map(time_date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ var src_time = (function() {
  return calendar(src_year, src_month, sunday, src_day, src_hour, src_minute, src_second, src_millisecond, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/utcTime.js




/* harmony default export */ var utcTime = (function() {
  return calendar(src_utcYear, src_utcMonth, utcSunday, src_utcDay, src_utcHour, src_utcMinute, src_second, src_millisecond, utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/colors.js
/* harmony default export */ var src_colors = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/category10.js


/* harmony default export */ var category10 = (src_colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));

// CONCATENATED MODULE: ./node_modules/d3-scale/src/category20b.js


/* harmony default export */ var category20b = (src_colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));

// CONCATENATED MODULE: ./node_modules/d3-scale/src/category20c.js


/* harmony default export */ var category20c = (src_colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));

// CONCATENATED MODULE: ./node_modules/d3-scale/src/category20.js


/* harmony default export */ var category20 = (src_colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));

// CONCATENATED MODULE: ./node_modules/d3-scale/src/cubehelix.js



/* harmony default export */ var d3_scale_src_cubehelix = (cubehelixLong(cubehelix_cubehelix(300, 0.5, 0.0), cubehelix_cubehelix(-240, 0.5, 1.0)));

// CONCATENATED MODULE: ./node_modules/d3-scale/src/rainbow.js



var warm = cubehelixLong(cubehelix_cubehelix(-100, 0.75, 0.35), cubehelix_cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix_cubehelix(260, 0.75, 0.35), cubehelix_cubehelix(80, 1.50, 0.8));

var rainbow = cubehelix_cubehelix();

/* harmony default export */ var src_rainbow = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});

// CONCATENATED MODULE: ./node_modules/d3-scale/src/viridis.js


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ var viridis = (ramp(src_colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(src_colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(src_colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(src_colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

// CONCATENATED MODULE: ./node_modules/d3-scale/src/sequential.js


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return linearish(scale);
}

// CONCATENATED MODULE: ./node_modules/d3-scale/index.js






































// EXTERNAL MODULE: ./node_modules/react-motion/lib/react-motion.js
var react_motion = __webpack_require__(88);
var react_motion_default = /*#__PURE__*/__webpack_require__.n(react_motion);

// CONCATENATED MODULE: ./src/components/Quiz/Slider.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import './Slider.scss';
// import sliderHadleSvg from 'assets/bg_notch.svg';

// Helper to get pageX from either a mouse or touch event
var getPageX = function getPageX(e) {
  return e.touches ? e.touches[e.touches.length - 1].pageX : e.pageX;
};

var Slider_Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: null,
      dragging: false
    }, _this.handleDragStart = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;

      var _this$slider$getBound = _this.slider.getBoundingClientRect(),
          left = _this$slider$getBound.left,
          width = _this$slider$getBound.width;

      var scrollLeft = document.body ? document.body.scrollLeft : 0;

      var x = getPageX(e) - left - scrollLeft;

      // Add global mouse listeners, so dragging outside of the slider keeps working
      // For some reason touch handlers work fine
      if (!e.touches) {
        window.addEventListener("mousemove", _this.handleDrag);
        window.addEventListener("mouseup", _this.handleDragEnd);
      }

      _this.scale.domain([min, max]).range([0, width]).clamp(true);
      _this.setState({ dragging: true, left: left + scrollLeft, width: width });
      _this.props.onChange && _this.props.onChange(Math.round(_this.scale.invert(x)));
    }, _this.handleDragEnd = function () {
      window.removeEventListener("mousemove", _this.handleDrag);
      window.removeEventListener("mouseup", _this.handleDragEnd);
      _this.setState({ dragging: false });
    }, _this.handleDrag = function (e) {
      e.preventDefault();
      if (!_this.state.dragging) {
        return;
      }
      var x = getPageX(e) - (_this.state.left || 0);
      _this.props.onChange(Math.round(_this.scale.invert(x)));
    }, _this.sliderRef = function (el) {
      _this.slider = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        var _props = _this2.props,
            min = _props.min,
            max = _props.max;

        var _slider$getBoundingCl = _this2.slider.getBoundingClientRect(),
            left = _slider$getBoundingCl.left,
            width = _slider$getBoundingCl.width;

        _this2.scale = linear_linear().domain([min, max]).range([0, width]).clamp(true);
        if (document.body) {
          _this2.setState({ left: left + document.body.scrollLeft, width: width });
        }
      }, 50);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max,
          value = _props2.value,
          unit = _props2.unit,
          color = _props2.color;
      var width = this.state.width;
      var scale = this.scale;


      if (width === null) {
        return react_default.a.createElement(
          "div",
          { className: "Slider", ref: this.sliderRef, "data-jsx": 3387591319
          },
          react_default.a.createElement(style_default.a, {
            styleId: 3387591319,
            css: ".Slider[data-jsx=\"3387591319\"]{width:calc(100% - 40px);max-width:420px;height:24px;position:relative;margin:50px auto}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovU2xpZGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdHc0IsQUFHcUMseUJBQTZCLGlCQUF5QixhQUErQixtQkFBOEIsa0JBQVciLCJmaWxlIjoic3JjL2NvbXBvbmVudHMvUXVpei9TbGlkZXIuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcblxuaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgc2NhbGVMaW5lYXIgfSBmcm9tIFwiZDMtc2NhbGVcIjtcbmltcG9ydCB7IE1vdGlvbiwgc3ByaW5nIH0gZnJvbSBcInJlYWN0LW1vdGlvblwiO1xuLy8gaW1wb3J0ICcuL1NsaWRlci5zY3NzJztcbi8vIGltcG9ydCBzbGlkZXJIYWRsZVN2ZyBmcm9tICdhc3NldHMvYmdfbm90Y2guc3ZnJztcblxuLy8gSGVscGVyIHRvIGdldCBwYWdlWCBmcm9tIGVpdGhlciBhIG1vdXNlIG9yIHRvdWNoIGV2ZW50XG5jb25zdCBnZXRQYWdlWCA9IChlOiBhbnkpOiBudW1iZXIgPT4ge1xuICByZXR1cm4gZS50b3VjaGVzID8gZS50b3VjaGVzW2UudG91Y2hlcy5sZW5ndGggLSAxXS5wYWdlWCA6IGUucGFnZVg7XG59O1xuXG50eXBlIFByb3BzID0ge1xuICBtaW46IG51bWJlcixcbiAgbWF4OiBudW1iZXIsXG4gIG9uQ2hhbmdlOiAodmFsdWU6IG51bWJlcikgPT4gdm9pZCxcbiAgdmFsdWU6IG51bWJlcixcbiAgdW5pdDogc3RyaW5nLFxuICBjb2xvcjogc3RyaW5nXG59O1xuXG50eXBlIFN0YXRlID0ge1xuICBsZWZ0PzogbnVtYmVyLFxuICB3aWR0aDogbnVtYmVyIHwgbnVsbCxcbiAgZHJhZ2dpbmc6IGJvb2xlYW5cbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFNsaWRlciBleHRlbmRzIENvbXBvbmVudDxhbnksIFByb3BzLCBTdGF0ZT4ge1xuICBzbGlkZXI6IEhUTUxFbGVtZW50O1xuICBzY2FsZTogYW55O1xuXG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgbWluOiAwLFxuICAgIG1heDogMTAwXG4gIH07XG5cbiAgc3RhdGUgPSB7XG4gICAgd2lkdGg6IG51bGwsXG4gICAgZHJhZ2dpbmc6IGZhbHNlXG4gIH07XG5cbiAgY29tcG9uZW50RGlkTW91bnQoKSB7XG4gICAgc2V0VGltZW91dCgoKSA9PiB7XG4gICAgICBjb25zdCB7IG1pbiwgbWF4IH0gPSB0aGlzLnByb3BzO1xuICAgICAgY29uc3QgeyBsZWZ0LCB3aWR0aCB9ID0gdGhpcy5zbGlkZXIuZ2V0Qm91bmRpbmdDbGllbnRSZWN0KCk7XG4gICAgICB0aGlzLnNjYWxlID0gc2NhbGVMaW5lYXIoKVxuICAgICAgICAuZG9tYWluKFttaW4sIG1heF0pXG4gICAgICAgIC5yYW5nZShbMCwgd2lkdGhdKVxuICAgICAgICAuY2xhbXAodHJ1ZSk7XG4gICAgICBpZiAoZG9jdW1lbnQuYm9keSkge1xuICAgICAgICB0aGlzLnNldFN0YXRlKHsgbGVmdDogbGVmdCArIGRvY3VtZW50LmJvZHkuc2Nyb2xsTGVmdCwgd2lkdGggfSk7XG4gICAgICB9XG4gICAgfSwgNTApO1xuICB9XG5cbiAgaGFuZGxlRHJhZ1N0YXJ0ID0gKGU6IFRvdWNoRXZlbnQgfCBNb3VzZUV2ZW50KSA9PiB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIGNvbnN0IHsgbWluLCBtYXggfSA9IHRoaXMucHJvcHM7XG4gICAgY29uc3QgeyBsZWZ0LCB3aWR0aCB9ID0gdGhpcy5zbGlkZXIuZ2V0Qm91bmRpbmdDbGllbnRSZWN0KCk7XG4gICAgY29uc3Qgc2Nyb2xsTGVmdCA9IGRvY3VtZW50LmJvZHkgPyBkb2N1bWVudC5ib2R5LnNjcm9sbExlZnQgOiAwO1xuXG4gICAgY29uc3QgeCA9IGdldFBhZ2VYKGUpIC0gbGVmdCAtIHNjcm9sbExlZnQ7XG5cbiAgICAvLyBBZGQgZ2xvYmFsIG1vdXNlIGxpc3RlbmVycywgc28gZHJhZ2dpbmcgb3V0c2lkZSBvZiB0aGUgc2xpZGVyIGtlZXBzIHdvcmtpbmdcbiAgICAvLyBGb3Igc29tZSByZWFzb24gdG91Y2ggaGFuZGxlcnMgd29yayBmaW5lXG4gICAgaWYgKCFlLnRvdWNoZXMpIHtcbiAgICAgIHdpbmRvdy5hZGRFdmVudExpc3RlbmVyKFwibW91c2Vtb3ZlXCIsIHRoaXMuaGFuZGxlRHJhZyk7XG4gICAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcihcIm1vdXNldXBcIiwgdGhpcy5oYW5kbGVEcmFnRW5kKTtcbiAgICB9XG5cbiAgICB0aGlzLnNjYWxlLmRvbWFpbihbbWluLCBtYXhdKS5yYW5nZShbMCwgd2lkdGhdKS5jbGFtcCh0cnVlKTtcbiAgICB0aGlzLnNldFN0YXRlKHsgZHJhZ2dpbmc6IHRydWUsIGxlZnQ6IGxlZnQgKyBzY3JvbGxMZWZ0LCB3aWR0aCB9KTtcbiAgICB0aGlzLnByb3BzLm9uQ2hhbmdlICYmXG4gICAgICB0aGlzLnByb3BzLm9uQ2hhbmdlKE1hdGgucm91bmQodGhpcy5zY2FsZS5pbnZlcnQoeCkpKTtcbiAgfTtcblxuICBoYW5kbGVEcmFnRW5kID0gKCkgPT4ge1xuICAgIHdpbmRvdy5yZW1vdmVFdmVudExpc3RlbmVyKFwibW91c2Vtb3ZlXCIsIHRoaXMuaGFuZGxlRHJhZyk7XG4gICAgd2luZG93LnJlbW92ZUV2ZW50TGlzdGVuZXIoXCJtb3VzZXVwXCIsIHRoaXMuaGFuZGxlRHJhZ0VuZCk7XG4gICAgdGhpcy5zZXRTdGF0ZSh7IGRyYWdnaW5nOiBmYWxzZSB9KTtcbiAgfTtcblxuICBoYW5kbGVEcmFnID0gKGU6IE1vdXNlRXZlbnQpID0+IHtcbiAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgaWYgKCF0aGlzLnN0YXRlLmRyYWdnaW5nKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIGNvbnN0IHggPSBnZXRQYWdlWChlKSAtICh0aGlzLnN0YXRlLmxlZnQgfHwgMCk7XG4gICAgdGhpcy5wcm9wcy5vbkNoYW5nZShNYXRoLnJvdW5kKHRoaXMuc2NhbGUuaW52ZXJ0KHgpKSk7XG4gIH07XG5cbiAgc2xpZGVyUmVmID0gKGVsOiBIVE1MRWxlbWVudCkgPT4ge1xuICAgIHRoaXMuc2xpZGVyID0gZWw7XG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgbWluLCBtYXgsIHZhbHVlLCB1bml0LCBjb2xvciB9ID0gdGhpcy5wcm9wcztcbiAgICBjb25zdCB7IHdpZHRoIH0gPSB0aGlzLnN0YXRlO1xuICAgIGNvbnN0IHsgc2NhbGUgfSA9IHRoaXM7XG5cbiAgICBpZiAod2lkdGggPT09IG51bGwpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiU2xpZGVyXCIgcmVmPXt0aGlzLnNsaWRlclJlZn0+XG4gICAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIC5TbGlkZXIge1xuICAgICAgICAgICAgd2lkdGg6IGNhbGMoMTAwJSAtIDQwcHgpO1xuICAgICAgICAgICAgbWF4LXdpZHRoOiA0MjBweDtcbiAgICAgICAgICAgIGhlaWdodDogMjRweDtcbiAgICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgICAgIG1hcmdpbjogNTBweCBhdXRvO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICk7XG4gICAgfVxuXG4gICAgY29uc3Qgc2xpZGVyWCA9IHNjYWxlKHZhbHVlID09PSBudWxsID8gKG1heCAtIG1pbikgLyAyIDogdmFsdWUpO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXZcbiAgICAgICAgY2xhc3NOYW1lPVwiU2xpZGVyXCJcbiAgICAgICAgcmVmPXt0aGlzLnNsaWRlclJlZn1cbiAgICAgICAgb25Nb3VzZURvd249e3RoaXMuaGFuZGxlRHJhZ1N0YXJ0fVxuICAgICAgICBvblRvdWNoU3RhcnQ9e3RoaXMuaGFuZGxlRHJhZ1N0YXJ0fVxuICAgICAgICBvblRvdWNoTW92ZT17dGhpcy5oYW5kbGVEcmFnfVxuICAgICAgICBvblRvdWNoRW5kPXt0aGlzLmhhbmRsZURyYWdFbmR9XG4gICAgICA+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiU2xpZGVyLVRpY2tMYWJlbFwiIHN0eWxlPXt7IGxlZnQ6IDAgfX0+XG4gICAgICAgICAge21pbn0ge3VuaXR9XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cIlNsaWRlci1UaWNrTGFiZWxcIiBzdHlsZT17eyByaWdodDogMCB9fT5cbiAgICAgICAgICB7bWF4fSB7dW5pdH1cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxNb3Rpb25cbiAgICAgICAgICBzdHlsZT17eyB2YWw6IHNwcmluZyhzbGlkZXJYLCB7IHN0aWZmbmVzczogNDAwLCBkYW1waW5nOiA1MCB9KSB9fVxuICAgICAgICA+XG4gICAgICAgICAgeyh7IHZhbCB9KSA9PiB7XG4gICAgICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgICA8ZGl2PlxuICAgICAgICAgICAgICAgIDxkaXZcbiAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cIlNsaWRlci1CYXJcIlxuICAgICAgICAgICAgICAgICAgc3R5bGU9e3tcbiAgICAgICAgICAgICAgICAgICAgd2lkdGg6IGAke3ZhbH1weGAsXG4gICAgICAgICAgICAgICAgICAgIGJhY2tncm91bmRDb2xvcjogY29sb3IsXG4gICAgICAgICAgICAgICAgICAgIG9wYWNpdHk6IHZhbHVlID09PSBudWxsID8gMCA6IDFcbiAgICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJTbGlkZXItSGFuZGxlXCJcbiAgICAgICAgICAgICAgICAgIHN0eWxlPXt7XG4gICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybTogYHRyYW5zbGF0ZVgoJHt2YWx9cHgpYCxcbiAgICAgICAgICAgICAgICAgICAgV2Via2l0VHJhbnNmb3JtOiBgdHJhbnNsYXRlWCgke3ZhbH1weClgLFxuICAgICAgICAgICAgICAgICAgICBtc1RyYW5zZm9ybTogYHRyYW5zbGF0ZVgoJHt2YWx9cHgpYFxuICAgICAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgIHt2YWx1ZSAhPT0gbnVsbCAmJlxuICAgICAgICAgICAgICAgICAgPGRpdlxuICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJTbGlkZXItTGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICBzdHlsZT17eyBib3R0b206IDMyLCBsZWZ0OiBgJHt2YWx9cHhgIH19XG4gICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgIHt2YWx1ZX0ge3VuaXR9XG4gICAgICAgICAgICAgICAgICA8L2Rpdj59XG4gICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgKTtcbiAgICAgICAgICB9fVxuICAgICAgICA8L01vdGlvbj5cbiAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIC5TbGlkZXIge1xuICAgICAgICAgICAgYmFja2dyb3VuZDogI2ZmZjtcbiAgICAgICAgICAgIHdpZHRoOiBjYWxjKDEwMCUgLSA0MHB4KTtcbiAgICAgICAgICAgIG1heC13aWR0aDogNDIwcHg7XG4gICAgICAgICAgICBoZWlnaHQ6IDI0cHg7XG4gICAgICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgICAgICBtYXJnaW46IDUwcHggYXV0bztcbiAgICAgICAgICAgIHRvdWNoLWFjdGlvbjogbWFuaXB1bGF0aW9uO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIC5TbGlkZXItQmFyIHtcbiAgICAgICAgICAgIHRyYW5zaXRpb246IG9wYWNpdHkgMC4ycztcbiAgICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICAgIHRvcDogMDtcbiAgICAgICAgICAgIGxlZnQ6IDA7XG4gICAgICAgICAgICBoZWlnaHQ6IDI0cHg7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjMzMzO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIC5TbGlkZXItVGlja0xhYmVsIHtcbiAgICAgICAgICAgIGNvbG9yOiAjMWMxYzFjO1xuICAgICAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgICAgICBmb250LXNpemU6IDEycHg7XG4gICAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgICB0b3A6IDM2cHg7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgLlNsaWRlci1IYW5kbGUge1xuICAgICAgICAgICAgYm94LXNoYWRvdzogMCAwIDJweCByZ2JhKDAsIDAsIDAsIDAuNSk7XG4gICAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgICAgd2lkdGg6IDIycHg7XG4gICAgICAgICAgICBtYXJnaW4tbGVmdDogLTExcHg7XG4gICAgICAgICAgICBtYXJnaW4tdG9wOiAtN3B4O1xuICAgICAgICAgICAgaGVpZ2h0OiAzOHB4O1xuICAgICAgICAgICAgYmFja2dyb3VuZDogIzFjMWMxYztcbiAgICAgICAgICB9XG5cbiAgICAgICAgICAuU2xpZGVyLUxhYmVsIHtcbiAgICAgICAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtNTAlKTtcbiAgICAgICAgICAgIGZvbnQtZmFtaWx5OiBGcnV0aWdlckxUQ29tO1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICAgIGxlZnQ6IDA7XG4gICAgICAgICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICAgICAgICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIC5TbGlkZXItU3ViTGFiZWwge1xuICAgICAgICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgICAgICAgICB9XG5cbiAgICAgICAgICAuU2xpZGVyLUluZGljYXRvciB7XG4gICAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgICB0b3A6IDA7XG4gICAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICAgICAgd2lkdGg6IDJweDtcbiAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAtMXB4O1xuICAgICAgICAgICAgaGVpZ2h0OiAyNHB4O1xuICAgICAgICAgICAgYmFja2dyb3VuZDogIzAwMDtcbiAgICAgICAgICB9XG4gICAgICAgIGB9PC9zdHlsZT5cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cbiJdfQ== */\n/*@ sourceURL=src/components/Quiz/Slider.js */"
          })
        );
      }

      var sliderX = scale(value === null ? (max - min) / 2 : value);

      return react_default.a.createElement(
        "div",
        {
          className: "Slider",
          ref: this.sliderRef,
          onMouseDown: this.handleDragStart,
          onTouchStart: this.handleDragStart,
          onTouchMove: this.handleDrag,
          onTouchEnd: this.handleDragEnd,
          "data-jsx": 1501953458
        },
        react_default.a.createElement(
          "div",
          { className: "Slider-TickLabel", style: { left: 0 }, "data-jsx": 1501953458
          },
          min,
          " ",
          unit
        ),
        react_default.a.createElement(
          "div",
          { className: "Slider-TickLabel", style: { right: 0 }, "data-jsx": 1501953458
          },
          max,
          " ",
          unit
        ),
        react_default.a.createElement(
          react_motion["Motion"],
          {
            style: { val: Object(react_motion["spring"])(sliderX, { stiffness: 400, damping: 50 }) }
          },
          function (_ref2) {
            var val = _ref2.val;

            return react_default.a.createElement(
              "div",
              {
                "data-jsx": 1501953458
              },
              react_default.a.createElement("div", {
                className: "Slider-Bar",
                style: {
                  width: val + "px",
                  backgroundColor: color,
                  opacity: value === null ? 0 : 1
                },
                "data-jsx": 1501953458
              }),
              react_default.a.createElement("div", {
                className: "Slider-Handle",
                style: {
                  transform: "translateX(" + val + "px)",
                  WebkitTransform: "translateX(" + val + "px)",
                  msTransform: "translateX(" + val + "px)"
                },
                "data-jsx": 1501953458
              }),
              value !== null && react_default.a.createElement(
                "div",
                {
                  className: "Slider-Label",
                  style: { bottom: 32, left: val + "px" },
                  "data-jsx": 1501953458
                },
                value,
                " ",
                unit
              )
            );
          }
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 1501953458,
          css: ".Slider[data-jsx=\"1501953458\"]{background:#fff;width:calc(100% - 40px);max-width:420px;height:24px;position:relative;margin:50px auto;touch-action:manipulation}.Slider-Bar[data-jsx=\"1501953458\"]{-webkit-transition:opacity 0.2s;transition:opacity 0.2s;position:absolute;top:0;left:0;height:24px;background:#333}.Slider-TickLabel[data-jsx=\"1501953458\"]{color:#1c1c1c;font-family:FrutigerLTCom;font-size:12px;position:absolute;top:36px}.Slider-Handle[data-jsx=\"1501953458\"]{box-shadow:0 0 2px rgba(0, 0, 0, 0.5);position:absolute;top:0;left:0;width:22px;margin-left:-11px;margin-top:-7px;height:38px;background:#1c1c1c}.Slider-Label[data-jsx=\"1501953458\"]{-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);font-family:FrutigerLTCom;font-weight:700;position:absolute;left:0;-webkit-text-align:center;text-align:center;white-space:nowrap}.Slider-SubLabel[data-jsx=\"1501953458\"]{font-size:12px;font-weight:500}.Slider-Indicator[data-jsx=\"1501953458\"]{position:absolute;top:0;left:0;width:2px;margin-left:-1px;height:24px;background:#000}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Slider.js */"
        })
      );
    }
  }]);

  return Slider;
}(react["Component"]);

Slider_Slider.defaultProps = {
  min: 0,
  max: 100
};
/* harmony default export */ var Quiz_Slider = (Slider_Slider);
// CONCATENATED MODULE: ./src/components/Quiz/AnswerSlider.js
var AnswerSlider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function AnswerSlider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnswerSlider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AnswerSlider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var noop = function noop() {};

var AnswerSlider_AnswerSlider = function (_Component) {
  AnswerSlider__inherits(AnswerSlider, _Component);

  function AnswerSlider() {
    var _ref;

    var _temp, _this, _ret;

    AnswerSlider__classCallCheck(this, AnswerSlider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AnswerSlider__possibleConstructorReturn(this, (_ref = AnswerSlider.__proto__ || Object.getPrototypeOf(AnswerSlider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      config: { stiffness: 100, damping: 30, precision: 1 }
    }, _temp), AnswerSlider__possibleConstructorReturn(_this, _ret);
  }

  AnswerSlider__createClass(AnswerSlider, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          min = _props.min,
          max = _props.max;

      this.scale = linear_linear().domain([min, max]).range([0, 100]);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var min = nextProps.min,
          max = nextProps.max;

      this.scale.domain([min, max]);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          guessedValue = _props2.guessedValue,
          unit = _props2.unit,
          color = _props2.color,
          onComplete = _props2.onComplete;
      var config = this.state.config;
      var scale = this.scale;


      return react_default.a.createElement(
        "div",
        { className: "Slider", "data-jsx": 1239760976
        },
        react_default.a.createElement(
          react_motion["Motion"],
          {
            defaultStyle: { val: guessedValue },
            style: { val: Object(react_motion["spring"])(value, config) },
            onRest: onComplete
          },
          function (_ref2) {
            var val = _ref2.val;

            var x = scale(val) + "%";
            return react_default.a.createElement(
              "div",
              {
                "data-jsx": 1239760976
              },
              react_default.a.createElement("div", {
                className: "Slider-Bar",
                style: { width: x, backgroundColor: color },
                "data-jsx": 1239760976
              }),
              react_default.a.createElement("div", { className: "Slider-Indicator", style: { left: x }, "data-jsx": 1239760976
              }),
              react_default.a.createElement(
                "div",
                { className: "Slider-Label", style: { top: 32, left: x }, "data-jsx": 1239760976
                },
                Math.round(val),
                " ",
                unit,
                react_default.a.createElement(
                  "div",
                  { className: "Slider-SubLabel", "data-jsx": 1239760976
                  },
                  "Correct Answer"
                )
              )
            );
          }
        ),
        react_default.a.createElement("div", {
          className: "Slider-Indicator",
          style: { left: scale(guessedValue) + "%", opacity: 0.5 },
          "data-jsx": 1239760976
        }),
        react_default.a.createElement(
          "div",
          {
            className: "Slider-Label",
            style: { bottom: 32, left: scale(guessedValue) + "%", opacity: 0.5 },
            "data-jsx": 1239760976
          },
          react_default.a.createElement(
            "div",
            { className: "Slider-SubLabel", "data-jsx": 1239760976
            },
            "Your guess"
          ),
          guessedValue,
          " ",
          unit
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 1239760976,
          css: ".Slider[data-jsx=\"1239760976\"]{background:#fff;width:calc(100% - 40px);max-width:420px;height:24px;position:relative;margin:50px auto;touch-action:manipulation}.Slider-Bar[data-jsx=\"1239760976\"]{-webkit-transition:opacity 0.2s;transition:opacity 0.2s;position:absolute;top:0;left:0;height:24px;background:#333}.Slider-TickLabel[data-jsx=\"1239760976\"]{color:#444;font-family:FrutigerLTCom;font-size:12px;position:absolute;top:28px}.Slider-Handle[data-jsx=\"1239760976\"]{box-shadow:0 0 2px rgba(0, 0, 0, 0.5);position:absolute;top:0;left:0;width:22px;margin-left:-11px;margin-top:-4px;height:32px;background:#000}.Slider-Label[data-jsx=\"1239760976\"]{-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);font-family:FrutigerLTCom;font-weight:700;position:absolute;left:0;-webkit-text-align:center;text-align:center;white-space:nowrap}.Slider-SubLabel[data-jsx=\"1239760976\"]{font-size:12px;font-weight:500}.Slider-Indicator[data-jsx=\"1239760976\"]{position:absolute;top:0;left:0;width:2px;margin-left:-1px;height:24px;background:#000}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/AnswerSlider.js */"
        })
      );
    }
  }]);

  return AnswerSlider;
}(react["Component"]);

AnswerSlider_AnswerSlider.defaultProps = {
  min: 0,
  max: 100,
  onComplete: noop
};
/* harmony default export */ var Quiz_AnswerSlider = (AnswerSlider_AnswerSlider);
// CONCATENATED MODULE: ./src/components/Quiz/Button.js


/* harmony default export */ var Button = (function (_ref) {
  var onClick = _ref.onClick,
      active = _ref.active,
      label = _ref.label;
  return react_default.a.createElement(
    "button",
    { onClick: onClick, "data-jsx": 3970233047
    },
    react_default.a.createElement(
      "span",
      {
        "data-jsx": 3970233047
      },
      label
    ),
    react_default.a.createElement(
      "svg",
      { height: "38", width: "12", "data-jsx": 3970233047
      },
      react_default.a.createElement("path", { d: "M0,0,L12,19L0,38Z", "data-jsx": 3970233047
      })
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 3970233047,
      css: "button[data-jsx=\"3970233047\"]{border:none;background:transparent;margin:0;padding:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;cursor:pointer;min-width:160px}button.active[data-jsx=\"3970233047\"]{background:#585148;color:#fff}button[data-jsx=\"3970233047\"]:focus{outline:none}span[data-jsx=\"3970233047\"]{color:#fff;font-family:FrutigerLTCom;font-weight:700;font-size:16px;display:block;padding:0 18px;line-height:38px;background:#3C8287;box-sizing:border-box;height:38px;-webkit-flex-grow:1;-ms-flex-grow:1;flex-grow:1}svg[data-jsx=\"3970233047\"]{display:block}path[data-jsx=\"3970233047\"]{fill:#3C8287}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovQnV0dG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9nQixBQUdxQixBQUNPLEFBQ04sQUFDRixBQUVuQixBQUNxQixZQUhpQyxDQUhGLENBRXhCLEFBSUEsQ0FEdEIsS0FKeUMsWUFBTyxLQURnQixFQUdTLFFBSFUsU0FHYyxFQUhRLGNBR2UsZUFBd0IsZ0JBQTBCLGtCQUE0QixlQUhyRSxLQUdvRyxXQUgzRSxZQUdnRyxLQUh6RixRQUc4RyxtREFBTyIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9RdWl6L0J1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIvb3B0L2J1aWxkL3JlcG8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5leHBvcnQgZGVmYXVsdCAoeyBvbkNsaWNrLCBhY3RpdmUsIGxhYmVsIH0pID0+IChcbiAgPGJ1dHRvbiBvbkNsaWNrPXtvbkNsaWNrfT5cbiAgICA8c3Bhbj57bGFiZWx9PC9zcGFuPlxuICAgIDxzdmcgaGVpZ2h0PVwiMzhcIiB3aWR0aD1cIjEyXCI+XG4gICAgICA8cGF0aCBkPVwiTTAsMCxMMTIsMTlMMCwzOFpcIiAvPlxuICAgIDwvc3ZnPlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIGJ1dHRvbiB7XG4gICAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgcGFkZGluZzogMDtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICBtaW4td2lkdGg6IDE2MHB4O1xuICAgICAgfVxuICAgICAgYnV0dG9uLmFjdGl2ZSB7XG4gICAgICAgIGJhY2tncm91bmQ6ICM1ODUxNDg7XG4gICAgICAgIGNvbG9yOiAjZmZmO1xuICAgICAgfVxuICAgICAgYnV0dG9uOmZvY3VzIHtcbiAgICAgICAgb3V0bGluZTogbm9uZTtcbiAgICAgIH1cbiAgICAgIHNwYW4ge1xuICAgICAgICBjb2xvcjogI2ZmZjtcbiAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICAgIGZvbnQtc2l6ZTogMTZweDtcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgIHBhZGRpbmc6IDAgMThweDtcbiAgICAgICAgbGluZS1oZWlnaHQ6IDM4cHg7XG4gICAgICAgIGJhY2tncm91bmQ6ICMzQzgyODc7XG4gICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICAgIGhlaWdodDogMzhweDtcbiAgICAgICAgZmxleC1ncm93OiAxO1xuICAgICAgfVxuICAgICAgc3ZnIHtcbiAgICAgICAgZGlzcGxheTogYmxvY2tcbiAgICAgIH1cbiAgICAgIHBhdGgge1xuICAgICAgICBmaWxsOiAjM0M4Mjg3O1xuICAgICAgfVxuICAgIGB9PC9zdHlsZT5cbiAgPC9idXR0b24+XG4pO1xuIl19 */\n/*@ sourceURL=src/components/Quiz/Button.js */"
    })
  );
});
// CONCATENATED MODULE: ./src/components/Quiz/Progress.js



/* harmony default export */ var Progress = (function (_ref) {
  var text = _ref.text,
      step = _ref.step,
      totalSteps = _ref.totalSteps,
      _ref$showText = _ref.showText,
      showText = _ref$showText === undefined ? true : _ref$showText;
  return react_default.a.createElement(
    "div",
    { className: "progress", "data-jsx": 1621946671
    },
    react_default.a.createElement(
      "div",
      { className: "bar", "data-jsx": 1621946671
      },
      react_default.a.createElement("div", {
        className: "progressBar",
        style: { width: step / totalSteps * 100 + "%" },
        "data-jsx": 1621946671
      })
    ),
    showText && react_default.a.createElement(
      "div",
      { className: "text", "data-jsx": 1621946671
      },
      text,
      " \u2013 ",
      step,
      " of ",
      totalSteps
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 1621946671,
      css: ".progress[data-jsx=\"1621946671\"]{width:100%;position:fixed;top:0;left:0}.bar[data-jsx=\"1621946671\"]{height:8px;background:#C9DCDA;position:relative;width:100%}.progressBar[data-jsx=\"1621946671\"]{background:#3C8287;height:8px;position:absolute;top:0;left:0}.text[data-jsx=\"1621946671\"]{color:#646464;font-family:FrutigerLTCom;font-weight:300;font-size:14px;-webkit-text-align:center;text-align:center;margin:24px 0}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovUHJvZ3Jlc3MuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0JnQixBQUdvQixBQUNBLEFBRVEsQUFDTCxZQUpxQixBQUNJLEdBR1UsS0FEVixRQUhXLElBQ2dCLEFBRUEsR0FIQSxPQUlRLENBSkQsUUFFakYsQUFDeUYsT0FBZ0IsQ0FDQyxJQUZwRyxHQUMwRyxTQUNxQiw4Q0FBdUIsZUFBTyIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9RdWl6L1Byb2dyZXNzLmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5cbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcblxudHlwZSBQcm9wcyA9IHtcbiAgdGV4dD86IHN0cmluZyxcbiAgc3RlcDogbnVtYmVyLFxuICB0b3RhbFN0ZXBzOiBudW1iZXIsXG4gIHNob3dUZXh0OiBib29sZWFuXG59O1xuXG5leHBvcnQgZGVmYXVsdCAoeyB0ZXh0LCBzdGVwLCB0b3RhbFN0ZXBzLCBzaG93VGV4dCA9IHRydWUgfTogUHJvcHMpID0+XG4gIDxkaXYgY2xhc3NOYW1lPVwicHJvZ3Jlc3NcIj5cbiAgICA8ZGl2IGNsYXNzTmFtZT1cImJhclwiPlxuICAgICAgPGRpdlxuICAgICAgICBjbGFzc05hbWU9XCJwcm9ncmVzc0JhclwiXG4gICAgICAgIHN0eWxlPXt7IHdpZHRoOiBgJHtzdGVwIC8gdG90YWxTdGVwcyAqIDEwMH0lYCB9fVxuICAgICAgLz5cbiAgICA8L2Rpdj5cbiAgICB7c2hvd1RleHQgJiYgPGRpdiBjbGFzc05hbWU9XCJ0ZXh0XCI+e3RleHR9IOKAkyB7c3RlcH0gb2Yge3RvdGFsU3RlcHN9PC9kaXY+fVxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIC5wcm9ncmVzcyB7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBwb3NpdGlvbjogZml4ZWQ7XG4gICAgICAgIHRvcDogMDtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgIH1cbiAgICAgIC5iYXIge1xuICAgICAgICBoZWlnaHQ6IDhweDtcbiAgICAgICAgYmFja2dyb3VuZDogI0M5RENEQTtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICB3aWR0aDogMTAwJVxuICAgICAgfVxuICAgICAgLnByb2dyZXNzQmFyIHtcbiAgICAgICAgYmFja2dyb3VuZDogIzNDODI4NztcbiAgICAgICAgaGVpZ2h0OiA4cHg7XG4gICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgdG9wOiAwO1xuICAgICAgICBsZWZ0OiAwO1xuICAgICAgfVxuICAgICAgLnRleHQge1xuICAgICAgICBjb2xvcjogIzY0NjQ2NDtcbiAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgIGZvbnQtd2VpZ2h0OiAzMDA7XG4gICAgICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICAgICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICAgICAgICBtYXJnaW46IDI0cHggMDtcbiAgICAgIH1cbiAgICBgfTwvc3R5bGU+XG4gIDwvZGl2PjtcbiJdfQ== */\n/*@ sourceURL=src/components/Quiz/Progress.js */"
    })
  );
});
// EXTERNAL MODULE: ./src/static/emoji/1f913.svg
var _f913 = __webpack_require__(615);
var _f913_default = /*#__PURE__*/__webpack_require__.n(_f913);

// EXTERNAL MODULE: ./src/static/emoji/1f60a.svg
var _f60a = __webpack_require__(616);
var _f60a_default = /*#__PURE__*/__webpack_require__.n(_f60a);

// EXTERNAL MODULE: ./src/static/emoji/1f623.svg
var _f623 = __webpack_require__(617);
var _f623_default = /*#__PURE__*/__webpack_require__.n(_f623);

// EXTERNAL MODULE: ./src/static/emoji/1f640.svg
var _f640 = __webpack_require__(618);
var _f640_default = /*#__PURE__*/__webpack_require__.n(_f640);

// EXTERNAL MODULE: ./src/static/emoji/1f44f.svg
var _f44f = __webpack_require__(619);
var _f44f_default = /*#__PURE__*/__webpack_require__.n(_f44f);

// EXTERNAL MODULE: ./src/static/emoji/1f451.svg
var _f451 = __webpack_require__(261);
var _f451_default = /*#__PURE__*/__webpack_require__.n(_f451);

// EXTERNAL MODULE: ./src/static/emoji/1f38a.svg
var _f38a = __webpack_require__(620);
var _f38a_default = /*#__PURE__*/__webpack_require__.n(_f38a);

// EXTERNAL MODULE: ./src/static/emoji/1f44d.svg
var _f44d = __webpack_require__(621);
var _f44d_default = /*#__PURE__*/__webpack_require__.n(_f44d);

// EXTERNAL MODULE: ./src/static/emoji/1f393.svg
var _f393 = __webpack_require__(262);
var _f393_default = /*#__PURE__*/__webpack_require__.n(_f393);

// EXTERNAL MODULE: ./src/static/emoji/1f389.svg
var _f389 = __webpack_require__(622);
var _f389_default = /*#__PURE__*/__webpack_require__.n(_f389);

// EXTERNAL MODULE: ./src/static/emoji/1f44b.svg
var _f44b = __webpack_require__(623);
var _f44b_default = /*#__PURE__*/__webpack_require__.n(_f44b);

// EXTERNAL MODULE: ./src/static/emoji/1f955.svg
var _f955 = __webpack_require__(624);
var _f955_default = /*#__PURE__*/__webpack_require__.n(_f955);

// EXTERNAL MODULE: ./src/static/emoji/1f949.svg
var _f949 = __webpack_require__(625);
var _f949_default = /*#__PURE__*/__webpack_require__.n(_f949);

// CONCATENATED MODULE: ./src/components/Quiz/Emoji.js
















var emojis = {
  nerd: {
    src: _f913_default.a,
    name: "nerd face"
  },
  blush: {
    src: _f60a_default.a,
    name: "smiling face with smiling eyes"
  },
  persevere: {
    src: _f623_default.a,
    name: "persevering face"
  },
  scream_cat: {
    src: _f640_default.a,
    name: "weary cat face"
  },
  clap: { src: _f44f_default.a, name: "clap" },
  crown: { src: _f451_default.a, name: "crown" },
  confetti_ball: { src: _f38a_default.a, name: "confetti ball" },
  thumbsup: { src: _f44d_default.a, name: "thumbs up sign" },
  mortar_board: { src: _f393_default.a, name: "graduation cap" },
  tada: { src: _f389_default.a, name: "party popper" },
  wave: { src: _f44b_default.a, name: "wave sign" },
  carrot: { src: _f955_default.a, name: "carrot" },
  third_place: { src: _f949_default.a, name: "third place medal" }
};

var Emoji_Emoji = function Emoji(_ref) {
  var name = _ref.name;

  var emoji = emojis[name];

  return emoji ? react_default.a.createElement(
    "span",
    {
      "data-jsx": 3290681337
    },
    react_default.a.createElement("img", { src: emojis[name].src, alt: emojis[name].name + " emoji", "data-jsx": 3290681337
    }),
    react_default.a.createElement(style_default.a, {
      styleId: 3290681337,
      css: "img[data-jsx=\"3290681337\"]{display:inline-block;height:24px;width:24px;vertical-align:bottom}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Emoji.js */"
    })
  ) : null;
};

/* harmony default export */ var Quiz_Emoji = (Emoji_Emoji);
// CONCATENATED MODULE: ./src/components/Quiz/BouncyText.js




var bouncySpringPreset = {
  stiffness: 250,
  damping: 16
};

var BouncyText_BouncyAnswer = function BouncyAnswer(_ref) {
  var items = _ref.items;
  return react_default.a.createElement(
    "span",
    {
      "data-jsx": 687357468
    },
    react_default.a.createElement(
      react_motion["StaggeredMotion"],
      {
        defaultStyles: items.map(function (i) {
          return { y: 30 };
        }),
        styles: function styles(_styles) {
          return _styles ? _styles.map(function (_, i, arr) {
            return i === 0 ? { y: Object(react_motion["spring"])(0, bouncySpringPreset) } : {
              y: Object(react_motion["spring"])(arr[i - 1].y, bouncySpringPreset)
            };
          }) : [];
        }
      },
      function (styles) {
        return react_default.a.createElement(
          "span",
          { className: "items", "data-jsx": 687357468
          },
          items.map(function (item, i) {
            return react_default.a.createElement(
              "span",
              {
                key: i,
                className: "item",
                style: {
                  top: styles[i].y + "px",
                  opacity: 1 - styles[i].y / 30
                },
                "data-jsx": 687357468
              },
              item
            );
          })
        );
      }
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 687357468,
      css: ".items[data-jsx=\"687357468\"]{position:relative}.item[data-jsx=\"687357468\"]{position:relative}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovQm91bmN5VGV4dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3Q2dCLEFBRzZCLEFBQ0EsbUJBRFMsQUFDQSIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9RdWl6L0JvdW5jeVRleHQuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCB7IFN0YWdnZXJlZE1vdGlvbiwgc3ByaW5nIH0gZnJvbSBcInJlYWN0LW1vdGlvblwiO1xuXG5jb25zdCBib3VuY3lTcHJpbmdQcmVzZXQgPSB7XG4gIHN0aWZmbmVzczogMjUwLFxuICBkYW1waW5nOiAxNlxufTtcblxuY29uc3QgQm91bmN5QW5zd2VyID0gKHsgaXRlbXMgfTogeyBpdGVtczogQXJyYXk8YW55PiB9KSA9PlxuICA8c3Bhbj5cbiAgICA8U3RhZ2dlcmVkTW90aW9uXG4gICAgICBkZWZhdWx0U3R5bGVzPXtpdGVtcy5tYXAoaSA9PiAoeyB5OiAzMCB9KSl9XG4gICAgICBzdHlsZXM9e3N0eWxlcyA9PlxuICAgICAgICBzdHlsZXNcbiAgICAgICAgICA/IHN0eWxlcy5tYXAoKF8sIGksIGFycikgPT4ge1xuICAgICAgICAgICAgICByZXR1cm4gaSA9PT0gMFxuICAgICAgICAgICAgICAgID8geyB5OiBzcHJpbmcoMCwgYm91bmN5U3ByaW5nUHJlc2V0KSB9XG4gICAgICAgICAgICAgICAgOiB7XG4gICAgICAgICAgICAgICAgICAgIHk6IHNwcmluZyhhcnJbaSAtIDFdLnksIGJvdW5jeVNwcmluZ1ByZXNldClcbiAgICAgICAgICAgICAgICAgIH07XG4gICAgICAgICAgICB9KVxuICAgICAgICAgIDogW119XG4gICAgPlxuICAgICAge3N0eWxlcyA9PlxuICAgICAgICA8c3BhbiBjbGFzc05hbWU9XCJpdGVtc1wiPlxuICAgICAgICAgIHtpdGVtcy5tYXAoKGl0ZW0sIGkpID0+XG4gICAgICAgICAgICA8c3BhblxuICAgICAgICAgICAgICBrZXk9e2l9XG4gICAgICAgICAgICAgIGNsYXNzTmFtZT1cIml0ZW1cIlxuICAgICAgICAgICAgICBzdHlsZT17e1xuICAgICAgICAgICAgICAgIHRvcDogYCR7c3R5bGVzW2ldLnl9cHhgLFxuICAgICAgICAgICAgICAgIG9wYWNpdHk6IDEgLSBzdHlsZXNbaV0ueSAvIDMwXG4gICAgICAgICAgICAgIH19XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIHtpdGVtfVxuICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICl9XG4gICAgICAgIDwvc3Bhbj59XG4gICAgPC9TdGFnZ2VyZWRNb3Rpb24+XG4gICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAuaXRlbXMge1xuICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgfVxuICAgICAgICAuaXRlbSB7XG4gICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICB9XG4gICAgICBgfTwvc3R5bGU+XG4gIDwvc3Bhbj47XG5cbmV4cG9ydCBkZWZhdWx0IEJvdW5jeUFuc3dlcjtcbiJdfQ== */\n/*@ sourceURL=src/components/Quiz/BouncyText.js */"
    })
  );
};

/* harmony default export */ var BouncyText = (BouncyText_BouncyAnswer);
// CONCATENATED MODULE: ./src/components/Quiz/Question.js
var Question__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function Question__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Question__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Question__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Question_Question = function (_Component) {
  Question__inherits(Question, _Component);

  function Question() {
    var _ref;

    var _temp, _this, _ret;

    Question__classCallCheck(this, Question);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Question__possibleConstructorReturn(this, (_ref = Question.__proto__ || Object.getPrototypeOf(Question)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: null,
      submitted: false,
      answerAnimationDone: false
    }, _this.updateValue = function (value) {
      _this.setState(function (state) {
        return Object.assign({}, state, {
          value: value
        });
      });
    }, _this.submit = function () {
      var value = _this.state.value;
      var answerValue = _this.props.answerValue;

      _this.setState(function (state) {
        return Object.assign({}, state, {
          submitted: true,
          answerAnimationDone: value === answerValue
        });
      });
    }, _this.answerAnimationDone = function () {
      _this.setState(function (state) {
        return Object.assign({}, state, {
          answerAnimationDone: true
        });
      });
    }, _this.commit = function () {
      if (_this.state.value !== null) {
        _this.props.commit(_this.state.value);
      }
    }, _temp), Question__possibleConstructorReturn(_this, _ret);
  }

  Question__createClass(Question, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          answerAnimationDone = _state.answerAnimationDone,
          value = _state.value,
          submitted = _state.submitted;
      var _props = this.props,
          step = _props.step,
          question = _props.question,
          answerValue = _props.answerValue,
          nextStep = _props.nextStep,
          totalSteps = _props.totalSteps;


      return react_default.a.createElement(
        "div",
        { className: "question", "data-jsx": 1866378959
        },
        react_default.a.createElement(Progress, {
          text: submitted ? "Answer" : "Question",
          step: step,
          totalSteps: totalSteps,
          showText: true
        }),
        react_default.a.createElement(
          "div",
          { className: "title", "data-jsx": 1866378959
          },
          "How many millennials \u2026",
          react_default.a.createElement("br", {
            "data-jsx": 1866378959
          }),
          question
        ),
        submitted && value !== null ? react_default.a.createElement(Question_Answer, {
          guessedValue: value,
          actualValue: answerValue,
          onAnimationDone: this.answerAnimationDone,
          animationDone: answerAnimationDone,
          commit: this.commit,
          finalQuestion: nextStep === "outro"
        }) : react_default.a.createElement(Question_Guess, {
          value: value,
          updateValue: this.updateValue,
          submit: this.submit,
          started: value !== null
        }),
        react_default.a.createElement(style_default.a, {
          styleId: 1866378959,
          css: ".question[data-jsx=\"1866378959\"]{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;max-height:100vh;height:500px;padding:72px 20px 20px 20px;width:100%}.title[data-jsx=\"1866378959\"]{box-sizing:border-box;font-family:FrutigerLTCom;font-weight:300;font-size:18px;line-height:20px;-webkit-text-align:center;text-align:center;height:104px;min-height:104px;padding-bottom:24px;width:100%;max-width:630px}@media screen and (min-width:480px){.title[data-jsx=\"1866378959\"]{font-size:24px;line-height:26px;height:102px;min-height:102px}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Question.js */"
        })
      );
    }
  }]);

  return Question;
}(react["Component"]);

/* harmony default export */ var Quiz_Question = (Question_Question);


var Question_Guess = function Guess(_ref2) {
  var value = _ref2.value,
      updateValue = _ref2.updateValue,
      submit = _ref2.submit,
      started = _ref2.started;
  return react_default.a.createElement(
    "div",
    { className: "guess", "data-jsx": 1007390995
    },
    react_default.a.createElement(
      "div",
      { className: "slider", "data-jsx": 1007390995
      },
      react_default.a.createElement(Quiz_Slider, {
        min: 0,
        max: 100,
        value: value,
        onChange: updateValue,
        unit: "%",
        color: "#3C8287"
      })
    ),
    react_default.a.createElement(
      "div",
      { className: "controls", "data-jsx": 1007390995
      },
      started && react_default.a.createElement(Button, { label: "Submit answer", onClick: submit })
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 1007390995,
      css: ".guess[data-jsx=\"1007390995\"]{width:100%;height:100%;position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slider[data-jsx=\"1007390995\"]{position:absolute;top:24px;left:0;width:100%}.controls[data-jsx=\"1007390995\"]{max-width:320px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovUXVlc3Rpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0pnQixBQUdvQixBQUNPLEFBQ0YsWUFGZ0IsS0FFTSxFQURGLE1BRHVCLElBQ1AsUUFBb0IsT0FEUyxLQUNGLDhDQUNWLDJCQUYyQyxzREFHekYsMkJBSDJILDRFQUdwSCx5QkFIZ0osaUdBQU8iLCJmaWxlIjoic3JjL2NvbXBvbmVudHMvUXVpei9RdWVzdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIvb3B0L2J1aWxkL3JlcG8iLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgU2xpZGVyIGZyb20gXCIuL1NsaWRlclwiO1xuaW1wb3J0IEFuc3dlclNsaWRlciBmcm9tIFwiLi9BbnN3ZXJTbGlkZXJcIjtcbmltcG9ydCBCdXR0b24gZnJvbSBcIi4vQnV0dG9uXCI7XG5pbXBvcnQgUHJvZ3Jlc3MgZnJvbSBcIi4vUHJvZ3Jlc3NcIjtcbmltcG9ydCBFbW9qaSBmcm9tIFwiLi9FbW9qaVwiO1xuaW1wb3J0IEJvdW5jeVRleHQgZnJvbSBcIi4vQm91bmN5VGV4dFwiO1xuXG50eXBlIFF1ZXN0aW9uUHJvcHMgPSB7XG4gIHN0ZXA6IG51bWJlcixcbiAgcXVlc3Rpb246IHN0cmluZyxcbiAgYW5zd2VyVmFsdWU6IG51bWJlcixcbiAgY29tbWl0OiAodmFsdWU6IG51bWJlcikgPT4gdm9pZCxcbiAgbmV4dFN0ZXA6IHN0cmluZyxcbiAgdG90YWxTdGVwczogbnVtYmVyXG59O1xuXG50eXBlIFF1ZXN0aW9uU3RhdGUgPSB7XG4gIHZhbHVlOiBudW1iZXIgfCBudWxsLFxuICBzdWJtaXR0ZWQ6IGJvb2xlYW4sXG4gIGFuc3dlckFuaW1hdGlvbkRvbmU6IGJvb2xlYW5cbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFF1ZXN0aW9uIGV4dGVuZHMgQ29tcG9uZW50PFxuICB2b2lkLFxuICBRdWVzdGlvblByb3BzLFxuICBRdWVzdGlvblN0YXRlXG4+IHtcbiAgc3RhdGUgPSB7XG4gICAgdmFsdWU6IG51bGwsXG4gICAgc3VibWl0dGVkOiBmYWxzZSxcbiAgICBhbnN3ZXJBbmltYXRpb25Eb25lOiBmYWxzZVxuICB9O1xuXG4gIHVwZGF0ZVZhbHVlID0gKHZhbHVlOiBudW1iZXIpID0+IHtcbiAgICB0aGlzLnNldFN0YXRlKChzdGF0ZTogUXVlc3Rpb25TdGF0ZSk6IFF1ZXN0aW9uU3RhdGUgPT4gKHtcbiAgICAgIC4uLnN0YXRlLFxuICAgICAgdmFsdWVcbiAgICB9KSk7XG4gIH07XG5cbiAgc3VibWl0ID0gKCkgPT4ge1xuICAgIGNvbnN0IHsgdmFsdWUgfSA9IHRoaXMuc3RhdGU7XG4gICAgY29uc3QgeyBhbnN3ZXJWYWx1ZSB9ID0gdGhpcy5wcm9wcztcbiAgICB0aGlzLnNldFN0YXRlKChzdGF0ZTogUXVlc3Rpb25TdGF0ZSk6IFF1ZXN0aW9uU3RhdGUgPT4gKHtcbiAgICAgIC4uLnN0YXRlLFxuICAgICAgc3VibWl0dGVkOiB0cnVlLFxuICAgICAgYW5zd2VyQW5pbWF0aW9uRG9uZTogdmFsdWUgPT09IGFuc3dlclZhbHVlXG4gICAgfSkpO1xuICB9O1xuXG4gIGFuc3dlckFuaW1hdGlvbkRvbmUgPSAoKSA9PiB7XG4gICAgdGhpcy5zZXRTdGF0ZSgoc3RhdGU6IFF1ZXN0aW9uU3RhdGUpOiBRdWVzdGlvblN0YXRlID0+ICh7XG4gICAgICAuLi5zdGF0ZSxcbiAgICAgIGFuc3dlckFuaW1hdGlvbkRvbmU6IHRydWVcbiAgICB9KSk7XG4gIH07XG5cbiAgY29tbWl0ID0gKCkgPT4ge1xuICAgIGlmICh0aGlzLnN0YXRlLnZhbHVlICE9PSBudWxsKSB7XG4gICAgICB0aGlzLnByb3BzLmNvbW1pdCh0aGlzLnN0YXRlLnZhbHVlKTtcbiAgICB9XG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgYW5zd2VyQW5pbWF0aW9uRG9uZSwgdmFsdWUsIHN1Ym1pdHRlZCB9ID0gdGhpcy5zdGF0ZTtcbiAgICBjb25zdCB7IHN0ZXAsIHF1ZXN0aW9uLCBhbnN3ZXJWYWx1ZSwgbmV4dFN0ZXAsIHRvdGFsU3RlcHMgfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJxdWVzdGlvblwiPlxuICAgICAgICA8UHJvZ3Jlc3NcbiAgICAgICAgICB0ZXh0PXtzdWJtaXR0ZWQgPyBcIkFuc3dlclwiIDogXCJRdWVzdGlvblwifVxuICAgICAgICAgIHN0ZXA9e3N0ZXB9XG4gICAgICAgICAgdG90YWxTdGVwcz17dG90YWxTdGVwc31cbiAgICAgICAgICBzaG93VGV4dFxuICAgICAgICAvPlxuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInRpdGxlXCI+XG4gICAgICAgICAgSG93IG1hbnkgbWlsbGVubmlhbHMg4oCmPGJyIC8+XG4gICAgICAgICAge3F1ZXN0aW9ufVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAge3N1Ym1pdHRlZCAmJiB2YWx1ZSAhPT0gbnVsbFxuICAgICAgICAgID8gPEFuc3dlclxuICAgICAgICAgICAgICBndWVzc2VkVmFsdWU9e3ZhbHVlfVxuICAgICAgICAgICAgICBhY3R1YWxWYWx1ZT17YW5zd2VyVmFsdWV9XG4gICAgICAgICAgICAgIG9uQW5pbWF0aW9uRG9uZT17dGhpcy5hbnN3ZXJBbmltYXRpb25Eb25lfVxuICAgICAgICAgICAgICBhbmltYXRpb25Eb25lPXthbnN3ZXJBbmltYXRpb25Eb25lfVxuICAgICAgICAgICAgICBjb21taXQ9e3RoaXMuY29tbWl0fVxuICAgICAgICAgICAgICBmaW5hbFF1ZXN0aW9uPXtuZXh0U3RlcCA9PT0gXCJvdXRyb1wifVxuICAgICAgICAgICAgLz5cbiAgICAgICAgICA6IDxHdWVzc1xuICAgICAgICAgICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICAgICAgICAgIHVwZGF0ZVZhbHVlPXt0aGlzLnVwZGF0ZVZhbHVlfVxuICAgICAgICAgICAgICBzdWJtaXQ9e3RoaXMuc3VibWl0fVxuICAgICAgICAgICAgICBzdGFydGVkPXt2YWx1ZSAhPT0gbnVsbH1cbiAgICAgICAgICAgIC8+fVxuXG4gICAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgICAucXVlc3Rpb24ge1xuICAgICAgICAgICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICAgIG1heC1oZWlnaHQ6IDEwMHZoO1xuICAgICAgICAgICAgaGVpZ2h0OiA1MDBweDtcbiAgICAgICAgICAgIHBhZGRpbmc6IDcycHggMjBweCAyMHB4IDIwcHg7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgICAgLnRpdGxlIHtcbiAgICAgICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICAgICAgICBmb250LWZhbWlseTogRnJ1dGlnZXJMVENvbTtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiAzMDA7XG4gICAgICAgICAgICBmb250LXNpemU6IDE4cHg7XG4gICAgICAgICAgICBsaW5lLWhlaWdodDogMjBweDtcbiAgICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICAgIGhlaWdodDogMTA0cHg7XG4gICAgICAgICAgICBtaW4taGVpZ2h0OiAxMDRweDtcbiAgICAgICAgICAgIHBhZGRpbmctYm90dG9tOiAyNHB4O1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgICBtYXgtd2lkdGg6IDYzMHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA0ODBweCkge1xuICAgICAgICAgICAgLnRpdGxlIHtcbiAgICAgICAgICAgICAgZm9udC1zaXplOiAyNHB4O1xuICAgICAgICAgICAgICBsaW5lLWhlaWdodDogMjZweDtcbiAgICAgICAgICAgICAgaGVpZ2h0OiAxMDJweDtcbiAgICAgICAgICAgICAgbWluLWhlaWdodDogMTAycHg7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG5cbmNvbnN0IEd1ZXNzID0gKHsgdmFsdWUsIHVwZGF0ZVZhbHVlLCBzdWJtaXQsIHN0YXJ0ZWQgfSkgPT5cbiAgPGRpdiBjbGFzc05hbWU9XCJndWVzc1wiPlxuICAgIDxkaXYgY2xhc3NOYW1lPVwic2xpZGVyXCI+XG4gICAgICA8U2xpZGVyXG4gICAgICAgIG1pbj17MH1cbiAgICAgICAgbWF4PXsxMDB9XG4gICAgICAgIHZhbHVlPXt2YWx1ZX1cbiAgICAgICAgb25DaGFuZ2U9e3VwZGF0ZVZhbHVlfVxuICAgICAgICB1bml0PVwiJVwiXG4gICAgICAgIGNvbG9yPVwiIzNDODI4N1wiXG4gICAgICAvPlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3NOYW1lPVwiY29udHJvbHNcIj5cbiAgICAgIHtzdGFydGVkICYmIDxCdXR0b24gbGFiZWw9XCJTdWJtaXQgYW5zd2VyXCIgb25DbGljaz17c3VibWl0fSAvPn1cbiAgICA8L2Rpdj5cbiAgICA8c3R5bGUganN4PntgXG4gICAgICAuZ3Vlc3Mge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICB9XG4gICAgICAuc2xpZGVyIHtcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgICB0b3A6IDI0cHg7XG4gICAgICAgIGxlZnQ6IDA7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgfVxuICAgICAgLmNvbnRyb2xzIHtcbiAgICAgICAgbWF4LXdpZHRoOiAzMjBweDtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblxuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgIH1cbiAgICBgfTwvc3R5bGU+XG4gIDwvZGl2PjtcblxuY29uc3QgQW5zd2VyRmVlZGJhY2sgPSAoeyBkaWZmIH0pID0+XG4gIDxkaXY+XG4gICAge2RpZmYgPCAxMFxuICAgICAgPyA8Qm91bmN5VGV4dCBpdGVtcz17W1wiU3BvdCBcIiwgXCJvblwiLCBcIiEgXCIsIDxFbW9qaSBuYW1lPVwibmVyZFwiIC8+XX0gLz5cbiAgICAgIDogZGlmZiA8IDI1XG4gICAgICAgID8gPEJvdW5jeVRleHQgaXRlbXM9e1tcIk5pY2VcIiwgXCIhIFwiLCA8RW1vamkgbmFtZT1cImJsdXNoXCIgLz5dfSAvPlxuICAgICAgICA6IGRpZmYgPCA1MFxuICAgICAgICAgID8gPEJvdW5jeVRleHRcbiAgICAgICAgICAgICAgaXRlbXM9e1tcIk5vdCBcIiwgXCJncmVhdFwiLCBcIiEgXCIsIDxFbW9qaSBuYW1lPVwicGVyc2V2ZXJlXCIgLz5dfVxuICAgICAgICAgICAgLz5cbiAgICAgICAgICA6IDxCb3VuY3lUZXh0XG4gICAgICAgICAgICAgIGl0ZW1zPXtbXG4gICAgICAgICAgICAgICAgXCJOb3QgXCIsXG4gICAgICAgICAgICAgICAgXCJldmVuIFwiLFxuICAgICAgICAgICAgICAgIFwiY2xvc2VcIixcbiAgICAgICAgICAgICAgICBcIiEgXCIsXG4gICAgICAgICAgICAgICAgPEVtb2ppIG5hbWU9XCJzY3JlYW1fY2F0XCIgLz5cbiAgICAgICAgICAgICAgXX1cbiAgICAgICAgICAgIC8+fVxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIGRpdiB7XG4gICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICAgIGZvbnQtc2l6ZTogMThweDtcbiAgICAgIH1cbiAgICBgfTwvc3R5bGU+XG4gIDwvZGl2PjtcblxudHlwZSBBbnN3ZXJQcm9wcyA9IHtcbiAgZ3Vlc3NlZFZhbHVlOiBudW1iZXIsXG4gIGFjdHVhbFZhbHVlOiBudW1iZXIsXG4gIG9uQW5pbWF0aW9uRG9uZTogKCkgPT4gdm9pZCxcbiAgYW5pbWF0aW9uRG9uZTogYm9vbGVhbixcbiAgY29tbWl0OiAoKSA9PiB2b2lkLFxuICBmaW5hbFF1ZXN0aW9uOiBib29sZWFuXG59O1xuXG5jb25zdCBBbnN3ZXIgPSAoe1xuICBndWVzc2VkVmFsdWUsXG4gIGFjdHVhbFZhbHVlLFxuICBvbkFuaW1hdGlvbkRvbmUsXG4gIGFuaW1hdGlvbkRvbmUsXG4gIGNvbW1pdCxcbiAgZmluYWxRdWVzdGlvblxufTogQW5zd2VyUHJvcHMpID0+XG4gIDxkaXYgY2xhc3NOYW1lPVwiYW5zd2VyXCI+XG4gICAgPGRpdiBjbGFzc05hbWU9XCJzbGlkZXJcIj5cbiAgICAgIDxBbnN3ZXJTbGlkZXJcbiAgICAgICAgbWluPXswfVxuICAgICAgICBtYXg9ezEwMH1cbiAgICAgICAgZ3Vlc3NlZFZhbHVlPXtndWVzc2VkVmFsdWV9XG4gICAgICAgIHZhbHVlPXthY3R1YWxWYWx1ZX1cbiAgICAgICAgdW5pdD1cIiVcIlxuICAgICAgICBjb2xvcj1cIiMzQzgyODdcIlxuICAgICAgICB0PXtzID0+IHN9XG4gICAgICAgIG9uQ29tcGxldGU9e29uQW5pbWF0aW9uRG9uZX1cbiAgICAgIC8+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzc05hbWU9XCJjb250cm9sc1wiPlxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJmZWVkYmFja1wiPlxuICAgICAgICB7YW5pbWF0aW9uRG9uZSAmJlxuICAgICAgICAgIDxBbnN3ZXJGZWVkYmFjayBkaWZmPXtNYXRoLmFicyhhY3R1YWxWYWx1ZSAtIGd1ZXNzZWRWYWx1ZSl9IC8+fVxuICAgICAgPC9kaXY+XG4gICAgICB7YW5pbWF0aW9uRG9uZSAmJlxuICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgbGFiZWw9e2ZpbmFsUXVlc3Rpb24gPyBcIlNlZSByZXN1bHRzXCIgOiBcIk5leHQgcXVlc3Rpb25cIn1cbiAgICAgICAgICBvbkNsaWNrPXtjb21taXR9XG4gICAgICAgIC8+fVxuICAgIDwvZGl2PlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIC5hbnN3ZXIge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICB9XG4gICAgICAuc2xpZGVyIHtcbiAgICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuXG4gICAgICAgIHRvcDogMjRweDtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICB9XG4gICAgICAuZmVlZGJhY2sge1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAzMnB4O1xuICAgICAgfVxuICAgICAgLmNvbnRyb2xzIHtcbiAgICAgICAgbWF4LXdpZHRoOiAzMjBweDtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L2Rpdj47XG4iXX0= */\n/*@ sourceURL=src/components/Quiz/Question.js */"
    })
  );
};

var Question_AnswerFeedback = function AnswerFeedback(_ref3) {
  var diff = _ref3.diff;
  return react_default.a.createElement(
    "div",
    {
      "data-jsx": 2318775402
    },
    diff < 10 ? react_default.a.createElement(BouncyText, { items: ["Spot ", "on", "! ", react_default.a.createElement(Quiz_Emoji, { name: "nerd" })] }) : diff < 25 ? react_default.a.createElement(BouncyText, { items: ["Nice", "! ", react_default.a.createElement(Quiz_Emoji, { name: "blush" })] }) : diff < 50 ? react_default.a.createElement(BouncyText, {
      items: ["Not ", "great", "! ", react_default.a.createElement(Quiz_Emoji, { name: "persevere" })]
    }) : react_default.a.createElement(BouncyText, {
      items: ["Not ", "even ", "close", "! ", react_default.a.createElement(Quiz_Emoji, { name: "scream_cat" })]
    }),
    react_default.a.createElement(style_default.a, {
      styleId: 2318775402,
      css: "div[data-jsx=\"2318775402\"]{-webkit-text-align:center;text-align:center;font-family:FrutigerLTCom;font-weight:700;font-size:18px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Question.js */"
    })
  );
};

var Question_Answer = function Answer(_ref4) {
  var guessedValue = _ref4.guessedValue,
      actualValue = _ref4.actualValue,
      onAnimationDone = _ref4.onAnimationDone,
      animationDone = _ref4.animationDone,
      commit = _ref4.commit,
      finalQuestion = _ref4.finalQuestion;
  return react_default.a.createElement(
    "div",
    { className: "answer", "data-jsx": 2552925287
    },
    react_default.a.createElement(
      "div",
      { className: "slider", "data-jsx": 2552925287
      },
      react_default.a.createElement(Quiz_AnswerSlider, {
        min: 0,
        max: 100,
        guessedValue: guessedValue,
        value: actualValue,
        unit: "%",
        color: "#3C8287",
        t: function t(s) {
          return s;
        },
        onComplete: onAnimationDone
      })
    ),
    react_default.a.createElement(
      "div",
      { className: "controls", "data-jsx": 2552925287
      },
      react_default.a.createElement(
        "div",
        { className: "feedback", "data-jsx": 2552925287
        },
        animationDone && react_default.a.createElement(Question_AnswerFeedback, { diff: Math.abs(actualValue - guessedValue) })
      ),
      animationDone && react_default.a.createElement(Button, {
        label: finalQuestion ? "See results" : "Next question",
        onClick: commit
      })
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 2552925287,
      css: ".answer[data-jsx=\"2552925287\"]{width:100%;height:100%;position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slider[data-jsx=\"2552925287\"]{position:absolute;top:24px;left:0;width:100%}.feedback[data-jsx=\"2552925287\"]{margin-bottom:32px}.controls[data-jsx=\"2552925287\"]{max-width:320px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Question.js */"
    })
  );
};
// EXTERNAL MODULE: ./src/static/emoji/1f914.svg
var _f914 = __webpack_require__(626);
var _f914_default = /*#__PURE__*/__webpack_require__.n(_f914);

// CONCATENATED MODULE: ./src/components/Quiz/Intro.js





var Intro_Intro = function Intro(_ref) {
  var title = _ref.title,
      text = _ref.text,
      start = _ref.start;
  return react_default.a.createElement(
    "div",
    { className: "intro", "data-jsx": 642393532
    },
    react_default.a.createElement("img", { className: "splash", src: _f914_default.a, alt: "Thinking face emoji", "data-jsx": 642393532
    }),
    react_default.a.createElement(
      "div",
      { className: "text", "data-jsx": 642393532
      },
      react_default.a.createElement(
        "h1",
        { className: "title", "data-jsx": 642393532
        },
        title
      ),
      react_default.a.createElement(
        "div",
        { className: "subtitle", "data-jsx": 642393532
        },
        text
      )
    ),
    react_default.a.createElement(
      "div",
      { className: "controls", "data-jsx": 642393532
      },
      react_default.a.createElement(Button, { label: "Start the quiz", onClick: start })
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 642393532,
      css: ".intro[data-jsx=\"642393532\"]{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100vh;padding:20px}.splash[data-jsx=\"642393532\"]{width:140px;height:140px}.text[data-jsx=\"642393532\"]{width:100%;padding:5vw 0 5vw 0}.title[data-jsx=\"642393532\"]{font-family:FrutigerLTCom;font-weight:300;font-size:24px;line-height:26px;-webkit-text-align:center;text-align:center;margin:0 0 16px 0;width:100%}.subtitle[data-jsx=\"642393532\"]{font-family:FrutigerLTCom;font-weight:300;font-size:16px;line-height:24px;-webkit-text-align:center;text-align:center;width:100%;max-width:640px;margin:0 auto}.controls[data-jsx=\"642393532\"]{max-width:320px;margin:0 auto 0 auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Intro.js */"
    })
  );
};

/* harmony default export */ var Quiz_Intro = (Intro_Intro);
// CONCATENATED MODULE: ./src/components/Quiz/ButtonSecondary.js


/* harmony default export */ var ButtonSecondary = (function (_ref) {
  var onClick = _ref.onClick,
      active = _ref.active,
      label = _ref.label;
  return react_default.a.createElement(
    "button",
    { onClick: onClick, "data-jsx": 3439051610
    },
    react_default.a.createElement(
      "span",
      {
        "data-jsx": 3439051610
      },
      react_default.a.createElement(
        "svg",
        { height: "10", width: "6", "data-jsx": 3439051610
        },
        react_default.a.createElement("path", { transform: "translate(1,1)", d: "M0,0L4,4L0,8", "data-jsx": 3439051610
        })
      ),
      label
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 3439051610,
      css: "button[data-jsx=\"3439051610\"]{border:none;background:transparent;margin:0;padding:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;cursor:pointer;min-width:160px}button.active[data-jsx=\"3439051610\"]{background:#585148;color:#fff}button[data-jsx=\"3439051610\"]:focus{outline:none}span[data-jsx=\"3439051610\"]{color:#007099;font-family:FrutigerLTCom;font-weight:500;font-size:14px;display:block;padding:0 18px;line-height:38px;box-sizing:border-box;height:38px;-webkit-flex-grow:1;-ms-flex-grow:1;flex-grow:1;position:relative;-webkit-text-indent:-12px;text-indent:-12px}svg[data-jsx=\"3439051610\"]{display:inline-block;margin-right:6px}path[data-jsx=\"3439051610\"]{fill:none;stroke:#007099;stroke-width:2}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovQnV0dG9uU2Vjb25kYXJ5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNnQixBQUdxQixBQUNPLEFBQ04sQUFDQyxBQUNPLEFBQ1gsV0FBd0IsRUFMVSxDQUV4QixDQUM2QixLQUZWLEVBR1EsS0FDVyxLQUpaLEtBRGdCLEdBSVIsRUFEb0IsQ0FFVCxJQUxnQixXQUFzQixDQUdMLGdCQUF1QixlQUF3QixnQkFBMEIsa0JBQStCLFlBSDNFLFdBR2dHLEtBSHZFLFFBRzRGLFNBSHJGLDBDQUdnSCxtQkFBMkIsOENBQU8iLCJmaWxlIjoic3JjL2NvbXBvbmVudHMvUXVpei9CdXR0b25TZWNvbmRhcnkuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuZXhwb3J0IGRlZmF1bHQgKHsgb25DbGljaywgYWN0aXZlLCBsYWJlbCB9KSA9PlxuICA8YnV0dG9uIG9uQ2xpY2s9e29uQ2xpY2t9PlxuICAgIDxzcGFuPlxuICAgICAgPHN2ZyBoZWlnaHQ9XCIxMFwiIHdpZHRoPVwiNlwiPlxuICAgICAgICA8cGF0aCB0cmFuc2Zvcm09XCJ0cmFuc2xhdGUoMSwxKVwiIGQ9XCJNMCwwTDQsNEwwLDhcIiAvPlxuICAgICAgPC9zdmc+XG4gICAgICB7bGFiZWx9XG4gICAgPC9zcGFuPlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIGJ1dHRvbiB7XG4gICAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgcGFkZGluZzogMDtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICAgICBtaW4td2lkdGg6IDE2MHB4O1xuICAgICAgfVxuICAgICAgYnV0dG9uLmFjdGl2ZSB7XG4gICAgICAgIGJhY2tncm91bmQ6ICM1ODUxNDg7XG4gICAgICAgIGNvbG9yOiAjZmZmO1xuICAgICAgfVxuICAgICAgYnV0dG9uOmZvY3VzIHtcbiAgICAgICAgb3V0bGluZTogbm9uZTtcbiAgICAgIH1cbiAgICAgIHNwYW4ge1xuICAgICAgICBjb2xvcjogIzAwNzA5OTtcbiAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA1MDA7XG4gICAgICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgIHBhZGRpbmc6IDAgMThweDtcbiAgICAgICAgbGluZS1oZWlnaHQ6IDM4cHg7XG4gICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICAgIGhlaWdodDogMzhweDtcbiAgICAgICAgZmxleC1ncm93OiAxO1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIHRleHQtaW5kZW50OiAtMTJweDtcbiAgICAgIH1cbiAgICAgIHN2ZyB7XG4gICAgICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAgICAgbWFyZ2luLXJpZ2h0OiA2cHg7XG4gICAgICB9XG4gICAgICBwYXRoIHtcbiAgICAgICAgZmlsbDogbm9uZTtcbiAgICAgICAgc3Ryb2tlOiAjMDA3MDk5O1xuICAgICAgICBzdHJva2Utd2lkdGg6IDI7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L2J1dHRvbj47XG4iXX0= */\n/*@ sourceURL=src/components/Quiz/ButtonSecondary.js */"
    })
  );
});
// CONCATENATED MODULE: ./src/components/Quiz/SocialIcons.js



var SocialIcons_SocialButtons = function SocialButtons(_ref) {
  var url = _ref.url,
      text = _ref.text;
  return react_default.a.createElement(
    "div",
    {
      "data-jsx": 304760133
    },
    react_default.a.createElement(SocialIcons_Facebook, { url: url }),
    react_default.a.createElement(SocialIcons_Twitter, { url: url, text: text }),
    react_default.a.createElement(SocialIcons_Linkedin, { url: url, text: text }),
    react_default.a.createElement(style_default.a, {
      styleId: 304760133,
      css: "div[data-jsx=\"304760133\"]{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between;height:32px;vertical-align:middle;width:120px;margin-left:12px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/SocialIcons.js */"
    })
  );
};

var SocialIcons_Facebook = function Facebook(_ref2) {
  var url = _ref2.url;
  return react_default.a.createElement(
    "a",
    {
      href: "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url),
      target: "_blank",
      rel: "noopener noreferrer",
      title: "Facebook"
    },
    react_default.a.createElement(
      "svg",
      { width: "32px", height: "32px", viewBox: "0 0 32 32", "data-jsx": 4009752810
      },
      react_default.a.createElement("polygon", { fill: "#3C5A99", points: "32 32 0 32 0 0 32 0", "data-jsx": 4009752810
      }),
      react_default.a.createElement("path", {
        d: "M19.7187556,28.496096 L19.7187556,17.5468764 L23.3906311,17.5468764 L23.9414044,13.2823111 L19.7187556,13.2823111 L19.7187556,10.5576178 C19.7187556,9.32227556 20.0585956,8.47950222 21.8300267,8.47950222 L24.0897244,8.47950222 L24.0897244,4.66407111 C23.6990933,4.61232 22.3592533,4.49607111 20.7967467,4.49607111 C17.5389387,4.49607111 15.3094382,6.48631111 15.3094382,10.1337422 L15.3094382,13.2802489 L11.6258133,13.2802489 L11.6258133,17.5468764 L15.3094382,17.5468764 L15.3094382,28.496096 L19.7187556,28.496096 L19.7187556,28.496096 Z",
        fill: "#FFFFFF",
        "data-jsx": 4009752810
      }),
      react_default.a.createElement(style_default.a, {
        styleId: 4009752810,
        css: "svg[data-jsx=\"4009752810\"]{display:block;height:32px;width:32px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/SocialIcons.js */"
      })
    )
  );
};

var SocialIcons_Twitter = function Twitter(_ref3) {
  var url = _ref3.url,
      text = _ref3.text;
  return react_default.a.createElement(
    "a",
    {
      href: "https://www.twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url) + "&via=" + "UBS_CIO",
      target: "_blank",
      rel: "noopener noreferrer",
      title: "Twitter",
      "data-jsx": 4009752810
    },
    react_default.a.createElement(
      "svg",
      { width: "32px", height: "32px", viewBox: "0 0 32 32", "data-jsx": 4009752810
      },
      react_default.a.createElement("polygon", { fill: "#41ABE1", points: "32 32 0 32 0 0 32 0", "data-jsx": 4009752810
      }),
      react_default.a.createElement("path", {
        d: "M25.8436267,9.89550222 C25.1209778,10.21776 24.3397156,10.4335644 23.5194133,10.5302578 C24.3592533,10.0302578 24.9959644,9.23825778 25.3006578,8.29393778 C24.5134933,8.75594667 23.6502756,9.09187556 22.7322489,9.27443556 C21.9920711,8.49219556 20.9451911,8 19.78112,8 C17.5506578,8 15.742064,9.80762667 15.742064,12.0401244 C15.742064,12.3584711 15.780032,12.6661333 15.8495004,12.9560711 C12.494032,12.7939378 9.51753067,11.1885689 7.52821867,8.74033778 C7.18143644,9.33596444 6.98028089,10.0303822 6.98028089,10.7705244 C6.98028089,12.1719111 7.69609422,13.4101511 8.77821867,14.1299022 C8.11809422,14.1104 7.493936,13.92784 6.94621867,13.6260267 L6.94621867,13.6739022 C6.94621867,15.6318773 8.33978133,17.2617511 10.1854364,17.6329084 C9.84950044,17.7266578 9.49206222,17.7735324 9.12393778,17.7735324 C8.86425067,17.7735324 8.61218667,17.750096 8.36425067,17.7071893 C8.87987556,19.3047822 10.3700942,20.4766578 12.1357191,20.5099093 C10.7539058,21.5918773 9.01368711,22.2384409 7.11818667,22.2384409 C6.791968,22.2384409 6.47165511,22.2189084 6.15624889,22.1876587 C7.94237333,23.3321902 10.0663751,24.002096 12.3496249,24.002096 C19.7773511,24.002096 23.8417778,17.8439076 23.8417778,12.5099022 C23.8417778,12.3341511 23.8398756,12.1602844 23.8261511,11.9884089 C24.6171911,11.4180978 25.3008178,10.70816 25.8398756,9.8976 L25.8437156,9.8976 L25.8435911,9.89555556 L25.8436267,9.89550222 Z",
        fill: "#FFFFFF",
        "data-jsx": 4009752810
      })
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 4009752810,
      css: "svg[data-jsx=\"4009752810\"]{display:block;height:32px;width:32px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/SocialIcons.js */"
    })
  );
};

var SocialIcons_Linkedin = function Linkedin(_ref4) {
  var url = _ref4.url,
      text = _ref4.text;
  return react_default.a.createElement(
    "a",
    {
      href: "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(url) + "&summary=" + encodeURIComponent(text),
      target: "_blank",
      rel: "noopener noreferrer",
      title: "Linkedin"
    },
    react_default.a.createElement(
      "svg",
      { width: "32px", height: "32px", viewBox: "0 0 32 32", "data-jsx": 4009752810
      },
      react_default.a.createElement("polygon", { fill: "#0475B7", points: "32 32 0 32 0 0 32 0", "data-jsx": 4009752810
      }),
      react_default.a.createElement("path", {
        d: "M6.09543822,25.9809404 L10.3329707,25.9809404 L10.3329707,12.4067911 L6.09543822,12.4067911 L6.09543822,25.9809404 L6.09543822,25.9809404 Z M8.23778311,5.86590222 C6.79100089,5.86590222 5.84375111,6.87950222 5.84375111,8.20988444 C5.84375111,9.51262222 6.76240711,10.5538489 8.18684444,10.5538489 L8.21287644,10.5538489 C9.69068978,10.5538489 10.6093458,9.51262222 10.6093458,8.20988444 C10.5822204,6.87950222 9.690752,5.86590222 8.23778311,5.86590222 L8.23778311,5.86590222 Z M21.2764978,12.0914133 C19.0151644,12.0914133 18.0184,13.4177778 17.4580018,14.3429689 L17.4580018,12.4068089 L13.2215644,12.4068089 C13.2786898,13.6804089 13.2215644,25.9809707 13.2215644,25.9809707 L17.4580018,25.9809707 L17.4580018,18.4000338 C17.4580018,17.9935644 17.4852836,17.5923467 17.6017831,17.3071893 C17.9067911,16.4890347 18.5985956,15.6535644 19.7689422,15.6535644 C21.3038222,15.6535644 21.9211911,16.8942204 21.9211911,18.7169404 L21.9211911,25.9811271 L26.1562489,25.9811271 L26.1562489,18.1995644 C26.1562489,14.0315378 24.0659733,12.0914133 21.2764978,12.0914133 L21.2764978,12.0914133 Z",
        fill: "#FFFFFF",
        "data-jsx": 4009752810
      }),
      react_default.a.createElement(style_default.a, {
        styleId: 4009752810,
        css: "svg[data-jsx=\"4009752810\"]{display:block;height:32px;width:32px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/SocialIcons.js */"
      })
    )
  );
};
// CONCATENATED MODULE: ./src/components/Quiz/FadeInText.js




var FadeInText_bouncySpringPreset = {
  stiffness: 30,
  damping: 16
};

var FadeInText_FadeInText = function FadeInText(_ref) {
  var items = _ref.items,
      targetValue = _ref.targetValue;
  return react_default.a.createElement(
    "div",
    {
      "data-jsx": 687357468
    },
    react_default.a.createElement(
      react_motion["StaggeredMotion"],
      {
        defaultStyles: items.map(function (i) {
          return { y: 0 };
        }),
        styles: function styles(_styles) {
          return _styles ? _styles.map(function (_, i, arr) {
            return i === 0 ? { y: Object(react_motion["spring"])(targetValue, FadeInText_bouncySpringPreset) } : {
              y: Object(react_motion["spring"])(arr[i - 1].y, FadeInText_bouncySpringPreset)
            };
          }) : [];
        }
      },
      function (styles) {
        return react_default.a.createElement(
          "div",
          { className: "items", "data-jsx": 687357468
          },
          items.map(function (item, i) {
            return react_default.a.createElement(
              "div",
              {
                key: i,
                className: "item",
                style: {
                  opacity: styles[i].y
                },
                "data-jsx": 687357468
              },
              item
            );
          })
        );
      }
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 687357468,
      css: ".items[data-jsx=\"687357468\"]{position:relative}.item[data-jsx=\"687357468\"]{position:relative}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1F1aXovRmFkZUluVGV4dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2Q2dCLEFBRzZCLEFBQ0EsbUJBRFMsQUFDQSIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9RdWl6L0ZhZGVJblRleHQuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCB7IFN0YWdnZXJlZE1vdGlvbiwgc3ByaW5nIH0gZnJvbSBcInJlYWN0LW1vdGlvblwiO1xuXG5jb25zdCBib3VuY3lTcHJpbmdQcmVzZXQgPSB7XG4gIHN0aWZmbmVzczogMzAsXG4gIGRhbXBpbmc6IDE2XG59O1xuXG5jb25zdCBGYWRlSW5UZXh0ID0gKHtcbiAgaXRlbXMsXG4gIHRhcmdldFZhbHVlXG59OiB7XG4gIGl0ZW1zOiBBcnJheTxhbnk+LFxuICB0YXJnZXRWYWx1ZTogbnVtYmVyXG59KSA9PlxuICA8ZGl2PlxuICAgIDxTdGFnZ2VyZWRNb3Rpb25cbiAgICAgIGRlZmF1bHRTdHlsZXM9e2l0ZW1zLm1hcChpID0+ICh7IHk6IDAgfSkpfVxuICAgICAgc3R5bGVzPXtzdHlsZXMgPT5cbiAgICAgICAgc3R5bGVzXG4gICAgICAgICAgPyBzdHlsZXMubWFwKChfLCBpLCBhcnIpID0+IHtcbiAgICAgICAgICAgICAgcmV0dXJuIGkgPT09IDBcbiAgICAgICAgICAgICAgICA/IHsgeTogc3ByaW5nKHRhcmdldFZhbHVlLCBib3VuY3lTcHJpbmdQcmVzZXQpIH1cbiAgICAgICAgICAgICAgICA6IHtcbiAgICAgICAgICAgICAgICAgICAgeTogc3ByaW5nKGFycltpIC0gMV0ueSwgYm91bmN5U3ByaW5nUHJlc2V0KVxuICAgICAgICAgICAgICAgICAgfTtcbiAgICAgICAgICAgIH0pXG4gICAgICAgICAgOiBbXX1cbiAgICA+XG4gICAgICB7c3R5bGVzID0+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiaXRlbXNcIj5cbiAgICAgICAgICB7aXRlbXMubWFwKChpdGVtLCBpKSA9PlxuICAgICAgICAgICAgPGRpdlxuICAgICAgICAgICAgICBrZXk9e2l9XG4gICAgICAgICAgICAgIGNsYXNzTmFtZT1cIml0ZW1cIlxuICAgICAgICAgICAgICBzdHlsZT17e1xuICAgICAgICAgICAgICAgIG9wYWNpdHk6IHN0eWxlc1tpXS55XG4gICAgICAgICAgICAgIH19XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIHtpdGVtfVxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgKX1cbiAgICAgICAgPC9kaXY+fVxuICAgIDwvU3RhZ2dlcmVkTW90aW9uPlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgLml0ZW1zIHtcbiAgICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIH1cbiAgICAgICAgLml0ZW0ge1xuICAgICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgfVxuICAgICAgYH08L3N0eWxlPlxuICA8L2Rpdj47XG5cbmV4cG9ydCBkZWZhdWx0IEZhZGVJblRleHQ7XG4iXX0= */\n/*@ sourceURL=src/components/Quiz/FadeInText.js */"
    })
  );
};

/* harmony default export */ var Quiz_FadeInText = (FadeInText_FadeInText);
// EXTERNAL MODULE: ./src/static/01-subscribe.png
var _1_subscribe = __webpack_require__(627);
var _1_subscribe_default = /*#__PURE__*/__webpack_require__.n(_1_subscribe);

// EXTERNAL MODULE: ./src/static/02-millennials_mobile.png
var _2_millennials_mobile = __webpack_require__(628);
var _2_millennials_mobile_default = /*#__PURE__*/__webpack_require__.n(_2_millennials_mobile);

// CONCATENATED MODULE: ./src/components/Quiz/Outro.js
var Outro__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function Outro__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Outro__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Outro__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SHARE_ARTICLE_URL = "https://www.ubs.com/global/en/wealth-management/chief-investment-office/features/millennials.html";
var SHARE_TEXT = "How well do you really know “millennials”? Take our quiz and find out.";

var scoreCounterSpringConfig = {
  stiffness: 60,
  damping: 18,
  precision: 1
};

var Outro_Outro = function Outro(_ref) {
  var text = _ref.text,
      score = _ref.score,
      restart = _ref.restart,
      showShareStuff = _ref.showShareStuff,
      showQRCode = _ref.showQRCode;
  return react_default.a.createElement(
    "div",
    { className: "outro", "data-jsx": 3561698838
    },
    react_default.a.createElement(Progress, { step: 1, totalSteps: 1, showText: false }),
    react_default.a.createElement(
      "div",
      { className: "score", "data-jsx": 3561698838
      },
      react_default.a.createElement(
        react_motion["Motion"],
        {
          defaultStyle: { value: 0 },
          style: { value: Object(react_motion["spring"])(score, scoreCounterSpringConfig) }
        },
        function (_ref2) {
          var value = _ref2.value;

          return react_default.a.createElement(
            "div",
            {
              "data-jsx": 3561698838
            },
            react_default.a.createElement(
              "div",
              { className: "title", "data-jsx": 3561698838
              },
              "You think"
            ),
            react_default.a.createElement(
              "div",
              { className: "scoreNumber", "data-jsx": 3561698838
              },
              Math.round(value),
              react_default.a.createElement(
                "span",
                { className: "scoreRef", "data-jsx": 3561698838
                },
                "%"
              )
            ),
            react_default.a.createElement(
              "div",
              { className: "title", "data-jsx": 3561698838
              },
              "like a \u201Cmillennial\u201D"
            ),
            react_default.a.createElement(
              "div",
              { className: "scoreFeedback", "data-jsx": 3561698838
              },
              value === score && react_default.a.createElement(Outro_ScoreFeedback, { score: score })
            )
          );
        }
      )
    ),
    react_default.a.createElement(
      "div",
      { className: "share", "data-jsx": 3561698838
      },
      showQRCode ? react_default.a.createElement(Quiz_FadeInText, {
        targetValue: showShareStuff ? 1 : 0,
        items: [react_default.a.createElement(Outro_QRCode, null)]
      }) : react_default.a.createElement(Quiz_FadeInText, {
        targetValue: showShareStuff ? 1 : 0,
        items: [react_default.a.createElement(Outro_ReadOn, null), react_default.a.createElement(Outro_SocialMedia, null), react_default.a.createElement(Outro_Newsletter, null)]
      })
    ),
    react_default.a.createElement(
      "div",
      { className: "controls", "data-jsx": 3561698838
      },
      react_default.a.createElement(ButtonSecondary, { label: "Restart quiz", onClick: restart }),
      react_default.a.createElement(
        "div",
        { className: "credits", "data-jsx": 3561698838
        },
        "Emoji artwork is provided by",
        " ",
        react_default.a.createElement(
          "a",
          {
            href: "https://www.emojione.com/",
            target: "_blank",
            rel: "noopener noreferrer",
            "data-jsx": 3561698838
          },
          "EmojiOne"
        ),
        " ",
        "and is licensed under",
        " ",
        react_default.a.createElement(
          "a",
          {
            href: "https://creativecommons.org/licenses/by/4.0/legalcode",
            target: "_blank",
            rel: "noopener noreferrer",
            "data-jsx": 3561698838
          },
          "CC-BY 4.0"
        ),
        react_default.a.createElement("br", {
          "data-jsx": 3561698838
        }),
        "Source: cross-generational external survey conducted via Google Forms. Data as of May 2017. N = 436"
      )
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 3561698838,
      css: "a[data-jsx=\"3561698838\"]{color:#007099;-webkit-text-decoration:none;text-decoration:none}a[data-jsx=\"3561698838\"]:hover{-webkit-text-decoration:underline;text-decoration:underline}.outro[data-jsx=\"3561698838\"]{box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;max-height:100vh;height:500px;padding:32px 20px 20px 20px}.title[data-jsx=\"3561698838\"]{font-family:FrutigerLTCom;font-weight:300;font-size:24px;line-height:26px;-webkit-text-align:center;text-align:center;margin:0;width:100%}.share[data-jsx=\"3561698838\"]{font-family:FrutigerLTCom;font-weight:300;font-size:16px;line-height:20px;-webkit-text-align:center;text-align:center;width:100%;margin:16px 0 auto 0}.socialButtons[data-jsx=\"3561698838\"]{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.score[data-jsx=\"3561698838\"]{font-family:FrutigerLTCom;font-weight:500;font-size:72px;line-height:1;-webkit-text-align:center;text-align:center;width:100%;padding:0;margin:auto 0}.scoreNumber[data-jsx=\"3561698838\"]{-webkit-text-indent:0.2em;text-indent:0.2em;display:block;margin:8px 0}.scoreFeedback[data-jsx=\"3561698838\"]{margin:24px 0 0 0;height:24px}.scoreRef[data-jsx=\"3561698838\"]{font-size:24px}.controls[data-jsx=\"3561698838\"]{max-width:320px;margin:0 auto 0 auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.credits[data-jsx=\"3561698838\"]{color:#646464;font-family:FrutigerLTCom;font-weight:300;font-size:9px;line-height:1.5;-webkit-text-align:center;text-align:center;width:100%;margin:8px 0 0 0}.credits[data-jsx=\"3561698838\"] a[data-jsx=\"3561698838\"]{color:#646464}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Outro.js */"
    })
  );
};

var Outro_OutroWithTimeout = function (_Component) {
  Outro__inherits(OutroWithTimeout, _Component);

  function OutroWithTimeout() {
    var _ref3;

    var _temp, _this, _ret;

    Outro__classCallCheck(this, OutroWithTimeout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Outro__possibleConstructorReturn(this, (_ref3 = OutroWithTimeout.__proto__ || Object.getPrototypeOf(OutroWithTimeout)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      timeoutDone: false
    }, _temp), Outro__possibleConstructorReturn(_this, _ret);
  }

  Outro__createClass(OutroWithTimeout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        _this2.setState(function () {
          return { timeoutDone: true };
        });
      }, 3200);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      return react_default.a.createElement(Outro_Outro, Object.assign({}, this.props, { showShareStuff: this.state.timeoutDone }));
    }
  }]);

  return OutroWithTimeout;
}(react["Component"]);

/* harmony default export */ var Quiz_Outro = (Outro_OutroWithTimeout);

var Outro_ReadOn = function ReadOn() {
  return react_default.a.createElement(
    "span",
    { className: "readon", "data-jsx": 4096578969
    },
    react_default.a.createElement(
      "a",
      { href: SHARE_ARTICLE_URL, target: "_blank", rel: "noopener noreferrer", "data-jsx": 4096578969
      },
      "Read on"
    ),
    " ",
    "to learn how millennials ",
    react_default.a.createElement("br", {
      "data-jsx": 4096578969
    }),
    "will shape the world.",
    react_default.a.createElement(style_default.a, {
      styleId: 4096578969,
      css: ".readon[data-jsx=\"4096578969\"]{display:inline-block;-webkit-text-align:center;text-align:center;font-weight:300;font-size:16px;line-height:1.5;margin:0 0 16px 0}a[data-jsx=\"4096578969\"]{color:#007099;-webkit-text-decoration:none;text-decoration:none}a[data-jsx=\"4096578969\"]:hover{-webkit-text-decoration:underline;text-decoration:underline}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Outro.js */"
    })
  );
};

var Outro_QRCode = function QRCode() {
  return react_default.a.createElement(
    "div",
    { className: "QRContainer", "data-jsx": 2007382825
    },
    react_default.a.createElement(
      "div",
      { className: "QRC", "data-jsx": 2007382825
      },
      react_default.a.createElement(
        "div",
        {
          "data-jsx": 2007382825
        },
        "Subscribe to CIO newsletter"
      ),
      react_default.a.createElement("img", { className: "QRCode", src: _1_subscribe_default.a, "data-jsx": 2007382825
      })
    ),
    react_default.a.createElement(
      "div",
      { className: "QRC", "data-jsx": 2007382825
      },
      react_default.a.createElement(
        "div",
        {
          "data-jsx": 2007382825
        },
        "Read CIO report on Millennials"
      ),
      react_default.a.createElement("img", { className: "QRCode", src: _2_millennials_mobile_default.a, "data-jsx": 2007382825
      })
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 2007382825,
      css: ".QRContainer[data-jsx=\"2007382825\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin:8px 8px 16px 8px}.QRC[data-jsx=\"2007382825\"]{margin:0 8px 0 8px}.QRCode[data-jsx=\"2007382825\"]{width:96px;margin-top:8px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Outro.js */"
    })
  );
};

var Outro_Newsletter = function Newsletter() {
  return react_default.a.createElement(
    "div",
    { className: "shareNewsletter", "data-jsx": 3776554545
    },
    "Stay up to date with our",
    " ",
    react_default.a.createElement(
      "a",
      {
        href: "http://ubs.com/cio-newsletter",
        target: "_blank",
        rel: "noopener noreferrer",
        "data-jsx": 3776554545
      },
      "newsletter"
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 3776554545,
      css: ".shareNewsletter[data-jsx=\"3776554545\"]{margin:0 0 16px 0}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Outro.js */"
    })
  );
};

var Outro_SocialMedia = function SocialMedia() {
  return react_default.a.createElement(
    "div",
    { className: "shareSocial", "data-jsx": 2777142171
    },
    "Share this quiz on",
    react_default.a.createElement(SocialIcons_SocialButtons, { url: SHARE_ARTICLE_URL, text: SHARE_TEXT }),
    react_default.a.createElement(style_default.a, {
      styleId: 2777142171,
      css: ".shareSocial[data-jsx=\"2777142171\"]{margin:0 0 16px 0}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Outro.js */"
    })
  );
};

var Outro_ScoreFeedback = function ScoreFeedback(_ref4) {
  var score = _ref4.score;
  return react_default.a.createElement(
    "div",
    {
      "data-jsx": 2318775402
    },
    score > 85 ? react_default.a.createElement(BouncyText, {
      items: ["Great ", "job", "! ", react_default.a.createElement(Quiz_Emoji, { name: "clap" }), react_default.a.createElement(Quiz_Emoji, { name: "crown" }), react_default.a.createElement(Quiz_Emoji, { name: "confetti_ball" })]
    }) : score > 60 ? react_default.a.createElement(BouncyText, {
      items: ["Very ", "nice", "! ", react_default.a.createElement(Quiz_Emoji, { name: "thumbsup" }), react_default.a.createElement(Quiz_Emoji, { name: "mortar_board" }), react_default.a.createElement(Quiz_Emoji, { name: "tada" })]
    }) : react_default.a.createElement(BouncyText, {
      items: ["Better luck ", "next time", "! ", react_default.a.createElement(Quiz_Emoji, { name: "wave" }), react_default.a.createElement(Quiz_Emoji, { name: "carrot" }), react_default.a.createElement(Quiz_Emoji, { name: "third_place" })]
    }),
    react_default.a.createElement(style_default.a, {
      styleId: 2318775402,
      css: "div[data-jsx=\"2318775402\"]{-webkit-text-align:center;text-align:center;font-family:FrutigerLTCom;font-weight:700;font-size:18px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/Quiz/Outro.js */"
    })
  );
};
// CONCATENATED MODULE: ./src/components/Quiz/Quiz.js
var Quiz__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Quiz__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Quiz__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Quiz__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Quiz_Quiz = function (_Component) {
  Quiz__inherits(Quiz, _Component);

  function Quiz() {
    var _ref;

    var _temp, _this, _ret;

    Quiz__classCallCheck(this, Quiz);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Quiz__possibleConstructorReturn(this, (_ref = Quiz.__proto__ || Object.getPrototypeOf(Quiz)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      answers: {},
      step: _this.props.firstStep
    }, _this.commit = function (answer) {
      _this.setState(function (_ref2) {
        var answers = _ref2.answers,
            step = _ref2.step;
        return {
          answers: Object.assign({}, answers, answer),
          step: _this.props.getStep(step.nextStep)
        };
      });
    }, _this.nextStep = function () {
      _this.setState(function (_ref3) {
        var step = _ref3.step;
        return {
          step: _this.props.getStep(step.nextStep)
        };
      });
    }, _this.getScore = function () {
      var questions = _this.props.questions;
      var answers = _this.state.answers;


      var score = Math.ceil(100 - src_mean(questions, function (q) {
        return Math.abs(q.answerValue - answers[q.id]);
      }));

      return score;
    }, _this.restart = function () {
      _this.setState(function () {
        return { answers: {}, step: _this.props.firstStep };
      });
    }, _temp), Quiz__possibleConstructorReturn(_this, _ret);
  }

  Quiz__createClass(Quiz, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var step = this.state.step;


      return step.type === "intro" ? react_default.a.createElement(Quiz_Intro, Object.assign({}, step, { start: this.nextStep })) : step.type === "outro" ? react_default.a.createElement(Quiz_Outro, Object.assign({}, step, {
        restart: this.restart,
        score: this.getScore(),
        showQRCode: this.props.showQRCode
      })) : react_default.a.createElement(Quiz_Question, Object.assign({
        key: step.id,
        step: step.step,
        totalSteps: this.props.questions.length
      }, step, {
        commit: function commit(value) {
          return _this2.commit(_defineProperty({}, step.id, value));
        }
      }));
    }
  }]);

  return Quiz;
}(react["Component"]);

/* harmony default export */ var components_Quiz_Quiz = (Quiz_Quiz);
// CONCATENATED MODULE: ./src/data/quizData.js


var quizData_questions = [{
  id: "q1",
  step: 1,
  type: "question",
  question: "set “doing good for society” as one of their long-term professional goals?",
  answerValue: 66,
  nextStep: "q2"
}, {
  id: "q2",
  step: 2,
  type: "question",
  question: "think they have influence at work to make a positive social impact?",
  answerValue: 48,
  nextStep: "q3"
}, {
  id: "q3",
  step: 3,
  type: "question",
  question: "think they can use their financial resources to make a positive social impact?",
  answerValue: 46,
  nextStep: "q4"
}, {
  id: "q4",
  step: 4,
  type: "question",
  question: "prefer to save cash rather than make financial investments in order to meet their long-term goals?",
  answerValue: 33,
  nextStep: "q5"
}, {
  id: "q5",
  step: 5,
  type: "question",
  question: "think it’s difficult to make money on investments, while also doing good for society?",
  answerValue: 32,
  nextStep: "q6"
}, {
  id: "q6",
  step: 6,
  type: "question",
  question: "think the potential benefits of making financial investments with positive social impact exceed the potential costs?",
  answerValue: 40,
  nextStep: "q7"
}, {
  id: "q7",
  step: 7,
  type: "question",
  question: "think that the right investment strategy for them is very different from their parents’ one?",
  answerValue: 64,
  nextStep: "q8"
}, {
  id: "q8",
  step: 8,
  type: "question",
  question: "think they’ll switch jobs more frequently than their parents?",
  answerValue: 69,
  nextStep: "q9"
}, {
  id: "q9",
  step: 9,
  type: "question",
  question: "think they’ll have to retire at a later stage in life than their parents?",
  answerValue: 60,
  nextStep: "outro"
}];

// export const strings = {
//   intro: "Hi",
//   "result.great": "Great",
//   "result.good": "Great",
//   "result.notgood": "Not good",
//   "result.terrible": "Terrible!",
//   "button.start": "Take the quiz",
//   "button.submit": "Submit",
//   "button.next": "Next question",
//   "button.reset": "Start again",
//   "button.sharetwitter": "Share on Twitter",
//   "button.sharetfacebook": "Share on Facebook",
//   "button.signup": "Sign up to stay informed"
// };

var steps = {
  intro: {
    id: "intro",
    type: "intro",
    title: "Do you think like a “millennial”?",
    text: "The millennial generation is fast becoming a major force in the world economy. Their varied tastes and evolving demands are influencing other generations too. The potential implications are big for everyone. So how well do you know the millennials?",
    nextStep: "q1"
  },
  q1: quizData_questions[0],
  q2: quizData_questions[1],
  q3: quizData_questions[2],
  q4: quizData_questions[3],
  q5: quizData_questions[4],
  q6: quizData_questions[5],
  q7: quizData_questions[6],
  q8: quizData_questions[7],
  q9: quizData_questions[8],
  outro: {
    id: "outro",
    type: "outro",
    text: "You achieved a score of",
    nextStep: "intro"
  }
};
// CONCATENATED MODULE: ./src/pages/quiz.js
var quiz__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function quiz__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function quiz__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function quiz__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var quiz_QuizPage = function (_Component) {
  quiz__inherits(QuizPage, _Component);

  function QuizPage() {
    var _ref;

    var _temp, _this, _ret;

    quiz__classCallCheck(this, QuizPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = quiz__possibleConstructorReturn(this, (_ref = QuizPage.__proto__ || Object.getPrototypeOf(QuizPage)).call.apply(_ref, [this].concat(args))), _this), _this.getStep = function (id) {
      return steps[id];
    }, _temp), quiz__possibleConstructorReturn(_this, _ret);
  }

  quiz__createClass(QuizPage, [{
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        { className: "quiz", "data-jsx": 2524917435
        },
        react_default.a.createElement(components_Quiz_Quiz, {
          firstStep: steps.intro,
          getStep: this.getStep,
          questions: quizData_questions,
          showQRCode: false
        }),
        react_default.a.createElement(style_default.a, {
          styleId: 166542297,
          css: "html,body{height:100%}body{margin:0;-webkit-text-rendering:optimizeLegibility;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-font-smoothing:grayscale}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9xdWl6LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCMkIsQUFHeUIsQUFDSCxVQUErQyxHQURqQywyRUFDaUYsb0NBQTJDLCtCQUFXIiwiZmlsZSI6InNyYy9wYWdlcy9xdWl6LmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5cbmltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBNYWluIGZyb20gXCIuLi9jb21wb25lbnRzL01haW5cIjtcbmltcG9ydCBRdWl6IGZyb20gXCIuLi9jb21wb25lbnRzL1F1aXovUXVpelwiO1xuaW1wb3J0IHsgc3RlcHMsIHF1ZXN0aW9ucyB9IGZyb20gXCIuLi9kYXRhL3F1aXpEYXRhXCI7XG5cbmltcG9ydCB0eXBlIHsgU3RlcCB9IGZyb20gXCIuLi9kYXRhL3F1aXpEYXRhXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFF1aXpQYWdlIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgZ2V0U3RlcCA9IChpZDogc3RyaW5nKTogU3RlcCA9PiBzdGVwc1tpZF07XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cInF1aXpcIj5cblxuICAgICAgICA8UXVpelxuICAgICAgICAgIGZpcnN0U3RlcD17c3RlcHMuaW50cm99XG4gICAgICAgICAgZ2V0U3RlcD17dGhpcy5nZXRTdGVwfVxuICAgICAgICAgIHF1ZXN0aW9ucz17cXVlc3Rpb25zfVxuICAgICAgICAgIHNob3dRUkNvZGU9e2ZhbHNlfVxuICAgICAgICAvPlxuXG4gICAgICAgIDxzdHlsZSBqc3ggZ2xvYmFsPntgXG4gICAgICAgICAgaHRtbCwgYm9keSB7XG4gICAgICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgICAgfVxuICAgICAgICAgIGJvZHkge1xuICAgICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgICAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTtcbiAgICAgICAgICAgIC13ZWJraXQtZm9udC1zbW9vdGhpbmc6IGFudGlhbGlhc2VkO1xuICAgICAgICAgICAgLW1vei1mb250LXNtb290aGluZzogZ3JheXNjYWxlO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgICA8c3R5bGUganN4PntgXG4gICAgICAgICAgLnF1aXoge1xuICAgICAgICAgICAgYmFja2dyb3VuZDogI0VFRjRGMDtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgICAgICBoZWlnaHQ6IDEwMHZoO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */\n/*@ sourceURL=src/pages/quiz.js */"
        }),
        react_default.a.createElement(style_default.a, {
          styleId: 3313751335,
          css: ".quiz[data-jsx=\"2524917435\"]{background:#EEF4F0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;height:100vh}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9xdWl6LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtDb0IsQUFHZ0Msb0JBQTBCLDhFQUFtQyxpRkFBb0MsdUdBQTBCLGNBQVciLCJmaWxlIjoic3JjL3BhZ2VzL3F1aXouanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcblxuaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IE1haW4gZnJvbSBcIi4uL2NvbXBvbmVudHMvTWFpblwiO1xuaW1wb3J0IFF1aXogZnJvbSBcIi4uL2NvbXBvbmVudHMvUXVpei9RdWl6XCI7XG5pbXBvcnQgeyBzdGVwcywgcXVlc3Rpb25zIH0gZnJvbSBcIi4uL2RhdGEvcXVpekRhdGFcIjtcblxuaW1wb3J0IHR5cGUgeyBTdGVwIH0gZnJvbSBcIi4uL2RhdGEvcXVpekRhdGFcIjtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgUXVpelBhZ2UgZXh0ZW5kcyBDb21wb25lbnQge1xuICBnZXRTdGVwID0gKGlkOiBzdHJpbmcpOiBTdGVwID0+IHN0ZXBzW2lkXTtcblxuICByZW5kZXIoKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwicXVpelwiPlxuXG4gICAgICAgIDxRdWl6XG4gICAgICAgICAgZmlyc3RTdGVwPXtzdGVwcy5pbnRyb31cbiAgICAgICAgICBnZXRTdGVwPXt0aGlzLmdldFN0ZXB9XG4gICAgICAgICAgcXVlc3Rpb25zPXtxdWVzdGlvbnN9XG4gICAgICAgICAgc2hvd1FSQ29kZT17ZmFsc2V9XG4gICAgICAgIC8+XG5cbiAgICAgICAgPHN0eWxlIGpzeCBnbG9iYWw+e2BcbiAgICAgICAgICBodG1sLCBib2R5IHtcbiAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgICAgYm9keSB7XG4gICAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgICAgICB0ZXh0LXJlbmRlcmluZzogb3B0aW1pemVMZWdpYmlsaXR5O1xuICAgICAgICAgICAgLXdlYmtpdC1mb250LXNtb290aGluZzogYW50aWFsaWFzZWQ7XG4gICAgICAgICAgICAtbW96LWZvbnQtc21vb3RoaW5nOiBncmF5c2NhbGU7XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgICAucXVpeiB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjRUVGNEYwO1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgIGhlaWdodDogMTAwdmg7XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG4iXX0= */\n/*@ sourceURL=src/pages/quiz.js */"
        })
      );
    }
  }]);

  return QuizPage;
}(react["Component"]);

/* harmony default export */ var quiz = (quiz_QuizPage);
// CONCATENATED MODULE: ./src/pages/quizQR.js
var quizQR__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function quizQR__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function quizQR__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function quizQR__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var quizQR_QuizPage = function (_Component) {
  quizQR__inherits(QuizPage, _Component);

  function QuizPage() {
    var _ref;

    var _temp, _this, _ret;

    quizQR__classCallCheck(this, QuizPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = quizQR__possibleConstructorReturn(this, (_ref = QuizPage.__proto__ || Object.getPrototypeOf(QuizPage)).call.apply(_ref, [this].concat(args))), _this), _this.getStep = function (id) {
      return steps[id];
    }, _temp), quizQR__possibleConstructorReturn(_this, _ret);
  }

  quizQR__createClass(QuizPage, [{
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        { className: "quiz", "data-jsx": 2524917435
        },
        react_default.a.createElement(components_Quiz_Quiz, {
          firstStep: steps.intro,
          getStep: this.getStep,
          questions: quizData_questions,
          showQRCode: true
        }),
        react_default.a.createElement(style_default.a, {
          styleId: 166542297,
          css: "html,body{height:100%}body{margin:0;-webkit-text-rendering:optimizeLegibility;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-font-smoothing:grayscale}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9xdWl6UVIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUIyQixBQUd5QixBQUNILFVBQStDLEdBRGpDLDJFQUNpRixvQ0FBMkMsK0JBQVciLCJmaWxlIjoic3JjL3BhZ2VzL3F1aXpRUi5qcyIsInNvdXJjZVJvb3QiOiIvb3B0L2J1aWxkL3JlcG8iLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5pbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgTWFpbiBmcm9tIFwiLi4vY29tcG9uZW50cy9NYWluXCI7XG5pbXBvcnQgUXVpeiBmcm9tIFwiLi4vY29tcG9uZW50cy9RdWl6L1F1aXpcIjtcbmltcG9ydCB7IHN0ZXBzLCBxdWVzdGlvbnMgfSBmcm9tIFwiLi4vZGF0YS9xdWl6RGF0YVwiO1xuXG5pbXBvcnQgdHlwZSB7IFN0ZXAgfSBmcm9tIFwiLi4vZGF0YS9xdWl6RGF0YVwiO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBRdWl6UGFnZSBleHRlbmRzIENvbXBvbmVudCB7XG4gIGdldFN0ZXAgPSAoaWQ6IHN0cmluZyk6IFN0ZXAgPT4gc3RlcHNbaWRdO1xuXG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJxdWl6XCI+XG5cbiAgICAgICAgPFF1aXpcbiAgICAgICAgICBmaXJzdFN0ZXA9e3N0ZXBzLmludHJvfVxuICAgICAgICAgIGdldFN0ZXA9e3RoaXMuZ2V0U3RlcH1cbiAgICAgICAgICBxdWVzdGlvbnM9e3F1ZXN0aW9uc31cbiAgICAgICAgICBzaG93UVJDb2RlPXt0cnVlfVxuICAgICAgICAvPlxuXG4gICAgICAgIDxzdHlsZSBqc3ggZ2xvYmFsPntgXG4gICAgICAgICAgaHRtbCwgYm9keSB7XG4gICAgICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgICAgfVxuICAgICAgICAgIGJvZHkge1xuICAgICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgICAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTtcbiAgICAgICAgICAgIC13ZWJraXQtZm9udC1zbW9vdGhpbmc6IGFudGlhbGlhc2VkO1xuICAgICAgICAgICAgLW1vei1mb250LXNtb290aGluZzogZ3JheXNjYWxlO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgICA8c3R5bGUganN4PntgXG4gICAgICAgICAgLnF1aXoge1xuICAgICAgICAgICAgYmFja2dyb3VuZDogI0VFRjRGMDtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgICAgICBoZWlnaHQ6IDEwMHZoO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */\n/*@ sourceURL=src/pages/quizQR.js */"
        }),
        react_default.a.createElement(style_default.a, {
          styleId: 3313751335,
          css: ".quiz[data-jsx=\"2524917435\"]{background:#EEF4F0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;height:100vh}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9xdWl6UVIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0NvQixBQUdnQyxvQkFBMEIsOEVBQW1DLGlGQUFvQyx1R0FBMEIsY0FBVyIsImZpbGUiOiJzcmMvcGFnZXMvcXVpelFSLmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5cbmltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQgfSBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBNYWluIGZyb20gXCIuLi9jb21wb25lbnRzL01haW5cIjtcbmltcG9ydCBRdWl6IGZyb20gXCIuLi9jb21wb25lbnRzL1F1aXovUXVpelwiO1xuaW1wb3J0IHsgc3RlcHMsIHF1ZXN0aW9ucyB9IGZyb20gXCIuLi9kYXRhL3F1aXpEYXRhXCI7XG5cbmltcG9ydCB0eXBlIHsgU3RlcCB9IGZyb20gXCIuLi9kYXRhL3F1aXpEYXRhXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFF1aXpQYWdlIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgZ2V0U3RlcCA9IChpZDogc3RyaW5nKTogU3RlcCA9PiBzdGVwc1tpZF07XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cInF1aXpcIj5cblxuICAgICAgICA8UXVpelxuICAgICAgICAgIGZpcnN0U3RlcD17c3RlcHMuaW50cm99XG4gICAgICAgICAgZ2V0U3RlcD17dGhpcy5nZXRTdGVwfVxuICAgICAgICAgIHF1ZXN0aW9ucz17cXVlc3Rpb25zfVxuICAgICAgICAgIHNob3dRUkNvZGU9e3RydWV9XG4gICAgICAgIC8+XG5cbiAgICAgICAgPHN0eWxlIGpzeCBnbG9iYWw+e2BcbiAgICAgICAgICBodG1sLCBib2R5IHtcbiAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgICAgYm9keSB7XG4gICAgICAgICAgICBtYXJnaW46IDA7XG4gICAgICAgICAgICB0ZXh0LXJlbmRlcmluZzogb3B0aW1pemVMZWdpYmlsaXR5O1xuICAgICAgICAgICAgLXdlYmtpdC1mb250LXNtb290aGluZzogYW50aWFsaWFzZWQ7XG4gICAgICAgICAgICAtbW96LWZvbnQtc21vb3RoaW5nOiBncmF5c2NhbGU7XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgICAucXVpeiB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjRUVGNEYwO1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgIGhlaWdodDogMTAwdmg7XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG4iXX0= */\n/*@ sourceURL=src/pages/quizQR.js */"
        })
      );
    }
  }]);

  return QuizPage;
}(react["Component"]);

/* harmony default export */ var quizQR = (quizQR_QuizPage);
// CONCATENATED MODULE: ./node_modules/d3-selection/src/namespaces.js
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ var namespaces = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/namespace.js


/* harmony default export */ var namespace = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/creator.js



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ var creator = (function(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/local.js
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

// CONCATENATED MODULE: ./node_modules/d3-selection/src/matcher.js
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var matcher_element = document.documentElement;
  if (!matcher_element.matches) {
    var vendorMatches = matcher_element.webkitMatchesSelector
        || matcher_element.msMatchesSelector
        || matcher_element.mozMatchesSelector
        || matcher_element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ var src_matcher = (matcher);

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/on.js
var filterEvents = {};

var on_event = null;

if (typeof document !== "undefined") {
  var on_element = document.documentElement;
  if (!("onmouseenter" in on_element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = on_event; // Events can be reentrant (e.g., focus).
    on_event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      on_event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ var on = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = on_event;
  event1.sourceEvent = on_event;
  on_event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    on_event = event0;
  }
}

// CONCATENATED MODULE: ./node_modules/d3-selection/src/sourceEvent.js


/* harmony default export */ var sourceEvent = (function() {
  var current = on_event, source;
  while (source = current.sourceEvent) current = source;
  return current;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/point.js
/* harmony default export */ var src_point = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/mouse.js



/* harmony default export */ var mouse = (function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return src_point(node, event);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selector.js
function none() {}

/* harmony default export */ var src_selector = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/select.js



/* harmony default export */ var selection_select = (function(select) {
  if (typeof select !== "function") select = src_selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selectorAll.js
function selectorAll_empty() {
  return [];
}

/* harmony default export */ var selectorAll = (function(selector) {
  return selector == null ? selectorAll_empty : function() {
    return this.querySelectorAll(selector);
  };
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/selectAll.js



/* harmony default export */ var selectAll = (function(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/filter.js



/* harmony default export */ var filter = (function(match) {
  if (typeof match !== "function") match = src_matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sparse.js
/* harmony default export */ var sparse = (function(update) {
  return new Array(update.length);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/enter.js



/* harmony default export */ var selection_enter = (function() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

// CONCATENATED MODULE: ./node_modules/d3-selection/src/constant.js
/* harmony default export */ var d3_selection_src_constant = (function(x) {
  return function() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/data.js




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ var selection_data = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = d3_selection_src_constant(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/exit.js



/* harmony default export */ var selection_exit = (function() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/merge.js


/* harmony default export */ var selection_merge = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/order.js
/* harmony default export */ var selection_order = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/sort.js


/* harmony default export */ var selection_sort = (function(compare) {
  if (!compare) compare = sort_ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
});

function sort_ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/call.js
/* harmony default export */ var call = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/nodes.js
/* harmony default export */ var nodes = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/node.js
/* harmony default export */ var selection_node = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/size.js
/* harmony default export */ var selection_size = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/empty.js
/* harmony default export */ var selection_empty = (function() {
  return !this.node();
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/each.js
/* harmony default export */ var each = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/attr.js


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ var attr = (function(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/window.js
/* harmony default export */ var src_window = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/style.js


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ var selection_style = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || src_window(node).getComputedStyle(node, null).getPropertyValue(name);
}

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/property.js
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ var property = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/classed.js
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ var classed = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/text.js
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ var selection_text = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/html.js
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ var html = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/raise.js
function raise_raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ var selection_raise = (function() {
  return this.each(raise_raise);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/lower.js
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ var selection_lower = (function() {
  return this.each(lower);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/append.js


/* harmony default export */ var append = (function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/insert.js



function constantNull() {
  return null;
}

/* harmony default export */ var insert = (function(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : src_selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/remove.js
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ var selection_remove = (function() {
  return this.each(remove);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/datum.js
/* harmony default export */ var datum = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/dispatch.js


function dispatchEvent(node, type, params) {
  var window = src_window(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ var dispatch = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selection/index.js






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection_selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection_selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selectAll,
  filter: filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: call,
  nodes: nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: each,
  attr: attr,
  style: selection_style,
  property: property,
  classed: classed,
  text: selection_text,
  html: html,
  raise: selection_raise,
  lower: selection_lower,
  append: append,
  insert: insert,
  remove: selection_remove,
  datum: datum,
  on: on,
  dispatch: dispatch
};

/* harmony default export */ var src_selection = (selection_selection);

// CONCATENATED MODULE: ./node_modules/d3-selection/src/select.js


/* harmony default export */ var src_select = (function(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/selectAll.js


/* harmony default export */ var src_selectAll = (function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/touch.js



/* harmony default export */ var src_touch = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return src_point(node, touch);
    }
  }

  return null;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/src/touches.js



/* harmony default export */ var src_touches = (function(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = src_point(node, touches[i]);
  }

  return points;
});

// CONCATENATED MODULE: ./node_modules/d3-selection/index.js

















// CONCATENATED MODULE: ./src/components/Charts/Question.js
var Charts_Question__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function Charts_Question__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Charts_Question__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Charts_Question__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Charts_Question_Question = function (_React$Component) {
  Charts_Question__inherits(Question, _React$Component);

  function Question() {
    Charts_Question__classCallCheck(this, Question);

    return Charts_Question__possibleConstructorReturn(this, (Question.__proto__ || Object.getPrototypeOf(Question)).apply(this, arguments));
  }

  Charts_Question__createClass(Question, [{
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        { className: "question", "data-jsx": 1014795115
        },
        "Factors millennials expect will influence their financial security, around the world.",
        react_default.a.createElement(style_default.a, {
          styleId: 1014795115,
          css: ".question[data-jsx=\"1014795115\"]{color:#444;font-family:FrutigerLTCom;font-weight:300;font-size:24px;line-height:32px;-webkit-text-align:center;text-align:center;margin:0 0 16px 0;width:100%}@media screen and (max-width:768px){.question[data-jsx=\"1014795115\"]{font-size:16px;line-height:24px;-webkit-text-align:left;text-align:left}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0NoYXJ0cy9RdWVzdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPb0IsQUFHd0IsQUFFVyxZQUY0QixJQUVTLGtCQUFvQyxLQUZoQixpQkFBNEIsZ0JBQThCLElBRTNCLGNBRjBELDhDQUErQixtQkFBd0IsWUFBVyIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9DaGFydHMvUXVlc3Rpb24uanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBRdWVzdGlvbiBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJxdWVzdGlvblwiPlxuICAgICAgICBGYWN0b3JzIG1pbGxlbm5pYWxzIGV4cGVjdCB3aWxsIGluZmx1ZW5jZSB0aGVpciBmaW5hbmNpYWwgc2VjdXJpdHksIGFyb3VuZCB0aGUgd29ybGQuXG4gICAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgICAucXVlc3Rpb24ge1xuICAgICAgICAgICAgY29sb3I6ICM0NDQ7XG4gICAgICAgICAgICBmb250LWZhbWlseTogRnJ1dGlnZXJMVENvbTtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiAzMDA7XG4gICAgICAgICAgICBmb250LXNpemU6IDI0cHg7XG4gICAgICAgICAgICBsaW5lLWhlaWdodDogMzJweDtcbiAgICAgICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgICAgIG1hcmdpbjogMCAwIDE2cHggMDtcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoIDogNzY4cHgpIHtcbiAgICAgICAgICAgICAgLnF1ZXN0aW9uIHtcbiAgICAgICAgICAgICAgICAgICBmb250LXNpemU6IDE2cHg7XG4gICAgICAgICAgICAgICAgICAgbGluZS1oZWlnaHQ6IDI0cHg7XG4gICAgICAgICAgICAgICAgICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgICA8L2Rpdj5cbiAgICApXG4gIH1cbn0iXX0= */\n/*@ sourceURL=src/components/Charts/Question.js */"
        })
      );
    }
  }]);

  return Question;
}(react_default.a.Component);

/* harmony default export */ var Charts_Question = (Charts_Question_Question);
// CONCATENATED MODULE: ./node_modules/d3-dispatch/src/dispatch.js
var dispatch_noop = {value: function() {}};

function dispatch_dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function dispatch_parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch_dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = dispatch_parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = dispatch_set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = dispatch_set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function dispatch_set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = dispatch_noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

/* harmony default export */ var src_dispatch = (dispatch_dispatch);

// CONCATENATED MODULE: ./node_modules/d3-dispatch/index.js


// CONCATENATED MODULE: ./node_modules/d3-timer/src/timer.js
var timer_frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    timer_interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++timer_frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --timer_frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  timer_frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    timer_frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (timer_frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, delay);
    if (timer_interval) timer_interval = clearInterval(timer_interval);
  } else {
    if (!timer_interval) clockLast = clockNow, timer_interval = setInterval(poke, pokeDelay);
    timer_frame = 1, setFrame(wake);
  }
}

// CONCATENATED MODULE: ./node_modules/d3-timer/src/timeout.js


/* harmony default export */ var src_timeout = (function(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});

// CONCATENATED MODULE: ./node_modules/d3-timer/src/interval.js


/* harmony default export */ var src_interval = (function(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});

// CONCATENATED MODULE: ./node_modules/d3-timer/index.js






// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/schedule.js



var emptyOn = src_dispatch("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

/* harmony default export */ var transition_schedule = (function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  schedule_create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
});

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function schedule_set(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function schedule_get(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function schedule_create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return src_timeout(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    src_timeout(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

// CONCATENATED MODULE: ./node_modules/d3-transition/src/interrupt.js


/* harmony default export */ var interrupt = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/interrupt.js


/* harmony default export */ var selection_interrupt = (function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/tween.js


function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = schedule_set(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

/* harmony default export */ var transition_tween = (function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = schedule_get(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
});

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = schedule_set(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return schedule_get(node, id).value[name];
  };
}

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/interpolate.js



/* harmony default export */ var transition_interpolate = (function(a, b) {
  var c;
  return (typeof b === "number" ? src_number
      : b instanceof color_color ? src_rgb
      : (c = color_color(b)) ? (b = c, src_rgb)
      : string)(a, b);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attr.js





function attr_attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attr_attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attr_attrConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attr_attrConstantNS(fullname, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function attr_attrFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function attr_attrFunctionNS(fullname, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ var transition_attr = (function(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : transition_interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attr_attrFunctionNS : attr_attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attr_attrRemoveNS : attr_attrRemove)(fullname)
      : (fullname.local ? attr_attrConstantNS : attr_attrConstant)(fullname, i, value + ""));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/attrTween.js


function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_attrTween = (function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/delay.js


function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

/* harmony default export */ var transition_delay = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : schedule_get(this.node(), id).delay;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/duration.js


function durationFunction(id, value) {
  return function() {
    schedule_set(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    schedule_set(this, id).duration = value;
  };
}

/* harmony default export */ var duration = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : schedule_get(this.node(), id).duration;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/ease.js


function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    schedule_set(this, id).ease = value;
  };
}

/* harmony default export */ var ease = (function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : schedule_get(this.node(), id).ease;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/filter.js



/* harmony default export */ var transition_filter = (function(match) {
  if (typeof match !== "function") match = src_matcher(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/merge.js


/* harmony default export */ var transition_merge = (function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/on.js


function on_start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = on_start(name) ? init : schedule_set;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

/* harmony default export */ var transition_on = (function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? schedule_get(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/remove.js
function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

/* harmony default export */ var transition_remove = (function() {
  return this.on("end.remove", removeFunction(this._id));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/select.js




/* harmony default export */ var transition_select = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = src_selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        transition_schedule(subgroup[i], name, id, i, subgroup, schedule_get(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selectAll.js




/* harmony default export */ var transition_selectAll = (function(select) {
  var name = this._name,
      id = this._id;

  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select.call(node, node.__data__, i, group), child, inherit = schedule_get(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            transition_schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/selection.js


var selection_Selection = src_selection.prototype.constructor;

/* harmony default export */ var transition_selection = (function() {
  return new selection_Selection(this._groups, this._parents);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/style.js





function style_styleRemove(name, interpolate) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function style_styleConstant(name, interpolate, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value1);
  };
}

function style_styleFunction(name, interpolate, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate(value00 = value0, value10 = value1);
  };
}

/* harmony default export */ var transition_style = (function(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : transition_interpolate;
  return value == null ? this
          .styleTween(name, style_styleRemove(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? style_styleFunction(name, i, tweenValue(this, "style." + name, value))
          : style_styleConstant(name, i, value + ""), priority);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/styleTween.js
function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

/* harmony default export */ var transition_styleTween = (function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/text.js


function text_textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function text_textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

/* harmony default export */ var transition_text = (function(value) {
  return this.tween("text", typeof value === "function"
      ? text_textFunction(tweenValue(this, "text", value))
      : text_textConstant(value == null ? "" : value + ""));
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/transition.js



/* harmony default export */ var transition_transition = (function() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = schedule_get(node, id0);
        transition_schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/transition/index.js



















var transition_id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function src_transition_transition(name) {
  return src_selection().transition(name);
}

function newId() {
  return ++transition_id;
}

var selection_prototype = src_selection.prototype;

Transition.prototype = src_transition_transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: duration,
  ease: ease
};

// CONCATENATED MODULE: ./node_modules/d3-ease/src/linear.js
function src_linear_linear(t) {
  return +t;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/quad.js
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/cubic.js
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/poly.js
var poly_exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(poly_exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(poly_exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(poly_exponent);

// CONCATENATED MODULE: ./node_modules/d3-ease/src/sin.js
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/exp.js
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/circle.js
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/bounce.js
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

// CONCATENATED MODULE: ./node_modules/d3-ease/src/back.js
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

// CONCATENATED MODULE: ./node_modules/d3-ease/src/elastic.js
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

// CONCATENATED MODULE: ./node_modules/d3-ease/index.js




















// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/transition.js





var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function transition_inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

/* harmony default export */ var selection_transition = (function(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        transition_schedule(node, name, id, i, group, timing || transition_inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
});

// CONCATENATED MODULE: ./node_modules/d3-transition/src/selection/index.js




src_selection.prototype.interrupt = selection_interrupt;
src_selection.prototype.transition = selection_transition;

// CONCATENATED MODULE: ./node_modules/d3-transition/src/active.js



var active_root = [null];

/* harmony default export */ var src_active = (function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], active_root, name, +i);
      }
    }
  }

  return null;
});

// CONCATENATED MODULE: ./node_modules/d3-transition/index.js





// EXTERNAL MODULE: ./src/static/arrow.svg
var arrow = __webpack_require__(263);
var arrow_default = /*#__PURE__*/__webpack_require__.n(arrow);

// EXTERNAL MODULE: ./src/static/emoji/1f4aa.svg
var _f4aa = __webpack_require__(629);
var _f4aa_default = /*#__PURE__*/__webpack_require__.n(_f4aa);

// EXTERNAL MODULE: ./src/static/emoji/1f939-1f3fd.svg
var _f939_1f3fd = __webpack_require__(630);
var _f939_1f3fd_default = /*#__PURE__*/__webpack_require__.n(_f939_1f3fd);

// EXTERNAL MODULE: ./src/static/emoji/26d1.svg
var _6d1 = __webpack_require__(631);
var _6d1_default = /*#__PURE__*/__webpack_require__.n(_6d1);

// EXTERNAL MODULE: ./src/static/emoji/1f4bc.svg
var _f4bc = __webpack_require__(632);
var _f4bc_default = /*#__PURE__*/__webpack_require__.n(_f4bc);

// EXTERNAL MODULE: ./src/static/emoji/1f4bb.svg
var _f4bb = __webpack_require__(633);
var _f4bb_default = /*#__PURE__*/__webpack_require__.n(_f4bb);

// EXTERNAL MODULE: ./src/static/emoji/1f5e8.svg
var _f5e8 = __webpack_require__(634);
var _f5e8_default = /*#__PURE__*/__webpack_require__.n(_f5e8);

// EXTERNAL MODULE: ./src/static/emoji/1f468-1f469-1f467.svg
var _f468_1f469_1f467 = __webpack_require__(635);
var _f468_1f469_1f467_default = /*#__PURE__*/__webpack_require__.n(_f468_1f469_1f467);

// EXTERNAL MODULE: ./src/static/emoji/1f4b0.svg
var _f4b0 = __webpack_require__(636);
var _f4b0_default = /*#__PURE__*/__webpack_require__.n(_f4b0);

// EXTERNAL MODULE: ./src/static/emoji/1f30d.svg
var _f30d = __webpack_require__(637);
var _f30d_default = /*#__PURE__*/__webpack_require__.n(_f30d);

// EXTERNAL MODULE: ./src/static/emoji/1f6eb.svg
var _f6eb = __webpack_require__(638);
var _f6eb_default = /*#__PURE__*/__webpack_require__.n(_f6eb);

// EXTERNAL MODULE: ./src/static/emoji/1f5e3.svg
var _f5e3 = __webpack_require__(639);
var _f5e3_default = /*#__PURE__*/__webpack_require__.n(_f5e3);

// EXTERNAL MODULE: ./src/static/emoji/1f4e6.svg
var _f4e6 = __webpack_require__(640);
var _f4e6_default = /*#__PURE__*/__webpack_require__.n(_f4e6);

// EXTERNAL MODULE: ./src/static/emoji/1f3e6.svg
var _f3e6 = __webpack_require__(641);
var _f3e6_default = /*#__PURE__*/__webpack_require__.n(_f3e6);

// EXTERNAL MODULE: ./src/static/emoji/1f46b.svg
var _f46b = __webpack_require__(642);
var _f46b_default = /*#__PURE__*/__webpack_require__.n(_f46b);

// EXTERNAL MODULE: ./src/static/emoji/1f6c2.svg
var _f6c2 = __webpack_require__(643);
var _f6c2_default = /*#__PURE__*/__webpack_require__.n(_f6c2);

// CONCATENATED MODULE: ./src/components/SlopeChartFactors.js
var SlopeChartFactors__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function SlopeChartFactors__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SlopeChartFactors__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SlopeChartFactors__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






 // education
 // ambition
 // flexibility
 // resilience
 // job market
 // tech skills
 // social network
 // family responsibilities
 // Economic policies
 // global standing
 // ability to work abroad
 // foreign language skills
 // trade relationships
 // access to family capital
 // gender
 // immigration

var svgHash = {
  "Level of education": _f393_default.a,
  Ambition: _f4aa_default.a,
  "Flexibility / Adaptability": _f939_1f3fd_default.a,
  Resilience: _6d1_default.a,
  "Job market": _f4bc_default.a,
  "Tech skills": _f4bb_default.a,
  "Social network": _f5e8_default.a,
  "Family responsibilities": _f468_1f469_1f467_default.a,
  "Economic policy": _f4b0_default.a,
  "Global standing": _f30d_default.a,
  "Ability to work abroad": _f6eb_default.a,
  "Foreign language skills": _f5e3_default.a,
  "Trade relationships": _f4e6_default.a,
  "Access to family capital": _f3e6_default.a,
  Gender: _f46b_default.a,
  Immigration: _f6c2_default.a
};

var RankStyleAbilities = {
  fill: "#807266",
  stroke: "#807266",
  strokeWidth: "2px",
  strokeLinecap: "round"
};
var RankStyleFactors = {
  fill: "#D7C2AA",
  stroke: "#D7C2AA",
  strokeWidth: "2px",
  strokeLinecap: "round"
};

var rowSpace = 40;

var SlopeChartFactors_Controls = function (_Component) {
  SlopeChartFactors__inherits(Controls, _Component);

  function Controls(props) {
    SlopeChartFactors__classCallCheck(this, Controls);

    var _this = SlopeChartFactors__possibleConstructorReturn(this, (Controls.__proto__ || Object.getPrototypeOf(Controls)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  SlopeChartFactors__createClass(Controls, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.onChange(event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var isMobile = this.props.width > 768;
      var oCountry = isMobile ? this.props.otherCountry : null;
      //const width = isMobile ? "210px" : this.props.width+"px";

      return react_default.a.createElement(
        "div",
        {
          className: this.props.side === "left" ? "controls-container controls-container-left" : "controls-container controls-container-right",
          "data-jsx": 751588917
        },
        react_default.a.createElement(
          "div",
          {
            "data-jsx": 751588917
          },
          react_default.a.createElement(
            "form",
            {
              "data-jsx": 751588917
            },
            react_default.a.createElement(
              "select",
              { value: this.props.country, onChange: this.handleChange, "data-jsx": 751588917
              },
              react_default.a.createElement(
                "optgroup",
                { label: "Markets: ", "data-jsx": 751588917
                },
                react_default.a.createElement(
                  "option",
                  {
                    disabled: oCountry === "Emerging markets",
                    value: "Emerging markets",
                    "data-jsx": 751588917
                  },
                  "Emerging markets"
                ),
                react_default.a.createElement(
                  "option",
                  {
                    disabled: oCountry === "Developed markets",
                    value: "Developed markets",
                    "data-jsx": 751588917
                  },
                  "Developed markets"
                )
              ),
              react_default.a.createElement(
                "optgroup",
                { label: "Countries: ", "data-jsx": 751588917
                },
                react_default.a.createElement(
                  "option",
                  {
                    disabled: oCountry === "United States",
                    value: "United States",
                    "data-jsx": 751588917
                  },
                  "United States"
                ),
                react_default.a.createElement(
                  "option",
                  {
                    disabled: oCountry === "United Kingdom",
                    value: "United Kingdom",
                    "data-jsx": 751588917
                  },
                  "United Kingdom"
                ),
                react_default.a.createElement(
                  "option",
                  { disabled: oCountry === "Germany", value: "Germany", "data-jsx": 751588917
                  },
                  "Germany"
                ),
                react_default.a.createElement(
                  "option",
                  { disabled: oCountry === "Singapore", value: "Singapore", "data-jsx": 751588917
                  },
                  "Singapore"
                ),
                react_default.a.createElement(
                  "option",
                  { disabled: oCountry === "Russia", value: "Russia", "data-jsx": 751588917
                  },
                  "Russia"
                ),
                react_default.a.createElement(
                  "option",
                  { disabled: oCountry === "China", value: "China", "data-jsx": 751588917
                  },
                  "China"
                ),
                react_default.a.createElement(
                  "option",
                  { disabled: oCountry === "India", value: "India", "data-jsx": 751588917
                  },
                  "India"
                ),
                react_default.a.createElement(
                  "option",
                  {
                    disabled: oCountry === "United Arab Emirates",
                    value: "United Arab Emirates",
                    "data-jsx": 751588917
                  },
                  "United Arab Emirates"
                ),
                react_default.a.createElement(
                  "option",
                  { disabled: oCountry === "Mexico", value: "Mexico", "data-jsx": 751588917
                  },
                  "Mexico"
                ),
                react_default.a.createElement(
                  "option",
                  {
                    disabled: oCountry === "South Africa",
                    value: "South Africa",
                    "data-jsx": 751588917
                  },
                  "South Africa"
                )
              )
            )
          ),
          react_default.a.createElement(SlopeChartFactors_RankList, {
            list: this.props.answers,
            country: this.props.country,
            personalAbilities: this.props.personalAbilities,
            side: this.props.side
          })
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 751588917,
          css: ".controls-container[data-jsx=\"751588917\"]{-webkit-flex:1 1 0%;-ms-flex:1 1 0%;flex:1 1 0%}.controls[data-jsx=\"751588917\"]{width:100%}select[data-jsx=\"751588917\"]{width:100%;margin:20px 0 10px 0;padding:10px;border:1px solid #646464;border-radius:0;font-family:FrutigerLTCom;font-size:14px;-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-appearance:none;background:url('" + arrow_default.a + "') no-repeat right;background-position-x:95%}select[data-jsx=\"751588917\"]:focus{outline:none}select[data-jsx=\"751588917\"]::-ms-expand{display:none}@media screen and (max-width:768px){.controls-container-left[data-jsx=\"751588917\"]{display:none}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartFactors.js */"
        })
      );
    }
  }]);

  return Controls;
}(react["Component"]);

var SlopeChartFactors_RankList = function (_Component2) {
  SlopeChartFactors__inherits(RankList, _Component2);

  function RankList() {
    SlopeChartFactors__classCallCheck(this, RankList);

    return SlopeChartFactors__possibleConstructorReturn(this, (RankList.__proto__ || Object.getPrototypeOf(RankList)).apply(this, arguments));
  }

  SlopeChartFactors__createClass(RankList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var thisNode = src_select(this.node);
      var listItems = thisNode.selectAll("div.rank-list-item");
      listItems.transition().duration(0).style("transform", function (d, i) {
        return "translate(0px, " + i * rowSpace + "px)";
      });

      listItems.on("mouseover", function (d, i) {
        src_selectAll("div.rank-list-item").style("opacity", ".3");
        src_selectAll("line").style("stroke-opacity", ".3");
        var val = thisNode.select("div.rank-list-item#id" + i + "").attr("value");
        src_selectAll('div.rank-list-item[value = "' + val + '"]').style("opacity", "1");
        src_select('line[value = "' + val + '"]').style("stroke-opacity", "1").raise();
      });

      src_selectAll(".controls-container").on("mouseleave", function (d, i) {
        src_selectAll("div.rank-list-item").style("opacity", "1");
        src_selectAll("line").style("stroke-opacity", "1");
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var thisNode = src_select(this.node);
      var listItems = src_select(this.node).selectAll("div.rank-list-item");
      listItems.transition().duration(1000).style("transform", function (d, i) {
        return "translate(0px, " + i * rowSpace + "px)";
      });

      listItems.on("mouseover", function (d, i) {
        src_selectAll("div.rank-list-item").style("opacity", ".3");
        src_selectAll("line").style("stroke-opacity", ".3");
        var val = thisNode.select("div.rank-list-item#id" + i + "").attr("value");
        src_selectAll('div.rank-list-item[value = "' + val + '"]').style("opacity", "1");
        src_select('line[value = "' + val + '"]').style("stroke-opacity", "1").raise();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var TheseAnswers = this.props.list.find(function (d) {
        return d.country === _this3.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });
      return react_default.a.createElement(
        "div",
        {
          className: "rank-list",
          ref: function ref(rankListDiv) {
            _this3.node = rankListDiv;
          },
          "data-jsx": 3285162477
        },
        TheseAnswers.map(function (d, i) {
          return react_default.a.createElement(
            "div",
            {
              className: _this3.props.side === "left" ? "rank-list-item rank-list-item-left" : "rank-list-item rank-list-item-right",
              key: d.key,
              id: "id" + i,
              value: d.key,
              "data-jsx": 3285162477
            },
            react_default.a.createElement("img", {
              src: svgHash[d.key],
              alt: "emoji " + d.key,
              width: "24px",
              height: "24px",
              "data-jsx": 3285162477
            }),
            react_default.a.createElement(
              "div",
              {
                className: _this3.props.side === "left" ? "rank-label rank-label-left" : "rank-label rank-label-right",
                "data-jsx": 3285162477
              },
              d.key
            ),
            react_default.a.createElement(
              "div",
              {
                className: "rank-number",
                style: {
                  color: _this3.props.personalAbilities.includes(d.key) ? RankStyleAbilities.fill : "#B89D83",
                  textAlign: _this3.props.side === "left" ? "right" : "left"
                },
                "data-jsx": 3285162477
              },
              i + 1
            )
          );
        }),
        react_default.a.createElement(style_default.a, {
          styleId: 3285162477,
          css: ".rank-list[data-jsx=\"3285162477\"]{position:relative;padding-top:12px}.rank-list-item[data-jsx=\"3285162477\"]{position:absolute;width:100%;height:30px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between}.rank-list-item-left[data-jsx=\"3285162477\"]{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row}.rank-list-item-right[data-jsx=\"3285162477\"]{-webkit-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.rank-label[data-jsx=\"3285162477\"]{color:#333;font-family:FrutigerLTCom;font-size:16px;font-weight:300;padding:0 10px 0 10px;cursor:default}.rank-label-left[data-jsx=\"3285162477\"]{margin-left:auto}.rank-label-right[data-jsx=\"3285162477\"]{margin-right:auto}.rank-number[data-jsx=\"3285162477\"]{font-family:FrutigerLTCom;font-size:16px;font-weight:700;width:16px}@media screen and (max-width:768px){.rank-list[data-jsx=\"3285162477\"]{pointer-events:none}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartFactors.js */"
        })
      );
    }
  }]);

  return RankList;
}(react["Component"]);

var SlopeChartFactors_Slope = function (_Component3) {
  SlopeChartFactors__inherits(Slope, _Component3);

  function Slope() {
    SlopeChartFactors__classCallCheck(this, Slope);

    return SlopeChartFactors__possibleConstructorReturn(this, (Slope.__proto__ || Object.getPrototypeOf(Slope)).apply(this, arguments));
  }

  SlopeChartFactors__createClass(Slope, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;

      var LeftAnswers = this.props.answers.find(function (d) {
        return d.country === _this5.props.LeftCountry;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });
      var RightAnswers = this.props.answers.find(function (d) {
        return d.country === _this5.props.RightCountry;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });

      RightAnswers.forEach(function (d, i) {
        d.rank = i;
      });

      var lines = src_select(this.node).selectAll("line");

      lines.transition().duration(0).attr("y1", function (d, i) {
        var id = src_select(this).attr("id");
        return id * rowSpace;
      }).attr("y2", function (d, i) {
        var id = src_select(this).attr("id");
        var rightRank = RightAnswers.find(function (r) {
          return r.key === LeftAnswers[id].key;
        });
        return rightRank.rank * rowSpace;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this6 = this;

      var LeftAnswers = this.props.answers.find(function (d) {
        return d.country === _this6.props.LeftCountry;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });
      var RightAnswers = this.props.answers.find(function (d) {
        return d.country === _this6.props.RightCountry;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });

      RightAnswers.forEach(function (d, i) {
        d.rank = i;
      });

      var lines = src_select(this.node).selectAll("line");

      lines.transition().duration(1000).attr("y1", function (d, i) {
        var id = src_select(this).attr("id");
        return id * rowSpace;
      }).attr("y2", function (d, i) {
        var id = src_select(this).attr("id");
        var rightRank = RightAnswers.find(function (r) {
          return r.key === LeftAnswers[id].key;
        });
        return rightRank.rank * rowSpace;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var LeftAnswers = this.props.answers.find(function (d) {
        return d.country === _this7.props.LeftCountry;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });

      return react_default.a.createElement(
        "div",
        {
          "data-jsx": 3158951469
        },
        react_default.a.createElement(
          "svg",
          { className: "svg-slope", width: "300px", height: "640px", "data-jsx": 3158951469
          },
          react_default.a.createElement(
            "g",
            {
              className: "slopes-group",
              ref: function ref(node) {
                _this7.node = node;
              },
              "data-jsx": 3158951469
            },
            LeftAnswers.map(function (d, i) {
              return react_default.a.createElement("line", {
                key: d.key,
                id: i,
                value: d.key,
                x1: 20,
                y1: 0,
                x2: 280,
                y2: 0,
                style: _this7.props.personalAbilities.includes(d.key) ? RankStyleAbilities : RankStyleFactors,
                "data-jsx": 3158951469
              });
            })
          )
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 3158951469,
          css: "svg[data-jsx=\"3158951469\"]{display:block}.svg-slope[data-jsx=\"3158951469\"]{padding-top:98px}@media screen and (max-width:768px){.svg-slope[data-jsx=\"3158951469\"]{display:none}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartFactors.js */"
        })
      );
    }
  }]);

  return Slope;
}(react["Component"]);

var SlopeChartFactors_ColorLegend = function (_Component4) {
  SlopeChartFactors__inherits(ColorLegend, _Component4);

  function ColorLegend() {
    SlopeChartFactors__classCallCheck(this, ColorLegend);

    return SlopeChartFactors__possibleConstructorReturn(this, (ColorLegend.__proto__ || Object.getPrototypeOf(ColorLegend)).apply(this, arguments));
  }

  SlopeChartFactors__createClass(ColorLegend, [{
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        { className: "legend-container", "data-jsx": 1018886954
        },
        react_default.a.createElement(
          "div",
          { className: "color-legend", "data-jsx": 1018886954
          },
          react_default.a.createElement(
            "div",
            { className: "color-legend-title", "data-jsx": 1018886954
            },
            "Areas of influence"
          ),
          react_default.a.createElement(
            "div",
            { className: "color-legend-items", "data-jsx": 1018886954
            },
            react_default.a.createElement(
              "div",
              {
                "data-jsx": 1018886954
              },
              react_default.a.createElement(
                "svg",
                { className: "left-legend-item", width: "10px", height: "10px", "data-jsx": 1018886954
                },
                react_default.a.createElement("circle", { cx: "5", cy: "5", r: "5", stroke: "none", fill: "#807266", "data-jsx": 1018886954
                })
              ),
              "Personal abilities"
            ),
            react_default.a.createElement(
              "div",
              {
                "data-jsx": 1018886954
              },
              react_default.a.createElement(
                "svg",
                { width: "10px", height: "10px", "data-jsx": 1018886954
                },
                react_default.a.createElement("circle", { cx: "5", cy: "5", r: "5", stroke: "none", fill: "#D7C2AA", "data-jsx": 1018886954
                })
              ),
              "Societal factors"
            )
          ),
          react_default.a.createElement(
            "div",
            { className: "source", "data-jsx": 1018886954
            },
            "Source: unlimited.world survey of affluent millennials, UBS. Data as of October 2016. N = 2,130."
          )
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 1018886954,
          css: ".legend-container[data-jsx=\"1018886954\"]{font-family:FrutigerLTCom;width:100%;padding-top:8px}.color-legend[data-jsx=\"1018886954\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:78px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;font-size:14px}.color-legend-title[data-jsx=\"1018886954\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;height:26px;font-weight:700}.color-legend-items[data-jsx=\"1018886954\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;font-weight:300;height:26px}svg[data-jsx=\"1018886954\"]{padding-left:15px;padding-right:8px}.source[data-jsx=\"1018886954\"]{font-size:11px;font-weight:300;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;color:#888;height:26px}@media screen and (max-width:768px){.color-legend-title[data-jsx=\"1018886954\"],.color-legend-items[data-jsx=\"1018886954\"],.source[data-jsx=\"1018886954\"]{-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.left-legend-item[data-jsx=\"1018886954\"]{padding-left:0}.legend-container[data-jsx=\"1018886954\"]{-webkit-align-self:flex-start;-ms-flex-item-align:flex-start;align-self:flex-start}}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1Nsb3BlQ2hhcnRGYWN0b3JzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNlb0IsQUFHdUMsQUFDYixBQUVBLEFBQ0EsQUFDSyxBQUNILEFBRVksQUFFUixBQUVPLGdCQU5rQixBQUlWLEdBTGUsUUFMQyxNQU1vQixLQURWLENBTG1CLGlCQUFXLHNCQUNwRCxBQUVXLEFBQ0EsUUFRUixLQVhnQyxvQkFLaUMsRUFHM0UsMkRBUjBFLFNBRWhDLEFBQ0EsWUFEeUIsQUFDSSxhQUR5QixJQUNBLElBRUcsUUFHcEYsQ0FONEYsQUFDQSxHQUVnQixZQUF5QixhQUFXLGtCQUp2Syx1R0FBNEIsZ0JBQVciLCJmaWxlIjoic3JjL2NvbXBvbmVudHMvU2xvcGVDaGFydEZhY3RvcnMuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgc2VsZWN0LCBzZWxlY3RBbGwgfSBmcm9tIFwiZDMtc2VsZWN0aW9uXCI7XG5pbXBvcnQgUXVlc3Rpb24gZnJvbSBcIi4vQ2hhcnRzL1F1ZXN0aW9uXCI7XG5pbXBvcnQgXCJkMy10cmFuc2l0aW9uXCI7XG5pbXBvcnQgYXJyb3dTdmcgZnJvbSBcIi4uL3N0YXRpYy9hcnJvdy5zdmdcIjtcbmltcG9ydCBzdmcxIGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWYzOTMuc3ZnXCI7IC8vIGVkdWNhdGlvblxuaW1wb3J0IHN2ZzIgZnJvbSBcIi4uL3N0YXRpYy9lbW9qaS8xZjRhYS5zdmdcIjsgLy8gYW1iaXRpb25cbmltcG9ydCBzdmczIGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY5MzktMWYzZmQuc3ZnXCI7IC8vIGZsZXhpYmlsaXR5XG5pbXBvcnQgc3ZnNCBmcm9tIFwiLi4vc3RhdGljL2Vtb2ppLzI2ZDEuc3ZnXCI7IC8vIHJlc2lsaWVuY2VcbmltcG9ydCBzdmc1IGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY0YmMuc3ZnXCI7IC8vIGpvYiBtYXJrZXRcbmltcG9ydCBzdmc2IGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY0YmIuc3ZnXCI7IC8vIHRlY2ggc2tpbGxzXG5pbXBvcnQgc3ZnNyBmcm9tIFwiLi4vc3RhdGljL2Vtb2ppLzFmNWU4LnN2Z1wiOyAvLyBzb2NpYWwgbmV0d29ya1xuaW1wb3J0IHN2ZzggZnJvbSBcIi4uL3N0YXRpYy9lbW9qaS8xZjQ2OC0xZjQ2OS0xZjQ2Ny5zdmdcIjsgLy8gZmFtaWx5IHJlc3BvbnNpYmlsaXRpZXNcbmltcG9ydCBzdmc5IGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY0YjAuc3ZnXCI7IC8vIEVjb25vbWljIHBvbGljaWVzXG5pbXBvcnQgc3ZnMTAgZnJvbSBcIi4uL3N0YXRpYy9lbW9qaS8xZjMwZC5zdmdcIjsgLy8gZ2xvYmFsIHN0YW5kaW5nXG5pbXBvcnQgc3ZnMTEgZnJvbSBcIi4uL3N0YXRpYy9lbW9qaS8xZjZlYi5zdmdcIjsgLy8gYWJpbGl0eSB0byB3b3JrIGFicm9hZFxuaW1wb3J0IHN2ZzEyIGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY1ZTMuc3ZnXCI7IC8vIGZvcmVpZ24gbGFuZ3VhZ2Ugc2tpbGxzXG5pbXBvcnQgc3ZnMTMgZnJvbSBcIi4uL3N0YXRpYy9lbW9qaS8xZjRlNi5zdmdcIjsgLy8gdHJhZGUgcmVsYXRpb25zaGlwc1xuaW1wb3J0IHN2ZzE0IGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWYzZTYuc3ZnXCI7IC8vIGFjY2VzcyB0byBmYW1pbHkgY2FwaXRhbFxuaW1wb3J0IHN2ZzE1IGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY0NmIuc3ZnXCI7IC8vIGdlbmRlclxuaW1wb3J0IHN2ZzE2IGZyb20gXCIuLi9zdGF0aWMvZW1vamkvMWY2YzIuc3ZnXCI7IC8vIGltbWlncmF0aW9uXG5cbmNvbnN0IHN2Z0hhc2ggPSB7XG4gIFwiTGV2ZWwgb2YgZWR1Y2F0aW9uXCI6IHN2ZzEsXG4gIEFtYml0aW9uOiBzdmcyLFxuICBcIkZsZXhpYmlsaXR5IC8gQWRhcHRhYmlsaXR5XCI6IHN2ZzMsXG4gIFJlc2lsaWVuY2U6IHN2ZzQsXG4gIFwiSm9iIG1hcmtldFwiOiBzdmc1LFxuICBcIlRlY2ggc2tpbGxzXCI6IHN2ZzYsXG4gIFwiU29jaWFsIG5ldHdvcmtcIjogc3ZnNyxcbiAgXCJGYW1pbHkgcmVzcG9uc2liaWxpdGllc1wiOiBzdmc4LFxuICBcIkVjb25vbWljIHBvbGljeVwiOiBzdmc5LFxuICBcIkdsb2JhbCBzdGFuZGluZ1wiOiBzdmcxMCxcbiAgXCJBYmlsaXR5IHRvIHdvcmsgYWJyb2FkXCI6IHN2ZzExLFxuICBcIkZvcmVpZ24gbGFuZ3VhZ2Ugc2tpbGxzXCI6IHN2ZzEyLFxuICBcIlRyYWRlIHJlbGF0aW9uc2hpcHNcIjogc3ZnMTMsXG4gIFwiQWNjZXNzIHRvIGZhbWlseSBjYXBpdGFsXCI6IHN2ZzE0LFxuICBHZW5kZXI6IHN2ZzE1LFxuICBJbW1pZ3JhdGlvbjogc3ZnMTZcbn07XG5cbmNvbnN0IFJhbmtTdHlsZUFiaWxpdGllcyA9IHtcbiAgZmlsbDogXCIjODA3MjY2XCIsXG4gIHN0cm9rZTogXCIjODA3MjY2XCIsXG4gIHN0cm9rZVdpZHRoOiBcIjJweFwiLFxuICBzdHJva2VMaW5lY2FwOiBcInJvdW5kXCJcbn07XG5jb25zdCBSYW5rU3R5bGVGYWN0b3JzID0ge1xuICBmaWxsOiBcIiNEN0MyQUFcIixcbiAgc3Ryb2tlOiBcIiNEN0MyQUFcIixcbiAgc3Ryb2tlV2lkdGg6IFwiMnB4XCIsXG4gIHN0cm9rZUxpbmVjYXA6IFwicm91bmRcIlxufTtcblxuY29uc3Qgcm93U3BhY2UgPSA0MDtcblxuY2xhc3MgQ29udHJvbHMgZXh0ZW5kcyBDb21wb25lbnQge1xuICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgIHN1cGVyKHByb3BzKTtcbiAgICB0aGlzLmhhbmRsZUNoYW5nZSA9IHRoaXMuaGFuZGxlQ2hhbmdlLmJpbmQodGhpcyk7XG4gIH1cblxuICBoYW5kbGVDaGFuZ2UoZXZlbnQpIHtcbiAgICB0aGlzLnByb3BzLm9uQ2hhbmdlKGV2ZW50LnRhcmdldC52YWx1ZSk7XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgaXNNb2JpbGUgPSB0aGlzLnByb3BzLndpZHRoID4gNzY4O1xuICAgIGNvbnN0IG9Db3VudHJ5ID0gaXNNb2JpbGUgPyB0aGlzLnByb3BzLm90aGVyQ291bnRyeSA6IG51bGw7XG4gICAgLy9jb25zdCB3aWR0aCA9IGlzTW9iaWxlID8gXCIyMTBweFwiIDogdGhpcy5wcm9wcy53aWR0aCtcInB4XCI7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdlxuICAgICAgICBjbGFzc05hbWU9e1xuICAgICAgICAgIHRoaXMucHJvcHMuc2lkZSA9PT0gXCJsZWZ0XCJcbiAgICAgICAgICAgID8gXCJjb250cm9scy1jb250YWluZXIgY29udHJvbHMtY29udGFpbmVyLWxlZnRcIlxuICAgICAgICAgICAgOiBcImNvbnRyb2xzLWNvbnRhaW5lciBjb250cm9scy1jb250YWluZXItcmlnaHRcIlxuICAgICAgICB9XG4gICAgICA+XG4gICAgICAgIDxkaXY+XG4gICAgICAgICAgPGZvcm0+XG4gICAgICAgICAgICA8c2VsZWN0IHZhbHVlPXt0aGlzLnByb3BzLmNvdW50cnl9IG9uQ2hhbmdlPXt0aGlzLmhhbmRsZUNoYW5nZX0+XG4gICAgICAgICAgICAgIDxvcHRncm91cCBsYWJlbD1cIk1hcmtldHM6IFwiPlxuICAgICAgICAgICAgICAgIDxvcHRpb25cbiAgICAgICAgICAgICAgICAgIGRpc2FibGVkPXtvQ291bnRyeSA9PT0gXCJFbWVyZ2luZyBtYXJrZXRzXCJ9XG4gICAgICAgICAgICAgICAgICB2YWx1ZT1cIkVtZXJnaW5nIG1hcmtldHNcIlxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgIEVtZXJnaW5nIG1hcmtldHNcbiAgICAgICAgICAgICAgICA8L29wdGlvbj5cbiAgICAgICAgICAgICAgICA8b3B0aW9uXG4gICAgICAgICAgICAgICAgICBkaXNhYmxlZD17b0NvdW50cnkgPT09IFwiRGV2ZWxvcGVkIG1hcmtldHNcIn1cbiAgICAgICAgICAgICAgICAgIHZhbHVlPVwiRGV2ZWxvcGVkIG1hcmtldHNcIlxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgIERldmVsb3BlZCBtYXJrZXRzXG4gICAgICAgICAgICAgICAgPC9vcHRpb24+XG4gICAgICAgICAgICAgIDwvb3B0Z3JvdXA+XG4gICAgICAgICAgICAgIDxvcHRncm91cCBsYWJlbD1cIkNvdW50cmllczogXCI+XG4gICAgICAgICAgICAgICAgPG9wdGlvblxuICAgICAgICAgICAgICAgICAgZGlzYWJsZWQ9e29Db3VudHJ5ID09PSBcIlVuaXRlZCBTdGF0ZXNcIn1cbiAgICAgICAgICAgICAgICAgIHZhbHVlPVwiVW5pdGVkIFN0YXRlc1wiXG4gICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgVW5pdGVkIFN0YXRlc1xuICAgICAgICAgICAgICAgIDwvb3B0aW9uPlxuICAgICAgICAgICAgICAgIDxvcHRpb25cbiAgICAgICAgICAgICAgICAgIGRpc2FibGVkPXtvQ291bnRyeSA9PT0gXCJVbml0ZWQgS2luZ2RvbVwifVxuICAgICAgICAgICAgICAgICAgdmFsdWU9XCJVbml0ZWQgS2luZ2RvbVwiXG4gICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgVW5pdGVkIEtpbmdkb21cbiAgICAgICAgICAgICAgICA8L29wdGlvbj5cbiAgICAgICAgICAgICAgICA8b3B0aW9uIGRpc2FibGVkPXtvQ291bnRyeSA9PT0gXCJHZXJtYW55XCJ9IHZhbHVlPVwiR2VybWFueVwiPlxuICAgICAgICAgICAgICAgICAgR2VybWFueVxuICAgICAgICAgICAgICAgIDwvb3B0aW9uPlxuICAgICAgICAgICAgICAgIDxvcHRpb24gZGlzYWJsZWQ9e29Db3VudHJ5ID09PSBcIlNpbmdhcG9yZVwifSB2YWx1ZT1cIlNpbmdhcG9yZVwiPlxuICAgICAgICAgICAgICAgICAgU2luZ2Fwb3JlXG4gICAgICAgICAgICAgICAgPC9vcHRpb24+XG4gICAgICAgICAgICAgICAgPG9wdGlvbiBkaXNhYmxlZD17b0NvdW50cnkgPT09IFwiUnVzc2lhXCJ9IHZhbHVlPVwiUnVzc2lhXCI+XG4gICAgICAgICAgICAgICAgICBSdXNzaWFcbiAgICAgICAgICAgICAgICA8L29wdGlvbj5cbiAgICAgICAgICAgICAgICA8b3B0aW9uIGRpc2FibGVkPXtvQ291bnRyeSA9PT0gXCJDaGluYVwifSB2YWx1ZT1cIkNoaW5hXCI+XG4gICAgICAgICAgICAgICAgICBDaGluYVxuICAgICAgICAgICAgICAgIDwvb3B0aW9uPlxuICAgICAgICAgICAgICAgIDxvcHRpb24gZGlzYWJsZWQ9e29Db3VudHJ5ID09PSBcIkluZGlhXCJ9IHZhbHVlPVwiSW5kaWFcIj5cbiAgICAgICAgICAgICAgICAgIEluZGlhXG4gICAgICAgICAgICAgICAgPC9vcHRpb24+XG4gICAgICAgICAgICAgICAgPG9wdGlvblxuICAgICAgICAgICAgICAgICAgZGlzYWJsZWQ9e29Db3VudHJ5ID09PSBcIlVuaXRlZCBBcmFiIEVtaXJhdGVzXCJ9XG4gICAgICAgICAgICAgICAgICB2YWx1ZT1cIlVuaXRlZCBBcmFiIEVtaXJhdGVzXCJcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICBVbml0ZWQgQXJhYiBFbWlyYXRlc1xuICAgICAgICAgICAgICAgIDwvb3B0aW9uPlxuICAgICAgICAgICAgICAgIDxvcHRpb24gZGlzYWJsZWQ9e29Db3VudHJ5ID09PSBcIk1leGljb1wifSB2YWx1ZT1cIk1leGljb1wiPlxuICAgICAgICAgICAgICAgICAgTWV4aWNvXG4gICAgICAgICAgICAgICAgPC9vcHRpb24+XG4gICAgICAgICAgICAgICAgPG9wdGlvblxuICAgICAgICAgICAgICAgICAgZGlzYWJsZWQ9e29Db3VudHJ5ID09PSBcIlNvdXRoIEFmcmljYVwifVxuICAgICAgICAgICAgICAgICAgdmFsdWU9XCJTb3V0aCBBZnJpY2FcIlxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgIFNvdXRoIEFmcmljYVxuICAgICAgICAgICAgICAgIDwvb3B0aW9uPlxuICAgICAgICAgICAgICA8L29wdGdyb3VwPlxuICAgICAgICAgICAgPC9zZWxlY3Q+XG4gICAgICAgICAgPC9mb3JtPlxuICAgICAgICAgIDxSYW5rTGlzdFxuICAgICAgICAgICAgbGlzdD17dGhpcy5wcm9wcy5hbnN3ZXJzfVxuICAgICAgICAgICAgY291bnRyeT17dGhpcy5wcm9wcy5jb3VudHJ5fVxuICAgICAgICAgICAgcGVyc29uYWxBYmlsaXRpZXM9e3RoaXMucHJvcHMucGVyc29uYWxBYmlsaXRpZXN9XG4gICAgICAgICAgICBzaWRlPXt0aGlzLnByb3BzLnNpZGV9XG4gICAgICAgICAgLz5cblxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIC5jb250cm9scy1jb250YWluZXIge1xuICAgICAgICAgICAgZmxleDogMSAxIDAlO1xuICAgICAgICAgIH1cbiAgICAgICAgICAuY29udHJvbHMge1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgfVxuICAgICAgICAgIHNlbGVjdCB7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgIG1hcmdpbjogMjBweCAwIDEwcHggMDtcbiAgICAgICAgICAgIHBhZGRpbmc6IDEwcHg7XG4gICAgICAgICAgICBib3JkZXI6IDFweCBzb2xpZCAjNjQ2NDY0O1xuICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogMDtcbiAgICAgICAgICAgIGZvbnQtZmFtaWx5OiBGcnV0aWdlckxUQ29tO1xuICAgICAgICAgICAgZm9udC1zaXplOiAxNHB4O1xuICAgICAgICAgICAgYXBwZWFyYW5jZTogbm9uZTtcbiAgICAgICAgICAgIC13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTtcbiAgICAgICAgICAgIGJhY2tncm91bmQ6IHVybCgnJHthcnJvd1N2Z30nKSBuby1yZXBlYXQgcmlnaHQ7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kLXBvc2l0aW9uLXg6IDk1JTtcbiAgICAgICAgICB9XG4gICAgICAgICAgc2VsZWN0OmZvY3VzIHtcbiAgICAgICAgICAgIG91dGxpbmU6IG5vbmU7XG4gICAgICAgICAgfVxuICAgICAgICAgIHNlbGVjdDo6LW1zLWV4cGFuZCB7XG4gICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoIDogNzY4cHgpIHtcbiAgICAgICAgICAgICAgLmNvbnRyb2xzLWNvbnRhaW5lci1sZWZ0IHtcbiAgICAgICAgICAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG5cbmNsYXNzIFJhbmtMaXN0IGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgY29tcG9uZW50RGlkTW91bnQoKSB7XG4gICAgY29uc3QgdGhpc05vZGUgPSBzZWxlY3QodGhpcy5ub2RlKTtcbiAgICBjb25zdCBsaXN0SXRlbXMgPSB0aGlzTm9kZS5zZWxlY3RBbGwoXCJkaXYucmFuay1saXN0LWl0ZW1cIik7XG4gICAgbGlzdEl0ZW1zLnRyYW5zaXRpb24oKS5kdXJhdGlvbigwKS5zdHlsZShcInRyYW5zZm9ybVwiLCBmdW5jdGlvbihkLCBpKSB7XG4gICAgICByZXR1cm4gXCJ0cmFuc2xhdGUoMHB4LCBcIiArIGkgKiByb3dTcGFjZSArIFwicHgpXCI7XG4gICAgfSk7XG5cbiAgICBsaXN0SXRlbXMub24oXCJtb3VzZW92ZXJcIiwgKGQsIGkpID0+IHtcbiAgICAgIHNlbGVjdEFsbChcImRpdi5yYW5rLWxpc3QtaXRlbVwiKS5zdHlsZShcIm9wYWNpdHlcIiwgXCIuM1wiKTtcbiAgICAgIHNlbGVjdEFsbChcImxpbmVcIikuc3R5bGUoXCJzdHJva2Utb3BhY2l0eVwiLCBcIi4zXCIpO1xuICAgICAgY29uc3QgdmFsID0gdGhpc05vZGVcbiAgICAgICAgLnNlbGVjdChcImRpdi5yYW5rLWxpc3QtaXRlbSNpZFwiICsgaSArIFwiXCIpXG4gICAgICAgIC5hdHRyKFwidmFsdWVcIik7XG4gICAgICBzZWxlY3RBbGwoJ2Rpdi5yYW5rLWxpc3QtaXRlbVt2YWx1ZSA9IFwiJyArIHZhbCArICdcIl0nKS5zdHlsZShcbiAgICAgICAgXCJvcGFjaXR5XCIsXG4gICAgICAgIFwiMVwiXG4gICAgICApO1xuICAgICAgc2VsZWN0KCdsaW5lW3ZhbHVlID0gXCInICsgdmFsICsgJ1wiXScpXG4gICAgICAgIC5zdHlsZShcInN0cm9rZS1vcGFjaXR5XCIsIFwiMVwiKVxuICAgICAgICAucmFpc2UoKTtcbiAgICB9KTtcblxuICAgIHNlbGVjdEFsbChcIi5jb250cm9scy1jb250YWluZXJcIikub24oXCJtb3VzZWxlYXZlXCIsIChkLCBpKSA9PiB7XG4gICAgICBzZWxlY3RBbGwoXCJkaXYucmFuay1saXN0LWl0ZW1cIikuc3R5bGUoXCJvcGFjaXR5XCIsIFwiMVwiKTtcbiAgICAgIHNlbGVjdEFsbChcImxpbmVcIikuc3R5bGUoXCJzdHJva2Utb3BhY2l0eVwiLCBcIjFcIik7XG4gICAgfSk7XG4gIH1cblxuICBjb21wb25lbnREaWRVcGRhdGUoKSB7XG4gICAgY29uc3QgdGhpc05vZGUgPSBzZWxlY3QodGhpcy5ub2RlKTtcbiAgICBjb25zdCBsaXN0SXRlbXMgPSBzZWxlY3QodGhpcy5ub2RlKS5zZWxlY3RBbGwoXCJkaXYucmFuay1saXN0LWl0ZW1cIik7XG4gICAgbGlzdEl0ZW1zLnRyYW5zaXRpb24oKS5kdXJhdGlvbigxMDAwKS5zdHlsZShcInRyYW5zZm9ybVwiLCBmdW5jdGlvbihkLCBpKSB7XG4gICAgICByZXR1cm4gXCJ0cmFuc2xhdGUoMHB4LCBcIiArIGkgKiByb3dTcGFjZSArIFwicHgpXCI7XG4gICAgfSk7XG5cbiAgICBsaXN0SXRlbXMub24oXCJtb3VzZW92ZXJcIiwgKGQsIGkpID0+IHtcbiAgICAgIHNlbGVjdEFsbChcImRpdi5yYW5rLWxpc3QtaXRlbVwiKS5zdHlsZShcIm9wYWNpdHlcIiwgXCIuM1wiKTtcbiAgICAgIHNlbGVjdEFsbChcImxpbmVcIikuc3R5bGUoXCJzdHJva2Utb3BhY2l0eVwiLCBcIi4zXCIpO1xuICAgICAgY29uc3QgdmFsID0gdGhpc05vZGVcbiAgICAgICAgLnNlbGVjdChcImRpdi5yYW5rLWxpc3QtaXRlbSNpZFwiICsgaSArIFwiXCIpXG4gICAgICAgIC5hdHRyKFwidmFsdWVcIik7XG4gICAgICBzZWxlY3RBbGwoJ2Rpdi5yYW5rLWxpc3QtaXRlbVt2YWx1ZSA9IFwiJyArIHZhbCArICdcIl0nKS5zdHlsZShcbiAgICAgICAgXCJvcGFjaXR5XCIsXG4gICAgICAgIFwiMVwiXG4gICAgICApO1xuICAgICAgc2VsZWN0KCdsaW5lW3ZhbHVlID0gXCInICsgdmFsICsgJ1wiXScpXG4gICAgICAgIC5zdHlsZShcInN0cm9rZS1vcGFjaXR5XCIsIFwiMVwiKVxuICAgICAgICAucmFpc2UoKTtcbiAgICB9KTtcbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCBUaGVzZUFuc3dlcnMgPSB0aGlzLnByb3BzLmxpc3RcbiAgICAgIC5maW5kKGQgPT4gZC5jb3VudHJ5ID09PSB0aGlzLnByb3BzLmNvdW50cnkpXG4gICAgICAuYW5zd2Vycy5zb3J0KChhLCBiKSA9PiB7XG4gICAgICAgIHJldHVybiBiLnZhbHVlIC0gYS52YWx1ZTtcbiAgICAgIH0pO1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2XG4gICAgICAgIGNsYXNzTmFtZT1cInJhbmstbGlzdFwiXG4gICAgICAgIHJlZj17cmFua0xpc3REaXYgPT4ge1xuICAgICAgICAgIHRoaXMubm9kZSA9IHJhbmtMaXN0RGl2O1xuICAgICAgICB9fVxuICAgICAgPlxuICAgICAgICB7VGhlc2VBbnN3ZXJzLm1hcCgoZCwgaSkgPT4ge1xuICAgICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgIGNsYXNzTmFtZT17XG4gICAgICAgICAgICAgICAgdGhpcy5wcm9wcy5zaWRlID09PSBcImxlZnRcIlxuICAgICAgICAgICAgICAgICAgPyBcInJhbmstbGlzdC1pdGVtIHJhbmstbGlzdC1pdGVtLWxlZnRcIlxuICAgICAgICAgICAgICAgICAgOiBcInJhbmstbGlzdC1pdGVtIHJhbmstbGlzdC1pdGVtLXJpZ2h0XCJcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICBrZXk9e2Qua2V5fVxuICAgICAgICAgICAgICBpZD17XCJpZFwiICsgaX1cbiAgICAgICAgICAgICAgdmFsdWU9e2Qua2V5fVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICA8aW1nXG4gICAgICAgICAgICAgICAgc3JjPXtzdmdIYXNoW2Qua2V5XX1cbiAgICAgICAgICAgICAgICBhbHQ9e1wiZW1vamkgXCIgKyBkLmtleX1cbiAgICAgICAgICAgICAgICB3aWR0aD1cIjI0cHhcIlxuICAgICAgICAgICAgICAgIGhlaWdodD1cIjI0cHhcIlxuICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICA8ZGl2XG4gICAgICAgICAgICAgICAgY2xhc3NOYW1lPXtcbiAgICAgICAgICAgICAgICAgIHRoaXMucHJvcHMuc2lkZSA9PT0gXCJsZWZ0XCJcbiAgICAgICAgICAgICAgICAgICAgPyBcInJhbmstbGFiZWwgcmFuay1sYWJlbC1sZWZ0XCJcbiAgICAgICAgICAgICAgICAgICAgOiBcInJhbmstbGFiZWwgcmFuay1sYWJlbC1yaWdodFwiXG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAge2Qua2V5fVxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgPGRpdlxuICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInJhbmstbnVtYmVyXCJcbiAgICAgICAgICAgICAgICBzdHlsZT17e1xuICAgICAgICAgICAgICAgICAgY29sb3I6IHRoaXMucHJvcHMucGVyc29uYWxBYmlsaXRpZXMuaW5jbHVkZXMoZC5rZXkpXG4gICAgICAgICAgICAgICAgICAgID8gUmFua1N0eWxlQWJpbGl0aWVzLmZpbGxcbiAgICAgICAgICAgICAgICAgICAgOiBcIiNCODlEODNcIixcbiAgICAgICAgICAgICAgICAgIHRleHRBbGlnbjogdGhpcy5wcm9wcy5zaWRlID09PSBcImxlZnRcIiA/IFwicmlnaHRcIiA6IFwibGVmdFwiXG4gICAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgIHtpICsgMX1cbiAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICApO1xuICAgICAgICB9KX1cbiAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIC5yYW5rLWxpc3Qge1xuICAgICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICAgICAgcGFkZGluZy10b3A6IDEycHg7XG4gICAgICAgICAgfVxuICAgICAgICAgIC5yYW5rLWxpc3QtaXRlbSB7XG4gICAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgIGhlaWdodDogMzBweDtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgICAgIH1cbiAgICAgICAgIC5yYW5rLWxpc3QtaXRlbS1sZWZ0IHtcbiAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgICAgICAgfVxuICAgICAgICAgIC5yYW5rLWxpc3QtaXRlbS1yaWdodCB7XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogcm93LXJldmVyc2U7XG4gICAgICAgICAgfVxuICAgICAgICAgIC5yYW5rLWxhYmVsIHtcbiAgICAgICAgICAgIGNvbG9yOiAjMzMzO1xuICAgICAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgICAgICBmb250LXNpemU6IDE2cHg7XG4gICAgICAgICAgICBmb250LXdlaWdodDogMzAwO1xuICAgICAgICAgICAgcGFkZGluZzogMCAxMHB4IDAgMTBweDtcbiAgICAgICAgICAgIGN1cnNvcjogZGVmYXVsdDtcbiAgICAgICAgICB9XG4gICAgICAgICAgLnJhbmstbGFiZWwtbGVmdCB7XG4gICAgICAgICAgICBtYXJnaW4tbGVmdDogYXV0bztcbiAgICAgICAgICB9XG4gICAgICAgICAgLnJhbmstbGFiZWwtcmlnaHQge1xuICAgICAgICAgICAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xuICAgICAgICAgIH1cbiAgICAgICAgICAucmFuay1udW1iZXIge1xuICAgICAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgICAgICBmb250LXNpemU6IDE2cHg7XG4gICAgICAgICAgICBmb250LXdlaWdodDogNzAwO1xuICAgICAgICAgICAgd2lkdGg6IDE2cHg7XG4gICAgICAgICAgfVxuICAgICAgICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGggOiA3NjhweCkge1xuICAgICAgICAgICAgICAucmFuay1saXN0IHtcbiAgICAgICAgICAgICAgICAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuXG5jbGFzcyBTbG9wZSBleHRlbmRzIENvbXBvbmVudCB7XG4gIGNvbXBvbmVudERpZE1vdW50KCkge1xuICAgIGNvbnN0IExlZnRBbnN3ZXJzID0gdGhpcy5wcm9wcy5hbnN3ZXJzXG4gICAgICAuZmluZChkID0+IGQuY291bnRyeSA9PT0gdGhpcy5wcm9wcy5MZWZ0Q291bnRyeSlcbiAgICAgIC5hbnN3ZXJzLnNvcnQoKGEsIGIpID0+IHtcbiAgICAgICAgcmV0dXJuIGIudmFsdWUgLSBhLnZhbHVlO1xuICAgICAgfSk7XG4gICAgY29uc3QgUmlnaHRBbnN3ZXJzID0gdGhpcy5wcm9wcy5hbnN3ZXJzXG4gICAgICAuZmluZChkID0+IGQuY291bnRyeSA9PT0gdGhpcy5wcm9wcy5SaWdodENvdW50cnkpXG4gICAgICAuYW5zd2Vycy5zb3J0KChhLCBiKSA9PiB7XG4gICAgICAgIHJldHVybiBiLnZhbHVlIC0gYS52YWx1ZTtcbiAgICAgIH0pO1xuXG4gICAgUmlnaHRBbnN3ZXJzLmZvckVhY2goKGQsIGkpID0+IHtcbiAgICAgIGQucmFuayA9IGk7XG4gICAgfSk7XG5cbiAgICBjb25zdCBsaW5lcyA9IHNlbGVjdCh0aGlzLm5vZGUpLnNlbGVjdEFsbChcImxpbmVcIik7XG5cbiAgICBsaW5lc1xuICAgICAgLnRyYW5zaXRpb24oKVxuICAgICAgLmR1cmF0aW9uKDApXG4gICAgICAuYXR0cihcInkxXCIsIGZ1bmN0aW9uKGQsIGkpIHtcbiAgICAgICAgbGV0IGlkID0gc2VsZWN0KHRoaXMpLmF0dHIoXCJpZFwiKTtcbiAgICAgICAgcmV0dXJuIGlkICogcm93U3BhY2U7XG4gICAgICB9KVxuICAgICAgLmF0dHIoXCJ5MlwiLCBmdW5jdGlvbihkLCBpKSB7XG4gICAgICAgIGxldCBpZCA9IHNlbGVjdCh0aGlzKS5hdHRyKFwiaWRcIik7XG4gICAgICAgIGxldCByaWdodFJhbmsgPSBSaWdodEFuc3dlcnMuZmluZChyID0+IHIua2V5ID09PSBMZWZ0QW5zd2Vyc1tpZF0ua2V5KTtcbiAgICAgICAgcmV0dXJuIHJpZ2h0UmFuay5yYW5rICogcm93U3BhY2U7XG4gICAgICB9KTtcbiAgfVxuXG4gIGNvbXBvbmVudERpZFVwZGF0ZSgpIHtcbiAgICBjb25zdCBMZWZ0QW5zd2VycyA9IHRoaXMucHJvcHMuYW5zd2Vyc1xuICAgICAgLmZpbmQoZCA9PiBkLmNvdW50cnkgPT09IHRoaXMucHJvcHMuTGVmdENvdW50cnkpXG4gICAgICAuYW5zd2Vycy5zb3J0KChhLCBiKSA9PiB7XG4gICAgICAgIHJldHVybiBiLnZhbHVlIC0gYS52YWx1ZTtcbiAgICAgIH0pO1xuICAgIGNvbnN0IFJpZ2h0QW5zd2VycyA9IHRoaXMucHJvcHMuYW5zd2Vyc1xuICAgICAgLmZpbmQoZCA9PiBkLmNvdW50cnkgPT09IHRoaXMucHJvcHMuUmlnaHRDb3VudHJ5KVxuICAgICAgLmFuc3dlcnMuc29ydCgoYSwgYikgPT4ge1xuICAgICAgICByZXR1cm4gYi52YWx1ZSAtIGEudmFsdWU7XG4gICAgICB9KTtcblxuICAgIFJpZ2h0QW5zd2Vycy5mb3JFYWNoKChkLCBpKSA9PiB7XG4gICAgICBkLnJhbmsgPSBpO1xuICAgIH0pO1xuXG4gICAgY29uc3QgbGluZXMgPSBzZWxlY3QodGhpcy5ub2RlKS5zZWxlY3RBbGwoXCJsaW5lXCIpO1xuXG4gICAgbGluZXNcbiAgICAgIC50cmFuc2l0aW9uKClcbiAgICAgIC5kdXJhdGlvbigxMDAwKVxuICAgICAgLmF0dHIoXCJ5MVwiLCBmdW5jdGlvbihkLCBpKSB7XG4gICAgICAgIGxldCBpZCA9IHNlbGVjdCh0aGlzKS5hdHRyKFwiaWRcIik7XG4gICAgICAgIHJldHVybiBpZCAqIHJvd1NwYWNlO1xuICAgICAgfSlcbiAgICAgIC5hdHRyKFwieTJcIiwgZnVuY3Rpb24oZCwgaSkge1xuICAgICAgICBsZXQgaWQgPSBzZWxlY3QodGhpcykuYXR0cihcImlkXCIpO1xuICAgICAgICBsZXQgcmlnaHRSYW5rID0gUmlnaHRBbnN3ZXJzLmZpbmQociA9PiByLmtleSA9PT0gTGVmdEFuc3dlcnNbaWRdLmtleSk7XG4gICAgICAgIHJldHVybiByaWdodFJhbmsucmFuayAqIHJvd1NwYWNlO1xuICAgICAgfSk7XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgTGVmdEFuc3dlcnMgPSB0aGlzLnByb3BzLmFuc3dlcnNcbiAgICAgIC5maW5kKGQgPT4gZC5jb3VudHJ5ID09PSB0aGlzLnByb3BzLkxlZnRDb3VudHJ5KVxuICAgICAgLmFuc3dlcnMuc29ydCgoYSwgYikgPT4ge1xuICAgICAgICByZXR1cm4gYi52YWx1ZSAtIGEudmFsdWU7XG4gICAgICB9KTtcblxuICAgIHJldHVybiAoXG4gICAgICA8ZGl2PlxuICAgICAgICA8c3ZnIGNsYXNzTmFtZT1cInN2Zy1zbG9wZVwiIHdpZHRoPVwiMzAwcHhcIiBoZWlnaHQ9XCI2NDBweFwiPlxuICAgICAgICAgIDxnXG4gICAgICAgICAgICBjbGFzc05hbWU9XCJzbG9wZXMtZ3JvdXBcIlxuICAgICAgICAgICAgcmVmPXtub2RlID0+IHtcbiAgICAgICAgICAgICAgdGhpcy5ub2RlID0gbm9kZTtcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgPlxuICAgICAgICAgICAge0xlZnRBbnN3ZXJzLm1hcCgoZCwgaSkgPT4ge1xuICAgICAgICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgICAgIDxsaW5lXG4gICAgICAgICAgICAgICAgICBrZXk9e2Qua2V5fVxuICAgICAgICAgICAgICAgICAgaWQ9e2l9XG4gICAgICAgICAgICAgICAgICB2YWx1ZT17ZC5rZXl9XG4gICAgICAgICAgICAgICAgICB4MT17MjB9XG4gICAgICAgICAgICAgICAgICB5MT17MH1cbiAgICAgICAgICAgICAgICAgIHgyPXsyODB9XG4gICAgICAgICAgICAgICAgICB5Mj17MH1cbiAgICAgICAgICAgICAgICAgIHN0eWxlPXtcbiAgICAgICAgICAgICAgICAgICAgdGhpcy5wcm9wcy5wZXJzb25hbEFiaWxpdGllcy5pbmNsdWRlcyhkLmtleSlcbiAgICAgICAgICAgICAgICAgICAgICA/IFJhbmtTdHlsZUFiaWxpdGllc1xuICAgICAgICAgICAgICAgICAgICAgIDogUmFua1N0eWxlRmFjdG9yc1xuICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICk7XG4gICAgICAgICAgICB9KX1cbiAgICAgICAgICA8L2c+XG4gICAgICAgIDwvc3ZnPlxuICAgICAgICA8c3R5bGUganN4PntgXG4gICAgICAgICAgc3ZnIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgIH1cbiAgICAgICAgICAuc3ZnLXNsb3BlIHtcbiAgICAgICAgICAgIHBhZGRpbmctdG9wOiA5OHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoIDogNzY4cHgpIHtcbiAgICAgICAgICAgICAgLnN2Zy1zbG9wZSB7XG4gICAgICAgICAgICAgICAgICAgZGlzcGxheTogbm9uZTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuXG5jbGFzcyBDb2xvckxlZ2VuZCBleHRlbmRzIENvbXBvbmVudCB7XG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJsZWdlbmQtY29udGFpbmVyXCI+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY29sb3ItbGVnZW5kXCI+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2xvci1sZWdlbmQtdGl0bGVcIj5BcmVhcyBvZiBpbmZsdWVuY2U8L2Rpdj5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImNvbG9yLWxlZ2VuZC1pdGVtc1wiPlxuICAgICAgICAgICAgPGRpdj5cbiAgICAgICAgICAgICAgPHN2ZyBjbGFzc05hbWU9XCJsZWZ0LWxlZ2VuZC1pdGVtXCIgd2lkdGg9XCIxMHB4XCIgaGVpZ2h0PVwiMTBweFwiPlxuICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9XCI1XCIgY3k9XCI1XCIgcj1cIjVcIiBzdHJva2U9XCJub25lXCIgZmlsbD1cIiM4MDcyNjZcIiAvPlxuICAgICAgICAgICAgICA8L3N2Zz5cbiAgICAgICAgICAgICAgUGVyc29uYWwgYWJpbGl0aWVzXG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgIDxzdmcgd2lkdGg9XCIxMHB4XCIgaGVpZ2h0PVwiMTBweFwiPlxuICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9XCI1XCIgY3k9XCI1XCIgcj1cIjVcIiBzdHJva2U9XCJub25lXCIgZmlsbD1cIiNEN0MyQUFcIiAvPlxuICAgICAgICAgICAgICA8L3N2Zz5cbiAgICAgICAgICAgICAgU29jaWV0YWwgZmFjdG9yc1xuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJzb3VyY2VcIj5cbiAgICAgICAgICAgIFNvdXJjZTogdW5saW1pdGVkLndvcmxkIHN1cnZleSBvZiBhZmZsdWVudCBtaWxsZW5uaWFscywgVUJTLiBEYXRhIGFzIG9mIE9jdG9iZXIgMjAxNi4gTiA9IDIsMTMwLlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIC5sZWdlbmQtY29udGFpbmVyIHtcbiAgICAgICAgICAgIGZvbnQtZmFtaWx5OiBGcnV0aWdlckxUQ29tO1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgICBwYWRkaW5nLXRvcDogOHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICAuY29sb3ItbGVnZW5kIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBoZWlnaHQ6IDc4cHg7XG4gICAgICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjsgXG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICAgICAgICB9XG4gICAgICAgICAgLmNvbG9yLWxlZ2VuZC10aXRsZSB7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgIGhlaWdodDogMjZweDtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG4gICAgICAgICAgfVxuICAgICAgICAgIC5jb2xvci1sZWdlbmQtaXRlbXMge1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgICBmb250LXdlaWdodDogMzAwO1xuICAgICAgICAgICAgaGVpZ2h0OiAyNnB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICBzdmcge1xuICAgICAgICAgICAgcGFkZGluZy1sZWZ0OiAxNXB4O1xuICAgICAgICAgICAgcGFkZGluZy1yaWdodDogOHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICAuc291cmNlIHtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTFweDtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiAzMDA7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICAgIGNvbG9yOiAjODg4O1xuICAgICAgICAgICAgaGVpZ2h0OiAyNnB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICBAbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoIDogNzY4cHgpIHtcbiAgICAgICAgICAgICAgLmNvbG9yLWxlZ2VuZC10aXRsZSwgLmNvbG9yLWxlZ2VuZC1pdGVtcywgLnNvdXJjZSB7XG4gICAgICAgICAgICAgICAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7IFxuICAgICAgICAgICAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAubGVmdC1sZWdlbmQtaXRlbSB7XG4gICAgICAgICAgICAgICAgcGFkZGluZy1sZWZ0OiAwO1xuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgIFxuICAgICAgICAgICAgICAubGVnZW5kLWNvbnRhaW5lciB7XG4gICAgICAgICAgICAgICAgYWxpZ24tc2VsZjogZmxleC1zdGFydDtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgIH1cbiAgICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFNsb3BlQ2hhcnRGYWN0b3JzIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgY29uc3RydWN0b3IocHJvcHMpIHtcbiAgICBzdXBlcihwcm9wcyk7XG4gICAgdGhpcy5zdGF0ZSA9IHtcbiAgICAgIExlZnRDb3VudHJ5OiBcIkRldmVsb3BlZCBtYXJrZXRzXCIsXG4gICAgICBSaWdodENvdW50cnk6IFwiRW1lcmdpbmcgbWFya2V0c1wiXG4gICAgfTtcblxuICAgIHRoaXMuaGFuZGxlTGVmdENoYW5nZSA9IHRoaXMuaGFuZGxlTGVmdENoYW5nZS5iaW5kKHRoaXMpO1xuICAgIHRoaXMuaGFuZGxlUmlnaHRDaGFuZ2UgPSB0aGlzLmhhbmRsZVJpZ2h0Q2hhbmdlLmJpbmQodGhpcyk7XG4gIH1cblxuICBoYW5kbGVMZWZ0Q2hhbmdlKGNvdW50cnkpIHtcbiAgICB0aGlzLnNldFN0YXRlKHtcbiAgICAgIExlZnRDb3VudHJ5OiBjb3VudHJ5LFxuICAgICAgb3RoZXJDb3VudHJ5OiB0aGlzLnN0YXRlLlJpZ2h0Q291bnRyeVxuICAgIH0pO1xuICB9XG5cbiAgaGFuZGxlUmlnaHRDaGFuZ2UoY291bnRyeSkge1xuICAgIHRoaXMuc2V0U3RhdGUoe1xuICAgICAgUmlnaHRDb3VudHJ5OiBjb3VudHJ5XG4gICAgfSk7XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgcGVyc29uYWxBYmlsaXRpZXMgPSBbXG4gICAgICBcIkxldmVsIG9mIGVkdWNhdGlvblwiLFxuICAgICAgXCJBbWJpdGlvblwiLFxuICAgICAgXCJGbGV4aWJpbGl0eSAvIEFkYXB0YWJpbGl0eVwiLFxuICAgICAgXCJSZXNpbGllbmNlXCIsXG4gICAgICBcIlRlY2ggc2tpbGxzXCIsXG4gICAgICBcIlNvY2lhbCBuZXR3b3JrXCIsXG4gICAgICBcIkZvcmVpZ24gbGFuZ3VhZ2Ugc2tpbGxzXCJcbiAgICBdO1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cIndob2xlLWNoYXJ0XCI+XG4gICAgICAgIDxRdWVzdGlvbiAvPlxuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInZpelwiPlxuICAgICAgICAgIDxDb250cm9sc1xuICAgICAgICAgICAgYW5zd2Vycz17dGhpcy5wcm9wcy5kYXRhfVxuICAgICAgICAgICAgY291bnRyeT17dGhpcy5zdGF0ZS5MZWZ0Q291bnRyeX1cbiAgICAgICAgICAgIG90aGVyQ291bnRyeT17dGhpcy5zdGF0ZS5SaWdodENvdW50cnl9XG4gICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5oYW5kbGVMZWZ0Q2hhbmdlfVxuICAgICAgICAgICAgcGVyc29uYWxBYmlsaXRpZXM9e3BlcnNvbmFsQWJpbGl0aWVzfVxuICAgICAgICAgICAgc2lkZT1cImxlZnRcIlxuICAgICAgICAgICAgd2lkdGg9e3RoaXMucHJvcHMud2lkdGh9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8U2xvcGVcbiAgICAgICAgICAgIGNsYXNzTmFtZT1cInNsb3BlXCJcbiAgICAgICAgICAgIGFuc3dlcnM9e3RoaXMucHJvcHMuZGF0YX1cbiAgICAgICAgICAgIExlZnRDb3VudHJ5PXt0aGlzLnN0YXRlLkxlZnRDb3VudHJ5fVxuICAgICAgICAgICAgUmlnaHRDb3VudHJ5PXt0aGlzLnN0YXRlLlJpZ2h0Q291bnRyeX1cbiAgICAgICAgICAgIHBlcnNvbmFsQWJpbGl0aWVzPXtwZXJzb25hbEFiaWxpdGllc31cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxDb250cm9sc1xuICAgICAgICAgICAgYW5zd2Vycz17dGhpcy5wcm9wcy5kYXRhfVxuICAgICAgICAgICAgY291bnRyeT17dGhpcy5zdGF0ZS5SaWdodENvdW50cnl9XG4gICAgICAgICAgICBvdGhlckNvdW50cnk9e3RoaXMuc3RhdGUuTGVmdENvdW50cnl9XG4gICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5oYW5kbGVSaWdodENoYW5nZX1cbiAgICAgICAgICAgIHBlcnNvbmFsQWJpbGl0aWVzPXtwZXJzb25hbEFiaWxpdGllc31cbiAgICAgICAgICAgIHNpZGU9XCJyaWdodFwiXG4gICAgICAgICAgICB3aWR0aD17dGhpcy5wcm9wcy53aWR0aH1cbiAgICAgICAgICAvPlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPENvbG9yTGVnZW5kIC8+XG4gICAgICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgICAgICAud2hvbGUtY2hhcnQge1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgICAgfVxuXHRcdFx0XHRcdC52aXoge1xuICAgICAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgICAgaGVpZ2h0OiA3MzBweDtcbiAgICAgICAgICB9XG5cdFx0ICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59Il19 */\n/*@ sourceURL=src/components/SlopeChartFactors.js */"
        })
      );
    }
  }]);

  return ColorLegend;
}(react["Component"]);

var SlopeChartFactors_SlopeChartFactors = function (_Component5) {
  SlopeChartFactors__inherits(SlopeChartFactors, _Component5);

  function SlopeChartFactors(props) {
    SlopeChartFactors__classCallCheck(this, SlopeChartFactors);

    var _this9 = SlopeChartFactors__possibleConstructorReturn(this, (SlopeChartFactors.__proto__ || Object.getPrototypeOf(SlopeChartFactors)).call(this, props));

    _this9.state = {
      LeftCountry: "Developed markets",
      RightCountry: "Emerging markets"
    };

    _this9.handleLeftChange = _this9.handleLeftChange.bind(_this9);
    _this9.handleRightChange = _this9.handleRightChange.bind(_this9);
    return _this9;
  }

  SlopeChartFactors__createClass(SlopeChartFactors, [{
    key: "handleLeftChange",
    value: function handleLeftChange(country) {
      this.setState({
        LeftCountry: country,
        otherCountry: this.state.RightCountry
      });
    }
  }, {
    key: "handleRightChange",
    value: function handleRightChange(country) {
      this.setState({
        RightCountry: country
      });
    }
  }, {
    key: "render",
    value: function render() {
      var personalAbilities = ["Level of education", "Ambition", "Flexibility / Adaptability", "Resilience", "Tech skills", "Social network", "Foreign language skills"];
      return react_default.a.createElement(
        "div",
        { className: "whole-chart", "data-jsx": 3114576919
        },
        react_default.a.createElement(Charts_Question, null),
        react_default.a.createElement(
          "div",
          { className: "viz", "data-jsx": 3114576919
          },
          react_default.a.createElement(SlopeChartFactors_Controls, {
            answers: this.props.data,
            country: this.state.LeftCountry,
            otherCountry: this.state.RightCountry,
            onChange: this.handleLeftChange,
            personalAbilities: personalAbilities,
            side: "left",
            width: this.props.width
          }),
          react_default.a.createElement(SlopeChartFactors_Slope, {
            className: "slope",
            answers: this.props.data,
            LeftCountry: this.state.LeftCountry,
            RightCountry: this.state.RightCountry,
            personalAbilities: personalAbilities
          }),
          react_default.a.createElement(SlopeChartFactors_Controls, {
            answers: this.props.data,
            country: this.state.RightCountry,
            otherCountry: this.state.LeftCountry,
            onChange: this.handleRightChange,
            personalAbilities: personalAbilities,
            side: "right",
            width: this.props.width
          })
        ),
        react_default.a.createElement(SlopeChartFactors_ColorLegend, null),
        react_default.a.createElement(style_default.a, {
          styleId: 3114576919,
          css: ".whole-chart[data-jsx=\"3114576919\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.viz[data-jsx=\"3114576919\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;height:730px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartFactors.js */"
        })
      );
    }
  }]);

  return SlopeChartFactors;
}(react["Component"]);

/* harmony default export */ var components_SlopeChartFactors = (SlopeChartFactors_SlopeChartFactors);
// CONCATENATED MODULE: ./src/data/chartData.js



var json_data_factors = [{
  country: "United States",
  answer: "Gender",
  count: 22
}, {
  country: "United States",
  answer: "Level of education",
  count: 142
}, {
  country: "United States",
  answer: "Family responsibilities",
  count: 50
}, {
  country: "United States",
  answer: "Access to family capital",
  count: 18
}, {
  country: "United States",
  answer: "Global standing",
  count: 36
}, {
  country: "United States",
  answer: "Job market",
  count: 72
}, {
  country: "United States",
  answer: "Economic policy",
  count: 45
}, {
  country: "United States",
  answer: "Trade relationships",
  count: 22
}, {
  country: "United States",
  answer: "Ability to work abroad",
  count: 24
}, {
  country: "United States",
  answer: "Immigration",
  count: 14
}, {
  country: "United States",
  answer: "Social network",
  count: 60
}, {
  country: "United States",
  answer: "Tech skills",
  count: 80
}, {
  country: "United States",
  answer: "Foreign language skills",
  count: 24
}, {
  country: "United States",
  answer: "Ambition",
  count: 127
}, {
  country: "United States",
  answer: "Flexibility / Adaptability",
  count: 109
}, {
  country: "United States",
  answer: "Resilience",
  count: 90
}, {
  country: "United Kingdom",
  answer: "Gender",
  count: 27
}, {
  country: "United Kingdom",
  answer: "Level of education",
  count: 109
}, {
  country: "United Kingdom",
  answer: "Family responsibilities",
  count: 47
}, {
  country: "United Kingdom",
  answer: "Access to family capital",
  count: 38
}, {
  country: "United Kingdom",
  answer: "Global standing",
  count: 29
}, {
  country: "United Kingdom",
  answer: "Job market",
  count: 68
}, {
  country: "United Kingdom",
  answer: "Economic policy",
  count: 44
}, {
  country: "United Kingdom",
  answer: "Trade relationships",
  count: 31
}, {
  country: "United Kingdom",
  answer: "Ability to work abroad",
  count: 41
}, {
  country: "United Kingdom",
  answer: "Immigration",
  count: 17
}, {
  country: "United Kingdom",
  answer: "Social network",
  count: 40
}, {
  country: "United Kingdom",
  answer: "Tech skills",
  count: 69
}, {
  country: "United Kingdom",
  answer: "Foreign language skills",
  count: 30
}, {
  country: "United Kingdom",
  answer: "Ambition",
  count: 89
}, {
  country: "United Kingdom",
  answer: "Flexibility / Adaptability",
  count: 83
}, {
  country: "United Kingdom",
  answer: "Resilience",
  count: 60
}, {
  country: "Germany",
  answer: "Gender",
  count: 22
}, {
  country: "Germany",
  answer: "Level of education",
  count: 146
}, {
  country: "Germany",
  answer: "Family responsibilities",
  count: 46
}, {
  country: "Germany",
  answer: "Access to family capital",
  count: 35
}, {
  country: "Germany",
  answer: "Global standing",
  count: 35
}, {
  country: "Germany",
  answer: "Job market",
  count: 70
}, {
  country: "Germany",
  answer: "Economic policy",
  count: 31
}, {
  country: "Germany",
  answer: "Trade relationships",
  count: 20
}, {
  country: "Germany",
  answer: "Ability to work abroad",
  count: 29
}, {
  country: "Germany",
  answer: "Immigration",
  count: 10
}, {
  country: "Germany",
  answer: "Social network",
  count: 57
}, {
  country: "Germany",
  answer: "Tech skills",
  count: 72
}, {
  country: "Germany",
  answer: "Foreign language skills",
  count: 58
}, {
  country: "Germany",
  answer: "Ambition",
  count: 106
}, {
  country: "Germany",
  answer: "Flexibility / Adaptability",
  count: 93
}, {
  country: "Germany",
  answer: "Resilience",
  count: 96
}, {
  country: "Singapore",
  answer: "Gender",
  count: 17
}, {
  country: "Singapore",
  answer: "Level of education",
  count: 101
}, {
  country: "Singapore",
  answer: "Family responsibilities",
  count: 60
}, {
  country: "Singapore",
  answer: "Access to family capital",
  count: 23
}, {
  country: "Singapore",
  answer: "Global standing",
  count: 60
}, {
  country: "Singapore",
  answer: "Job market",
  count: 103
}, {
  country: "Singapore",
  answer: "Economic policy",
  count: 78
}, {
  country: "Singapore",
  answer: "Trade relationships",
  count: 47
}, {
  country: "Singapore",
  answer: "Ability to work abroad",
  count: 55
}, {
  country: "Singapore",
  answer: "Immigration",
  count: 21
}, {
  country: "Singapore",
  answer: "Social network",
  count: 65
}, {
  country: "Singapore",
  answer: "Tech skills",
  count: 62
}, {
  country: "Singapore",
  answer: "Foreign language skills",
  count: 35
}, {
  country: "Singapore",
  answer: "Ambition",
  count: 84
}, {
  country: "Singapore",
  answer: "Flexibility / Adaptability",
  count: 102
}, {
  country: "Singapore",
  answer: "Resilience",
  count: 83
}, {
  country: "Russia",
  answer: "Gender",
  count: 13
}, {
  country: "Russia",
  answer: "Level of education",
  count: 149
}, {
  country: "Russia",
  answer: "Family responsibilities",
  count: 43
}, {
  country: "Russia",
  answer: "Access to family capital",
  count: 20
}, {
  country: "Russia",
  answer: "Global standing",
  count: 41
}, {
  country: "Russia",
  answer: "Job market",
  count: 50
}, {
  country: "Russia",
  answer: "Economic policy",
  count: 64
}, {
  country: "Russia",
  answer: "Trade relationships",
  count: 27
}, {
  country: "Russia",
  answer: "Ability to work abroad",
  count: 32
}, {
  country: "Russia",
  answer: "Immigration",
  count: 4
}, {
  country: "Russia",
  answer: "Social network",
  count: 94
}, {
  country: "Russia",
  answer: "Tech skills",
  count: 123
}, {
  country: "Russia",
  answer: "Foreign language skills",
  count: 74
}, {
  country: "Russia",
  answer: "Ambition",
  count: 138
}, {
  country: "Russia",
  answer: "Flexibility / Adaptability",
  count: 164
}, {
  country: "Russia",
  answer: "Resilience",
  count: 147
}, {
  country: "China",
  answer: "Gender",
  count: 6
}, {
  country: "China",
  answer: "Level of education",
  count: 72
}, {
  country: "China",
  answer: "Family responsibilities",
  count: 50
}, {
  country: "China",
  answer: "Access to family capital",
  count: 61
}, {
  country: "China",
  answer: "Global standing",
  count: 61
}, {
  country: "China",
  answer: "Job market",
  count: 51
}, {
  country: "China",
  answer: "Economic policy",
  count: 87
}, {
  country: "China",
  answer: "Trade relationships",
  count: 61
}, {
  country: "China",
  answer: "Ability to work abroad",
  count: 25
}, {
  country: "China",
  answer: "Immigration",
  count: 22
}, {
  country: "China",
  answer: "Social network",
  count: 81
}, {
  country: "China",
  answer: "Tech skills",
  count: 94
}, {
  country: "China",
  answer: "Foreign language skills",
  count: 38
}, {
  country: "China",
  answer: "Ambition",
  count: 70
}, {
  country: "China",
  answer: "Flexibility / Adaptability",
  count: 81
}, {
  country: "China",
  answer: "Resilience",
  count: 55
}, {
  country: "India",
  answer: "Gender",
  count: 78
}, {
  country: "India",
  answer: "Level of education",
  count: 117
}, {
  country: "India",
  answer: "Family responsibilities",
  count: 110
}, {
  country: "India",
  answer: "Access to family capital",
  count: 70
}, {
  country: "India",
  answer: "Global standing",
  count: 86
}, {
  country: "India",
  answer: "Job market",
  count: 97
}, {
  country: "India",
  answer: "Economic policy",
  count: 86
}, {
  country: "India",
  answer: "Trade relationships",
  count: 69
}, {
  country: "India",
  answer: "Ability to work abroad",
  count: 86
}, {
  country: "India",
  answer: "Immigration",
  count: 47
}, {
  country: "India",
  answer: "Social network",
  count: 93
}, {
  country: "India",
  answer: "Tech skills",
  count: 94
}, {
  country: "India",
  answer: "Foreign language skills",
  count: 52
}, {
  country: "India",
  answer: "Ambition",
  count: 80
}, {
  country: "India",
  answer: "Flexibility / Adaptability",
  count: 67
}, {
  country: "India",
  answer: "Resilience",
  count: 33
}, {
  country: "United Arab Emirates",
  answer: "Gender",
  count: 34
}, {
  country: "United Arab Emirates",
  answer: "Level of education",
  count: 131
}, {
  country: "United Arab Emirates",
  answer: "Family responsibilities",
  count: 70
}, {
  country: "United Arab Emirates",
  answer: "Access to family capital",
  count: 42
}, {
  country: "United Arab Emirates",
  answer: "Global standing",
  count: 56
}, {
  country: "United Arab Emirates",
  answer: "Job market",
  count: 102
}, {
  country: "United Arab Emirates",
  answer: "Economic policy",
  count: 71
}, {
  country: "United Arab Emirates",
  answer: "Trade relationships",
  count: 48
}, {
  country: "United Arab Emirates",
  answer: "Ability to work abroad",
  count: 59
}, {
  country: "United Arab Emirates",
  answer: "Immigration",
  count: 30
}, {
  country: "United Arab Emirates",
  answer: "Social network",
  count: 60
}, {
  country: "United Arab Emirates",
  answer: "Tech skills",
  count: 81
}, {
  country: "United Arab Emirates",
  answer: "Foreign language skills",
  count: 69
}, {
  country: "United Arab Emirates",
  answer: "Ambition",
  count: 90
}, {
  country: "United Arab Emirates",
  answer: "Flexibility / Adaptability",
  count: 79
}, {
  country: "United Arab Emirates",
  answer: "Resilience",
  count: 37
}, {
  country: "Mexico",
  answer: "Gender",
  count: 15
}, {
  country: "Mexico",
  answer: "Level of education",
  count: 162
}, {
  country: "Mexico",
  answer: "Family responsibilities",
  count: 34
}, {
  country: "Mexico",
  answer: "Access to family capital",
  count: 28
}, {
  country: "Mexico",
  answer: "Global standing",
  count: 21
}, {
  country: "Mexico",
  answer: "Job market",
  count: 62
}, {
  country: "Mexico",
  answer: "Economic policy",
  count: 54
}, {
  country: "Mexico",
  answer: "Trade relationships",
  count: 35
}, {
  country: "Mexico",
  answer: "Ability to work abroad",
  count: 62
}, {
  country: "Mexico",
  answer: "Immigration",
  count: 7
}, {
  country: "Mexico",
  answer: "Social network",
  count: 68
}, {
  country: "Mexico",
  answer: "Tech skills",
  count: 114
}, {
  country: "Mexico",
  answer: "Foreign language skills",
  count: 90
}, {
  country: "Mexico",
  answer: "Ambition",
  count: 109
}, {
  country: "Mexico",
  answer: "Flexibility / Adaptability",
  count: 123
}, {
  country: "Mexico",
  answer: "Resilience",
  count: 61
}, {
  country: "South Africa",
  answer: "Gender",
  count: 31
}, {
  country: "South Africa",
  answer: "Level of education",
  count: 169
}, {
  country: "South Africa",
  answer: "Family responsibilities",
  count: 72
}, {
  country: "South Africa",
  answer: "Access to family capital",
  count: 22
}, {
  country: "South Africa",
  answer: "Global standing",
  count: 48
}, {
  country: "South Africa",
  answer: "Job market",
  count: 88
}, {
  country: "South Africa",
  answer: "Economic policy",
  count: 70
}, {
  country: "South Africa",
  answer: "Trade relationships",
  count: 46
}, {
  country: "South Africa",
  answer: "Ability to work abroad",
  count: 71
}, {
  country: "South Africa",
  answer: "Immigration",
  count: 17
}, {
  country: "South Africa",
  answer: "Social network",
  count: 55
}, {
  country: "South Africa",
  answer: "Tech skills",
  count: 125
}, {
  country: "South Africa",
  answer: "Foreign language skills",
  count: 27
}, {
  country: "South Africa",
  answer: "Ambition",
  count: 151
}, {
  country: "South Africa",
  answer: "Flexibility / Adaptability",
  count: 130
}, {
  country: "South Africa",
  answer: "Resilience",
  count: 112
}, {
  country: "Developed markets",
  answer: "Gender",
  count: 88
}, {
  country: "Developed markets",
  answer: "Level of education",
  count: 498
}, {
  country: "Developed markets",
  answer: "Family responsibilities",
  count: 203
}, {
  country: "Developed markets",
  answer: "Access to family capital",
  count: 114
}, {
  country: "Developed markets",
  answer: "Global standing",
  count: 160
}, {
  country: "Developed markets",
  answer: "Job market",
  count: 313
}, {
  country: "Developed markets",
  answer: "Economic policy",
  count: 198
}, {
  country: "Developed markets",
  answer: "Trade relationships",
  count: 120
}, {
  country: "Developed markets",
  answer: "Ability to work abroad",
  count: 149
}, {
  country: "Developed markets",
  answer: "Immigration",
  count: 62
}, {
  country: "Developed markets",
  answer: "Social network",
  count: 222
}, {
  country: "Developed markets",
  answer: "Tech skills",
  count: 283
}, {
  country: "Developed markets",
  answer: "Foreign language skills",
  count: 147
}, {
  country: "Developed markets",
  answer: "Ambition",
  count: 406
}, {
  country: "Developed markets",
  answer: "Flexibility / Adaptability",
  count: 387
}, {
  country: "Developed markets",
  answer: "Resilience",
  count: 329
}, {
  country: "Emerging markets",
  answer: "Gender",
  count: 97
}, {
  country: "Emerging markets",
  answer: "Level of education",
  count: 338
}, {
  country: "Emerging markets",
  answer: "Family responsibilities",
  count: 203
}, {
  country: "Emerging markets",
  answer: "Access to family capital",
  count: 151
}, {
  country: "Emerging markets",
  answer: "Global standing",
  count: 188
}, {
  country: "Emerging markets",
  answer: "Job market",
  count: 198
}, {
  country: "Emerging markets",
  answer: "Economic policy",
  count: 237
}, {
  country: "Emerging markets",
  answer: "Trade relationships",
  count: 157
}, {
  country: "Emerging markets",
  answer: "Ability to work abroad",
  count: 143
}, {
  country: "Emerging markets",
  answer: "Immigration",
  count: 73
}, {
  country: "Emerging markets",
  answer: "Social network",
  count: 268
}, {
  country: "Emerging markets",
  answer: "Tech skills",
  count: 311
}, {
  country: "Emerging markets",
  answer: "Foreign language skills",
  count: 164
}, {
  country: "Emerging markets",
  answer: "Ambition",
  count: 288
}, {
  country: "Emerging markets",
  answer: "Flexibility / Adaptability",
  count: 312
}, {
  country: "Emerging markets",
  answer: "Resilience",
  count: 235
}];

var json_data_wealthMillennials = [{
  country: "United States",
  answer: "Well connected",
  count: 7,
  question: "q1"
}, {
  country: "United States",
  answer: "Philanthropy",
  count: 14,
  question: "q1"
}, {
  country: "United States",
  answer: "Luxury",
  count: 19,
  question: "q1"
}, {
  country: "United States",
  answer: "Exciting experiences",
  count: 117,
  question: "q1"
}, {
  country: "United States",
  answer: "Legacy for family",
  count: 40,
  question: "q1"
}, {
  country: "United States",
  answer: "Social Status",
  count: 8,
  question: "q1"
}, {
  country: "United States",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "Well connected",
  count: 19,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "Philanthropy",
  count: 25,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "Luxury",
  count: 18,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "Exciting experiences",
  count: 88,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "Legacy for family",
  count: 43,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "Social Status",
  count: 17,
  question: "q1"
}, {
  country: "United Kingdom",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "Germany",
  answer: "Well connected",
  count: 31,
  question: "q1"
}, {
  country: "Germany",
  answer: "Philanthropy",
  count: 11,
  question: "q1"
}, {
  country: "Germany",
  answer: "Luxury",
  count: 32,
  question: "q1"
}, {
  country: "Germany",
  answer: "Exciting experiences",
  count: 72,
  question: "q1"
}, {
  country: "Germany",
  answer: "Legacy for family",
  count: 54,
  question: "q1"
}, {
  country: "Germany",
  answer: "Social Status",
  count: 14,
  question: "q1"
}, {
  country: "Germany",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "Singapore",
  answer: "Well connected",
  count: 19,
  question: "q1"
}, {
  country: "Singapore",
  answer: "Philanthropy",
  count: 12,
  question: "q1"
}, {
  country: "Singapore",
  answer: "Luxury",
  count: 47,
  question: "q1"
}, {
  country: "Singapore",
  answer: "Exciting experiences",
  count: 104,
  question: "q1"
}, {
  country: "Singapore",
  answer: "Legacy for family",
  count: 24,
  question: "q1"
}, {
  country: "Singapore",
  answer: "Social Status",
  count: 7,
  question: "q1"
}, {
  country: "Singapore",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "Russia",
  answer: "Well connected",
  count: 32,
  question: "q1"
}, {
  country: "Russia",
  answer: "Philanthropy",
  count: 17,
  question: "q1"
}, {
  country: "Russia",
  answer: "Luxury",
  count: 40,
  question: "q1"
}, {
  country: "Russia",
  answer: "Exciting experiences",
  count: 74,
  question: "q1"
}, {
  country: "Russia",
  answer: "Legacy for family",
  count: 76,
  question: "q1"
}, {
  country: "Russia",
  answer: "Social Status",
  count: 10,
  question: "q1"
}, {
  country: "Russia",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "China",
  answer: "Well connected",
  count: 43,
  question: "q1"
}, {
  country: "China",
  answer: "Philanthropy",
  count: 10,
  question: "q1"
}, {
  country: "China",
  answer: "Luxury",
  count: 31,
  question: "q1"
}, {
  country: "China",
  answer: "Exciting experiences",
  count: 90,
  question: "q1"
}, {
  country: "China",
  answer: "Legacy for family",
  count: 24,
  question: "q1"
}, {
  country: "China",
  answer: "Social Status",
  count: 22,
  question: "q1"
}, {
  country: "China",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "India",
  answer: "Well connected",
  count: 28,
  question: "q1"
}, {
  country: "India",
  answer: "Philanthropy",
  count: 26,
  question: "q1"
}, {
  country: "India",
  answer: "Luxury",
  count: 38,
  question: "q1"
}, {
  country: "India",
  answer: "Exciting experiences",
  count: 39,
  question: "q1"
}, {
  country: "India",
  answer: "Legacy for family",
  count: 38,
  question: "q1"
}, {
  country: "India",
  answer: "Social Status",
  count: 34,
  question: "q1"
}, {
  country: "India",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "Well connected",
  count: 37,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "Philanthropy",
  count: 41,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "Luxury",
  count: 38,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "Exciting experiences",
  count: 34,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "Legacy for family",
  count: 36,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "Social Status",
  count: 21,
  question: "q1"
}, {
  country: "United Arab Emirates",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "Mexico",
  answer: "Well connected",
  count: 18,
  question: "q1"
}, {
  country: "Mexico",
  answer: "Philanthropy",
  count: 20,
  question: "q1"
}, {
  country: "Mexico",
  answer: "Luxury",
  count: 27,
  question: "q1"
}, {
  country: "Mexico",
  answer: "Exciting experiences",
  count: 79,
  question: "q1"
}, {
  country: "Mexico",
  answer: "Legacy for family",
  count: 54,
  question: "q1"
}, {
  country: "Mexico",
  answer: "Social Status",
  count: 8,
  question: "q1"
}, {
  country: "Mexico",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "South Africa",
  answer: "Well connected",
  count: 15,
  question: "q1"
}, {
  country: "South Africa",
  answer: "Philanthropy",
  count: 33,
  question: "q1"
}, {
  country: "South Africa",
  answer: "Luxury",
  count: 13,
  question: "q1"
}, {
  country: "South Africa",
  answer: "Exciting experiences",
  count: 74,
  question: "q1"
}, {
  country: "South Africa",
  answer: "Legacy for family",
  count: 64,
  question: "q1"
}, {
  country: "South Africa",
  answer: "Social Status",
  count: 4,
  question: "q1"
}, {
  country: "South Africa",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "Well connected",
  count: 76,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "Philanthropy",
  count: 62,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "Luxury",
  count: 116,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "Exciting experiences",
  count: 381,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "Legacy for family",
  count: 161,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "Social Status",
  count: 46,
  question: "q1"
}, {
  country: "Developed markets",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "Well connected",
  count: 173,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "Philanthropy",
  count: 147,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "Luxury",
  count: 187,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "Exciting experiences",
  count: 390,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "Legacy for family",
  count: 292,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "Social Status",
  count: 99,
  question: "q1"
}, {
  country: "Emerging markets",
  answer: "None of these",
  count: 0,
  question: "q1"
}, {
  country: "All countries",
  answer: "Well connected",
  count: 249,
  question: "q1"
}, {
  country: "All countries",
  answer: "Philanthropy",
  count: 209,
  question: "q1"
}, {
  country: "All countries",
  answer: "Luxury",
  count: 303,
  question: "q1"
}, {
  country: "All countries",
  answer: "Exciting experiences",
  count: 771,
  question: "q1"
}, {
  country: "All countries",
  answer: "Legacy for family",
  count: 453,
  question: "q1"
}, {
  country: "All countries",
  answer: "Social Status",
  count: 145,
  question: "q1"
}, {
  country: "All countries",
  answer: "None of these",
  count: 0,
  question: "q1"
}];

var json_data_wealthParents = [{
  country: "United States",
  answer: "Well connected",
  count: 28,
  question: "q4"
}, {
  country: "United States",
  answer: "Philanthropy",
  count: 12,
  question: "q4"
}, {
  country: "United States",
  answer: "Luxury",
  count: 29,
  question: "q4"
}, {
  country: "United States",
  answer: "Exciting experiences",
  count: 49,
  question: "q4"
}, {
  country: "United States",
  answer: "Legacy for family",
  count: 70,
  question: "q4"
}, {
  country: "United States",
  answer: "Social Status",
  count: 8,
  question: "q4"
}, {
  country: "United States",
  answer: "None of these",
  count: 9,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "Well connected",
  count: 37,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "Philanthropy",
  count: 23,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "Luxury",
  count: 29,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "Exciting experiences",
  count: 53,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "Legacy for family",
  count: 56,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "Social Status",
  count: 4,
  question: "q4"
}, {
  country: "United Kingdom",
  answer: "None of these",
  count: 8,
  question: "q4"
}, {
  country: "Germany",
  answer: "Well connected",
  count: 48,
  question: "q4"
}, {
  country: "Germany",
  answer: "Philanthropy",
  count: 19,
  question: "q4"
}, {
  country: "Germany",
  answer: "Luxury",
  count: 23,
  question: "q4"
}, {
  country: "Germany",
  answer: "Exciting experiences",
  count: 25,
  question: "q4"
}, {
  country: "Germany",
  answer: "Legacy for family",
  count: 70,
  question: "q4"
}, {
  country: "Germany",
  answer: "Social Status",
  count: 14,
  question: "q4"
}, {
  country: "Germany",
  answer: "None of these",
  count: 15,
  question: "q4"
}, {
  country: "Singapore",
  answer: "Well connected",
  count: 21,
  question: "q4"
}, {
  country: "Singapore",
  answer: "Philanthropy",
  count: 19,
  question: "q4"
}, {
  country: "Singapore",
  answer: "Luxury",
  count: 60,
  question: "q4"
}, {
  country: "Singapore",
  answer: "Exciting experiences",
  count: 32,
  question: "q4"
}, {
  country: "Singapore",
  answer: "Legacy for family",
  count: 66,
  question: "q4"
}, {
  country: "Singapore",
  answer: "Social Status",
  count: 6,
  question: "q4"
}, {
  country: "Singapore",
  answer: "None of these",
  count: 9,
  question: "q4"
}, {
  country: "Russia",
  answer: "Well connected",
  count: 30,
  question: "q4"
}, {
  country: "Russia",
  answer: "Philanthropy",
  count: 14,
  question: "q4"
}, {
  country: "Russia",
  answer: "Luxury",
  count: 42,
  question: "q4"
}, {
  country: "Russia",
  answer: "Exciting experiences",
  count: 21,
  question: "q4"
}, {
  country: "Russia",
  answer: "Legacy for family",
  count: 105,
  question: "q4"
}, {
  country: "Russia",
  answer: "Social Status",
  count: 17,
  question: "q4"
}, {
  country: "Russia",
  answer: "None of these",
  count: 20,
  question: "q4"
}, {
  country: "China",
  answer: "Well connected",
  count: 71,
  question: "q4"
}, {
  country: "China",
  answer: "Philanthropy",
  count: 21,
  question: "q4"
}, {
  country: "China",
  answer: "Luxury",
  count: 22,
  question: "q4"
}, {
  country: "China",
  answer: "Exciting experiences",
  count: 57,
  question: "q4"
}, {
  country: "China",
  answer: "Legacy for family",
  count: 27,
  question: "q4"
}, {
  country: "China",
  answer: "Social Status",
  count: 19,
  question: "q4"
}, {
  country: "China",
  answer: "None of these",
  count: 3,
  question: "q4"
}, {
  country: "India",
  answer: "Well connected",
  count: 72,
  question: "q4"
}, {
  country: "India",
  answer: "Philanthropy",
  count: 38,
  question: "q4"
}, {
  country: "India",
  answer: "Luxury",
  count: 25,
  question: "q4"
}, {
  country: "India",
  answer: "Exciting experiences",
  count: 29,
  question: "q4"
}, {
  country: "India",
  answer: "Legacy for family",
  count: 25,
  question: "q4"
}, {
  country: "India",
  answer: "Social Status",
  count: 13,
  question: "q4"
}, {
  country: "India",
  answer: "None of these",
  count: 1,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "Well connected",
  count: 44,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "Philanthropy",
  count: 50,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "Luxury",
  count: 34,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "Exciting experiences",
  count: 10,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "Legacy for family",
  count: 41,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "Social Status",
  count: 22,
  question: "q4"
}, {
  country: "United Arab Emirates",
  answer: "None of these",
  count: 6,
  question: "q4"
}, {
  country: "Mexico",
  answer: "Well connected",
  count: 32,
  question: "q4"
}, {
  country: "Mexico",
  answer: "Philanthropy",
  count: 13,
  question: "q4"
}, {
  country: "Mexico",
  answer: "Luxury",
  count: 24,
  question: "q4"
}, {
  country: "Mexico",
  answer: "Exciting experiences",
  count: 24,
  question: "q4"
}, {
  country: "Mexico",
  answer: "Legacy for family",
  count: 86,
  question: "q4"
}, {
  country: "Mexico",
  answer: "Social Status",
  count: 10,
  question: "q4"
}, {
  country: "Mexico",
  answer: "None of these",
  count: 17,
  question: "q4"
}, {
  country: "South Africa",
  answer: "Well connected",
  count: 12,
  question: "q4"
}, {
  country: "South Africa",
  answer: "Philanthropy",
  count: 26,
  question: "q4"
}, {
  country: "South Africa",
  answer: "Luxury",
  count: 30,
  question: "q4"
}, {
  country: "South Africa",
  answer: "Exciting experiences",
  count: 35,
  question: "q4"
}, {
  country: "South Africa",
  answer: "Legacy for family",
  count: 85,
  question: "q4"
}, {
  country: "South Africa",
  answer: "Social Status",
  count: 3,
  question: "q4"
}, {
  country: "South Africa",
  answer: "None of these",
  count: 12,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "Well connected",
  count: 134,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "Philanthropy",
  count: 73,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "Luxury",
  count: 141,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "Exciting experiences",
  count: 159,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "Legacy for family",
  count: 262,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "Social Status",
  count: 32,
  question: "q4"
}, {
  country: "Developed markets",
  answer: "None of these",
  count: 41,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "Well connected",
  count: 261,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "Philanthropy",
  count: 162,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "Luxury",
  count: 177,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "Exciting experiences",
  count: 176,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "Legacy for family",
  count: 369,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "Social Status",
  count: 84,
  question: "q4"
}, {
  country: "Emerging markets",
  answer: "None of these",
  count: 59,
  question: "q4"
}, {
  country: "All countries",
  answer: "Well connected",
  count: 395,
  question: "q4"
}, {
  country: "All countries",
  answer: "Philanthropy",
  count: 235,
  question: "q4"
}, {
  country: "All countries",
  answer: "Luxury",
  count: 318,
  question: "q4"
}, {
  country: "All countries",
  answer: "Exciting experiences",
  count: 335,
  question: "q4"
}, {
  country: "All countries",
  answer: "Legacy for family",
  count: 631,
  question: "q4"
}, {
  country: "All countries",
  answer: "Social Status",
  count: 116,
  question: "q4"
}, {
  country: "All countries",
  answer: "None of these",
  count: 100,
  question: "q4"
}];

var factors = src_nest().key(function (d) {
  return d.country;
}).key(function (d) {
  return d.answer;
}).rollup(function (values) {
  return src_sum(values, function (d) {
    return d.count;
  });
}).entries(json_data_factors).map(function (d, i) {
  return {
    country: d.key,
    answers: d.values
  };
});
//})

var wealthMillennials = src_nest().key(function (d) {
  return d.country;
}).key(function (d) {
  return d.answer;
}).rollup(function (values) {
  return src_sum(values, function (d) {
    return d.count;
  });
}).entries(json_data_wealthMillennials).map(function (d, i) {
  return {
    country: d.key,
    answers: d.values
  };
});
var wealthParents = src_nest().key(function (d) {
  return d.country;
}).key(function (d) {
  return d.answer;
}).rollup(function (values) {
  return src_sum(values, function (d) {
    return d.count;
  });
}).entries(json_data_wealthParents).map(function (d, i) {
  return {
    country: d.key,
    answers: d.values
  };
});
// CONCATENATED MODULE: ./src/pages/slope-factors.js
var slope_factors__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function slope_factors__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function slope_factors__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function slope_factors__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var slope_factors__class = function (_React$Component) {
  slope_factors__inherits(_class, _React$Component);

  function _class() {
    slope_factors__classCallCheck(this, _class);

    return slope_factors__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  slope_factors__createClass(_class, [{
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        {
          "data-jsx": 2871253640
        },
        react_default.a.createElement(
          Main,
          null,
          react_default.a.createElement(components_SlopeChartFactors, {
            data: factors,
            width: this.props.width })
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 2871253640,
          css: "html,body{height:100%}body{background:#fff;margin:0;-webkit-text-rendering:optimizeLegibility;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-font-smoothing:grayscale}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9zbG9wZS1mYWN0b3JzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWUyQixBQUlDLEFBRTRCLGFBRmxCLElBRXdDLFVBQStDLDhFQUFnRCxvQ0FBMkMsK0JBQVciLCJmaWxlIjoic3JjL3BhZ2VzL3Nsb3BlLWZhY3RvcnMuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IE1haW4gZnJvbSBcIi4uL2NvbXBvbmVudHMvTWFpblwiO1xuaW1wb3J0IFNsb3BlQ2hhcnRGYWN0b3JzIGZyb20gXCIuLi9jb21wb25lbnRzL1Nsb3BlQ2hhcnRGYWN0b3JzXCI7XG5pbXBvcnQgeyBmYWN0b3JzIH0gZnJvbSBcIi4uL2RhdGEvY2hhcnREYXRhXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8ZGl2PlxuICAgICAgICA8TWFpbj5cbiAgICAgICAgICA8U2xvcGVDaGFydEZhY3RvcnMgXG4gICAgICAgICAgICBkYXRhPXtmYWN0b3JzfVxuICAgICAgICAgICAgd2lkdGg9e3RoaXMucHJvcHMud2lkdGh9IC8+XG4gICAgICAgIDwvTWFpbj5cblxuICAgICAgICA8c3R5bGUganN4IGdsb2JhbD57YFxuICAgICAgICAgIGh0bWwsIGJvZHkge1xuICAgICAgICAgICAgaGVpZ2h0OiAxMDAlXG4gICAgICAgICAgfVxuXG4gICAgICAgICAgYm9keSB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjZmZmO1xuICAgICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgICAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTtcbiAgICAgICAgICAgIC13ZWJraXQtZm9udC1zbW9vdGhpbmc6IGFudGlhbGlhc2VkO1xuICAgICAgICAgICAgLW1vei1mb250LXNtb290aGluZzogZ3JheXNjYWxlO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */\n/*@ sourceURL=src/pages/slope-factors.js */"
        })
      );
    }
  }]);

  return _class;
}(react_default.a.Component);

/* harmony default export */ var slope_factors = (slope_factors__class);
// EXTERNAL MODULE: ./src/static/emoji/1f4a5.svg
var _f4a5 = __webpack_require__(644);
var _f4a5_default = /*#__PURE__*/__webpack_require__.n(_f4a5);

// EXTERNAL MODULE: ./src/static/emoji/1f46a.svg
var _f46a = __webpack_require__(645);
var _f46a_default = /*#__PURE__*/__webpack_require__.n(_f46a);

// EXTERNAL MODULE: ./src/static/emoji/1f48e.svg
var _f48e = __webpack_require__(646);
var _f48e_default = /*#__PURE__*/__webpack_require__.n(_f48e);

// EXTERNAL MODULE: ./src/static/emoji/1f91d.svg
var _f91d = __webpack_require__(647);
var _f91d_default = /*#__PURE__*/__webpack_require__.n(_f91d);

// EXTERNAL MODULE: ./src/static/emoji/1f333.svg
var _f333 = __webpack_require__(648);
var _f333_default = /*#__PURE__*/__webpack_require__.n(_f333);

// EXTERNAL MODULE: ./src/static/emoji/1f910.svg
var _f910 = __webpack_require__(649);
var _f910_default = /*#__PURE__*/__webpack_require__.n(_f910);

// CONCATENATED MODULE: ./src/components/SlopeChartWealth.js
var SlopeChartWealth__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function SlopeChartWealth__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SlopeChartWealth__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SlopeChartWealth__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SlopeChartWealth_svgHash = {
  "Exciting experiences": _f4a5_default.a,
  "Legacy for family": _f46a_default.a,
  Luxury: _f48e_default.a,
  "Well connected": _f91d_default.a,
  Philanthropy: _f333_default.a,
  "Social Status": _f451_default.a,
  "None of these": _f910_default.a
};

var SlopeChartWealth_rowSpace = 40;

var SlopeChartWealth_Question = function Question() {
  return react_default.a.createElement(
    "div",
    { className: "question", "data-jsx": 868443243
    },
    "The most important forms of wealth for millennials and their parents",
    react_default.a.createElement(style_default.a, {
      styleId: 868443243,
      css: ".question[data-jsx=\"868443243\"]{color:#444;font-family:FrutigerLTCom;font-weight:300;font-size:24px;line-height:32px;-webkit-text-align:center;text-align:center;margin:0 0 16px 0;width:100%}@media screen and (max-width:768px){.question[data-jsx=\"868443243\"]{font-size:16px;line-height:24px;-webkit-text-align:left;text-align:left}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartWealth.js */"
    })
  );
};

var SlopeChartWealth_Controls = function (_Component) {
  SlopeChartWealth__inherits(Controls, _Component);

  function Controls(props) {
    SlopeChartWealth__classCallCheck(this, Controls);

    var _this = SlopeChartWealth__possibleConstructorReturn(this, (Controls.__proto__ || Object.getPrototypeOf(Controls)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.state = {
      group: "millennials"
    };
    return _this;
  }

  SlopeChartWealth__createClass(Controls, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.onChange(event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isMobile = this.props.width < 768;

      return react_default.a.createElement(
        "div",
        { className: "controls-container", "data-jsx": 1423833961
        },
        react_default.a.createElement(
          "div",
          { className: "controls", "data-jsx": 1423833961
          },
          react_default.a.createElement(
            "form",
            {
              "data-jsx": 1423833961
            },
            react_default.a.createElement(
              "select",
              { value: this.props.country, onChange: this.handleChange, "data-jsx": 1423833961
              },
              react_default.a.createElement(
                "option",
                { value: "All countries", "data-jsx": 1423833961
                },
                "All countries"
              ),
              react_default.a.createElement(
                "optgroup",
                { label: "Markets: ", "data-jsx": 1423833961
                },
                react_default.a.createElement(
                  "option",
                  { value: "Emerging markets", "data-jsx": 1423833961
                  },
                  "Emerging markets"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "Developed markets", "data-jsx": 1423833961
                  },
                  "Developed markets"
                )
              ),
              react_default.a.createElement(
                "optgroup",
                { label: "Countries: ", "data-jsx": 1423833961
                },
                react_default.a.createElement(
                  "option",
                  { value: "United States", "data-jsx": 1423833961
                  },
                  "United States"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "United Kingdom", "data-jsx": 1423833961
                  },
                  "United Kingdom"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "Germany", "data-jsx": 1423833961
                  },
                  "Germany"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "Singapore", "data-jsx": 1423833961
                  },
                  "Singapore"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "Russia", "data-jsx": 1423833961
                  },
                  "Russia"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "China", "data-jsx": 1423833961
                  },
                  "China"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "India", "data-jsx": 1423833961
                  },
                  "India"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "United Arab Emirates", "data-jsx": 1423833961
                  },
                  "United Arab Emirates"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "Mexico", "data-jsx": 1423833961
                  },
                  "Mexico"
                ),
                react_default.a.createElement(
                  "option",
                  { value: "South Africa", "data-jsx": 1423833961
                  },
                  "South Africa"
                )
              )
            )
          )
        ),
        isMobile ? react_default.a.createElement(
          "div",
          { className: "buttons", "data-jsx": 1423833961
          },
          react_default.a.createElement(
            "button",
            {
              className: this.state.group === "millennials" ? "active" : null,
              onClick: function onClick() {
                return _this2.setState({ group: "millennials" });
              },
              "data-jsx": 1423833961
            },
            "Millennials"
          ),
          react_default.a.createElement(
            "button",
            {
              className: this.state.group === "parents" ? "active" : null,
              onClick: function onClick() {
                return _this2.setState({ group: "parents" });
              },
              "data-jsx": 1423833961
            },
            "Parents"
          )
        ) : null,
        react_default.a.createElement(
          "div",
          { className: "chart-itself", "data-jsx": 1423833961
          },
          !isMobile ? react_default.a.createElement(SlopeChartWealth_RankList, {
            list: this.props.answersMillennials,
            country: this.props.country,
            side: "left"
          }) : null,
          react_default.a.createElement(SlopeChartWealth_Slope, {
            answersMillennials: this.props.answersMillennials,
            answersParents: this.props.answersParents,
            country: this.props.country
          }),
          react_default.a.createElement(SlopeChartWealth_RankList, {
            list: isMobile && this.state.group === "millennials" ? this.props.answersMillennials : this.props.answersParents,
            country: this.props.country,
            side: "right"
          })
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 1423833961,
          css: ".controls[data-jsx=\"1423833961\"]{padding-bottom:24px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%}.chart-itself[data-jsx=\"1423833961\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%}select[data-jsx=\"1423833961\"]{width:100%;margin:20px 0 10px 0;padding:10px;border:1px solid #444;border-radius:0;font-family:FrutigerLTCom;font-size:14px;-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-appearance:none;background:url('" + arrow_default.a + "') no-repeat right;background-position-x:95%}select[data-jsx=\"1423833961\"]:focus{outline:none}select[data-jsx=\"1423833961\"]::-ms-expand{display:none}.buttons[data-jsx=\"1423833961\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;padding-bottom:5px}button[data-jsx=\"1423833961\"]{font-size:14px;border:1px solid #444;width:50%;background:transparent;padding:10px;margin:0}button.active[data-jsx=\"1423833961\"]{background:#444;color:#fff}button[data-jsx=\"1423833961\"]:first-child{border-top-left-radius:1px;border-bottom-left-radius:1px}button[data-jsx=\"1423833961\"]:last-child{border-top-right-radius:1px;border-bottom-right-radius:1px}button[data-jsx=\"1423833961\"]:focus{outline:none}@media screen and (max-width:768px){.controls[data-jsx=\"1423833961\"]{padding-bottom:8px}form[data-jsx=\"1423833961\"]{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartWealth.js */"
        })
      );
    }
  }]);

  return Controls;
}(react["Component"]);

var SlopeChartWealth_RankList = function (_Component2) {
  SlopeChartWealth__inherits(RankList, _Component2);

  function RankList() {
    SlopeChartWealth__classCallCheck(this, RankList);

    return SlopeChartWealth__possibleConstructorReturn(this, (RankList.__proto__ || Object.getPrototypeOf(RankList)).apply(this, arguments));
  }

  SlopeChartWealth__createClass(RankList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var thisNode = src_select(this.node);
      var listItems = thisNode.selectAll("div.rank-list-item");
      listItems.transition().duration(0).style("transform", function (d, i) {
        return "translate(0px, " + i * SlopeChartWealth_rowSpace + "px)";
      });

      listItems.on("mouseover", function (d, i) {
        src_selectAll("div.rank-list-item").style("opacity", ".3");
        src_selectAll("line").style("stroke-opacity", ".3");
        var val = thisNode.select("div.rank-list-item#id" + i + "").attr("value");
        src_selectAll("div.rank-list-item[value = \"" + val + "\"]").style("opacity", "1");
        src_select("line[value = \"" + val + "\"]").style("stroke-opacity", "1");
      });

      src_selectAll(".controls-container").on("mouseleave", function (d, i) {
        src_selectAll("div.rank-list-item").style("opacity", "1");
        src_selectAll("line").style("stroke-opacity", "1");
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var thisNode = src_select(this.node);
      var listItems = src_select(this.node).selectAll("div.rank-list-item");
      listItems.transition().duration(1000).style("transform", function (d, i) {
        return "translate(0px, " + i * SlopeChartWealth_rowSpace + "px)";
      });

      listItems.on("mouseover", function (d, i) {
        src_selectAll("div.rank-list-item").style("opacity", ".3");
        src_selectAll("line").style("stroke-opacity", ".3");
        var val = thisNode.select("div.rank-list-item#id" + i + "").attr("value");
        src_selectAll("div.rank-list-item[value = \"" + val + "\"]").style("opacity", "1");
        src_select("line[value = \"" + val + "\"]").style("stroke-opacity", "1");
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var TheseAnswers = this.props.list.find(function (d) {
        return d.country === _this4.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });
      return react_default.a.createElement(
        "div",
        { className: "rank-list-container", "data-jsx": 1550588338
        },
        react_default.a.createElement(
          "div",
          { className: this.props.side === "left" ? "rank-list-title rank-list-title-millennials" : "rank-list-title rank-list-title-parents", "data-jsx": 1550588338
          },
          this.props.side === "left" ? "Millennials" : "Parents"
        ),
        react_default.a.createElement(
          "div",
          {
            className: "rank-list",
            ref: function ref(rankListDiv) {
              _this4.node = rankListDiv;
            },
            "data-jsx": 1550588338
          },
          TheseAnswers.map(function (d, i) {
            return react_default.a.createElement(
              "div",
              { className: _this4.props.side === "left" ? "rank-list-item rank-list-item-left" : "rank-list-item rank-list-item-right",
                key: d.key,
                id: "id" + i,
                value: d.key, "data-jsx": 1550588338
              },
              react_default.a.createElement("img", {
                width: "24px",
                height: "24px",
                src: SlopeChartWealth_svgHash[d.key],
                alt: "emoji " + d.key,
                "data-jsx": 1550588338
              }),
              react_default.a.createElement(
                "div",
                {
                  className: _this4.props.side === "left" ? "rank-label rank-label-left" : "rank-label rank-label-right", "data-jsx": 1550588338
                },
                d.key
              ),
              react_default.a.createElement(
                "div",
                { className: "rank-number",
                  style: {
                    textAlign: _this4.props.side === "left" ? "right" : "left"
                  }, "data-jsx": 1550588338
                },
                i + 1
              )
            );
          })
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 1550588338,
          css: ".rank-list-container[data-jsx=\"1550588338\"]{-webkit-flex:1 1 0%;-ms-flex:1 1 0%;flex:1 1 0%}.rank-list-title[data-jsx=\"1550588338\"]{font-family:FrutigerLTCom;font-weight:700;padding:0 26px 0 26px}.rank-list-title-millennials[data-jsx=\"1550588338\"]{-webkit-text-align:right;text-align:right}.rank-list[data-jsx=\"1550588338\"]{position:relative;font-size:14px;height:280px;padding-top:12px}.rank-list-item[data-jsx=\"1550588338\"]{position:absolute;width:100%;height:30px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between}.rank-list-item-left[data-jsx=\"1550588338\"]{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row}.rank-list-item-right[data-jsx=\"1550588338\"]{-webkit-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.rank-label[data-jsx=\"1550588338\"]{color:#333;font-family:FrutigerLTCom;font-size:16px;font-weight:300;padding:0 10px 0 10px;cursor:default}.rank-label-left[data-jsx=\"1550588338\"]{margin-left:auto}.rank-label-right[data-jsx=\"1550588338\"]{margin-right:auto}.rank-number[data-jsx=\"1550588338\"]{font-family:FrutigerLTCom;font-size:16px;font-weight:700;color:#807266;width:16px}@media screen and (max-width:768px){.rank-list-title[data-jsx=\"1550588338\"]{display:none}.rank-list[data-jsx=\"1550588338\"]{pointer-events:none}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartWealth.js */"
        })
      );
    }
  }]);

  return RankList;
}(react["Component"]);

var SlopeChartWealth_Slope = function (_Component3) {
  SlopeChartWealth__inherits(Slope, _Component3);

  function Slope() {
    SlopeChartWealth__classCallCheck(this, Slope);

    return SlopeChartWealth__possibleConstructorReturn(this, (Slope.__proto__ || Object.getPrototypeOf(Slope)).apply(this, arguments));
  }

  SlopeChartWealth__createClass(Slope, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;

      var MillennialsAnswers = this.props.answersMillennials.find(function (d) {
        return d.country === _this6.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });
      var ParentsAnswers = this.props.answersParents.find(function (d) {
        return d.country === _this6.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });

      ParentsAnswers.forEach(function (d, i) {
        d.rank = i;
      });

      var lines = src_select(this.node).selectAll("line");

      lines.transition().duration(0).attr("y1", function (d, i) {
        return i * SlopeChartWealth_rowSpace;
      }).attr("y2", function (d, i) {
        var ParentRank = ParentsAnswers.find(function (r) {
          return r.key === MillennialsAnswers[i].key;
        });
        return ParentRank.rank * SlopeChartWealth_rowSpace;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this7 = this;

      var MillennialsAnswers = this.props.answersMillennials.find(function (d) {
        return d.country === _this7.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });
      var ParentsAnswers = this.props.answersParents.find(function (d) {
        return d.country === _this7.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });

      ParentsAnswers.forEach(function (d, i) {
        d.rank = i;
      });

      var lines = src_select(this.node).selectAll("line");

      lines.transition().duration(1000).attr("y1", function (d, i) {
        return i * SlopeChartWealth_rowSpace;
      }).attr("y2", function (d, i) {
        var ParentRank = ParentsAnswers.find(function (r) {
          return r.key === MillennialsAnswers[i].key;
        });
        return ParentRank.rank * SlopeChartWealth_rowSpace;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var MillennialsAnswers = this.props.answersMillennials.find(function (d) {
        return d.country === _this8.props.country;
      }).answers.sort(function (a, b) {
        return b.value - a.value;
      });

      return react_default.a.createElement(
        "div",
        { className: "slope", "data-jsx": 3216700783
        },
        react_default.a.createElement(
          "svg",
          { className: "svg-slope", width: "300px", height: "280px", "data-jsx": 3216700783
          },
          react_default.a.createElement(
            "g",
            {
              className: "slopes-group",
              ref: function ref(node) {
                _this8.node = node;
              },
              "data-jsx": 3216700783
            },
            MillennialsAnswers.map(function (d, i) {
              return react_default.a.createElement("line", {
                key: d.key,
                value: d.key,
                x1: 20,
                y1: 0,
                x2: 280,
                y2: 0,
                style: { stroke: "#807266", strokeLinecap: "round", "strokeWidth": "2px" },
                "data-jsx": 3216700783
              });
            })
          )
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 3216700783,
          css: "svg[data-jsx=\"3216700783\"]{display:block}.svg-slope[data-jsx=\"3216700783\"]{padding-top:48px}@media screen and (max-width:768px){.slope[data-jsx=\"3216700783\"]{display:none}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartWealth.js */"
        })
      );
    }
  }]);

  return Slope;
}(react["Component"]);

var SlopeChartWealth_Source = function Source() {
  return react_default.a.createElement(
    "div",
    { className: "source", "data-jsx": 1208713003
    },
    "Source: unlimited.world survey of affluent millennials, UBS. Data as of October 2016. N = 2,130.",
    react_default.a.createElement(style_default.a, {
      styleId: 1208713003,
      css: ".source[data-jsx=\"1208713003\"]{font-family:FrutigerLTCom;width:100%;font-size:11px;font-weight:300;color:#888;height:26px;-webkit-text-align:center;text-align:center}@media screen and (max-width:768px){.source[data-jsx=\"1208713003\"]{-webkit-text-align:left;text-align:left}}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/components/SlopeChartWealth.js */"
    })
  );
};

var SlopeChartWealth_SlopeChartWealth = function (_Component4) {
  SlopeChartWealth__inherits(SlopeChartWealth, _Component4);

  function SlopeChartWealth(props) {
    SlopeChartWealth__classCallCheck(this, SlopeChartWealth);

    var _this9 = SlopeChartWealth__possibleConstructorReturn(this, (SlopeChartWealth.__proto__ || Object.getPrototypeOf(SlopeChartWealth)).call(this, props));

    _this9.state = {
      country: "All countries"
    };

    _this9.handleChange = _this9.handleChange.bind(_this9);
    return _this9;
  }

  SlopeChartWealth__createClass(SlopeChartWealth, [{
    key: "handleChange",
    value: function handleChange(country) {
      this.setState({
        country: country
      });
    }
  }, {
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        { className: "whole-chart" },
        react_default.a.createElement(SlopeChartWealth_Question, null),
        react_default.a.createElement(SlopeChartWealth_Controls, {
          answersMillennials: this.props.dataMillennials,
          answersParents: this.props.dataParents,
          country: this.state.country,
          onChange: this.handleChange,
          width: this.props.width
        }),
        react_default.a.createElement(SlopeChartWealth_Source, null)
      );
    }
  }]);

  return SlopeChartWealth;
}(react["Component"]);

/* harmony default export */ var components_SlopeChartWealth = (SlopeChartWealth_SlopeChartWealth);
// CONCATENATED MODULE: ./src/pages/slope-wealth.js
var slope_wealth__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function slope_wealth__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function slope_wealth__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function slope_wealth__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var slope_wealth__class = function (_React$Component) {
  slope_wealth__inherits(_class, _React$Component);

  function _class() {
    slope_wealth__classCallCheck(this, _class);

    return slope_wealth__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  slope_wealth__createClass(_class, [{
    key: "render",
    value: function render() {
      return react_default.a.createElement(
        "div",
        {
          "data-jsx": 2871253640
        },
        react_default.a.createElement(
          Main,
          null,
          react_default.a.createElement(components_SlopeChartWealth, {
            dataMillennials: wealthMillennials,
            dataParents: wealthParents,
            width: this.props.width
          })
        ),
        react_default.a.createElement(style_default.a, {
          styleId: 2871253640,
          css: "html,body{height:100%}body{background:#fff;margin:0;-webkit-text-rendering:optimizeLegibility;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-font-smoothing:grayscale}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9zbG9wZS13ZWFsdGguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUIyQixBQUlDLEFBRTRCLGFBRmxCLElBRXdDLFVBQStDLDhFQUFnRCxvQ0FBMkMsK0JBQVciLCJmaWxlIjoic3JjL3BhZ2VzL3Nsb3BlLXdlYWx0aC5qcyIsInNvdXJjZVJvb3QiOiIvb3B0L2J1aWxkL3JlcG8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgTWFpbiBmcm9tIFwiLi4vY29tcG9uZW50cy9NYWluXCI7XG5pbXBvcnQgU2xvcGVDaGFydFdlYWx0aCBmcm9tIFwiLi4vY29tcG9uZW50cy9TbG9wZUNoYXJ0V2VhbHRoXCI7XG5pbXBvcnQgeyB3ZWFsdGhNaWxsZW5uaWFscywgd2VhbHRoUGFyZW50cyB9IGZyb20gXCIuLi9kYXRhL2NoYXJ0RGF0YVwiO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdj5cbiAgICAgICAgPE1haW4+XG4gICAgICAgICAgPFNsb3BlQ2hhcnRXZWFsdGhcbiAgICAgICAgICAgIGRhdGFNaWxsZW5uaWFscz17d2VhbHRoTWlsbGVubmlhbHN9XG4gICAgICAgICAgICBkYXRhUGFyZW50cz17d2VhbHRoUGFyZW50c31cbiAgICAgICAgICAgIHdpZHRoPXt0aGlzLnByb3BzLndpZHRofVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvTWFpbj5cblxuICAgICAgICA8c3R5bGUganN4IGdsb2JhbD57YFxuICAgICAgICAgIGh0bWwsIGJvZHkge1xuICAgICAgICAgICAgaGVpZ2h0OiAxMDAlXG4gICAgICAgICAgfVxuXG4gICAgICAgICAgYm9keSB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjZmZmO1xuICAgICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgICAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTtcbiAgICAgICAgICAgIC13ZWJraXQtZm9udC1zbW9vdGhpbmc6IGFudGlhbGlhc2VkO1xuICAgICAgICAgICAgLW1vei1mb250LXNtb290aGluZzogZ3JheXNjYWxlO1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */\n/*@ sourceURL=src/pages/slope-wealth.js */"
        })
      );
    }
  }]);

  return _class;
}(react_default.a.Component);

/* harmony default export */ var slope_wealth = (slope_wealth__class);
// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var react_loadable_lib = __webpack_require__(650);
var react_loadable_lib_default = /*#__PURE__*/__webpack_require__.n(react_loadable_lib);

// CONCATENATED MODULE: ./node_modules/d3-path/src/path.js
var path_pi = Math.PI,
    path_tau = 2 * path_pi,
    epsilon = 1e-6,
    tauEpsilon = path_tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path_path() {
  return new Path;
}

Path.prototype = path_path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((path_pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % path_tau + path_tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= path_pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ var src_path = (path_path);

// CONCATENATED MODULE: ./node_modules/d3-path/index.js


// CONCATENATED MODULE: ./node_modules/d3-shape/src/constant.js
/* harmony default export */ var d3_shape_src_constant = (function(x) {
  return function constant() {
    return x;
  };
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/math.js
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var math_max = Math.max;
var math_min = Math.min;
var sin = Math.sin;
var math_sqrt = Math.sqrt;

var math_epsilon = 1e-12;
var math_pi = Math.PI;
var math_halfPi = math_pi / 2;
var math_tau = 2 * math_pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? math_pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? math_halfPi : x <= -1 ? -math_halfPi : Math.asin(x);
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/arc.js




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / math_sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * math_sqrt(math_max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ var src_arc = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = d3_shape_src_constant(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - math_halfPi,
        a1 = endAngle.apply(this, arguments) - math_halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = src_path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > math_epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > math_tau - math_epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > math_epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > math_epsilon) && (padRadius ? +padRadius.apply(this, arguments) : math_sqrt(r0 * r0 + r1 * r1)),
          rc = math_min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > math_epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > math_epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > math_epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > math_epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < math_pi) {
          var oc = da0 > math_epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (math_sqrt(ax * ax + ay * ay) * math_sqrt(bx * bx + by * by))) / 2),
              lc = math_sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = math_min(rc, (r0 - lc) / (kc - 1));
          rc1 = math_min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > math_epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > math_epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > math_epsilon) || !(da0 > math_epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > math_epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - math_pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ var curve_linear = (function(context) {
  return new Linear(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/point.js
function point_x(p) {
  return p[0];
}

function point_y(p) {
  return p[1];
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/line.js





/* harmony default export */ var src_line = (function() {
  var x = point_x,
      y = point_y,
      defined = d3_shape_src_constant(true),
      context = null,
      curve = curve_linear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = src_path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : d3_shape_src_constant(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : d3_shape_src_constant(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : d3_shape_src_constant(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/area.js






/* harmony default export */ var src_area = (function() {
  var x0 = point_x,
      x1 = null,
      y0 = d3_shape_src_constant(0),
      y1 = point_y,
      defined = d3_shape_src_constant(true),
      context = null,
      curve = curve_linear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = src_path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return src_line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : d3_shape_src_constant(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : d3_shape_src_constant(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : d3_shape_src_constant(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : d3_shape_src_constant(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : d3_shape_src_constant(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : d3_shape_src_constant(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : d3_shape_src_constant(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/descending.js
/* harmony default export */ var src_descending = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/identity.js
/* harmony default export */ var d3_shape_src_identity = (function(d) {
  return d;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/pie.js





/* harmony default export */ var src_pie = (function() {
  var value = d3_shape_src_identity,
      sortValues = src_descending,
      sort = null,
      startAngle = d3_shape_src_constant(0),
      endAngle = d3_shape_src_constant(math_tau),
      padAngle = d3_shape_src_constant(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(math_tau, Math.max(-math_tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : d3_shape_src_constant(+_), pie) : padAngle;
  };

  return pie;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/radial.js


var curveRadialLinear = curveRadial(curve_linear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/lineRadial.js



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ var src_lineRadial = (function() {
  return lineRadial(src_line().curve(curveRadialLinear));
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/areaRadial.js




/* harmony default export */ var areaRadial = (function() {
  var a = src_area().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/pointRadial.js
/* harmony default export */ var pointRadial = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/array.js
var src_array_slice = Array.prototype.slice;

// CONCATENATED MODULE: ./node_modules/d3-shape/src/link/index.js






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link_link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = point_x,
      y = point_y,
      context = null;

  function link() {
    var buffer, argv = src_array_slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = src_path();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : d3_shape_src_constant(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : d3_shape_src_constant(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function link_curveRadial(context, x0, y0, x1, y1) {
  var p0 = pointRadial(x0, y0),
      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
      p2 = pointRadial(x1, y0),
      p3 = pointRadial(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link_link(curveHorizontal);
}

function linkVertical() {
  return link_link(curveVertical);
}

function linkRadial() {
  var l = link_link(link_curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/circle.js


/* harmony default export */ var circle = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / math_pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, math_tau);
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/cross.js
/* harmony default export */ var symbol_cross = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/diamond.js
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ var diamond = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/star.js


var ka = 0.89081309152928522810,
    kr = Math.sin(math_pi / 10) / Math.sin(7 * math_pi / 10),
    kx = Math.sin(math_tau / 10) * kr,
    ky = -Math.cos(math_tau / 10) * kr;

/* harmony default export */ var star = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = math_tau * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/square.js
/* harmony default export */ var square = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/triangle.js
var sqrt3 = Math.sqrt(3);

/* harmony default export */ var triangle = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol/wye.js
var wye_c = -0.5,
    wye_s = Math.sqrt(3) / 2,
    wye_k = 1 / Math.sqrt(12),
    wye_a = (wye_k / 2 + 1) * 3;

/* harmony default export */ var wye = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / wye_a),
        x0 = r / 2,
        y0 = r * wye_k,
        x1 = x0,
        y1 = r * wye_k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(wye_c * x0 - wye_s * y0, wye_s * x0 + wye_c * y0);
    context.lineTo(wye_c * x1 - wye_s * y1, wye_s * x1 + wye_c * y1);
    context.lineTo(wye_c * x2 - wye_s * y2, wye_s * x2 + wye_c * y2);
    context.lineTo(wye_c * x0 + wye_s * y0, wye_c * y0 - wye_s * x0);
    context.lineTo(wye_c * x1 + wye_s * y1, wye_c * y1 - wye_s * x1);
    context.lineTo(wye_c * x2 + wye_s * y2, wye_c * y2 - wye_s * x2);
    context.closePath();
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/symbol.js










var symbols = [
  circle,
  symbol_cross,
  diamond,
  square,
  star,
  triangle,
  wye
];

/* harmony default export */ var src_symbol = (function() {
  var type = d3_shape_src_constant(circle),
      size = d3_shape_src_constant(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = src_path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : d3_shape_src_constant(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : d3_shape_src_constant(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/noop.js
/* harmony default export */ var src_noop = (function() {});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/basis.js
function basis_point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: basis_point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: basis_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ var curve_basis = (function(context) {
  return new Basis(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/basisClosed.js



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: src_noop,
  areaEnd: src_noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: basis_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ var curve_basisClosed = (function(context) {
  return new BasisClosed(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/basisOpen.js


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: basis_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ var basisOpen = (function(context) {
  return new BasisOpen(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/bundle.js


function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ var curve_bundle = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/cardinal.js
function cardinal_point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: cardinal_point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: cardinal_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var cardinal = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/cardinalClosed.js



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: src_noop,
  areaEnd: src_noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: cardinal_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var cardinalClosed = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/cardinalOpen.js


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: cardinal_point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var cardinalOpen = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/catmullRom.js



function catmullRom_point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > math_epsilon) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > math_epsilon) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: catmullRom_point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var curve_catmullRom = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/catmullRomClosed.js




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: src_noop,
  areaEnd: src_noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: catmullRom_point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var catmullRomClosed = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/catmullRomOpen.js



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: catmullRom_point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ var catmullRomOpen = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/linearClosed.js


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: src_noop,
  areaEnd: src_noop,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ var linearClosed = (function(context) {
  return new LinearClosed(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/monotone.js
function monotone_sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (monotone_sign(s0) + monotone_sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function monotone_point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: monotone_point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; monotone_point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: monotone_point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/natural.js
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ var natural = (function(context) {
  return new Natural(context);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/curve/step.js
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ var curve_step = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/none.js
/* harmony default export */ var offset_none = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/none.js
/* harmony default export */ var order_none = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/stack.js





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ var src_stack = (function() {
  var keys = d3_shape_src_constant([]),
      order = order_none,
      offset = offset_none,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : d3_shape_src_constant(src_array_slice.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : d3_shape_src_constant(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? order_none : typeof _ === "function" ? _ : d3_shape_src_constant(src_array_slice.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? offset_none : _, stack) : offset;
  };

  return stack;
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/expand.js


/* harmony default export */ var expand = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  offset_none(series, order);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/diverging.js
/* harmony default export */ var diverging = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/silhouette.js


/* harmony default export */ var silhouette = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  offset_none(series, order);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/offset/wiggle.js


/* harmony default export */ var wiggle = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  offset_none(series, order);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/ascending.js


/* harmony default export */ var order_ascending = (function(series) {
  var sums = series.map(ascending_sum);
  return order_none(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function ascending_sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/descending.js


/* harmony default export */ var order_descending = (function(series) {
  return order_ascending(series).reverse();
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/insideOut.js



/* harmony default export */ var insideOut = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(ascending_sum),
      order = order_none(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});

// CONCATENATED MODULE: ./node_modules/d3-shape/src/order/reverse.js


/* harmony default export */ var order_reverse = (function(series) {
  return order_none(series).reverse();
});

// CONCATENATED MODULE: ./node_modules/d3-shape/index.js




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!








































// CONCATENATED MODULE: ./src/components/InternalSurvey/InternalSurvey.js


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









/**
 * question (27 + 7)
 *   x all/country/division (1 + 7 + 6 = 14)
 *     x all/gender/rank/linemgr/los (5)
 * = 2380 charts?!
 * 
 * hierarchy w 2 levels:
 * - charts (e.g. q + country + facet)
 * - rows (facet value)
 */

/**
 *     {
    "GCRS_Division_Desc": "Wealth Management",
    "GCRS_Unit_Desc": "International Wealth Management",
    "GCRS_Area_Desc": "WM Europe and Emerging Markets",
    "Work_Location_Region": "SWITZERLAND",
    "Country_Descr": "Switzerland",
    "City": "Zürich",
    "Line_Manager_Flag": "N",
    "Being_with_UBS": "1 year or less",
    "Corporate_Title": "AD",
    "Gender": "Male",
    "dimension": "Career Path Planning & Internal Mobility",
    "subdimension": "Training and Development",
    "question": "to be encouraged and supported in pursuing my chosen career path",
    "questionCode": "A1_0",
    "likert": "Disagree",
    "ranking": "Priority 1"
  },
 */

var COUNTRIES = new Map([["Switzerland", 1], ["United Kingdom", 2], ["Poland", 3], ["United States", 4], ["Hong Kong", 5], ["Singapore", 6], ["India", 7]]);

var SUBDIMENSIONS = new Map([["Training and Development", 1], ["Internal Mobility", 2], ["Workplace", 3], ["Agile Working Practices", 4], ["Asset Management", 5], ["Feedback and Recognition", 6], ["Compensation and Benefits", 7], ["Collaboration and Interaction", 8], ["Management and Hierarchy", 9], ["Purpose and Meaning", 10]]);

var DIVISIONS = new Map([["Corporate Center", 1], ["Investment Bank", 2], ["Personal & Corporate Banking", 3], ["Wealth Management", 4], ["Wealth Management Americas", 5], ["Global Asset Management", 6]]);

var FACET_ORDERS = new Map([
// Corporate titles
["DI - MD", 1], ["AD", 2], ["AO", 3], ["EE", 4],
// Countries
["Switzerland", 1], ["United Kingdom", 2], ["Poland", 3], ["United States", 4], ["Hong Kong", 5], ["Singapore", 6], ["India", 7]]);

var InternalSurvey_facetKey = function facetKey(facet) {
  return function (d) {
    switch (facet) {
      case "Countries":
        return d.Country_Descr;
      case "Business Divisions":
        return d.GCRS_Division_Desc;
      case "Gender":
        return d.Gender;
      case "Corporate Title":
        return d.Corporate_Title;
      case "Being a Line Manager":
        return d.Line_Manager_Flag;
      case "Length of Service":
        return d.Being_with_UBS;
      default:
        // Match exhaustively: http://ouicar.github.io/2016/08/08/exhaustive-switch.html
        throw new Error("Unknown facet: " + facet);
    }
  };
};

var fmtPct = defaultLocale_format(".0%");

var filterValid = function filterValid(d) {
  return COUNTRIES.has(d.Country_Descr) && SUBDIMENSIONS.has(d.subdimension) && DIVISIONS.has(d.GCRS_Division_Desc);
};

var LIKERT_NEUTRAL = 3;
var InternalSurvey_offsetLikert = function offsetLikert(series, order) {
  // normalize from 0 to 1
  expand(series, order);

  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    // Stack the neutral and positive values
    for (yp = yn = 0, i = LIKERT_NEUTRAL - 1; i < n; ++i) {
      dy = (d = series[order[i]][j])[1] - d[0];

      if (i === LIKERT_NEUTRAL - 1) {
        //neutral goes centered in the middle
        d[0] = yp - dy / 2, d[1] = yp += dy / 2;
      } else {
        d[0] = yp, d[1] = yp += dy;
      }
    }
    // Now stack the negative values
    for (yp = yn = 0, i = LIKERT_NEUTRAL - 1; i >= 0; --i) {
      dy = (d = series[order[i]][j])[1] - d[0];
      if (i === LIKERT_NEUTRAL - 1) {
        yp -= dy / 2;
      } else if (i < LIKERT_NEUTRAL - 1) {
        d[1] = yp, d[0] = yp -= dy;
      }
    }
  }
};

var likertStack = src_stack().keys(["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]).value(function (d, key) {
  return d.value[key];
}).order(order_none).offset(InternalSurvey_offsetLikert);

var InternalSurvey_color = ordinal().domain(["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]).range(["#585148", "#807266", "#BEBEBE", "#D7C2AA", "#B89D83"]);

var priorityColor = linear_linear().range(["#fff", "#3B8085"]);

var InternalSurvey_x = linear_linear().domain([-1, 1]).rangeRound([100, 500]);

var InternalSurvey_rollupValues = function rollupValues(values) {
  return {
    "Strongly disagree": src_sum(values, function (d) {
      return d.likert === "Strongly disagree";
    }),
    Disagree: src_sum(values, function (d) {
      return d.likert === "Disagree";
    }),
    Neutral: src_sum(values, function (d) {
      return d.likert === "Neutral";
    }),
    Agree: src_sum(values, function (d) {
      return d.likert === "Agree";
    }),
    "Strongly agree": src_sum(values, function (d) {
      return d.likert === "Strongly agree";
    }),
    "Priority 1": src_sum(values, function (d) {
      return d.ranking === "Priority 1";
    }) / values.length,
    "Priority 2": src_sum(values, function (d) {
      return d.ranking === "Priority 2";
    }) / values.length,
    "Priority 3": src_sum(values, function (d) {
      return d.ranking === "Priority 3";
    }) / values.length
  };
};

var getKeyOrder = function getKeyOrder(k) {
  return FACET_ORDERS.has(k) ? FACET_ORDERS.get(k) : k;
};

var InternalSurvey = react_loadable_lib_default()({
  loader: function loader() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 654));
  },
  loading: function loading() {
    return react_default.a.createElement(
      "div",
      null,
      "\u2026"
    );
  },
  render: function render(data, props) {
    var bySubdimension = src_nest().key(function (d) {
      return d.subdimension;
    }).key(function (d) {
      return "... " + d.question;
    }).key(function () {
      return "global";
    }).rollup(InternalSurvey_rollupValues);

    var bySubdimensionFacets = src_nest().key(function (d) {
      return "" + d.subdimension;
    }).key(function (d) {
      return "... " + d.question;
    }).key(InternalSurvey_facetKey(props.facets)).sortKeys(function (a, b) {
      return ascending(getKeyOrder(a), getKeyOrder(b));
    }).rollup(InternalSurvey_rollupValues);

    var subdimensionsGlobal = bySubdimension.object(data);
    var subdimensions = bySubdimensionFacets.entries(data.filter(filterValid));
    return react_default.a.createElement(
      "div",
      { className: "page", "data-jsx": 1252408888
      },
      react_default.a.createElement(
        "h1",
        {
          "data-jsx": 1252408888
        },
        props.facets
      ),
      subdimensions.map(function (_ref) {
        var subdimension = _ref.key,
            questions = _ref.values;

        return react_default.a.createElement(
          "div",
          { className: "subdimension", "data-jsx": 1252408888
          },
          react_default.a.createElement(
            "h2",
            {
              "data-jsx": 1252408888
            },
            subdimension
          ),
          questions.map(function (_ref2, i) {
            var question = _ref2.key,
                facetsWithoutGlobal = _ref2.values;

            var globalFacet = {
              key: "Global",
              value: subdimensionsGlobal[subdimension][question].global
            };
            var facets = [globalFacet].concat(_toConsumableArray(facetsWithoutGlobal));
            var stack = likertStack(facets);
            var facetKeys = facets.map(function (f) {
              return f.key;
            });
            var y = band().domain(facetKeys).range([60, facets.length * 30 + 60]);

            return react_default.a.createElement(
              "div",
              { className: "facet", "data-jsx": 1252408888
              },
              react_default.a.createElement(
                "div",
                {
                  "data-jsx": 1252408888
                },
                react_default.a.createElement(
                  "h3",
                  {
                    "data-jsx": 1252408888
                  },
                  question
                )
              ),
              react_default.a.createElement(
                "div",
                { className: "facetBlock", "data-jsx": 1252408888
                },
                react_default.a.createElement(
                  "div",
                  { className: "questions", "data-jsx": 1252408888
                  },
                  facetKeys.map(function (facetKey, i) {
                    return react_default.a.createElement(
                      "div",
                      {
                        className: "question",
                        style: {
                          transform: "translate(" + 0 + "px," + (y(facetKey) + y.step() / 2) + "px)"
                        },
                        "data-jsx": 1252408888
                      },
                      facetKey
                    );
                  })
                ),
                react_default.a.createElement(
                  "svg",
                  {
                    width: InternalSurvey_x.range()[1] + 100,
                    height: y.range()[1] + 50,
                    "data-jsx": 1252408888
                  },
                  react_default.a.createElement(
                    "g",
                    { className: "priority-label", "data-jsx": 1252408888
                    },
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "end" },
                        transform: "translate(" + (InternalSurvey_x(-1) - 4) + ", 30)",
                        "data-jsx": 1252408888
                      },
                      "Disagree"
                    ),
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "middle" },
                        transform: "translate(" + InternalSurvey_x(0) + ", 30)",
                        "data-jsx": 1252408888
                      },
                      "Neutral"
                    ),
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "start" },
                        transform: "translate(" + (InternalSurvey_x(1) + 4) + ", 30)",
                        "data-jsx": 1252408888
                      },
                      "Agree"
                    )
                  ),
                  [-1, -0.5, 0, 0.5, 1].map(function (d) {
                    return react_default.a.createElement(
                      "g",
                      { transform: "translate(" + InternalSurvey_x(d) + ",0)", "data-jsx": 1252408888
                      },
                      react_default.a.createElement("path", {
                        className: "tick",
                        d: "M0," + y.range()[0] + "V" + y.range()[1],
                        "data-jsx": 1252408888
                      }),
                      react_default.a.createElement("text", {
                        dy: ".35em",
                        className: "tickLabel",
                        transform: "translate(0," + (y.range()[1] + y.step() / 2) + ")",
                        "data-jsx": 1252408888
                      })
                    );
                  }),
                  stack[0].map(function (d, i) {
                    return react_default.a.createElement(
                      "g",
                      {
                        "data-jsx": 1252408888
                      },
                      react_default.a.createElement(
                        "text",
                        {
                          dy: ".35em",
                          className: "rowLabel",
                          style: { textAnchor: "end" },
                          transform: "translate(" + (InternalSurvey_x(-1) - 4) + "," + (y(d.data.key) + y.step() / 2) + ")",
                          "data-jsx": 1252408888
                        },
                        fmtPct(stack[0][i][1] - stack[0][i][0] + (stack[1][i][1] - stack[1][i][0]))
                      ),
                      react_default.a.createElement(
                        "text",
                        {
                          dy: ".35em",
                          className: "rowLabel",
                          style: { textAnchor: "start" },
                          transform: "translate(" + (InternalSurvey_x(1) + 4) + "," + (y(d.data.key) + y.step() / 2) + ")",
                          "data-jsx": 1252408888
                        },
                        fmtPct(stack[3][i][1] - stack[3][i][0] + (stack[4][i][1] - stack[4][i][0]))
                      )
                    );
                  }),
                  stack.map(function (facet) {
                    return react_default.a.createElement(
                      "g",
                      { fill: InternalSurvey_color(facet.key), "data-jsx": 1252408888
                      },
                      facet.map(function (value, i) {
                        return react_default.a.createElement("rect", {
                          transform: "translate(" + InternalSurvey_x(value[0]) + "," + (y(value.data.key) + 3) + ")",
                          height: "24",
                          width: InternalSurvey_x(value[1]) - InternalSurvey_x(value[0]),
                          "data-jsx": 1252408888
                        });
                      })
                    );
                  })
                ),
                react_default.a.createElement(
                  "svg",
                  { width: "130", "data-jsx": 1252408888
                  },
                  react_default.a.createElement(
                    "g",
                    { className: "priority-label", "data-jsx": 1252408888
                    },
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "middle" },
                        transform: "translate(45, 12)",
                        "data-jsx": 1252408888
                      },
                      "Priority"
                    ),
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "middle" },
                        transform: "translate(15, 30)",
                        "data-jsx": 1252408888
                      },
                      "1"
                    ),
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "middle" },
                        transform: "translate(45, 30)",
                        "data-jsx": 1252408888
                      },
                      "2"
                    ),
                    react_default.a.createElement(
                      "text",
                      {
                        dy: "1.6em",
                        className: "pcLabelTitle",
                        style: { textAnchor: "middle" },
                        transform: "translate(75, 30)",
                        "data-jsx": 1252408888
                      },
                      "3"
                    )
                  ),
                  facets.map(function (_ref3) {
                    var facet = _ref3.key,
                        answers = _ref3.value;

                    priorityColor.domain([0, 1]);
                    return react_default.a.createElement(
                      "g",
                      {
                        "data-jsx": 1252408888
                      },
                      react_default.a.createElement("rect", {
                        height: "30"
                        //width={`${answers['Priority 1']}`}
                        , width: "30",
                        fill: "" + priorityColor(answers["Priority 1"]),
                        transform: "translate(0, " + y(facet) + ")",
                        "data-jsx": 1252408888
                      }),
                      react_default.a.createElement(
                        "text",
                        {
                          dy: "1.6em",
                          className: "pcLabel",
                          style: { textAnchor: "middle" },
                          transform: "translate(15, " + y(facet) + ")",
                          "data-jsx": 1252408888
                        },
                        Math.round(answers["Priority 1"] * 100)
                      ),
                      react_default.a.createElement("rect", {
                        height: "30"
                        //width={`${answers['Priority 2']}`}
                        , width: "30",
                        fill: "" + priorityColor(answers["Priority 2"]),
                        transform: "translate(30, " + y(facet) + ")",
                        "data-jsx": 1252408888
                      }),
                      react_default.a.createElement(
                        "text",
                        {
                          dy: "1.6em",
                          className: "pcLabel",
                          style: { textAnchor: "middle" },
                          transform: "translate(45, " + y(facet) + ")",
                          "data-jsx": 1252408888
                        },
                        Math.round(answers["Priority 2"] * 100)
                      ),
                      react_default.a.createElement("rect", {
                        height: "30"
                        //width={`${answers['Priority 3']}`}
                        , width: "30",
                        fill: "" + priorityColor(answers["Priority 3"]),
                        transform: "translate(60, " + y(facet) + ")",
                        "data-jsx": 1252408888
                      }),
                      react_default.a.createElement(
                        "text",
                        {
                          dy: "1.6em",
                          className: "pcLabel",
                          style: { textAnchor: "middle" },
                          transform: "translate(75, " + y(facet) + ")",
                          "data-jsx": 1252408888
                        },
                        Math.round(answers["Priority 3"] * 100)
                      ),
                      react_default.a.createElement(
                        "text",
                        {
                          dy: "1.6em",
                          className: "pcLabel",
                          style: { textAnchor: "start" },
                          transform: "translate(92, " + y(facet) + ")",
                          "data-jsx": 1252408888
                        },
                        "%"
                      )
                    );
                  })
                )
              )
            );
          })
        );
      }),
      react_default.a.createElement(style_default.a, {
        styleId: 1252408888,
        css: "div[data-jsx=\"1252408888\"]{color:#4D4D4D;font-family:FrutigerLTCom;font-weight:300;font-size:14px}text[data-jsx=\"1252408888\"]{fill:#4D4D4D;font-family:FrutigerLTCom;font-weight:300;font-size:14px}h1[data-jsx=\"1252408888\"]{font-size:48px;font-weight:300;page-break-before:always}h2[data-jsx=\"1252408888\"]{font-size:24px;font-weight:300}h3[data-jsx=\"1252408888\"]{font-size:16px;font-weight:700;margin:0}svg[data-jsx=\"1252408888\"]{display:block}.questionAndPriorities[data-jsx=\"1252408888\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between;width:100%}.priority-label[data-jsx=\"1252408888\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.tick[data-jsx=\"1252408888\"]{stroke-width:1;stroke:#bbb;fill:none;shape-rendering:crispEdges}.tickLabel[data-jsx=\"1252408888\"]{fill:#bbb;-webkit-text-anchor:middle;text-anchor:middle;font-size:12px}.rowLabel[data-jsx=\"1252408888\"]{fill:#4D4D4D;font-size:12px;font-weight:700}.pcLabel[data-jsx=\"1252408888\"]{font-size:12px;font-weight:300}.pcLabelTitle[data-jsx=\"1252408888\"]{font-size:12px;font-weight:700}.facetBlock[data-jsx=\"1252408888\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:space-between;-webkit-justify-content:space-between;-ms-flex-pack:space-between;justify-content:space-between;width:1000px}.questions[data-jsx=\"1252408888\"]{width:200px;position:relative}.question[data-jsx=\"1252408888\"]{position:absolute;width:100%;font-size:12px;height:30px;margin-top:-15px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.subdimension[data-jsx=\"1252408888\"]{page-break-before:always}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0ludGVybmFsU3VydmV5L0ludGVybmFsU3VydmV5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdkb0IsQUFHMkIsQUFDRCxBQUNFLEFBQ0EsQUFDQSxBQUNELEFBQ0QsQUFDQSxBQUNFLEFBQ0wsQUFDRyxBQUNFLEFBQ0EsQUFDRixBQUNELEFBQ00sQUFFTyxXQVJpQixFQUtDLENBYlMsQUFTWCxDQVZZLEFBSzVCLENBSG1CLEFBQ0EsQUFDQSxBQUlKLEFBR0ksQUFDQSxHQUdGLE9BRU4sR0FUMkIsQ0FFTyxDQU12RCxDQUZ1QyxDQVo0QixBQUMzQixBQUNXLEFBT1gsQUFDQSxPQUpnRCxDQVB0QixDQURDLENBSUwsSUFNSSxBQU16QyxXQWZxRSxDQURDLEFBRWpCLEFBT3ZCLENBT0EsUUFSNEMsTUFQTSxDQURDLEFBU3hDLEdBSHpCLEFBQ2hDLEFBTWdDLEFBR3dDLDhFQUFtQyxxREFWbkQsQUFPRSxZQVBTLEVBT0UsY0FHMEUsdUdBQVciLCJmaWxlIjoic3JjL2NvbXBvbmVudHMvSW50ZXJuYWxTdXJ2ZXkvSW50ZXJuYWxTdXJ2ZXkuanMiLCJzb3VyY2VSb290IjoiL29wdC9idWlsZC9yZXBvIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCB7IG5lc3QsIGVudHJpZXMgfSBmcm9tIFwiZDMtY29sbGVjdGlvblwiO1xuaW1wb3J0IExvYWRhYmxlIGZyb20gXCJyZWFjdC1sb2FkYWJsZVwiO1xuaW1wb3J0IHsgc3RhY2ssIHN0YWNrT3JkZXJOb25lLCBzdGFja09mZnNldEV4cGFuZCB9IGZyb20gXCJkMy1zaGFwZVwiO1xuaW1wb3J0IHsgc3VtLCBhc2NlbmRpbmcsIGV4dGVudCB9IGZyb20gXCJkMy1hcnJheVwiO1xuaW1wb3J0IHsgc2NhbGVPcmRpbmFsLCBzY2FsZUxpbmVhciwgc2NhbGVCYW5kIH0gZnJvbSBcImQzLXNjYWxlXCI7XG5pbXBvcnQgeyBmb3JtYXQgfSBmcm9tIFwiZDMtZm9ybWF0XCI7XG5cbi8qKlxuICogcXVlc3Rpb24gKDI3ICsgNylcbiAqICAgeCBhbGwvY291bnRyeS9kaXZpc2lvbiAoMSArIDcgKyA2ID0gMTQpXG4gKiAgICAgeCBhbGwvZ2VuZGVyL3JhbmsvbGluZW1nci9sb3MgKDUpXG4gKiA9IDIzODAgY2hhcnRzPyFcbiAqIFxuICogaGllcmFyY2h5IHcgMiBsZXZlbHM6XG4gKiAtIGNoYXJ0cyAoZS5nLiBxICsgY291bnRyeSArIGZhY2V0KVxuICogLSByb3dzIChmYWNldCB2YWx1ZSlcbiAqL1xuXG4vKipcbiAqICAgICB7XG4gICAgXCJHQ1JTX0RpdmlzaW9uX0Rlc2NcIjogXCJXZWFsdGggTWFuYWdlbWVudFwiLFxuICAgIFwiR0NSU19Vbml0X0Rlc2NcIjogXCJJbnRlcm5hdGlvbmFsIFdlYWx0aCBNYW5hZ2VtZW50XCIsXG4gICAgXCJHQ1JTX0FyZWFfRGVzY1wiOiBcIldNIEV1cm9wZSBhbmQgRW1lcmdpbmcgTWFya2V0c1wiLFxuICAgIFwiV29ya19Mb2NhdGlvbl9SZWdpb25cIjogXCJTV0lUWkVSTEFORFwiLFxuICAgIFwiQ291bnRyeV9EZXNjclwiOiBcIlN3aXR6ZXJsYW5kXCIsXG4gICAgXCJDaXR5XCI6IFwiWsO8cmljaFwiLFxuICAgIFwiTGluZV9NYW5hZ2VyX0ZsYWdcIjogXCJOXCIsXG4gICAgXCJCZWluZ193aXRoX1VCU1wiOiBcIjEgeWVhciBvciBsZXNzXCIsXG4gICAgXCJDb3Jwb3JhdGVfVGl0bGVcIjogXCJBRFwiLFxuICAgIFwiR2VuZGVyXCI6IFwiTWFsZVwiLFxuICAgIFwiZGltZW5zaW9uXCI6IFwiQ2FyZWVyIFBhdGggUGxhbm5pbmcgJiBJbnRlcm5hbCBNb2JpbGl0eVwiLFxuICAgIFwic3ViZGltZW5zaW9uXCI6IFwiVHJhaW5pbmcgYW5kIERldmVsb3BtZW50XCIsXG4gICAgXCJxdWVzdGlvblwiOiBcInRvIGJlIGVuY291cmFnZWQgYW5kIHN1cHBvcnRlZCBpbiBwdXJzdWluZyBteSBjaG9zZW4gY2FyZWVyIHBhdGhcIixcbiAgICBcInF1ZXN0aW9uQ29kZVwiOiBcIkExXzBcIixcbiAgICBcImxpa2VydFwiOiBcIkRpc2FncmVlXCIsXG4gICAgXCJyYW5raW5nXCI6IFwiUHJpb3JpdHkgMVwiXG4gIH0sXG4gKi9cblxudHlwZSBEYXR1bSA9IHtcbiAgQ291bnRyeV9EZXNjcjogc3RyaW5nLFxuICBxdWVzdGlvbjogc3RyaW5nLFxuICBHQ1JTX0RpdmlzaW9uX0Rlc2M6IHN0cmluZyxcbiAgR2VuZGVyOiBcIk1hbGVcIiB8IFwiRmVtYWxlXCIsXG4gIGxpa2VydDogc3RyaW5nLFxuICBxdWVzdGlvbkNvZGU6IHN0cmluZyxcbiAgc3ViZGltZW5zaW9uOiBzdHJpbmdcbn07XG5cbnR5cGUgRGF0YSA9IEFycmF5PERhdHVtPjtcblxudHlwZSBGYWNldCA9XG4gIHwgXCJDb3VudHJpZXNcIlxuICB8IFwiQnVzaW5lc3MgRGl2aXNpb25zXCJcbiAgfCBcIkdlbmRlclwiXG4gIHwgXCJDb3Jwb3JhdGUgVGl0bGVcIlxuICB8IFwiQmVpbmcgYSBMaW5lIE1hbmFnZXJcIlxuICB8IFwiTGVuZ3RoIG9mIFNlcnZpY2VcIjtcblxuY29uc3QgQ09VTlRSSUVTID0gbmV3IE1hcChbXG4gIFtcIlN3aXR6ZXJsYW5kXCIsIDFdLFxuICBbXCJVbml0ZWQgS2luZ2RvbVwiLCAyXSxcbiAgW1wiUG9sYW5kXCIsIDNdLFxuICBbXCJVbml0ZWQgU3RhdGVzXCIsIDRdLFxuICBbXCJIb25nIEtvbmdcIiwgNV0sXG4gIFtcIlNpbmdhcG9yZVwiLCA2XSxcbiAgW1wiSW5kaWFcIiwgN11cbl0pO1xuXG5jb25zdCBTVUJESU1FTlNJT05TID0gbmV3IE1hcChbXG4gIFtcIlRyYWluaW5nIGFuZCBEZXZlbG9wbWVudFwiLCAxXSxcbiAgW1wiSW50ZXJuYWwgTW9iaWxpdHlcIiwgMl0sXG4gIFtcIldvcmtwbGFjZVwiLCAzXSxcbiAgW1wiQWdpbGUgV29ya2luZyBQcmFjdGljZXNcIiwgNF0sXG4gIFtcIkFzc2V0IE1hbmFnZW1lbnRcIiwgNV0sXG4gIFtcIkZlZWRiYWNrIGFuZCBSZWNvZ25pdGlvblwiLCA2XSxcbiAgW1wiQ29tcGVuc2F0aW9uIGFuZCBCZW5lZml0c1wiLCA3XSxcbiAgW1wiQ29sbGFib3JhdGlvbiBhbmQgSW50ZXJhY3Rpb25cIiwgOF0sXG4gIFtcIk1hbmFnZW1lbnQgYW5kIEhpZXJhcmNoeVwiLCA5XSxcbiAgW1wiUHVycG9zZSBhbmQgTWVhbmluZ1wiLCAxMF1cbl0pO1xuXG5jb25zdCBESVZJU0lPTlMgPSBuZXcgTWFwKFtcbiAgW1wiQ29ycG9yYXRlIENlbnRlclwiLCAxXSxcbiAgW1wiSW52ZXN0bWVudCBCYW5rXCIsIDJdLFxuICBbXCJQZXJzb25hbCAmIENvcnBvcmF0ZSBCYW5raW5nXCIsIDNdLFxuICBbXCJXZWFsdGggTWFuYWdlbWVudFwiLCA0XSxcbiAgW1wiV2VhbHRoIE1hbmFnZW1lbnQgQW1lcmljYXNcIiwgNV0sXG4gIFtcIkdsb2JhbCBBc3NldCBNYW5hZ2VtZW50XCIsIDZdXG5dKTtcblxuY29uc3QgRkFDRVRfT1JERVJTID0gbmV3IE1hcChbXG4gIC8vIENvcnBvcmF0ZSB0aXRsZXNcbiAgW1wiREkgLSBNRFwiLCAxXSxcbiAgW1wiQURcIiwgMl0sXG4gIFtcIkFPXCIsIDNdLFxuICBbXCJFRVwiLCA0XSxcbiAgLy8gQ291bnRyaWVzXG4gIFtcIlN3aXR6ZXJsYW5kXCIsIDFdLFxuICBbXCJVbml0ZWQgS2luZ2RvbVwiLCAyXSxcbiAgW1wiUG9sYW5kXCIsIDNdLFxuICBbXCJVbml0ZWQgU3RhdGVzXCIsIDRdLFxuICBbXCJIb25nIEtvbmdcIiwgNV0sXG4gIFtcIlNpbmdhcG9yZVwiLCA2XSxcbiAgW1wiSW5kaWFcIiwgN11cbl0pO1xuXG5jb25zdCBmYWNldEtleSA9IChmYWNldDogRmFjZXQpID0+IGQgPT4ge1xuICBzd2l0Y2ggKGZhY2V0KSB7XG4gICAgY2FzZSBcIkNvdW50cmllc1wiOlxuICAgICAgcmV0dXJuIGQuQ291bnRyeV9EZXNjcjtcbiAgICBjYXNlIFwiQnVzaW5lc3MgRGl2aXNpb25zXCI6XG4gICAgICByZXR1cm4gZC5HQ1JTX0RpdmlzaW9uX0Rlc2M7XG4gICAgY2FzZSBcIkdlbmRlclwiOlxuICAgICAgcmV0dXJuIGQuR2VuZGVyO1xuICAgIGNhc2UgXCJDb3Jwb3JhdGUgVGl0bGVcIjpcbiAgICAgIHJldHVybiBkLkNvcnBvcmF0ZV9UaXRsZTtcbiAgICBjYXNlIFwiQmVpbmcgYSBMaW5lIE1hbmFnZXJcIjpcbiAgICAgIHJldHVybiBkLkxpbmVfTWFuYWdlcl9GbGFnO1xuICAgIGNhc2UgXCJMZW5ndGggb2YgU2VydmljZVwiOlxuICAgICAgcmV0dXJuIGQuQmVpbmdfd2l0aF9VQlM7XG4gICAgZGVmYXVsdDpcbiAgICAgIC8vIE1hdGNoIGV4aGF1c3RpdmVseTogaHR0cDovL291aWNhci5naXRodWIuaW8vMjAxNi8wOC8wOC9leGhhdXN0aXZlLXN3aXRjaC5odG1sXG4gICAgICB0aHJvdyBuZXcgRXJyb3IoXCJVbmtub3duIGZhY2V0OiBcIiArIGZhY2V0KTtcbiAgfVxufTtcblxuY29uc3QgZm10UGN0ID0gZm9ybWF0KFwiLjAlXCIpO1xuXG5jb25zdCBmaWx0ZXJWYWxpZCA9IChkOiBEYXR1bSkgPT5cbiAgQ09VTlRSSUVTLmhhcyhkLkNvdW50cnlfRGVzY3IpICYmXG4gIFNVQkRJTUVOU0lPTlMuaGFzKGQuc3ViZGltZW5zaW9uKSAmJlxuICBESVZJU0lPTlMuaGFzKGQuR0NSU19EaXZpc2lvbl9EZXNjKTtcblxuY29uc3QgTElLRVJUX05FVVRSQUwgPSAzO1xuY29uc3Qgb2Zmc2V0TGlrZXJ0ID0gKHNlcmllcywgb3JkZXIpID0+IHtcbiAgLy8gbm9ybWFsaXplIGZyb20gMCB0byAxXG4gIHN0YWNrT2Zmc2V0RXhwYW5kKHNlcmllcywgb3JkZXIpO1xuXG4gIGlmICghKChuID0gc2VyaWVzLmxlbmd0aCkgPiAxKSkgcmV0dXJuO1xuICBmb3IgKFxuICAgIHZhciBpLCBqID0gMCwgZCwgZHksIHlwLCB5biwgbiwgbSA9IHNlcmllc1tvcmRlclswXV0ubGVuZ3RoO1xuICAgIGogPCBtO1xuICAgICsralxuICApIHtcbiAgICAvLyBTdGFjayB0aGUgbmV1dHJhbCBhbmQgcG9zaXRpdmUgdmFsdWVzXG4gICAgZm9yICh5cCA9IHluID0gMCwgaSA9IExJS0VSVF9ORVVUUkFMIC0gMTsgaSA8IG47ICsraSkge1xuICAgICAgZHkgPSAoZCA9IHNlcmllc1tvcmRlcltpXV1bal0pWzFdIC0gZFswXTtcblxuICAgICAgaWYgKGkgPT09IExJS0VSVF9ORVVUUkFMIC0gMSkge1xuICAgICAgICAvL25ldXRyYWwgZ29lcyBjZW50ZXJlZCBpbiB0aGUgbWlkZGxlXG4gICAgICAgIChkWzBdID0geXAgLSBkeSAvIDIpLCAoZFsxXSA9IHlwICs9IGR5IC8gMik7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICAoZFswXSA9IHlwKSwgKGRbMV0gPSB5cCArPSBkeSk7XG4gICAgICB9XG4gICAgfVxuICAgIC8vIE5vdyBzdGFjayB0aGUgbmVnYXRpdmUgdmFsdWVzXG4gICAgZm9yICh5cCA9IHluID0gMCwgaSA9IExJS0VSVF9ORVVUUkFMIC0gMTsgaSA+PSAwOyAtLWkpIHtcbiAgICAgIGR5ID0gKGQgPSBzZXJpZXNbb3JkZXJbaV1dW2pdKVsxXSAtIGRbMF07XG4gICAgICBpZiAoaSA9PT0gTElLRVJUX05FVVRSQUwgLSAxKSB7XG4gICAgICAgIHlwIC09IGR5IC8gMjtcbiAgICAgIH0gZWxzZSBpZiAoaSA8IExJS0VSVF9ORVVUUkFMIC0gMSkge1xuICAgICAgICAoZFsxXSA9IHlwKSwgKGRbMF0gPSB5cCAtPSBkeSk7XG4gICAgICB9XG4gICAgfVxuICB9XG59O1xuXG5jb25zdCBsaWtlcnRTdGFjayA9IHN0YWNrKClcbiAgLmtleXMoW1wiU3Ryb25nbHkgZGlzYWdyZWVcIiwgXCJEaXNhZ3JlZVwiLCBcIk5ldXRyYWxcIiwgXCJBZ3JlZVwiLCBcIlN0cm9uZ2x5IGFncmVlXCJdKVxuICAudmFsdWUoKGQsIGtleSkgPT4gZC52YWx1ZVtrZXldKVxuICAub3JkZXIoc3RhY2tPcmRlck5vbmUpXG4gIC5vZmZzZXQob2Zmc2V0TGlrZXJ0KTtcblxuY29uc3QgY29sb3IgPSBzY2FsZU9yZGluYWwoKVxuICAuZG9tYWluKFtcbiAgICBcIlN0cm9uZ2x5IGRpc2FncmVlXCIsXG4gICAgXCJEaXNhZ3JlZVwiLFxuICAgIFwiTmV1dHJhbFwiLFxuICAgIFwiQWdyZWVcIixcbiAgICBcIlN0cm9uZ2x5IGFncmVlXCJcbiAgXSlcbiAgLnJhbmdlKFtcIiM1ODUxNDhcIiwgXCIjODA3MjY2XCIsIFwiI0JFQkVCRVwiLCBcIiNEN0MyQUFcIiwgXCIjQjg5RDgzXCJdKTtcblxuY29uc3QgcHJpb3JpdHlDb2xvciA9IHNjYWxlTGluZWFyKCkucmFuZ2UoW1wiI2ZmZlwiLCBcIiMzQjgwODVcIl0pO1xuXG5jb25zdCB4ID0gc2NhbGVMaW5lYXIoKS5kb21haW4oWy0xLCAxXSkucmFuZ2VSb3VuZChbMTAwLCA1MDBdKTtcblxuY29uc3Qgcm9sbHVwVmFsdWVzID0gdmFsdWVzID0+ICh7XG4gIFwiU3Ryb25nbHkgZGlzYWdyZWVcIjogc3VtKHZhbHVlcywgZCA9PiBkLmxpa2VydCA9PT0gXCJTdHJvbmdseSBkaXNhZ3JlZVwiKSxcbiAgRGlzYWdyZWU6IHN1bSh2YWx1ZXMsIGQgPT4gZC5saWtlcnQgPT09IFwiRGlzYWdyZWVcIiksXG4gIE5ldXRyYWw6IHN1bSh2YWx1ZXMsIGQgPT4gZC5saWtlcnQgPT09IFwiTmV1dHJhbFwiKSxcbiAgQWdyZWU6IHN1bSh2YWx1ZXMsIGQgPT4gZC5saWtlcnQgPT09IFwiQWdyZWVcIiksXG4gIFwiU3Ryb25nbHkgYWdyZWVcIjogc3VtKHZhbHVlcywgZCA9PiBkLmxpa2VydCA9PT0gXCJTdHJvbmdseSBhZ3JlZVwiKSxcbiAgXCJQcmlvcml0eSAxXCI6IHN1bSh2YWx1ZXMsIGQgPT4gZC5yYW5raW5nID09PSBcIlByaW9yaXR5IDFcIikgLyB2YWx1ZXMubGVuZ3RoLFxuICBcIlByaW9yaXR5IDJcIjogc3VtKHZhbHVlcywgZCA9PiBkLnJhbmtpbmcgPT09IFwiUHJpb3JpdHkgMlwiKSAvIHZhbHVlcy5sZW5ndGgsXG4gIFwiUHJpb3JpdHkgM1wiOiBzdW0odmFsdWVzLCBkID0+IGQucmFua2luZyA9PT0gXCJQcmlvcml0eSAzXCIpIC8gdmFsdWVzLmxlbmd0aFxufSk7XG5cbmNvbnN0IGdldEtleU9yZGVyID0gayA9PiAoRkFDRVRfT1JERVJTLmhhcyhrKSA/IEZBQ0VUX09SREVSUy5nZXQoaykgOiBrKTtcblxuZXhwb3J0IGNvbnN0IEludGVybmFsU3VydmV5ID0gTG9hZGFibGUoe1xuICBsb2FkZXI6ICgpID0+XG4gICAgaW1wb3J0KC8qIHdlYnBhY2tDaHVua05hbWU6IFwiZGF0YVwiICovIFwiLi4vLi4vZGF0YS91YnMtZGF0YS5qc29uXCIpLFxuICBsb2FkaW5nOiAoKSA9PiA8ZGl2PuKApjwvZGl2PixcbiAgcmVuZGVyOiAoZGF0YTogRGF0YSwgcHJvcHMpID0+IHtcbiAgICBjb25zdCBieVN1YmRpbWVuc2lvbiA9IG5lc3QoKVxuICAgICAgLmtleShkID0+IGQuc3ViZGltZW5zaW9uKVxuICAgICAgLmtleShkID0+IGAuLi4gJHtkLnF1ZXN0aW9ufWApXG4gICAgICAua2V5KCgpID0+IFwiZ2xvYmFsXCIpXG4gICAgICAucm9sbHVwKHJvbGx1cFZhbHVlcyk7XG5cbiAgICBjb25zdCBieVN1YmRpbWVuc2lvbkZhY2V0cyA9IG5lc3QoKVxuICAgICAgLmtleShkID0+IGAke2Quc3ViZGltZW5zaW9ufWApXG4gICAgICAua2V5KGQgPT4gYC4uLiAke2QucXVlc3Rpb259YClcbiAgICAgIC5rZXkoZmFjZXRLZXkocHJvcHMuZmFjZXRzKSlcbiAgICAgIC5zb3J0S2V5cygoYSwgYikgPT4gYXNjZW5kaW5nKGdldEtleU9yZGVyKGEpLCBnZXRLZXlPcmRlcihiKSkpXG4gICAgICAucm9sbHVwKHJvbGx1cFZhbHVlcyk7XG5cbiAgICBjb25zdCBzdWJkaW1lbnNpb25zR2xvYmFsID0gYnlTdWJkaW1lbnNpb24ub2JqZWN0KGRhdGEpO1xuICAgIGNvbnN0IHN1YmRpbWVuc2lvbnMgPSBieVN1YmRpbWVuc2lvbkZhY2V0cy5lbnRyaWVzKFxuICAgICAgZGF0YS5maWx0ZXIoZmlsdGVyVmFsaWQpXG4gICAgKTtcbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9XCJwYWdlXCI+XG4gICAgICAgIDxoMT57cHJvcHMuZmFjZXRzfTwvaDE+XG4gICAgICAgIHtzdWJkaW1lbnNpb25zLm1hcCgoeyBrZXk6IHN1YmRpbWVuc2lvbiwgdmFsdWVzOiBxdWVzdGlvbnMgfSkgPT4ge1xuICAgICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInN1YmRpbWVuc2lvblwiPlxuICAgICAgICAgICAgICA8aDI+XG4gICAgICAgICAgICAgICAge3N1YmRpbWVuc2lvbn1cbiAgICAgICAgICAgICAgPC9oMj5cblxuICAgICAgICAgICAgICB7cXVlc3Rpb25zLm1hcChcbiAgICAgICAgICAgICAgICAoeyBrZXk6IHF1ZXN0aW9uLCB2YWx1ZXM6IGZhY2V0c1dpdGhvdXRHbG9iYWwgfSwgaSkgPT4ge1xuICAgICAgICAgICAgICAgICAgY29uc3QgZ2xvYmFsRmFjZXQgPSB7XG4gICAgICAgICAgICAgICAgICAgIGtleTogXCJHbG9iYWxcIixcbiAgICAgICAgICAgICAgICAgICAgdmFsdWU6IHN1YmRpbWVuc2lvbnNHbG9iYWxbc3ViZGltZW5zaW9uXVtxdWVzdGlvbl0uZ2xvYmFsXG4gICAgICAgICAgICAgICAgICB9O1xuICAgICAgICAgICAgICAgICAgY29uc3QgZmFjZXRzID0gW2dsb2JhbEZhY2V0LCAuLi5mYWNldHNXaXRob3V0R2xvYmFsXTtcbiAgICAgICAgICAgICAgICAgIGNvbnN0IHN0YWNrID0gbGlrZXJ0U3RhY2soZmFjZXRzKTtcbiAgICAgICAgICAgICAgICAgIGNvbnN0IGZhY2V0S2V5cyA9IGZhY2V0cy5tYXAoZiA9PiBmLmtleSk7XG4gICAgICAgICAgICAgICAgICBjb25zdCB5ID0gc2NhbGVCYW5kKClcbiAgICAgICAgICAgICAgICAgICAgLmRvbWFpbihmYWNldEtleXMpXG4gICAgICAgICAgICAgICAgICAgIC5yYW5nZShbNjAsIGZhY2V0cy5sZW5ndGggKiAzMCArIDYwXSk7XG5cbiAgICAgICAgICAgICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiZmFjZXRcIj5cbiAgICAgICAgICAgICAgICAgICAgICA8ZGl2PlxuICAgICAgICAgICAgICAgICAgICAgICAgPGgzPntxdWVzdGlvbn08L2gzPlxuICAgICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiZmFjZXRCbG9ja1wiPlxuICAgICAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJxdWVzdGlvbnNcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAge2ZhY2V0S2V5cy5tYXAoKGZhY2V0S2V5LCBpKSA9PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxkaXZcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInF1ZXN0aW9uXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybTogYHRyYW5zbGF0ZSgkezB9cHgsJHt5KGZhY2V0S2V5KSArXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgeS5zdGVwKCkgLyAyfXB4KWBcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAge2ZhY2V0S2V5fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICAgICAgICApfVxuICAgICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgICAgICA8c3ZnXG4gICAgICAgICAgICAgICAgICAgICAgICAgIHdpZHRoPXt4LnJhbmdlKClbMV0gKyAxMDB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgIGhlaWdodD17eS5yYW5nZSgpWzFdICsgNTB9XG4gICAgICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGNsYXNzTmFtZT1cInByaW9yaXR5LWxhYmVsXCI+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHRcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiMS42ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwicGNMYWJlbFRpdGxlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwiZW5kXCIgfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSgke3goLTEpIC0gNH0sIDMwKWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgRGlzYWdyZWVcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHRcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiMS42ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwicGNMYWJlbFRpdGxlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwibWlkZGxlXCIgfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSgke3goMCl9LCAzMClgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIE5ldXRyYWxcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHRcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiMS42ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwicGNMYWJlbFRpdGxlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwic3RhcnRcIiB9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKCR7eCgxKSArIDR9LCAzMClgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIEFncmVlXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PlxuICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+XG5cbiAgICAgICAgICAgICAgICAgICAgICAgICAge1stMSwgLTAuNSwgMCwgMC41LCAxXS5tYXAoZCA9PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSgke3goZCl9LDApYH0+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJ0aWNrXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZD17YE0wLCR7eS5yYW5nZSgpWzBdfVYke3kucmFuZ2UoKVsxXX1gfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiLjM1ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJ0aWNrTGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09e2B0cmFuc2xhdGUoMCwke3kucmFuZ2UoKVsxXSArXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgeS5zdGVwKCkgLyAyfSlgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICl9XG5cbiAgICAgICAgICAgICAgICAgICAgICAgICAge3N0YWNrWzBdLm1hcCgoZCwgaSkgPT5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8Zz5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiLjM1ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJyb3dMYWJlbFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwiZW5kXCIgfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKCR7eCgtMSkgLSA0fSwke3koXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZC5kYXRhLmtleVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICApICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB5LnN0ZXAoKSAvIDJ9KWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHtmbXRQY3QoXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgc3RhY2tbMF1baV1bMV0gLVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgc3RhY2tbMF1baV1bMF0gK1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKHN0YWNrWzFdW2ldWzFdIC0gc3RhY2tbMV1baV1bMF0pXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGV4dFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBkeT1cIi4zNWVtXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwicm93TGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdHlsZT17eyB0ZXh0QW5jaG9yOiBcInN0YXJ0XCIgfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKCR7eCgxKSArIDR9LCR7eShcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBkLmRhdGEua2V5XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICkgK1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHkuc3RlcCgpIC8gMn0pYH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAge2ZtdFBjdChcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdGFja1szXVtpXVsxXSAtXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdGFja1szXVtpXVswXSArXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAoc3RhY2tbNF1baV1bMV0gLSBzdGFja1s0XVtpXVswXSlcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGV4dD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICl9XG5cbiAgICAgICAgICAgICAgICAgICAgICAgICAge3N0YWNrLm1hcChmYWNldCA9PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGZpbGw9e2NvbG9yKGZhY2V0LmtleSl9PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAge2ZhY2V0Lm1hcCgodmFsdWUsIGkpID0+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKCR7eCh2YWx1ZVswXSl9LCR7eShcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHZhbHVlLmRhdGEua2V5XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKSArIDN9KWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgaGVpZ2h0PVwiMjRcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHdpZHRoPXt4KHZhbHVlWzFdKSAtIHgodmFsdWVbMF0pfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgICAgICAgICAgICA8L3N2Zz5cbiAgICAgICAgICAgICAgICAgICAgICAgIDxzdmcgd2lkdGg9XCIxMzBcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgPGcgY2xhc3NOYW1lPVwicHJpb3JpdHktbGFiZWxcIj5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGV4dFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZHk9XCIxLjZlbVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJwY0xhYmVsVGl0bGVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgc3R5bGU9e3sgdGV4dEFuY2hvcjogXCJtaWRkbGVcIiB9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKDQ1LCAxMilgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIFByaW9yaXR5XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICBkeT1cIjEuNmVtXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInBjTGFiZWxUaXRsZVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdHlsZT17eyB0ZXh0QW5jaG9yOiBcIm1pZGRsZVwiIH19XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09e2B0cmFuc2xhdGUoMTUsIDMwKWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgMVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGV4dD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGV4dFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZHk9XCIxLjZlbVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJwY0xhYmVsVGl0bGVcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgc3R5bGU9e3sgdGV4dEFuY2hvcjogXCJtaWRkbGVcIiB9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKDQ1LCAzMClgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHRcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiMS42ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwicGNMYWJlbFRpdGxlXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwibWlkZGxlXCIgfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSg3NSwgMzApYH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAzXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PlxuICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+XG4gICAgICAgICAgICAgICAgICAgICAgICAgIHtmYWNldHMubWFwKCh7IGtleTogZmFjZXQsIHZhbHVlOiBhbnN3ZXJzIH0pID0+IHtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICBwcmlvcml0eUNvbG9yLmRvbWFpbihbMCwgMV0pO1xuICAgICAgICAgICAgICAgICAgICAgICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8Zz5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3RcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBoZWlnaHQ9XCIzMFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgLy93aWR0aD17YCR7YW5zd2Vyc1snUHJpb3JpdHkgMSddfWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgd2lkdGg9XCIzMFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZmlsbD17YCR7cHJpb3JpdHlDb2xvcihcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGFuc3dlcnNbXCJQcmlvcml0eSAxXCJdXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKX1gfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSgwLCAke3koZmFjZXQpfSlgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGV4dFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiMS42ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInBjTGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwibWlkZGxlXCIgfX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09e2B0cmFuc2xhdGUoMTUsICR7eShmYWNldCl9KWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB7TWF0aC5yb3VuZChhbnN3ZXJzW1wiUHJpb3JpdHkgMVwiXSAqIDEwMCl9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGV4dD5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3RcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBoZWlnaHQ9XCIzMFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgLy93aWR0aD17YCR7YW5zd2Vyc1snUHJpb3JpdHkgMiddfWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgd2lkdGg9XCIzMFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZmlsbD17YCR7cHJpb3JpdHlDb2xvcihcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGFuc3dlcnNbXCJQcmlvcml0eSAyXCJdXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKX1gfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSgzMCwgJHt5KGZhY2V0KX0pYH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHRcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBkeT1cIjEuNmVtXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJwY0xhYmVsXCJcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdHlsZT17eyB0ZXh0QW5jaG9yOiBcIm1pZGRsZVwiIH19XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdHJhbnNmb3JtPXtgdHJhbnNsYXRlKDQ1LCAke3koZmFjZXQpfSlgfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAge01hdGgucm91bmQoYW5zd2Vyc1tcIlByaW9yaXR5IDJcIl0gKiAxMDApfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgaGVpZ2h0PVwiMzBcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIC8vd2lkdGg9e2Ake2Fuc3dlcnNbJ1ByaW9yaXR5IDMnXX1gfVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHdpZHRoPVwiMzBcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGZpbGw9e2Ake3ByaW9yaXR5Q29sb3IoXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBhbnN3ZXJzW1wiUHJpb3JpdHkgM1wiXVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICl9YH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFuc2Zvcm09e2B0cmFuc2xhdGUoNjAsICR7eShmYWNldCl9KWB9XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0XG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZHk9XCIxLjZlbVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwicGNMYWJlbFwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgc3R5bGU9e3sgdGV4dEFuY2hvcjogXCJtaWRkbGVcIiB9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSg3NSwgJHt5KGZhY2V0KX0pYH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHtNYXRoLnJvdW5kKGFuc3dlcnNbXCJQcmlvcml0eSAzXCJdICogMTAwKX1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGV4dFxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGR5PVwiMS42ZW1cIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInBjTGFiZWxcIlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHN0eWxlPXt7IHRleHRBbmNob3I6IFwic3RhcnRcIiB9fVxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRyYW5zZm9ybT17YHRyYW5zbGF0ZSg5MiwgJHt5KGZhY2V0KX0pYH1cbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICVcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPlxuICAgICAgICAgICAgICAgICAgICAgICAgICAgICk7XG4gICAgICAgICAgICAgICAgICAgICAgICAgIH0pfVxuICAgICAgICAgICAgICAgICAgICAgICAgPC9zdmc+XG4gICAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICl9XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICApO1xuICAgICAgICB9KX1cbiAgICAgICAgPHN0eWxlIGpzeD57YFxuICAgICAgICAgIGRpdiB7XG4gICAgICAgICAgICBjb2xvcjogIzRENEQ0RDtcbiAgICAgICAgICAgIGZvbnQtZmFtaWx5OiBGcnV0aWdlckxUQ29tO1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDMwMDtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMTRweDtcbiAgICAgICAgICB9XG4gICAgICAgICAgdGV4dCB7XG4gICAgICAgICAgICBmaWxsOiAjNEQ0RDREO1xuICAgICAgICAgICAgZm9udC1mYW1pbHk6IEZydXRpZ2VyTFRDb207XG4gICAgICAgICAgICBmb250LXdlaWdodDogMzAwO1xuICAgICAgICAgICAgZm9udC1zaXplOiAxNHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgICBoMSB7XG4gICAgICAgICAgICBmb250LXNpemU6IDQ4cHg7XG4gICAgICAgICAgICBmb250LXdlaWdodDogMzAwO1xuICAgICAgICAgICAgcGFnZS1icmVhay1iZWZvcmU6IGFsd2F5cztcbiAgICAgICAgICB9XG4gICAgICAgICAgaDIge1xuICAgICAgICAgICAgZm9udC1zaXplOiAyNHB4O1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDMwMDtcbiAgICAgICAgICB9XG4gICAgICAgICAgaDMge1xuICAgICAgICAgICAgZm9udC1zaXplOiAxNnB4O1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgICB9XG4gICAgICAgICAgc3ZnIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgIH1cbiAgICAgICAgICAucXVlc3Rpb25BbmRQcmlvcml0aWVzIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgICAgLnByaW9yaXR5LWxhYmVsIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgfVxuICAgICAgICAgIC50aWNrIHtcbiAgICAgICAgICAgIHN0cm9rZS13aWR0aDogMTtcbiAgICAgICAgICAgIHN0cm9rZTogI2JiYjtcbiAgICAgICAgICAgIGZpbGw6IG5vbmU7XG4gICAgICAgICAgICBzaGFwZS1yZW5kZXJpbmc6IGNyaXNwRWRnZXM7XG4gICAgICAgICAgfVxuICAgICAgICAgIC50aWNrTGFiZWwge1xuICAgICAgICAgICAgZmlsbDogI2JiYjtcbiAgICAgICAgICAgIHRleHQtYW5jaG9yOiBtaWRkbGU7XG4gICAgICAgICAgICBmb250LXNpemU6IDEycHg7XG4gICAgICAgICAgfVxuICAgICAgICAgIC5yb3dMYWJlbCB7XG4gICAgICAgICAgICBmaWxsOiAjNEQ0RDREO1xuICAgICAgICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICB9XG4gICAgICAgICAgLnBjTGFiZWwge1xuICAgICAgICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDMwMDtcbiAgICAgICAgICB9XG4gICAgICAgICAgLnBjTGFiZWxUaXRsZSB7XG4gICAgICAgICAgICBmb250LXNpemU6IDEycHg7XG4gICAgICAgICAgICBmb250LXdlaWdodDogNzAwO1xuICAgICAgICAgIH1cbiAgICAgICAgICAuZmFjZXRCbG9jayB7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgICAgICAgd2lkdGg6IDEwMDBweDtcbiAgICAgICAgICB9XG4gICAgICAgICAgLnF1ZXN0aW9ucyB7XG4gICAgICAgICAgICB3aWR0aDogMjAwcHg7XG4gICAgICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgICAgfVxuICAgICAgICAgIC5xdWVzdGlvbiB7XG4gICAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgICB3aWR0aDogMTAwJTtcblxuICAgICAgICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgICAgICAgICAgaGVpZ2h0OiAzMHB4O1xuICAgICAgICAgICAgbWFyZ2luLXRvcDogLTE1cHg7XG4gICAgICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICAgIH1cbiAgICAgICAgICAuc3ViZGltZW5zaW9uIHtcbiAgICAgICAgICAgIHBhZ2UtYnJlYWstYmVmb3JlOiBhbHdheXM7XG4gICAgICAgICAgfVxuICAgICAgICBgfTwvc3R5bGU+XG4gICAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59KTtcblxuZXhwb3J0IGRlZmF1bHQgSW50ZXJuYWxTdXJ2ZXk7XG4iXX0= */\n/*@ sourceURL=src/components/InternalSurvey/InternalSurvey.js */"
      })
    );
  }
});

/* harmony default export */ var InternalSurvey_InternalSurvey = (InternalSurvey);
// CONCATENATED MODULE: ./src/pages/internal-survey.js
var internal_survey__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function internal_survey__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function internal_survey__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function internal_survey__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { factors } from "../data/chartData";

var internal_survey__class = function (_React$Component) {
  internal_survey__inherits(_class, _React$Component);

  function _class() {
    internal_survey__classCallCheck(this, _class);

    return internal_survey__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  internal_survey__createClass(_class, [{
    key: "render",
    value: function render() {

      return react_default.a.createElement(
        "div",
        { className: "page", "data-jsx": 1700785490
        },
        react_default.a.createElement(InternalSurvey_InternalSurvey, { facets: "Countries" }),
        react_default.a.createElement(InternalSurvey_InternalSurvey, { facets: "Business Divisions" }),
        react_default.a.createElement(InternalSurvey_InternalSurvey, { facets: "Gender" }),
        react_default.a.createElement(InternalSurvey_InternalSurvey, { facets: "Corporate Title" }),
        react_default.a.createElement(InternalSurvey_InternalSurvey, { facets: "Being a Line Manager" }),
        react_default.a.createElement(InternalSurvey_InternalSurvey, { facets: "Length of Service" }),
        react_default.a.createElement(style_default.a, {
          styleId: 1700785490,
          css: "html,body{height:100%}body{background:#fff;margin:0;-webkit-text-rendering:optimizeLegibility;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-font-smoothing:grayscale}.page{padding:20px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9pbnRlcm5hbC1zdXJ2ZXkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUIyQixBQUd5QixBQUNJLEFBQ0gsYUFGVSxDQUVDLEdBRGMsVUFBK0MsOEVBQWdELG9DQUEyQywrQkFBVyIsImZpbGUiOiJzcmMvcGFnZXMvaW50ZXJuYWwtc3VydmV5LmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBNYWluIGZyb20gXCIuLi9jb21wb25lbnRzL01haW5cIjtcbmltcG9ydCBJbnRlcm5hbFN1cnZleSBmcm9tIFwiLi4vY29tcG9uZW50cy9JbnRlcm5hbFN1cnZleS9JbnRlcm5hbFN1cnZleVwiO1xuLy8gaW1wb3J0IHsgZmFjdG9ycyB9IGZyb20gXCIuLi9kYXRhL2NoYXJ0RGF0YVwiO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIHJlbmRlcigpIHtcblxuICAgIHJldHVybiAoXG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cInBhZ2VcIj5cbiAgICAgICAgPEludGVybmFsU3VydmV5IGZhY2V0cz1cIkNvdW50cmllc1wiLz5cbiAgICAgICAgPEludGVybmFsU3VydmV5IGZhY2V0cz1cIkJ1c2luZXNzIERpdmlzaW9uc1wiLz5cbiAgICAgICAgPEludGVybmFsU3VydmV5IGZhY2V0cz1cIkdlbmRlclwiLz5cbiAgICAgICAgPEludGVybmFsU3VydmV5IGZhY2V0cz1cIkNvcnBvcmF0ZSBUaXRsZVwiLz5cbiAgICAgICAgPEludGVybmFsU3VydmV5IGZhY2V0cz1cIkJlaW5nIGEgTGluZSBNYW5hZ2VyXCIvPlxuICAgICAgICA8SW50ZXJuYWxTdXJ2ZXkgZmFjZXRzPVwiTGVuZ3RoIG9mIFNlcnZpY2VcIi8+XG5cbiAgICAgICAgPHN0eWxlIGpzeCBnbG9iYWw+e2BcbiAgICAgICAgICBodG1sLCBib2R5IHtcbiAgICAgICAgICAgIGhlaWdodDogMTAwJTtcbiAgICAgICAgICB9XG4gICAgICAgICAgYm9keSB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kOiAjZmZmO1xuICAgICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICAgICAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTtcbiAgICAgICAgICAgIC13ZWJraXQtZm9udC1zbW9vdGhpbmc6IGFudGlhbGlhc2VkO1xuICAgICAgICAgICAgLW1vei1mb250LXNtb290aGluZzogZ3JheXNjYWxlO1xuICAgICAgICAgIH1cbiAgICAgICAgICAucGFnZSB7XG4gICAgICAgICAgICBwYWRkaW5nOiAyMHB4O1xuICAgICAgICAgIH1cbiAgICAgICAgYH08L3N0eWxlPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19 */\n/*@ sourceURL=src/pages/internal-survey.js */"
        })
      );
    }
  }]);

  return _class;
}(react_default.a.Component);

/* harmony default export */ var internal_survey = (internal_survey__class);
// CONCATENATED MODULE: ./src/components/PrototypeNavigation.js


/* harmony default export */ var PrototypeNavigation = (function () {
  return react_default.a.createElement(
    "nav",
    {
      "data-jsx": 367598781
    },
    react_default.a.createElement(
      "ul",
      {
        "data-jsx": 367598781
      },
      react_default.a.createElement(
        "li",
        {
          "data-jsx": 367598781
        },
        react_default.a.createElement(
          "a",
          { href: "#quiz", "data-jsx": 367598781
          },
          "Quiz"
        )
      ),
      react_default.a.createElement(
        "li",
        {
          "data-jsx": 367598781
        },
        react_default.a.createElement(
          "a",
          { href: "#quizQR", "data-jsx": 367598781
          },
          "QuizQR"
        )
      ),
      react_default.a.createElement(
        "li",
        {
          "data-jsx": 367598781
        },
        react_default.a.createElement(
          "a",
          { href: "#slope-factors", "data-jsx": 367598781
          },
          "Slope Chart Factors"
        )
      ),
      react_default.a.createElement(
        "li",
        {
          "data-jsx": 367598781
        },
        react_default.a.createElement(
          "a",
          { href: "#slope-wealth", "data-jsx": 367598781
          },
          "Slope Chart Forms of Wealth"
        )
      ),
      react_default.a.createElement(
        "li",
        {
          "data-jsx": 367598781
        },
        react_default.a.createElement(
          "a",
          { href: "#internal-survey", "data-jsx": 367598781
          },
          "Internal Survey"
        )
      ),
      react_default.a.createElement(
        "li",
        {
          "data-jsx": 367598781
        },
        react_default.a.createElement(
          "a",
          {
            className: "download",
            href: "/static/build.zip",
            download: "millennials-app.zip",
            "data-jsx": 367598781
          },
          "Download Code"
        )
      )
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 367598781,
      css: "nav[data-jsx=\"367598781\"]{background:#333;width:100vw;font-family:sans-serif;font-size:12px;position:absolute;top:0;left:0;right:0}ul[data-jsx=\"367598781\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:0;padding:10px;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}li[data-jsx=\"367598781\"]{display:block;margin:0 10px;list-style:none}a[data-jsx=\"367598781\"]{color:white;-webkit-text-decoration:none;text-decoration:none}a[data-jsx=\"367598781\"]:hover{-webkit-text-decoration:underline;text-decoration:underline}a.download[data-jsx=\"367598781\"]{color:#f55}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1Byb3RvdHlwZU5hdmlnYXRpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUNnQixBQUd5QixBQUNILEFBQ0MsQUFDRixBQUNjLEFBQ2YsWUFBTyxDQUZ3QixFQURMLEVBRkEsYUFBZ0MsQUFFUCxpQkFBTyxPQUZ3QixRQUk1RCxHQURnQixLQUh1RSxRQUN6RixVQUFzQixDQURrRixPQUFnQixNQUNoRSxFQURpRixTQUFPLDBGQUNqRiIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9Qcm90b3R5cGVOYXZpZ2F0aW9uLmpzIiwic291cmNlUm9vdCI6Ii9vcHQvYnVpbGQvcmVwbyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmV4cG9ydCBkZWZhdWx0ICgpID0+XG4gIDxuYXY+XG4gICAgPHVsPlxuICAgICAgPGxpPlxuICAgICAgICA8YSBocmVmPVwiI3F1aXpcIj5cbiAgICAgICAgICBRdWl6XG4gICAgICAgIDwvYT5cbiAgICAgIDwvbGk+XG4gICAgICA8bGk+XG4gICAgICAgIDxhIGhyZWY9XCIjcXVpelFSXCI+XG4gICAgICAgICAgUXVpelFSXG4gICAgICAgIDwvYT5cbiAgICAgIDwvbGk+XG4gICAgICA8bGk+XG4gICAgICAgIDxhIGhyZWY9XCIjc2xvcGUtZmFjdG9yc1wiPlxuICAgICAgICAgIFNsb3BlIENoYXJ0IEZhY3RvcnNcbiAgICAgICAgPC9hPlxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAgPGEgaHJlZj1cIiNzbG9wZS13ZWFsdGhcIj5cbiAgICAgICAgICBTbG9wZSBDaGFydCBGb3JtcyBvZiBXZWFsdGhcbiAgICAgICAgPC9hPlxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAgPGEgaHJlZj1cIiNpbnRlcm5hbC1zdXJ2ZXlcIj5cbiAgICAgICAgICBJbnRlcm5hbCBTdXJ2ZXlcbiAgICAgICAgPC9hPlxuICAgICAgPC9saT5cbiAgICAgIDxsaT5cbiAgICAgICAgPGFcbiAgICAgICAgICBjbGFzc05hbWU9XCJkb3dubG9hZFwiXG4gICAgICAgICAgaHJlZj1cIi9zdGF0aWMvYnVpbGQuemlwXCJcbiAgICAgICAgICBkb3dubG9hZD1cIm1pbGxlbm5pYWxzLWFwcC56aXBcIlxuICAgICAgICA+XG4gICAgICAgICAgRG93bmxvYWQgQ29kZVxuICAgICAgICA8L2E+XG4gICAgICA8L2xpPlxuICAgIDwvdWw+XG4gICAgPHN0eWxlIGpzeD57YFxuICAgICAgbmF2IHtcbiAgICAgICAgYmFja2dyb3VuZDogIzMzMztcbiAgICAgICAgd2lkdGg6IDEwMHZ3O1xuICAgICAgICBmb250LWZhbWlseTogc2Fucy1zZXJpZjtcbiAgICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgIHRvcDogMDtcbiAgICAgICAgbGVmdDogMDtcbiAgICAgICAgcmlnaHQ6IDA7XG4gICAgICB9XG4gICAgICB1bCB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgcGFkZGluZzogMTBweDtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICAgIH1cbiAgICAgIGxpIHtcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgIG1hcmdpbjogMCAxMHB4O1xuICAgICAgICBsaXN0LXN0eWxlOiBub25lO1xuICAgICAgfVxuICAgICAgYSB7XG4gICAgICAgIGNvbG9yOiB3aGl0ZTtcbiAgICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICAgICAgfVxuICAgICAgYTpob3ZlciB7XG4gICAgICAgIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICAgICAgfVxuICAgICAgYS5kb3dubG9hZCB7XG4gICAgICAgIGNvbG9yOiAjZjU1O1xuICAgICAgfVxuICAgIGB9PC9zdHlsZT5cbiAgPC9uYXY+O1xuIl19 */\n/*@ sourceURL=src/components/PrototypeNavigation.js */"
    })
  );
});
// CONCATENATED MODULE: ./src/pages/index.js





var pages_Frame = function Frame(_ref) {
  var width = _ref.width,
      height = _ref.height,
      path = _ref.path,
      title = _ref.title;
  return react_default.a.createElement(
    "div",
    { className: "Frame", "data-jsx": 979585503
    },
    react_default.a.createElement(
      "dl",
      { className: "instructions", "data-jsx": 979585503
      },
      react_default.a.createElement(
        "div",
        {
          "data-jsx": 979585503
        },
        react_default.a.createElement(
          "dt",
          {
            "data-jsx": 979585503
          },
          "iframe src"
        ),
        react_default.a.createElement(
          "dd",
          {
            "data-jsx": 979585503
          },
          "index.html#",
          path
        )
      ),
      react_default.a.createElement(
        "div",
        {
          "data-jsx": 979585503
        },
        react_default.a.createElement(
          "dt",
          {
            "data-jsx": 979585503
          },
          "iframe height"
        ),
        react_default.a.createElement(
          "dd",
          {
            "data-jsx": 979585503
          },
          height
        )
      )
    ),
    react_default.a.createElement("iframe", {
      title: title,
      src: "?iframe#" + path,
      width: width,
      height: height,
      frameBorder: "0",
      allowTransparency: "true",
      scrolling: "no",
      "data-jsx": 979585503
    }),
    react_default.a.createElement(style_default.a, {
      styleId: 979585503,
      css: ".Frame[data-jsx=\"979585503\"]{background:#fff;border:1px solid #cfcfcf;margin:0 0 20px 0}.instructions[data-jsx=\"979585503\"]{color:#555;background:#efefef;padding:10px;margin:0}.instructions[data-jsx=\"979585503\"] div[data-jsx=\"979585503\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;font-size:12px}.instructions[data-jsx=\"979585503\"] dt[data-jsx=\"979585503\"]{width:100px}.instructions[data-jsx=\"979585503\"] dd[data-jsx=\"979585503\"]{font-weight:bold;-webkit-flex:1 1 0;-ms-flex:1 1 0;flex:1 1 0;padding:0;margin:0}iframe[data-jsx=\"979585503\"]{margin:20px}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/pages/index.js */"
    })
  );
};

/* harmony default export */ var pages = (function () {
  return react_default.a.createElement(
    "div",
    {
      "data-jsx": 2250717908
    },
    react_default.a.createElement(PrototypeNavigation, null),
    react_default.a.createElement(
      Main,
      null,
      react_default.a.createElement(
        "div",
        { className: "frames", "data-jsx": 2250717908
        },
        react_default.a.createElement(pages_Frame, { title: "Quiz desktop", path: "quiz", width: "944", height: "484" }),
        react_default.a.createElement(pages_Frame, {
          title: "Slope Chart Factors desktop",
          path: "slope-factors",
          width: "944",
          height: "864"
        }),
        react_default.a.createElement(pages_Frame, {
          title: "Slope Chart Wealth desktop",
          path: "slope-wealth",
          width: "944",
          height: "495"
        }),
        react_default.a.createElement(pages_Frame, { title: "Quiz mobile", path: "quiz", width: "320", height: "504" }),
        react_default.a.createElement(pages_Frame, {
          title: "Slope Chart Factors mobile",
          path: "slope-factors",
          width: "320",
          height: "880"
        }),
        react_default.a.createElement(pages_Frame, {
          title: "Slope Chart Wealth mobile",
          path: "slope-wealth",
          width: "320",
          height: "503"
        })
      )
    ),
    react_default.a.createElement(style_default.a, {
      styleId: 782342309,
      css: "html,body{height:100%}body{margin:0;font-family:sans-serif;background:#efefef}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/pages/index.js */"
    }),
    react_default.a.createElement(style_default.a, {
      styleId: 303398580,
      css: ".frames[data-jsx=\"2250717908\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:50px 0}iframe[data-jsx=\"2250717908\"]{border:1px solid #cfcfcf;margin:0 0 20px 0}\n/*# sourceMappingURL=data:application/json;base64,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 */\n/*@ sourceURL=src/pages/index.js */"
    })
  );
});
// CONCATENATED MODULE: ./src/index.js










var src_render = function render() {
  var width = window.innerWidth;
  var page = window.location.hash;
  var App = page === "#quiz" ? quiz : page === "#quizQR" ? quizQR : page === "#slope-factors" ? slope_factors : page === "#slope-wealth" ? slope_wealth : page === "#internal-survey" ? internal_survey : pages;

  react_dom_default.a.render(react_default.a.createElement(App, { width: width }), document.getElementById("root"));
};

window.addEventListener("hashchange", src_render);
window.addEventListener("resize", src_render);

src_render();

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(273);

__webpack_require__(451);

__webpack_require__(452);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(138);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(200);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(201);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(449);
__webpack_require__(450);
module.exports = __webpack_require__(40);

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(3)
  , has            = __webpack_require__(17)
  , DESCRIPTORS    = __webpack_require__(12)
  , $export        = __webpack_require__(0)
  , redefine       = __webpack_require__(21)
  , META           = __webpack_require__(48).KEY
  , $fails         = __webpack_require__(5)
  , shared         = __webpack_require__(90)
  , setToStringTag = __webpack_require__(65)
  , uid            = __webpack_require__(52)
  , wks            = __webpack_require__(9)
  , wksExt         = __webpack_require__(184)
  , wksDefine      = __webpack_require__(118)
  , keyOf          = __webpack_require__(275)
  , enumKeys       = __webpack_require__(276)
  , isArray        = __webpack_require__(121)
  , anObject       = __webpack_require__(2)
  , toIObject      = __webpack_require__(23)
  , toPrimitive    = __webpack_require__(34)
  , createDesc     = __webpack_require__(47)
  , _create        = __webpack_require__(56)
  , gOPNExt        = __webpack_require__(187)
  , $GOPD          = __webpack_require__(26)
  , $DP            = __webpack_require__(13)
  , $keys          = __webpack_require__(54)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(57).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(79).f  = $propertyIsEnumerable;
  __webpack_require__(92).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(53)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(20)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(54)
  , toIObject = __webpack_require__(23);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(54)
  , gOPS    = __webpack_require__(92)
  , pIE     = __webpack_require__(79);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(56)});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', {defineProperty: __webpack_require__(13).f});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(12), 'Object', {defineProperties: __webpack_require__(186)});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(23)
  , $getOwnPropertyDescriptor = __webpack_require__(26).f;

__webpack_require__(35)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(16)
  , $getPrototypeOf = __webpack_require__(27);

__webpack_require__(35)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(16)
  , $keys    = __webpack_require__(54);

__webpack_require__(35)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(35)('getOwnPropertyNames', function(){
  return __webpack_require__(187).f;
});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8)
  , meta     = __webpack_require__(48).onFreeze;

__webpack_require__(35)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8)
  , meta     = __webpack_require__(48).onFreeze;

__webpack_require__(35)('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8)
  , meta     = __webpack_require__(48).onFreeze;

__webpack_require__(35)('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(35)('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(35)('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(35)('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(188)});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', {is: __webpack_require__(189)});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(123).set});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(80)
  , test    = {};
test[__webpack_require__(9)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(21)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', {bind: __webpack_require__(190)});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(13).f
  , createDesc = __webpack_require__(47)
  , has        = __webpack_require__(17)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject       = __webpack_require__(8)
  , getPrototypeOf = __webpack_require__(27)
  , HAS_INSTANCE   = __webpack_require__(9)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(13).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(0)
  , $parseInt = __webpack_require__(191);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(0)
  , $parseFloat = __webpack_require__(192);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(3)
  , has               = __webpack_require__(17)
  , cof               = __webpack_require__(29)
  , inheritIfRequired = __webpack_require__(125)
  , toPrimitive       = __webpack_require__(34)
  , fails             = __webpack_require__(5)
  , gOPN              = __webpack_require__(57).f
  , gOPD              = __webpack_require__(26).f
  , dP                = __webpack_require__(13).f
  , $trim             = __webpack_require__(66).trim
  , NUMBER            = 'Number'
  , $Number           = global[NUMBER]
  , Base              = $Number
  , proto             = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF        = cof(__webpack_require__(56)(proto)) == NUMBER
  , TRIM              = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for(var keys = __webpack_require__(12) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++){
    if(has(Base, key = keys[j]) && !has($Number, key)){
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(21)(global, NUMBER, $Number);
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(0)
  , toInteger    = __webpack_require__(49)
  , aNumberValue = __webpack_require__(193)
  , repeat       = __webpack_require__(126)
  , $toFixed     = 1..toFixed
  , floor        = Math.floor
  , data         = [0, 0, 0, 0, 0, 0]
  , ERROR        = 'Number.toFixed: incorrect invocation!'
  , ZERO         = '0';

var multiply = function(n, c){
  var i  = -1
    , c2 = c;
  while(++i < 6){
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function(n){
  var i = 6
    , c = 0;
  while(--i >= 0){
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function(){
  var i = 6
    , s = '';
  while(--i >= 0){
    if(s !== '' || i === 0 || data[i] !== 0){
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function(x, n, acc){
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function(x){
  var n  = 0
    , x2 = x;
  while(x2 >= 4096){
    n += 12;
    x2 /= 4096;
  }
  while(x2 >= 2){
    n  += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128..toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(5)(function(){
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits){
    var x = aNumberValue(this, ERROR)
      , f = toInteger(fractionDigits)
      , s = ''
      , m = ZERO
      , e, z, j, k;
    if(f < 0 || f > 20)throw RangeError(ERROR);
    if(x != x)return 'NaN';
    if(x <= -1e21 || x >= 1e21)return String(x);
    if(x < 0){
      s = '-';
      x = -x;
    }
    if(x > 1e-21){
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if(e > 0){
        multiply(0, z);
        j = f;
        while(j >= 7){
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while(j >= 23){
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if(f > 0){
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(0)
  , $fails       = __webpack_require__(5)
  , aNumberValue = __webpack_require__(193)
  , $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function(){
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function(){
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision){
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
  }
});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(0)
  , _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {isInteger: __webpack_require__(194)});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(0)
  , isInteger = __webpack_require__(194)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(0)
  , $parseFloat = __webpack_require__(192);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(0)
  , $parseInt = __webpack_require__(191);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0)
  , log1p   = __webpack_require__(195)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0)
  , sign    = __webpack_require__(127);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0)
  , $expm1  = __webpack_require__(128);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(0)
  , sign      = __webpack_require__(127)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(5)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {log1p: __webpack_require__(195)});

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {sign: __webpack_require__(127)});

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0)
  , expm1   = __webpack_require__(128)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(5)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0)
  , expm1   = __webpack_require__(128)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(0)
  , toIndex        = __webpack_require__(55)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(0)
  , toIObject = __webpack_require__(23)
  , toLength  = __webpack_require__(15);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(66)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(129)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(130)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $at     = __webpack_require__(129)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(0)
  , toLength  = __webpack_require__(15)
  , context   = __webpack_require__(132)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(133)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(0)
  , context  = __webpack_require__(132)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(133)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(126)
});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(0)
  , toLength    = __webpack_require__(15)
  , context     = __webpack_require__(132)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(133)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(24)('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(24)('big', function(createHTML){
  return function big(){
    return createHTML(this, 'big', '', '');
  }
});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(24)('blink', function(createHTML){
  return function blink(){
    return createHTML(this, 'blink', '', '');
  }
});

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(24)('bold', function(createHTML){
  return function bold(){
    return createHTML(this, 'b', '', '');
  }
});

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(24)('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(24)('fontcolor', function(createHTML){
  return function fontcolor(color){
    return createHTML(this, 'font', 'color', color);
  }
});

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(24)('fontsize', function(createHTML){
  return function fontsize(size){
    return createHTML(this, 'font', 'size', size);
  }
});

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(24)('italics', function(createHTML){
  return function italics(){
    return createHTML(this, 'i', '', '');
  }
});

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(24)('link', function(createHTML){
  return function link(url){
    return createHTML(this, 'a', 'href', url);
  }
});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(24)('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(24)('strike', function(createHTML){
  return function strike(){
    return createHTML(this, 'strike', '', '');
  }
});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(24)('sub', function(createHTML){
  return function sub(){
    return createHTML(this, 'sub', '', '');
  }
});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(24)('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export     = __webpack_require__(0)
  , toObject    = __webpack_require__(16)
  , toPrimitive = __webpack_require__(34);

$export($export.P + $export.F * __webpack_require__(5)(function(){
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
}), 'Date', {
  toJSON: function toJSON(key){
    var O  = toObject(this)
      , pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0)
  , fails   = __webpack_require__(5)
  , getTime = Date.prototype.getTime;

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto    = Date.prototype
  , INVALID_DATE = 'Invalid Date'
  , TO_STRING    = 'toString'
  , $toString    = DateProto[TO_STRING]
  , getTime      = DateProto.getTime;
if(new Date(NaN) + '' != INVALID_DATE){
  __webpack_require__(21)(DateProto, TO_STRING, function toString(){
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(9)('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))__webpack_require__(20)(proto, TO_PRIMITIVE, __webpack_require__(355));

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject    = __webpack_require__(2)
  , toPrimitive = __webpack_require__(34)
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', {isArray: __webpack_require__(121)});

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(41)
  , $export        = __webpack_require__(0)
  , toObject       = __webpack_require__(16)
  , call           = __webpack_require__(196)
  , isArrayIter    = __webpack_require__(134)
  , toLength       = __webpack_require__(15)
  , createProperty = __webpack_require__(135)
  , getIterFn      = __webpack_require__(136);

$export($export.S + $export.F * !__webpack_require__(95)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export        = __webpack_require__(0)
  , createProperty = __webpack_require__(135);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(5)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export   = __webpack_require__(0)
  , toIObject = __webpack_require__(23)
  , arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(78) != Object || !__webpack_require__(31)(arrayJoin)), 'Array', {
  join: function join(separator){
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export    = __webpack_require__(0)
  , html       = __webpack_require__(122)
  , cof        = __webpack_require__(29)
  , toIndex    = __webpack_require__(55)
  , toLength   = __webpack_require__(15)
  , arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(5)(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export   = __webpack_require__(0)
  , aFunction = __webpack_require__(22)
  , toObject  = __webpack_require__(16)
  , fails     = __webpack_require__(5)
  , $sort     = [].sort
  , test      = [1, 2, 3];

$export($export.P + $export.F * (fails(function(){
  // IE8-
  test.sort(undefined);
}) || !fails(function(){
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(31)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn){
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export  = __webpack_require__(0)
  , $forEach = __webpack_require__(36)(0)
  , STRICT   = __webpack_require__(31)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */){
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(364);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8)
  , isArray  = __webpack_require__(121)
  , SPECIES  = __webpack_require__(9)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $map    = __webpack_require__(36)(1);

$export($export.P + $export.F * !__webpack_require__(31)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $filter = __webpack_require__(36)(2);

$export($export.P + $export.F * !__webpack_require__(31)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $some   = __webpack_require__(36)(3);

$export($export.P + $export.F * !__webpack_require__(31)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */){
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $every  = __webpack_require__(36)(4);

$export($export.P + $export.F * !__webpack_require__(31)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */){
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $reduce = __webpack_require__(197);

$export($export.P + $export.F * !__webpack_require__(31)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0)
  , $reduce = __webpack_require__(197);

$export($export.P + $export.F * !__webpack_require__(31)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(0)
  , $indexOf      = __webpack_require__(91)(false)
  , $native       = [].indexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(31)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(0)
  , toIObject     = __webpack_require__(23)
  , toInteger     = __webpack_require__(49)
  , toLength      = __webpack_require__(15)
  , $native       = [].lastIndexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(31)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
    // convert -0 to +0
    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
    if(index < 0)index = length + index;
    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
    return -1;
  }
});

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', {copyWithin: __webpack_require__(198)});

__webpack_require__(68)('copyWithin');

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', {fill: __webpack_require__(137)});

__webpack_require__(68)('fill');

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0)
  , $find   = __webpack_require__(36)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(68)(KEY);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0)
  , $find   = __webpack_require__(36)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(68)(KEY);

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(58)('Array');

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var global            = __webpack_require__(3)
  , inheritIfRequired = __webpack_require__(125)
  , dP                = __webpack_require__(13).f
  , gOPN              = __webpack_require__(57).f
  , isRegExp          = __webpack_require__(94)
  , $flags            = __webpack_require__(96)
  , $RegExp           = global.RegExp
  , Base              = $RegExp
  , proto             = $RegExp.prototype
  , re1               = /a/g
  , re2               = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW       = new $RegExp(re1) !== re1;

if(__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(5)(function(){
  re2[__webpack_require__(9)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var tiRE = this instanceof $RegExp
      , piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function(key){
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  };
  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(21)(global, 'RegExp', $RegExp);
}

__webpack_require__(58)('RegExp');

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(200);
var anObject    = __webpack_require__(2)
  , $flags      = __webpack_require__(96)
  , DESCRIPTORS = __webpack_require__(12)
  , TO_STRING   = 'toString'
  , $toString   = /./[TO_STRING];

var define = function(fn){
  __webpack_require__(21)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if(__webpack_require__(5)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
  define(function toString(){
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if($toString.name != TO_STRING){
  define(function toString(){
    return $toString.call(this);
  });
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(97)('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(97)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(97)('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(97)('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = __webpack_require__(94)
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(53)
  , global             = __webpack_require__(3)
  , ctx                = __webpack_require__(41)
  , classof            = __webpack_require__(80)
  , $export            = __webpack_require__(0)
  , isObject           = __webpack_require__(8)
  , aFunction          = __webpack_require__(22)
  , anInstance         = __webpack_require__(59)
  , forOf              = __webpack_require__(69)
  , speciesConstructor = __webpack_require__(139)
  , task               = __webpack_require__(140).set
  , microtask          = __webpack_require__(141)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(60)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(65)($Promise, PROMISE);
__webpack_require__(58)(PROMISE);
Wrapper = __webpack_require__(40)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(95)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(205);

// 23.4 WeakSet Objects
__webpack_require__(98)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(0)
  , $typed       = __webpack_require__(99)
  , buffer       = __webpack_require__(142)
  , anObject     = __webpack_require__(2)
  , toIndex      = __webpack_require__(55)
  , toLength     = __webpack_require__(15)
  , isObject     = __webpack_require__(8)
  , ArrayBuffer  = __webpack_require__(3).ArrayBuffer
  , speciesConstructor = __webpack_require__(139)
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(5)(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(58)(ARRAY_BUFFER);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(99).ABV, {
  DataView: __webpack_require__(142).DataView
});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(0)
  , aFunction = __webpack_require__(22)
  , anObject  = __webpack_require__(2)
  , rApply    = (__webpack_require__(3).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(5)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = __webpack_require__(0)
  , create     = __webpack_require__(56)
  , aFunction  = __webpack_require__(22)
  , anObject   = __webpack_require__(2)
  , isObject   = __webpack_require__(8)
  , fails      = __webpack_require__(5)
  , bind       = __webpack_require__(190)
  , rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = __webpack_require__(13)
  , $export     = __webpack_require__(0)
  , anObject    = __webpack_require__(2)
  , toPrimitive = __webpack_require__(34);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(5)(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(0)
  , gOPD     = __webpack_require__(26).f
  , anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export  = __webpack_require__(0)
  , anObject = __webpack_require__(2);
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
__webpack_require__(131)(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = __webpack_require__(26)
  , getPrototypeOf = __webpack_require__(27)
  , has            = __webpack_require__(17)
  , $export        = __webpack_require__(0)
  , isObject       = __webpack_require__(8)
  , anObject       = __webpack_require__(2);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = __webpack_require__(26)
  , $export  = __webpack_require__(0)
  , anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(0)
  , getProto = __webpack_require__(27)
  , anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(0)
  , anObject      = __webpack_require__(2)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(206)});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(0)
  , anObject           = __webpack_require__(2)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = __webpack_require__(13)
  , gOPD           = __webpack_require__(26)
  , getPrototypeOf = __webpack_require__(27)
  , has            = __webpack_require__(17)
  , $export        = __webpack_require__(0)
  , createDesc     = __webpack_require__(47)
  , anObject       = __webpack_require__(2)
  , isObject       = __webpack_require__(8);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(0)
  , setProto = __webpack_require__(123);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export   = __webpack_require__(0)
  , $includes = __webpack_require__(91)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(68)('includes');

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0)
  , $at     = __webpack_require__(129)(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0)
  , $pad    = __webpack_require__(207);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0)
  , $pad    = __webpack_require__(207);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(66)('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(66)('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export     = __webpack_require__(0)
  , defined     = __webpack_require__(30)
  , toLength    = __webpack_require__(15)
  , isRegExp    = __webpack_require__(94)
  , getFlags    = __webpack_require__(96)
  , RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function(regexp, string){
  this._r = regexp;
  this._s = string;
};

__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next(){
  var match = this._r.exec(this._s);
  return {value: match, done: match === null};
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp){
    defined(this);
    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
    var S     = String(this)
      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118)('asyncIterator');

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118)('observable');

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(0)
  , ownKeys        = __webpack_require__(206)
  , toIObject      = __webpack_require__(23)
  , gOPD           = __webpack_require__(26)
  , createProperty = __webpack_require__(135);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0)
  , $values = __webpack_require__(208)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(0)
  , $entries = __webpack_require__(208)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(0)
  , toObject        = __webpack_require__(16)
  , aFunction       = __webpack_require__(22)
  , $defineProperty = __webpack_require__(13);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(12) && $export($export.P + __webpack_require__(100), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(0)
  , toObject        = __webpack_require__(16)
  , aFunction       = __webpack_require__(22)
  , $defineProperty = __webpack_require__(13);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(12) && $export($export.P + __webpack_require__(100), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(0)
  , toObject                 = __webpack_require__(16)
  , toPrimitive              = __webpack_require__(34)
  , getPrototypeOf           = __webpack_require__(27)
  , getOwnPropertyDescriptor = __webpack_require__(26).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(100), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(0)
  , toObject                 = __webpack_require__(16)
  , toPrimitive              = __webpack_require__(34)
  , getPrototypeOf           = __webpack_require__(27)
  , getOwnPropertyDescriptor = __webpack_require__(26).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(12) && $export($export.P + __webpack_require__(100), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(0);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(209)('Map')});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(0);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(209)('Set')});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', {global: __webpack_require__(3)});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0)
  , cof     = __webpack_require__(29);

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >> 16
      , v1 = $v >> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >>> 16
      , v1 = $v >>> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(43)
  , anObject                  = __webpack_require__(2)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(43)
  , anObject               = __webpack_require__(2)
  , toMetaKey              = metadata.key
  , getOrCreateMetadataMap = metadata.map
  , store                  = metadata.store;

metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
  if(metadataMap.size)return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
}});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(43)
  , anObject               = __webpack_require__(2)
  , getPrototypeOf         = __webpack_require__(27)
  , ordinaryHasOwnMetadata = metadata.has
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

var ordinaryGetMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Set                     = __webpack_require__(203)
  , from                    = __webpack_require__(210)
  , metadata                = __webpack_require__(43)
  , anObject                = __webpack_require__(2)
  , getPrototypeOf          = __webpack_require__(27)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

var ordinaryMetadataKeys = function(O, P){
  var oKeys  = ordinaryOwnMetadataKeys(O, P)
    , parent = getPrototypeOf(O);
  if(parent === null)return oKeys;
  var pKeys  = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(43)
  , anObject               = __webpack_require__(2)
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                = __webpack_require__(43)
  , anObject                = __webpack_require__(2)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(43)
  , anObject               = __webpack_require__(2)
  , getPrototypeOf         = __webpack_require__(27)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

var ordinaryHasMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(43)
  , anObject               = __webpack_require__(2)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(43)
  , anObject                  = __webpack_require__(2)
  , aFunction                 = __webpack_require__(22)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({metadata: function metadata(metadataKey, metadataValue){
  return function decorator(target, targetKey){
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
}});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export   = __webpack_require__(0)
  , microtask = __webpack_require__(141)()
  , process   = __webpack_require__(3).process
  , isNode    = __webpack_require__(29)(process) == 'process';

$export($export.G, {
  asap: function asap(fn){
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export     = __webpack_require__(0)
  , global      = __webpack_require__(3)
  , core        = __webpack_require__(40)
  , microtask   = __webpack_require__(141)()
  , OBSERVABLE  = __webpack_require__(9)('observable')
  , aFunction   = __webpack_require__(22)
  , anObject    = __webpack_require__(2)
  , anInstance  = __webpack_require__(59)
  , redefineAll = __webpack_require__(60)
  , hide        = __webpack_require__(20)
  , forOf       = __webpack_require__(69)
  , RETURN      = forOf.RETURN;

var getMethod = function(fn){
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function(subscription){
  var cleanup = subscription._c;
  if(cleanup){
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function(subscription){
  return subscription._o === undefined;
};

var closeSubscription = function(subscription){
  if(!subscriptionClosed(subscription)){
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function(observer, subscriber){
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup      = subscriber(observer)
      , subscription = cleanup;
    if(cleanup != null){
      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch(e){
    observer.error(e);
    return;
  } if(subscriptionClosed(this))cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe(){ closeSubscription(this); }
});

var SubscriptionObserver = function(subscription){
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if(m)return m.call(observer, value);
      } catch(e){
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value){
    var subscription = this._s;
    if(subscriptionClosed(subscription))throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if(!m)throw value;
      value = m.call(observer, value);
    } catch(e){
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch(e){
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber){
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer){
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn){
    var that = this;
    return new (core.Promise || global.Promise)(function(resolve, reject){
      aFunction(fn);
      var subscription = that.subscribe({
        next : function(value){
          try {
            return fn(value);
          } catch(e){
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x){
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if(method){
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function(observer){
        return observable.subscribe(observer);
      });
    }
    return new C(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          try {
            if(forOf(x, false, function(it){
              observer.next(it);
              if(done)return RETURN;
            }) === RETURN)return;
          } catch(e){
            if(done)throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  },
  of: function of(){
    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          for(var i = 0; i < items.length; ++i){
            observer.next(items[i]);
            if(done)return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function(){ return this; });

$export($export.G, {Observable: $Observable});

__webpack_require__(58)('Observable');

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(3)
  , $export    = __webpack_require__(0)
  , invoke     = __webpack_require__(93)
  , partial    = __webpack_require__(447)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path      = __webpack_require__(448)
  , invoke    = __webpack_require__(93)
  , aFunction = __webpack_require__(22);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0)
  , $task   = __webpack_require__(140);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators    = __webpack_require__(138)
  , redefine      = __webpack_require__(21)
  , global        = __webpack_require__(3)
  , hide          = __webpack_require__(20)
  , Iterators     = __webpack_require__(67)
  , wks           = __webpack_require__(9)
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)))

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(453);
module.exports = __webpack_require__(40).RegExp.escape;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0)
  , $re     = __webpack_require__(454)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(457);
var ReactElement = __webpack_require__(71);

var emptyFunction = __webpack_require__(28);
var traverseAllChildren = __webpack_require__(458);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(81);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(81);

var ReactCurrentOwner = __webpack_require__(44);
var REACT_ELEMENT_TYPE = __webpack_require__(214);

var getIteratorFn = __webpack_require__(459);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(460);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(71);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(71),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(215);

module.exports = factory(isValidElement);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(28);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(216);
var checkPropTypes = __webpack_require__(464);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(211),
    Component = _require.Component;

var _require2 = __webpack_require__(71),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(212);
var factory = __webpack_require__(467);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var emptyObject = __webpack_require__(101);
var _invariant = __webpack_require__(1);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(81);

var ReactElement = __webpack_require__(71);

var invariant = __webpack_require__(1);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(470);


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(14);
var ReactDefaultInjection = __webpack_require__(471);
var ReactMount = __webpack_require__(240);
var ReactReconciler = __webpack_require__(73);
var ReactUpdates = __webpack_require__(37);
var ReactVersion = __webpack_require__(543);

var findDOMNode = __webpack_require__(544);
var getHostComponentFromComposite = __webpack_require__(241);
var renderSubtreeIntoContainer = __webpack_require__(545);
var warning = __webpack_require__(6);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(472);
var BeforeInputEventPlugin = __webpack_require__(473);
var ChangeEventPlugin = __webpack_require__(477);
var DefaultEventPluginOrder = __webpack_require__(480);
var EnterLeaveEventPlugin = __webpack_require__(481);
var HTMLDOMPropertyConfig = __webpack_require__(482);
var ReactComponentBrowserEnvironment = __webpack_require__(483);
var ReactDOMComponent = __webpack_require__(489);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMEmptyComponent = __webpack_require__(514);
var ReactDOMTreeTraversal = __webpack_require__(515);
var ReactDOMTextComponent = __webpack_require__(516);
var ReactDefaultBatchingStrategy = __webpack_require__(517);
var ReactEventListener = __webpack_require__(518);
var ReactInjection = __webpack_require__(520);
var ReactReconcileTransaction = __webpack_require__(521);
var SVGDOMPropertyConfig = __webpack_require__(527);
var SelectEventPlugin = __webpack_require__(528);
var SimpleEventPlugin = __webpack_require__(529);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(82);
var ExecutionEnvironment = __webpack_require__(18);
var FallbackCompositionState = __webpack_require__(474);
var SyntheticCompositionEvent = __webpack_require__(475);
var SyntheticInputEvent = __webpack_require__(476);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(61);

var getTextContentAccessor = __webpack_require__(220);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(83);
var EventPropagators = __webpack_require__(82);
var ExecutionEnvironment = __webpack_require__(18);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(37);
var SyntheticEvent = __webpack_require__(45);

var inputValueTracking = __webpack_require__(223);
var getEventTarget = __webpack_require__(146);
var isEventSupported = __webpack_require__(147);
var isTextInputElement = __webpack_require__(224);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(479);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(82);
var ReactDOMComponentTree = __webpack_require__(14);
var SyntheticMouseEvent = __webpack_require__(103);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(72);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(149);
var ReactDOMIDOperations = __webpack_require__(488);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(74);
var ExecutionEnvironment = __webpack_require__(18);

var createNodesFromMarkup = __webpack_require__(485);
var emptyFunction = __webpack_require__(28);
var invariant = __webpack_require__(1);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(18);

var createArrayFromMixed = __webpack_require__(486);
var getMarkupWrap = __webpack_require__(487);
var invariant = __webpack_require__(1);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(1);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(18);

var invariant = __webpack_require__(1);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(149);
var ReactDOMComponentTree = __webpack_require__(14);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var AutoFocusUtils = __webpack_require__(490);
var CSSPropertyOperations = __webpack_require__(491);
var DOMLazyTree = __webpack_require__(74);
var DOMNamespaces = __webpack_require__(150);
var DOMProperty = __webpack_require__(72);
var DOMPropertyOperations = __webpack_require__(229);
var EventPluginHub = __webpack_require__(83);
var EventPluginRegistry = __webpack_require__(143);
var ReactBrowserEventEmitter = __webpack_require__(106);
var ReactDOMComponentFlags = __webpack_require__(217);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMInput = __webpack_require__(501);
var ReactDOMOption = __webpack_require__(503);
var ReactDOMSelect = __webpack_require__(230);
var ReactDOMTextarea = __webpack_require__(504);
var ReactInstrumentation = __webpack_require__(32);
var ReactMultiChild = __webpack_require__(505);
var ReactServerRenderingTransaction = __webpack_require__(512);

var emptyFunction = __webpack_require__(28);
var escapeTextContentForBrowser = __webpack_require__(105);
var invariant = __webpack_require__(1);
var isEventSupported = __webpack_require__(147);
var shallowEqual = __webpack_require__(154);
var inputValueTracking = __webpack_require__(223);
var validateDOMNesting = __webpack_require__(158);
var warning = __webpack_require__(6);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(14);

var focusNode = __webpack_require__(227);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(228);
var ExecutionEnvironment = __webpack_require__(18);
var ReactInstrumentation = __webpack_require__(32);

var camelizeStyleName = __webpack_require__(492);
var dangerousStyleValue = __webpack_require__(494);
var hyphenateStyleName = __webpack_require__(495);
var memoizeStringOnly = __webpack_require__(497);
var warning = __webpack_require__(6);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(493);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(228);
var warning = __webpack_require__(6);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(496);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(105);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(83);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(18);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var DOMPropertyOperations = __webpack_require__(229);
var LinkedValueUtils = __webpack_require__(152);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(37);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var React = __webpack_require__(70);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMSelect = __webpack_require__(230);

var warning = __webpack_require__(6);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(152);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(37);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactComponentEnvironment = __webpack_require__(153);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(32);

var ReactCurrentOwner = __webpack_require__(44);
var ReactReconciler = __webpack_require__(73);
var ReactChildReconciler = __webpack_require__(506);

var emptyFunction = __webpack_require__(28);
var flattenChildren = __webpack_require__(511);
var invariant = __webpack_require__(1);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(73);

var instantiateReactComponent = __webpack_require__(231);
var KeyEscapeUtils = __webpack_require__(156);
var shouldUpdateReactComponent = __webpack_require__(155);
var traverseAllChildren = __webpack_require__(235);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"."}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(236);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var React = __webpack_require__(70);
var ReactComponentEnvironment = __webpack_require__(153);
var ReactCurrentOwner = __webpack_require__(44);
var ReactErrorUtils = __webpack_require__(145);
var ReactInstanceMap = __webpack_require__(85);
var ReactInstrumentation = __webpack_require__(32);
var ReactNodeTypes = __webpack_require__(232);
var ReactReconciler = __webpack_require__(73);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(101);
var invariant = __webpack_require__(1);
var shallowEqual = __webpack_require__(154);
var shouldUpdateReactComponent = __webpack_require__(155);
var warning = __webpack_require__(6);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(156);
var traverseAllChildren = __webpack_require__(235);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"."}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(236);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(61);
var Transaction = __webpack_require__(102);
var ReactInstrumentation = __webpack_require__(32);
var ReactServerUpdateQueue = __webpack_require__(513);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(157);

var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var DOMLazyTree = __webpack_require__(74);
var ReactDOMComponentTree = __webpack_require__(14);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(1);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(11);

var DOMChildrenOperations = __webpack_require__(149);
var DOMLazyTree = __webpack_require__(74);
var ReactDOMComponentTree = __webpack_require__(14);

var escapeTextContentForBrowser = __webpack_require__(105);
var invariant = __webpack_require__(1);
var validateDOMNesting = __webpack_require__(158);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactUpdates = __webpack_require__(37);
var Transaction = __webpack_require__(102);

var emptyFunction = __webpack_require__(28);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var EventListener = __webpack_require__(237);
var ExecutionEnvironment = __webpack_require__(18);
var PooledClass = __webpack_require__(61);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(37);

var getEventTarget = __webpack_require__(146);
var getUnboundedScrollPosition = __webpack_require__(519);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(72);
var EventPluginHub = __webpack_require__(83);
var EventPluginUtils = __webpack_require__(144);
var ReactComponentEnvironment = __webpack_require__(153);
var ReactEmptyComponent = __webpack_require__(233);
var ReactBrowserEventEmitter = __webpack_require__(106);
var ReactHostComponent = __webpack_require__(234);
var ReactUpdates = __webpack_require__(37);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(221);
var PooledClass = __webpack_require__(61);
var ReactBrowserEventEmitter = __webpack_require__(106);
var ReactInputSelection = __webpack_require__(238);
var ReactInstrumentation = __webpack_require__(32);
var Transaction = __webpack_require__(102);
var ReactUpdateQueue = __webpack_require__(157);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(18);

var getNodeForCharacterOffset = __webpack_require__(523);
var getTextContentAccessor = __webpack_require__(220);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(525);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(526);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(82);
var ExecutionEnvironment = __webpack_require__(18);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInputSelection = __webpack_require__(238);
var SyntheticEvent = __webpack_require__(45);

var getActiveElement = __webpack_require__(239);
var isTextInputElement = __webpack_require__(224);
var shallowEqual = __webpack_require__(154);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var EventListener = __webpack_require__(237);
var EventPropagators = __webpack_require__(82);
var ReactDOMComponentTree = __webpack_require__(14);
var SyntheticAnimationEvent = __webpack_require__(530);
var SyntheticClipboardEvent = __webpack_require__(531);
var SyntheticEvent = __webpack_require__(45);
var SyntheticFocusEvent = __webpack_require__(532);
var SyntheticKeyboardEvent = __webpack_require__(533);
var SyntheticMouseEvent = __webpack_require__(103);
var SyntheticDragEvent = __webpack_require__(535);
var SyntheticTouchEvent = __webpack_require__(536);
var SyntheticTransitionEvent = __webpack_require__(537);
var SyntheticUIEvent = __webpack_require__(84);
var SyntheticWheelEvent = __webpack_require__(538);

var emptyFunction = __webpack_require__(28);
var getEventCharCode = __webpack_require__(159);
var invariant = __webpack_require__(1);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(84);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(84);

var getEventCharCode = __webpack_require__(159);
var getEventKey = __webpack_require__(534);
var getEventModifierState = __webpack_require__(148);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(159);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(103);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(84);

var getEventModifierState = __webpack_require__(148);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(45);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(103);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(158);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(542);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInstanceMap = __webpack_require__(85);

var getHostComponentFromComposite = __webpack_require__(241);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(6);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(240);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(160);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = __webpack_require__(249);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(569);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(573);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(574);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(578);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(589);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.flush = flush;

var _react = __webpack_require__(4);

var _render = __webpack_require__(597);

var _render2 = _interopRequireDefault(_render);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = [];

var _class = function (_Component) {
  (0, _inherits3.default)(_class, _Component);

  function _class() {
    (0, _classCallCheck3.default)(this, _class);
    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
  }

  (0, _createClass3.default)(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      mount(this);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      update();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      unmount(this);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return _class;
}(_react.Component);

exports.default = _class;


function componentMap() {
  var ret = new _map2.default();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(components), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var c = _step.value;

      ret.set(c.props.styleId, c);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

function flush() {
  var ret = componentMap();
  components = [];
  return ret;
}

function mount(component) {
  components.push(component);
  update();
}

function unmount(component) {
  var i = components.indexOf(component);
  if (i < 0) {
    return;
  }

  components.splice(i, 1);
  update();
}

function update() {
  (0, _render2.default)(componentMap());
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(87);
module.exports = __webpack_require__(557);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(549)
  , step             = __webpack_require__(242)
  , Iterators        = __webpack_require__(75)
  , toIObject        = __webpack_require__(62);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(162)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(110)
  , descriptor     = __webpack_require__(86)
  , setToStringTag = __webpack_require__(114)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(50)(IteratorPrototype, __webpack_require__(25)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(33)
  , anObject = __webpack_require__(51)
  , getKeys  = __webpack_require__(111);

module.exports = __webpack_require__(39) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(62)
  , toLength  = __webpack_require__(112)
  , toIndex   = __webpack_require__(554);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(165)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(38).document && document.documentElement;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(165)
  , defined   = __webpack_require__(109);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(51)
  , get      = __webpack_require__(169);
module.exports = __webpack_require__(19).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(250);
__webpack_require__(87);
__webpack_require__(108);
__webpack_require__(559);
__webpack_require__(566);
module.exports = __webpack_require__(19).Map;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(560);

// 23.1 Map Objects
module.exports = __webpack_require__(562)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(33).f
  , create      = __webpack_require__(110)
  , redefineAll = __webpack_require__(251)
  , ctx         = __webpack_require__(76)
  , anInstance  = __webpack_require__(252)
  , defined     = __webpack_require__(109)
  , forOf       = __webpack_require__(171)
  , $iterDefine = __webpack_require__(162)
  , step        = __webpack_require__(242)
  , setSpecies  = __webpack_require__(561)
  , DESCRIPTORS = __webpack_require__(39)
  , fastKey     = __webpack_require__(172).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(38)
  , core        = __webpack_require__(19)
  , dP          = __webpack_require__(33)
  , DESCRIPTORS = __webpack_require__(39)
  , SPECIES     = __webpack_require__(25)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(38)
  , $export        = __webpack_require__(46)
  , meta           = __webpack_require__(172)
  , fails          = __webpack_require__(77)
  , hide           = __webpack_require__(50)
  , redefineAll    = __webpack_require__(251)
  , forOf          = __webpack_require__(171)
  , anInstance     = __webpack_require__(252)
  , isObject       = __webpack_require__(63)
  , setToStringTag = __webpack_require__(114)
  , dP             = __webpack_require__(33).f
  , each           = __webpack_require__(563)(0)
  , DESCRIPTORS    = __webpack_require__(39);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(76)
  , IObject  = __webpack_require__(243)
  , toObject = __webpack_require__(115)
  , toLength = __webpack_require__(112)
  , asc      = __webpack_require__(564);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(565);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(63)
  , isArray  = __webpack_require__(255)
  , SPECIES  = __webpack_require__(25)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(46);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(567)('Map')});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(170)
  , from    = __webpack_require__(568);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(171);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(570), __esModule: true };

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(571);
module.exports = __webpack_require__(19).Object.getPrototypeOf;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(115)
  , $getPrototypeOf = __webpack_require__(248);

__webpack_require__(572)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(46)
  , core    = __webpack_require__(19)
  , fails   = __webpack_require__(77);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(575);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(576), __esModule: true };

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(577);
var $Object = __webpack_require__(19).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(46);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(39), 'Object', {defineProperty: __webpack_require__(33).f});

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(256);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(580), __esModule: true };

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87);
__webpack_require__(108);
module.exports = __webpack_require__(173).f('iterator');

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(582), __esModule: true };

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(583);
__webpack_require__(250);
__webpack_require__(587);
__webpack_require__(588);
module.exports = __webpack_require__(19).Symbol;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(38)
  , has            = __webpack_require__(64)
  , DESCRIPTORS    = __webpack_require__(39)
  , $export        = __webpack_require__(46)
  , redefine       = __webpack_require__(246)
  , META           = __webpack_require__(172).KEY
  , $fails         = __webpack_require__(77)
  , shared         = __webpack_require__(167)
  , setToStringTag = __webpack_require__(114)
  , uid            = __webpack_require__(113)
  , wks            = __webpack_require__(25)
  , wksExt         = __webpack_require__(173)
  , wksDefine      = __webpack_require__(174)
  , keyOf          = __webpack_require__(584)
  , enumKeys       = __webpack_require__(585)
  , isArray        = __webpack_require__(255)
  , anObject       = __webpack_require__(51)
  , toIObject      = __webpack_require__(62)
  , toPrimitive    = __webpack_require__(164)
  , createDesc     = __webpack_require__(86)
  , _create        = __webpack_require__(110)
  , gOPNExt        = __webpack_require__(586)
  , $GOPD          = __webpack_require__(259)
  , $DP            = __webpack_require__(33)
  , $keys          = __webpack_require__(111)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(258).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(175).f  = $propertyIsEnumerable;
  __webpack_require__(257).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(163)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(50)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(111)
  , toIObject = __webpack_require__(62);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(111)
  , gOPS    = __webpack_require__(257)
  , pIE     = __webpack_require__(175);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(62)
  , gOPN      = __webpack_require__(258).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174)('asyncIterator');

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174)('observable');

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(590);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(594);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(256);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(591), __esModule: true };

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(592);
module.exports = __webpack_require__(19).Object.setPrototypeOf;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(46);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(593).set});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(63)
  , anObject = __webpack_require__(51);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(76)(Function.call, __webpack_require__(259).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(595), __esModule: true };

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(596);
var $Object = __webpack_require__(19).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(46)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(110)});

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(160);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(598);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _from = __webpack_require__(602);

var _from2 = _interopRequireDefault(_from);

var _map = __webpack_require__(249);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tags = new _map2.default();
var prevStyles = new _map2.default();

exports.default = typeof window === 'undefined' ? renderOnServer : renderOnClient;


function renderOnServer() {}

function renderOnClient(styles) {
  patch(diff(prevStyles, styles));
  prevStyles = styles;
}

function diff(a, b) {
  var added = (0, _from2.default)(b.entries()).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
        k = _ref2[0];

    return !a.has(k);
  });
  var removed = (0, _from2.default)(a.entries()).filter(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
        k = _ref4[0];

    return !b.has(k);
  });
  return [added, removed];
}

var fromServer = new _map2.default();

function patch(_ref5) {
  var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
      added = _ref6[0],
      removed = _ref6[1];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(added), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
          id = _step$value[0],
          c = _step$value[1];

      // Avoid duplicates from server-rendered markup
      if (!fromServer.has(id)) {
        fromServer.set(id, document.getElementById('__jsx-style-' + id));
      }

      var tag = fromServer.get(id) || makeStyleTag(c.props.css);
      tags.set(id, tag);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(removed), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _step2$value = (0, _slicedToArray3.default)(_step2.value, 1),
          id = _step2$value[0];

      var t = tags.get(id);
      tags.delete(id);
      t.parentNode.removeChild(t);
      // Avoid checking the DOM later on
      fromServer.delete(id);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function makeStyleTag(str) {
  // Based on implementation by glamor
  var tag = document.createElement('style');
  tag.appendChild(document.createTextNode(str));

  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);

  return tag;
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(599);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(160);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(600), __esModule: true };

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
__webpack_require__(87);
module.exports = __webpack_require__(601);

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(170)
  , ITERATOR  = __webpack_require__(25)('iterator')
  , Iterators = __webpack_require__(75);
module.exports = __webpack_require__(19).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(603), __esModule: true };

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87);
__webpack_require__(604);
module.exports = __webpack_require__(19).Array.from;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(76)
  , $export        = __webpack_require__(46)
  , toObject       = __webpack_require__(115)
  , call           = __webpack_require__(253)
  , isArrayIter    = __webpack_require__(254)
  , toLength       = __webpack_require__(112)
  , createProperty = __webpack_require__(605)
  , getIterFn      = __webpack_require__(169);

$export($export.S + $export.F * !__webpack_require__(606)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(33)
  , createDesc      = __webpack_require__(86);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(25)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(176);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(116);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(177);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(178);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(179);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(180);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(181);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)))

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(28);
var invariant = __webpack_require__(1);
var ReactPropTypesSecret = __webpack_require__(216);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(176);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(116);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(177);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(178);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(179);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(180);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(181);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(176);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(116);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(177);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(612);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(178);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(179);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(180);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(181);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(260);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f913.31151024.svg";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f60a.9ac49133.svg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f623.4c36b410.svg";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f640.5ab9aaf1.svg";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f44f.d86b68ae.svg";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f38a.32fcfaa3.svg";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f44d.040deb1c.svg";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f389.7279b3c3.svg";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f44b.f73e1854.svg";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f955.612ef40f.svg";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f949.141a8dae.svg";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f914.c58396d2.svg";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/01-subscribe.98d346c2.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/02-millennials_mobile.4108b7a9.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f4aa.86dd7f49.svg";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f939-1f3fd.df760d5d.svg";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/26d1.40cc267c.svg";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f4bc.3ff8ae91.svg";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f4bb.0200eb56.svg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f5e8.dc9bee11.svg";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f468-1f469-1f467.a0e7965b.svg";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f4b0.234b2d11.svg";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f30d.81aad1ab.svg";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f6eb.41b45618.svg";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f5e3.c353bf8e.svg";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f4e6.7a3329c2.svg";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f3e6.17cc228b.svg";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f46b.748285d4.svg";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f6c2.19901692.svg";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f4a5.987b27ef.svg";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f46a.5c0828b2.svg";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f48e.a90e9cfa.svg";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f91d.cd1a8569.svg";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f333.5ac1b0a0.svg";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1f910.445d6244.svg";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(4);
var isWebpackBundle = __webpack_require__(264);
var webpackRequireWeak = __webpack_require__(652);

var _require = __webpack_require__(653),
    inspect = _require.inspect;

function capture(fn) {
  var reported = [];
  var stopInspecting = inspect(function (metadata) {
    return reported.push(metadata);
  });
  var promise = fn();
  stopInspecting();
  return { promise: promise, reported: reported };
}

function load(loader) {
  var _capture = capture(function () {
    return loader();
  }),
      promise = _capture.promise,
      reported = _capture.reported;

  if (reported.length > 1) {
    throw new Error('react-loadable cannot handle more than one import() in each loader');
  }

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  var metadata = reported[0] || {};

  try {
    if (isWebpackBundle) {
      if (typeof metadata.webpackRequireWeakId === 'function') {
        state.loading = false;
        state.loaded = webpackRequireWeak(metadata.webpackRequireWeakId());
      }
    } else {
      if (typeof metadata.serverSideRequirePath === 'string') {
        state.loading = false;
        state.loaded = module.require(metadata.serverSideRequirePath);
      }
    }
  } catch (err) {
    state.error = err;
  }

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  if (!options.loading) {
    throw new Error('react-loadable requires a `loading` component');
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render
  }, options);

  var res = null;

  return function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      if (!res) {
        res = loadFn(opts.loader);
      }

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      if (!res) {
        res = loadFn(opts.loader);
      }
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      this._mounted = true;

      if (res.resolved) {
        return;
      }

      if (typeof opts.delay === 'number') {
        this._delay = setTimeout(function () {
          _this2.setState({ pastDelay: true });
        }, opts.delay);
      }

      if (typeof opts.timeout === 'number') {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
        throw err;
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component);
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== 'function') {
    throw new Error('LoadableMap requires a `render(loaded, props)` function');
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

module.exports = Loadable;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(651)(module)))

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @flow


var isWebpackBundle = __webpack_require__(264);

/*::
declare var __webpack_require__: Function;
declare var __webpack_modules__: Object;
*/

function requireWeak(id /*: number | string */ ) {
  if (__webpack_require__.m[id]) {
    return __webpack_require__(id);
  }
}

module.exports = isWebpackBundle ? requireWeak : null;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callbacks = [];

function report(promise, metadata) {
  callbacks.forEach(function(callback) {
    callback(metadata);
  });

  return promise;
}

function inspect(callback) {
  var index = callbacks.push(callback) - 1;

  return function stopInspecting() {
    callbacks.splice(index, 1);
  };
}

exports.report = report;
exports.inspect = inspect;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.14ece145.js